/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ContactCreator
// ====================================================

export interface ContactCreator {
  contactCreator: boolean;
}

export interface ContactCreatorVariables {
  email: any;
  creatorEmail: any;
  fullname: string;
  body: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: ContactFormPrefilledData
// ====================================================

export interface ContactFormPrefilledData_user {
  __typename: "User";
  /**
   * Main email address
   */
  email: any;
  id: string;
  /**
   * Full name
   */
  name: string;
}

export interface ContactFormPrefilledData {
  /**
   * Currently authenticated user
   */
  user: ContactFormPrefilledData_user | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetWorkspaceByDomain
// ====================================================

export interface GetWorkspaceByDomain_workspace_user {
  __typename: "User";
  id: string;
  /**
   * First name
   */
  firstname: string;
  /**
   * Last name
   */
  lastname: string;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * Personal slogan
   */
  payoff: string | null;
  /**
   * User banner
   */
  banner: any | null;
}

export interface GetWorkspaceByDomain_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Brand Name for white label
   */
  brandName: string | null;
  /**
   * Small squared logo for white label
   */
  brandLogoSmall: any | null;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
  /**
   * Who created the workspace (or first related user if creator is null)
   */
  user: GetWorkspaceByDomain_workspace_user | null;
}

export interface GetWorkspaceByDomain {
  workspace: GetWorkspaceByDomain_workspace | null;
}

export interface GetWorkspaceByDomainVariables {
  domainName: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: TrackMediaEnd
// ====================================================

export interface TrackMediaEnd_trackMediaEnd {
  __typename: "AudioContent" | "VideoContent";
}

export interface TrackMediaEnd {
  /**
   * Track end event on media content by current user
   */
  trackMediaEnd: TrackMediaEnd_trackMediaEnd;
}

export interface TrackMediaEndVariables {
  data: any;
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: TrackMediaPause
// ====================================================

export interface TrackMediaPause_trackMediaPause {
  __typename: "AudioContent" | "VideoContent";
}

export interface TrackMediaPause {
  /**
   * Track pause event on media content by current user
   */
  trackMediaPause: TrackMediaPause_trackMediaPause;
}

export interface TrackMediaPauseVariables {
  data: any;
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: TrackMediaPlay
// ====================================================

export interface TrackMediaPlay_trackMediaPlay {
  __typename: "AudioContent" | "VideoContent";
}

export interface TrackMediaPlay {
  /**
   * Track play event on media content by current user
   */
  trackMediaPlay: TrackMediaPlay_trackMediaPlay;
}

export interface TrackMediaPlayVariables {
  data: any;
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: TrackMediaSeek
// ====================================================

export interface TrackMediaSeek_trackMediaSeek {
  __typename: "AudioContent" | "VideoContent";
}

export interface TrackMediaSeek {
  /**
   * Track seek event on media content by current user
   */
  trackMediaSeek: TrackMediaSeek_trackMediaSeek;
}

export interface TrackMediaSeekVariables {
  data: any;
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: TrackMediaVolumeChange
// ====================================================

export interface TrackMediaVolumeChange_trackMediaVolumeChange {
  __typename: "AudioContent" | "VideoContent";
}

export interface TrackMediaVolumeChange {
  /**
   * Track volume change on media content by current user
   */
  trackMediaVolumeChange: TrackMediaVolumeChange_trackMediaVolumeChange;
}

export interface TrackMediaVolumeChangeVariables {
  data: any;
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetWorkspaceCookie
// ====================================================

export interface GetWorkspaceCookie_workspaceCookie {
  __typename: "WorkspaceCookie";
  workspaceId: string;
  workspaceRole: string;
}

export interface GetWorkspaceCookie {
  workspaceCookie: GetWorkspaceCookie_workspaceCookie | null;
}

export interface GetWorkspaceCookieVariables {
  workspaceId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateUserLanguage
// ====================================================

export interface UpdateUserLanguage_updateUser {
  __typename: "User";
  /**
   * Language
   */
  language: string;
}

export interface UpdateUserLanguage {
  /**
   * Update current user profile
   */
  updateUser: UpdateUserLanguage_updateUser;
}

export interface UpdateUserLanguageVariables {
  input: UpdateUserInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetUserCollectionAuthorization
// ====================================================

export interface GetUserCollectionAuthorization_collection {
  __typename: "BlendedCollection" | "MixedCollection" | "VideoCollection";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Defines if current user has a specific permission on the collection
   */
  canManage: boolean;
}

export interface GetUserCollectionAuthorization {
  /**
   * Get a collection, identified by id or by slug,
   * optionally an authorization token can be used to enable access for current user.
   */
  collection: GetUserCollectionAuthorization_collection | null;
}

export interface GetUserCollectionAuthorizationVariables {
  identifier: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: CanImportScorm
// ====================================================

export interface CanImportScorm_me {
  __typename: "User";
  id: string;
  /**
   * Whether the authenticated user may import SCORM packages; always false for another user
   */
  canImportScorm: boolean;
}

export interface CanImportScorm {
  /**
   * Currently authenticated user
   */
  me: CanImportScorm_me | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetElementAuthorizationForGroups
// ====================================================

export interface GetElementAuthorizationForGroups_element_MixedCollection_authorizationsGroups_group {
  __typename: "Group";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Custom identifier
   */
  identifier: string | null;
  /**
   * Name
   */
  name: string;
  /**
   * Total users in the group
   */
  usersCount: number;
}

export interface GetElementAuthorizationForGroups_element_MixedCollection_authorizationsGroups {
  __typename: "AuthorizationGroup";
  id: string;
  group: GetElementAuthorizationForGroups_element_MixedCollection_authorizationsGroups_group;
  value: number;
}

export interface GetElementAuthorizationForGroups_element_MixedCollection_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface GetElementAuthorizationForGroups_element_MixedCollection_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
  /**
   * Name
   */
  name: string;
}

export interface GetElementAuthorizationForGroups_element_MixedCollection_creator {
  __typename: "User";
  /**
   * Self description of the user
   */
  bio: string | null;
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: GetElementAuthorizationForGroups_element_MixedCollection_creator_subscriptionPlan;
  /**
   * Main email address
   */
  email: any;
  workspace: GetElementAuthorizationForGroups_element_MixedCollection_creator_workspace | null;
}

export interface GetElementAuthorizationForGroups_element_MixedCollection {
  __typename: "MixedCollection" | "BlendedCollection" | "VideoCollection";
  /**
   * Unique identifier
   */
  id: string;
  authorizationsGroups: GetElementAuthorizationForGroups_element_MixedCollection_authorizationsGroups[];
  /**
   * Collection creator
   */
  creator: GetElementAuthorizationForGroups_element_MixedCollection_creator;
}

export interface GetElementAuthorizationForGroups_element_AudioContent_authorizationsGroups_group {
  __typename: "Group";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Custom identifier
   */
  identifier: string | null;
  /**
   * Name
   */
  name: string;
  /**
   * Total users in the group
   */
  usersCount: number;
}

export interface GetElementAuthorizationForGroups_element_AudioContent_authorizationsGroups {
  __typename: "AuthorizationGroup";
  id: string;
  group: GetElementAuthorizationForGroups_element_AudioContent_authorizationsGroups_group;
  value: number;
}

export interface GetElementAuthorizationForGroups_element_AudioContent_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface GetElementAuthorizationForGroups_element_AudioContent_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
  /**
   * Name
   */
  name: string;
}

export interface GetElementAuthorizationForGroups_element_AudioContent_creator {
  __typename: "User";
  /**
   * Self description of the user
   */
  bio: string | null;
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: GetElementAuthorizationForGroups_element_AudioContent_creator_subscriptionPlan;
  /**
   * Main email address
   */
  email: any;
  workspace: GetElementAuthorizationForGroups_element_AudioContent_creator_workspace | null;
}

export interface GetElementAuthorizationForGroups_element_AudioContent {
  __typename: "AudioContent" | "EventContent" | "ImageContent" | "LinkContent" | "PdfContent" | "QuizContent" | "ScormContent" | "TextContent" | "VideoContent";
  /**
   * Unique identifier
   */
  id: string;
  authorizationsGroups: GetElementAuthorizationForGroups_element_AudioContent_authorizationsGroups[];
  /**
   * Content creator
   */
  creator: GetElementAuthorizationForGroups_element_AudioContent_creator;
}

export interface GetElementAuthorizationForGroups_element_Folder_authorizationsGroups_group {
  __typename: "Group";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Custom identifier
   */
  identifier: string | null;
  /**
   * Name
   */
  name: string;
  /**
   * Total users in the group
   */
  usersCount: number;
}

export interface GetElementAuthorizationForGroups_element_Folder_authorizationsGroups {
  __typename: "AuthorizationGroup";
  id: string;
  group: GetElementAuthorizationForGroups_element_Folder_authorizationsGroups_group;
  value: number;
}

export interface GetElementAuthorizationForGroups_element_Folder_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface GetElementAuthorizationForGroups_element_Folder_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
  /**
   * Name
   */
  name: string;
}

export interface GetElementAuthorizationForGroups_element_Folder_creator {
  __typename: "User";
  /**
   * Self description of the user
   */
  bio: string | null;
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: GetElementAuthorizationForGroups_element_Folder_creator_subscriptionPlan;
  /**
   * Main email address
   */
  email: any;
  workspace: GetElementAuthorizationForGroups_element_Folder_creator_workspace | null;
}

export interface GetElementAuthorizationForGroups_element_Folder {
  __typename: "Folder";
  /**
   * Unique identifier
   */
  id: string;
  authorizationsGroups: GetElementAuthorizationForGroups_element_Folder_authorizationsGroups[];
  /**
   * Folder creator
   */
  creator: GetElementAuthorizationForGroups_element_Folder_creator;
}

export type GetElementAuthorizationForGroups_element = GetElementAuthorizationForGroups_element_MixedCollection | GetElementAuthorizationForGroups_element_AudioContent | GetElementAuthorizationForGroups_element_Folder;

export interface GetElementAuthorizationForGroups {
  element: GetElementAuthorizationForGroups_element | null;
}

export interface GetElementAuthorizationForGroupsVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GroupsByWorkspace
// ====================================================

export interface GroupsByWorkspace_groupsByWorkspace {
  __typename: "Group";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Custom identifier
   */
  identifier: string | null;
  /**
   * Name
   */
  name: string;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Total users in the group
   */
  usersCount: number;
}

export interface GroupsByWorkspace {
  groupsByWorkspace: (GroupsByWorkspace_groupsByWorkspace | null)[] | null;
}

export interface GroupsByWorkspaceVariables {
  workspaceId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetUserRegistrationDate
// ====================================================

export interface GetUserRegistrationDate_user {
  __typename: "User";
  /**
   * When user registered
   */
  createdAt: any;
}

export interface GetUserRegistrationDate {
  user: GetUserRegistrationDate_user | null;
}

export interface GetUserRegistrationDateVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: TrackCollectionVisit
// ====================================================

export interface TrackCollectionVisit_trackCollectionVisit {
  __typename: "BlendedCollection" | "MixedCollection" | "VideoCollection";
  /**
   * Unique identifier
   */
  id: string;
}

export interface TrackCollectionVisit {
  /**
   * Track collection visit by current user
   */
  trackCollectionVisit: TrackCollectionVisit_trackCollectionVisit;
}

export interface TrackCollectionVisitVariables {
  id: string;
  ip?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: TrackContentVisit
// ====================================================

export interface TrackContentVisit_trackContentVisit {
  __typename: "AudioContent" | "EventContent" | "ImageContent" | "LinkContent" | "PdfContent" | "QuizContent" | "ScormContent" | "TextContent" | "VideoContent";
  /**
   * Unique identifier
   */
  id: string;
}

export interface TrackContentVisit {
  /**
   * Track content visit by current user
   */
  trackContentVisit: TrackContentVisit_trackContentVisit;
}

export interface TrackContentVisitVariables {
  id: string;
  ip?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: UserCollections
// ====================================================

export interface UserCollections_me_collections_edges_node_authorizations_user {
  __typename: "User";
  /**
   * Full name
   */
  name: string;
}

export interface UserCollections_me_collections_edges_node_authorizations {
  __typename: "Authorization";
  id: string;
  user: UserCollections_me_collections_edges_node_authorizations_user;
  value: number;
}

export interface UserCollections_me_collections_edges_node {
  __typename: "BlendedCollection" | "MixedCollection" | "VideoCollection";
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  authorizations: UserCollections_me_collections_edges_node_authorizations[];
}

export interface UserCollections_me_collections_edges {
  __typename: "CollectionEdge";
  /**
   * The Collection node.
   */
  node: UserCollections_me_collections_edges_node;
}

export interface UserCollections_me_collections {
  __typename: "CollectionConnection";
  /**
   * A list of Collection edges.
   */
  edges: UserCollections_me_collections_edges[];
}

export interface UserCollections_me {
  __typename: "User";
  id: string;
  /**
   * Collections managed by the user
   */
  collections: UserCollections_me_collections;
}

export interface UserCollections {
  /**
   * Currently authenticated user
   */
  me: UserCollections_me | null;
}

export interface UserCollectionsVariables {
  visibility?: Visibility[] | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: SubscriptionPlan
// ====================================================

export interface SubscriptionPlan_me_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface SubscriptionPlan_me {
  __typename: "User";
  id: string;
  /**
   * Main email address
   */
  email: any;
  subscriptionPlan: SubscriptionPlan_me_subscriptionPlan;
}

export interface SubscriptionPlan {
  /**
   * Currently authenticated user
   */
  me: SubscriptionPlan_me | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetWorkspaceCookieFromElement
// ====================================================

export interface GetWorkspaceCookieFromElement_workspaceCookieFromElement {
  __typename: "WorkspaceCookie";
  workspaceId: string;
  workspaceRole: string;
}

export interface GetWorkspaceCookieFromElement {
  workspaceCookieFromElement: GetWorkspaceCookieFromElement_workspaceCookieFromElement | null;
}

export interface GetWorkspaceCookieFromElementVariables {
  elementId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetWorkspaceById
// ====================================================

export interface GetWorkspaceById_workspace_user_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Internal code
   */
  code: string;
}

export interface GetWorkspaceById_workspace_user {
  __typename: "User";
  id: string;
  subscriptionPlan: GetWorkspaceById_workspace_user_subscriptionPlan;
}

export interface GetWorkspaceById_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Slug
   */
  slug: string | null;
  /**
   * Who created the workspace (or first related user if creator is null)
   */
  user: GetWorkspaceById_workspace_user | null;
}

export interface GetWorkspaceById {
  workspace: GetWorkspaceById_workspace | null;
}

export interface GetWorkspaceByIdVariables {
  workspaceId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: ContentAdjacentSSR
// ====================================================

export interface ContentAdjacentSSR_getPreviousContent {
  __typename: "AudioContent" | "EventContent" | "ImageContent" | "LinkContent" | "PdfContent" | "QuizContent" | "ScormContent" | "TextContent" | "VideoContent";
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * Determines if subject content is visible in a collection
   */
  visibilityForCollection: Visibility | null;
}

export interface ContentAdjacentSSR_getNextContent {
  __typename: "AudioContent" | "EventContent" | "ImageContent" | "LinkContent" | "PdfContent" | "QuizContent" | "ScormContent" | "TextContent" | "VideoContent";
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * Determines if subject content is visible in a collection
   */
  visibilityForCollection: Visibility | null;
}

export interface ContentAdjacentSSR {
  getPreviousContent: ContentAdjacentSSR_getPreviousContent | null;
  getNextContent: ContentAdjacentSSR_getNextContent | null;
}

export interface ContentAdjacentSSRVariables {
  collectionIdentifier: string;
  prevPosition: number;
  nextPosition: number;
  currentContentIdentifier?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: CollectionContentForRedirectAndMetadata
// ====================================================

export interface CollectionContentForRedirectAndMetadata_content_AudioContent_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Brand Name for white label
   */
  brandName: string | null;
  /**
   * Small squared logo for white label
   */
  brandLogoSmall: any | null;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
}

export interface CollectionContentForRedirectAndMetadata_content_AudioContent_creator {
  __typename: "User";
  workspace: CollectionContentForRedirectAndMetadata_content_AudioContent_creator_workspace | null;
}

export interface CollectionContentForRedirectAndMetadata_content_AudioContent {
  __typename: "AudioContent" | "EventContent" | "ImageContent" | "LinkContent" | "QuizContent" | "ScormContent" | "TextContent" | "VideoContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Determines if subject content is visible in a collection
   */
  visibilityForCollection: Visibility | null;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Content creator
   */
  creator: CollectionContentForRedirectAndMetadata_content_AudioContent_creator;
}

export interface CollectionContentForRedirectAndMetadata_content_PdfContent_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Brand Name for white label
   */
  brandName: string | null;
  /**
   * Small squared logo for white label
   */
  brandLogoSmall: any | null;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
}

export interface CollectionContentForRedirectAndMetadata_content_PdfContent_creator {
  __typename: "User";
  workspace: CollectionContentForRedirectAndMetadata_content_PdfContent_creator_workspace | null;
}

export interface CollectionContentForRedirectAndMetadata_content_PdfContent {
  __typename: "PdfContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Determines if subject content is visible in a collection
   */
  visibilityForCollection: Visibility | null;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Content creator
   */
  creator: CollectionContentForRedirectAndMetadata_content_PdfContent_creator;
  /**
   * Activate PDF download
   */
  canDownload: boolean | null;
}

export type CollectionContentForRedirectAndMetadata_content = CollectionContentForRedirectAndMetadata_content_AudioContent | CollectionContentForRedirectAndMetadata_content_PdfContent;

export interface CollectionContentForRedirectAndMetadata_collection_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Internal code
   */
  code: string;
}

export interface CollectionContentForRedirectAndMetadata_collection_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Brand Name for white label
   */
  brandName: string | null;
  /**
   * Small squared logo for white label
   */
  brandLogoSmall: any | null;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
}

export interface CollectionContentForRedirectAndMetadata_collection_creator {
  __typename: "User";
  id: string;
  subscriptionPlan: CollectionContentForRedirectAndMetadata_collection_creator_subscriptionPlan;
  workspace: CollectionContentForRedirectAndMetadata_collection_creator_workspace | null;
}

export interface CollectionContentForRedirectAndMetadata_collection {
  __typename: "BlendedCollection" | "MixedCollection" | "VideoCollection";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  preparatory: string | null;
  /**
   * Defines if current user has a specific permission on the collection
   */
  canRead: boolean;
  /**
   * Defines if current user has a specific permission on the collection
   */
  canKeepAccess: boolean;
  selling: boolean;
  sellingPricing: number | null;
  sellingMethod: string | null;
  /**
   * When visibility is public and this flag is set to true require registration to view all content
   */
  need_registration: boolean | null;
  /**
   * Collection creator
   */
  creator: CollectionContentForRedirectAndMetadata_collection_creator;
}

export interface CollectionContentForRedirectAndMetadata {
  /**
   * Get a content, identified by id or by slug,
   * optionally an authorization token can be used to enable access for current user.
   */
  content: CollectionContentForRedirectAndMetadata_content | null;
  /**
   * Get a collection, identified by id or by slug,
   * optionally an authorization token can be used to enable access for current user.
   */
  collection: CollectionContentForRedirectAndMetadata_collection | null;
}

export interface CollectionContentForRedirectAndMetadataVariables {
  identifier: string;
  token?: string | null;
  collectionIdentifier: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: ContentPositionSSR
// ====================================================

export interface ContentPositionSSR {
  getPosition: any | null;
}

export interface ContentPositionSSRVariables {
  collectionIdentifier: string;
  contentIdentifier: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetCollectionStats
// ====================================================

export interface GetCollectionStats_collection_visitsByWeek {
  __typename: "AnalyticsVisitsByWeek";
  week: string;
  total: number;
}

export interface GetCollectionStats_collection_visitorsByWeek {
  __typename: "AnalyticsVisitsByWeek";
  week: string;
  total: number;
}

export interface GetCollectionStats_collection_completionStats {
  __typename: "ElementCompletionStats";
  /**
   * Authorized users (excluding the creator) who have opened the element.
   */
  opened: number;
  /**
   * Pending invites plus authorized users who have not opened the element.
   */
  notOpened: number;
  /**
   * Authorized users who have completed the element.
   */
  completed: number;
  /**
   * Authorized users who completed the element during the current ISO week.
   */
  completedThisWeek: number;
  /**
   * Total authorizations (excluding the creator) plus pending invites.
   */
  total: number;
}

export interface GetCollectionStats_collection {
  __typename: "BlendedCollection" | "MixedCollection" | "VideoCollection";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Defines if current user has a specific permission on the collection
   */
  canManage: boolean;
  /**
   * Main title
   */
  title: string;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * Total visitors to the collection
   */
  totalVisitors: number;
  /**
   * Total visits to the collection
   */
  totalVisits: number;
  /**
   * Visits by week
   */
  visitsByWeek: GetCollectionStats_collection_visitsByWeek[];
  /**
   * Visitors by week
   */
  visitorsByWeek: GetCollectionStats_collection_visitorsByWeek[];
  /**
   * Aggregated completion counts for the authorization list, computed server-side (constant with respect to the number of authorized users).
   */
  completionStats: GetCollectionStats_collection_completionStats;
}

export interface GetCollectionStats {
  /**
   * Timestamp of the last data-warehouse refresh backing the stats pages and the CSV report dialog. Global (identical for every content/collection); null when the warehouse is unavailable or when neither warehouse-backed feature (stats, reports) is enabled.
   */
  statsLastUpdate: any | null;
  /**
   * Get a collection, identified by id or by slug,
   * optionally an authorization token can be used to enable access for current user.
   */
  collection: GetCollectionStats_collection | null;
}

export interface GetCollectionStatsVariables {
  idString: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: CollectionForMetadata
// ====================================================

export interface CollectionForMetadata_collection_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface CollectionForMetadata_collection_creator_workspace_user {
  __typename: "User";
  id: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
}

export interface CollectionForMetadata_collection_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
  /**
   * Brand Name for white label
   */
  brandName: string | null;
  /**
   * Small squared logo for white label
   */
  brandLogoSmall: any | null;
  /**
   * Who created the workspace (or first related user if creator is null)
   */
  user: CollectionForMetadata_collection_creator_workspace_user | null;
}

export interface CollectionForMetadata_collection_creator {
  __typename: "User";
  /**
   * Self description of the user
   */
  bio: string | null;
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: CollectionForMetadata_collection_creator_subscriptionPlan;
  /**
   * Main email address
   */
  email: any;
  workspace: CollectionForMetadata_collection_creator_workspace | null;
}

export interface CollectionForMetadata_collection {
  __typename: "BlendedCollection" | "MixedCollection" | "VideoCollection";
  /**
   * Defines if current user has a specific permission on the collection
   */
  canManage: boolean;
  /**
   * Defines if current user has a specific permission on the collection
   */
  canRead: boolean;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Main title
   */
  title: string;
  selling: boolean;
  sellingMethod: string | null;
  sellingPricing: number | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  collectionDisplayStatus: CollectionDisplayStatus;
  /**
   * When visibility is public and this flag is set to true require registration to view all content
   */
  need_registration: boolean | null;
  /**
   * Collection creator
   */
  creator: CollectionForMetadata_collection_creator;
}

export interface CollectionForMetadata_me_contents_pageInfo {
  __typename: "PageInfo";
  /**
   * Total number of nodes in the paginated connection.
   */
  total: number;
}

export interface CollectionForMetadata_me_contents {
  __typename: "ContentConnection";
  /**
   * Pagination information about the list of edges.
   */
  pageInfo: CollectionForMetadata_me_contents_pageInfo;
}

export interface CollectionForMetadata_me {
  __typename: "User";
  /**
   * Contents managed by the user
   */
  contents: CollectionForMetadata_me_contents;
  id: string;
}

export interface CollectionForMetadata {
  /**
   * Get a collection, identified by id or by slug,
   * optionally an authorization token can be used to enable access for current user.
   */
  collection: CollectionForMetadata_collection | null;
  /**
   * Currently authenticated user
   */
  me: CollectionForMetadata_me | null;
}

export interface CollectionForMetadataVariables {
  identifier: string;
  token?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetContentStats
// ====================================================

export interface GetContentStats_content_visitsByWeek {
  __typename: "AnalyticsVisitsByWeek";
  week: string;
  total: number;
}

export interface GetContentStats_content_visitorsByWeek {
  __typename: "AnalyticsVisitsByWeek";
  week: string;
  total: number;
}

export interface GetContentStats_content_completionStats {
  __typename: "ElementCompletionStats";
  /**
   * Authorized users (excluding the creator) who have opened the element.
   */
  opened: number;
  /**
   * Pending invites plus authorized users who have not opened the element.
   */
  notOpened: number;
  /**
   * Authorized users who have completed the element.
   */
  completed: number;
  /**
   * Authorized users who completed the element during the current ISO week.
   */
  completedThisWeek: number;
  /**
   * Total authorizations (excluding the creator) plus pending invites.
   */
  total: number;
}

export interface GetContentStats_content {
  __typename: "AudioContent" | "EventContent" | "ImageContent" | "LinkContent" | "PdfContent" | "QuizContent" | "ScormContent" | "TextContent" | "VideoContent";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Main title
   */
  title: string;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * Total visitors to the content
   */
  totalVisitors: number;
  /**
   * Total visits to the content
   */
  totalVisits: number;
  /**
   * Total visits by week
   */
  visitsByWeek: GetContentStats_content_visitsByWeek[];
  /**
   * Visitors by week
   */
  visitorsByWeek: GetContentStats_content_visitorsByWeek[];
  /**
   * Aggregated completion counts for the authorization list, computed server-side (constant with respect to the number of authorized users).
   */
  completionStats: GetContentStats_content_completionStats;
}

export interface GetContentStats {
  /**
   * Timestamp of the last data-warehouse refresh backing the stats pages and the CSV report dialog. Global (identical for every content/collection); null when the warehouse is unavailable or when neither warehouse-backed feature (stats, reports) is enabled.
   */
  statsLastUpdate: any | null;
  /**
   * Get a content, identified by id or by slug,
   * optionally an authorization token can be used to enable access for current user.
   */
  content: GetContentStats_content | null;
}

export interface GetContentStatsVariables {
  idString: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: ContentForRedirectAndMetadata
// ====================================================

export interface ContentForRedirectAndMetadata_content_AudioContent_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface ContentForRedirectAndMetadata_content_AudioContent_creator_workspace_user {
  __typename: "User";
  id: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
}

export interface ContentForRedirectAndMetadata_content_AudioContent_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
  /**
   * Brand Name for white label
   */
  brandName: string | null;
  /**
   * Small squared logo for white label
   */
  brandLogoSmall: any | null;
  /**
   * Who created the workspace (or first related user if creator is null)
   */
  user: ContentForRedirectAndMetadata_content_AudioContent_creator_workspace_user | null;
}

export interface ContentForRedirectAndMetadata_content_AudioContent_creator {
  __typename: "User";
  /**
   * Self description of the user
   */
  bio: string | null;
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: ContentForRedirectAndMetadata_content_AudioContent_creator_subscriptionPlan;
  /**
   * Main email address
   */
  email: any;
  workspace: ContentForRedirectAndMetadata_content_AudioContent_creator_workspace | null;
}

export interface ContentForRedirectAndMetadata_content_AudioContent {
  __typename: "AudioContent" | "EventContent" | "ImageContent" | "LinkContent" | "QuizContent" | "ScormContent" | "TextContent" | "VideoContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Destination link
   */
  url: any | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  displayStatus: ContentDisplayStatus;
  /**
   * When visibility is public and this flag is set to true require registration to view all content
   */
  need_registration: boolean | null;
  /**
   * Id of the saved collection copy (in the user's workspace) this content was copied as part of; null if the content is not a copy or was saved individually
   */
  parentSavedCollectionId: string | null;
  /**
   * Content creator
   */
  creator: ContentForRedirectAndMetadata_content_AudioContent_creator;
}

export interface ContentForRedirectAndMetadata_content_PdfContent_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface ContentForRedirectAndMetadata_content_PdfContent_creator_workspace_user {
  __typename: "User";
  id: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
}

export interface ContentForRedirectAndMetadata_content_PdfContent_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
  /**
   * Brand Name for white label
   */
  brandName: string | null;
  /**
   * Small squared logo for white label
   */
  brandLogoSmall: any | null;
  /**
   * Who created the workspace (or first related user if creator is null)
   */
  user: ContentForRedirectAndMetadata_content_PdfContent_creator_workspace_user | null;
}

export interface ContentForRedirectAndMetadata_content_PdfContent_creator {
  __typename: "User";
  /**
   * Self description of the user
   */
  bio: string | null;
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: ContentForRedirectAndMetadata_content_PdfContent_creator_subscriptionPlan;
  /**
   * Main email address
   */
  email: any;
  workspace: ContentForRedirectAndMetadata_content_PdfContent_creator_workspace | null;
}

export interface ContentForRedirectAndMetadata_content_PdfContent {
  __typename: "PdfContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Destination link
   */
  url: any | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  displayStatus: ContentDisplayStatus;
  /**
   * When visibility is public and this flag is set to true require registration to view all content
   */
  need_registration: boolean | null;
  /**
   * Id of the saved collection copy (in the user's workspace) this content was copied as part of; null if the content is not a copy or was saved individually
   */
  parentSavedCollectionId: string | null;
  /**
   * Content creator
   */
  creator: ContentForRedirectAndMetadata_content_PdfContent_creator;
  /**
   * Activate PDF download
   */
  canDownload: boolean | null;
}

export type ContentForRedirectAndMetadata_content = ContentForRedirectAndMetadata_content_AudioContent | ContentForRedirectAndMetadata_content_PdfContent;

export interface ContentForRedirectAndMetadata {
  /**
   * Get a content, identified by id or by slug,
   * optionally an authorization token can be used to enable access for current user.
   */
  content: ContentForRedirectAndMetadata_content | null;
}

export interface ContentForRedirectAndMetadataVariables {
  identifier: string;
  token?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: FolderForMetadata
// ====================================================

export interface FolderForMetadata_folder_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface FolderForMetadata_folder_creator_workspace_user {
  __typename: "User";
  id: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
}

export interface FolderForMetadata_folder_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
  /**
   * Brand Name for white label
   */
  brandName: string | null;
  /**
   * Small squared logo for white label
   */
  brandLogoSmall: any | null;
  /**
   * Who created the workspace (or first related user if creator is null)
   */
  user: FolderForMetadata_folder_creator_workspace_user | null;
}

export interface FolderForMetadata_folder_creator {
  __typename: "User";
  /**
   * Self description of the user
   */
  bio: string | null;
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: FolderForMetadata_folder_creator_subscriptionPlan;
  /**
   * Main email address
   */
  email: any;
  workspace: FolderForMetadata_folder_creator_workspace | null;
}

export interface FolderForMetadata_folder {
  __typename: "Folder";
  canManage: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Folder creator
   */
  creator: FolderForMetadata_folder_creator;
}

export interface FolderForMetadata_me {
  __typename: "User";
  id: string;
}

export interface FolderForMetadata {
  /**
   * Get a folder, identified by id or by slug,
   * optionally an authorization token can be used to enable access for current user.
   */
  folder: FolderForMetadata_folder | null;
  /**
   * Currently authenticated user
   */
  me: FolderForMetadata_me | null;
}

export interface FolderForMetadataVariables {
  identifier: string;
  token?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetWorkspaceSlugById
// ====================================================

export interface GetWorkspaceSlugById_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Slug
   */
  slug: string | null;
}

export interface GetWorkspaceSlugById {
  workspace: GetWorkspaceSlugById_workspace | null;
}

export interface GetWorkspaceSlugByIdVariables {
  workspaceId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetLoggedUserWorkspace
// ====================================================

export interface GetLoggedUserWorkspace_user_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Slug
   */
  slug: string | null;
}

export interface GetLoggedUserWorkspace_user {
  __typename: "User";
  id: string;
  workspace: GetLoggedUserWorkspace_user_workspace | null;
}

export interface GetLoggedUserWorkspace {
  /**
   * Currently authenticated user
   */
  user: GetLoggedUserWorkspace_user | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetCollectionVisibility
// ====================================================

export interface GetCollectionVisibility_collection {
  __typename: "BlendedCollection" | "MixedCollection" | "VideoCollection";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
}

export interface GetCollectionVisibility {
  /**
   * Get a collection, identified by id or by slug,
   * optionally an authorization token can be used to enable access for current user.
   */
  collection: GetCollectionVisibility_collection | null;
}

export interface GetCollectionVisibilityVariables {
  identifier: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetContentVisibility
// ====================================================

export interface GetContentVisibility_content {
  __typename: "AudioContent" | "EventContent" | "ImageContent" | "LinkContent" | "PdfContent" | "QuizContent" | "ScormContent" | "TextContent" | "VideoContent";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
}

export interface GetContentVisibility {
  /**
   * Get a content, identified by id or by slug,
   * optionally an authorization token can be used to enable access for current user.
   */
  content: GetContentVisibility_content | null;
}

export interface GetContentVisibilityVariables {
  identifier: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetWorkspaceBySlug
// ====================================================

export interface GetWorkspaceBySlug_workspaceBySlug_user {
  __typename: "User";
  id: string;
  /**
   * First name
   */
  firstname: string;
  /**
   * Last name
   */
  lastname: string;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * Personal slogan
   */
  payoff: string | null;
  /**
   * User banner
   */
  banner: any | null;
}

export interface GetWorkspaceBySlug_workspaceBySlug {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Brand Name for white label
   */
  brandName: string | null;
  /**
   * Small squared logo for white label
   */
  brandLogoSmall: any | null;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
  /**
   * Who created the workspace (or first related user if creator is null)
   */
  user: GetWorkspaceBySlug_workspaceBySlug_user | null;
}

export interface GetWorkspaceBySlug {
  workspaceBySlug: GetWorkspaceBySlug_workspaceBySlug | null;
}

export interface GetWorkspaceBySlugVariables {
  slug: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetCertificatesCreatedByMyself
// ====================================================

export interface GetCertificatesCreatedByMyself_user_certificates_edges_node {
  __typename: "Certificate";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Main title
   */
  title: string;
  /**
   * First phrase
   */
  type: string | null;
  /**
   * First phrase
   */
  first_phrase: string | null;
  /**
   * Second phrase
   */
  second_phrase: string | null;
  /**
   * Third phrase
   */
  third_phrase: string | null;
  /**
   * Background image
   */
  background_image: any | null;
  /**
   * Notes of the current user about this collection
   */
  note: string | null;
}

export interface GetCertificatesCreatedByMyself_user_certificates_edges {
  __typename: "CertificateEdge";
  /**
   * The Certificate node.
   */
  node: GetCertificatesCreatedByMyself_user_certificates_edges_node;
}

export interface GetCertificatesCreatedByMyself_user_certificates {
  __typename: "CertificateConnection";
  /**
   * A list of Certificate edges.
   */
  edges: GetCertificatesCreatedByMyself_user_certificates_edges[];
}

export interface GetCertificatesCreatedByMyself_user {
  __typename: "User";
  id: string;
  /**
   * Certificates created by the user
   */
  certificates: GetCertificatesCreatedByMyself_user_certificates;
}

export interface GetCertificatesCreatedByMyself {
  /**
   * Currently authenticated user
   */
  user: GetCertificatesCreatedByMyself_user | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetCollectionId
// ====================================================

export interface GetCollectionId_collection {
  __typename: "BlendedCollection" | "MixedCollection" | "VideoCollection";
  /**
   * Unique identifier
   */
  id: string;
}

export interface GetCollectionId {
  /**
   * Get a collection, identified by id or by slug,
   * optionally an authorization token can be used to enable access for current user.
   */
  collection: GetCollectionId_collection | null;
}

export interface GetCollectionIdVariables {
  identifier: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetContentId
// ====================================================

export interface GetContentId_content {
  __typename: "AudioContent" | "EventContent" | "ImageContent" | "LinkContent" | "PdfContent" | "QuizContent" | "ScormContent" | "TextContent" | "VideoContent";
  /**
   * Unique identifier
   */
  id: string;
}

export interface GetContentId {
  /**
   * Get a content, identified by id or by slug,
   * optionally an authorization token can be used to enable access for current user.
   */
  content: GetContentId_content | null;
}

export interface GetContentIdVariables {
  identifier: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetUserByID
// ====================================================

export interface GetUserByID_user {
  __typename: "User";
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Main email address
   */
  email: any;
}

export interface GetUserByID {
  user: GetUserByID_user | null;
}

export interface GetUserByIDVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetUserByVanityName
// ====================================================

export interface GetUserByVanityName_userByFields_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Brand Name for white label
   */
  brandName: string | null;
  /**
   * Small squared logo for white label
   */
  brandLogoSmall: any | null;
}

export interface GetUserByVanityName_userByFields_preferences {
  __typename: "UserPreferences";
  hideMessageCreator: boolean;
}

export interface GetUserByVanityName_userByFields_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Internal code
   */
  code: string;
}

export interface GetUserByVanityName_userByFields {
  __typename: "User";
  /**
   * Self description of the user
   */
  bio: string | null;
  /**
   * First name
   */
  firstname: string;
  id: string;
  /**
   * Main email address
   */
  email: any;
  /**
   * Last name
   */
  lastname: string;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  /**
   * Profile page
   */
  linkedin: any | null;
  /**
   * Profile page
   */
  facebook: any | null;
  /**
   * Profile page
   */
  instagram: any | null;
  /**
   * Profile page
   */
  twitter: any | null;
  /**
   * User banner
   */
  banner: any | null;
  /**
   * Personal slogan
   */
  payoff: string | null;
  /**
   * Custom route
   */
  vanity_name: string | null;
  workspace: GetUserByVanityName_userByFields_workspace | null;
  preferences: GetUserByVanityName_userByFields_preferences;
  /**
   * User location (e.g., City, Country)
   */
  location: string | null;
  /**
   * User professional category
   */
  category: UserCategory | null;
  subscriptionPlan: GetUserByVanityName_userByFields_subscriptionPlan;
}

export interface GetUserByVanityName {
  userByFields: GetUserByVanityName_userByFields | null;
}

export interface GetUserByVanityNameVariables {
  fields: UserField[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GET_USER_EMAIL
// ====================================================

export interface GET_USER_EMAIL_me {
  __typename: "User";
  /**
   * Main email address
   */
  email: any;
}

export interface GET_USER_EMAIL {
  /**
   * Currently authenticated user
   */
  me: GET_USER_EMAIL_me | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetWorkspace
// ====================================================

export interface GetWorkspace_workspaceBySlug_user {
  __typename: "User";
  id: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
}

export interface GetWorkspace_workspaceBySlug {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Small squared logo for white label
   */
  brandLogoSmall: any | null;
  /**
   * Brand Name for white label
   */
  brandName: string | null;
  /**
   * Slug
   */
  slug: string | null;
  /**
   * Who created the workspace (or first related user if creator is null)
   */
  user: GetWorkspace_workspaceBySlug_user | null;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
}

export interface GetWorkspace {
  workspaceBySlug: GetWorkspace_workspaceBySlug | null;
}

export interface GetWorkspaceVariables {
  slug: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetWorkspacesListForUserOnWorkspacePage
// ====================================================

export interface GetWorkspacesListForUserOnWorkspacePage_workspacesListForUser {
  __typename: "UserWorkspacePayload";
  id: string;
  slug: string;
  autologin_link: any;
}

export interface GetWorkspacesListForUserOnWorkspacePage {
  workspacesListForUser: GetWorkspacesListForUserOnWorkspacePage_workspacesListForUser[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetLoggedUserWorkspaceForRedirect
// ====================================================

export interface GetLoggedUserWorkspaceForRedirect_user_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Slug
   */
  slug: string | null;
}

export interface GetLoggedUserWorkspaceForRedirect_user {
  __typename: "User";
  id: string;
  workspace: GetLoggedUserWorkspaceForRedirect_user_workspace | null;
}

export interface GetLoggedUserWorkspaceForRedirect {
  /**
   * Currently authenticated user
   */
  user: GetLoggedUserWorkspaceForRedirect_user | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetWorkspaceSwitchInfo
// ====================================================

export interface GetWorkspaceSwitchInfo_workspaceSwitchInfo {
  __typename: "UserWorkspacePayload";
  role: string;
  autologin_link: any;
}

export interface GetWorkspaceSwitchInfo {
  workspaceSwitchInfo: GetWorkspaceSwitchInfo_workspaceSwitchInfo;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: CurrentUserFoldersForCollection
// ====================================================

export interface CurrentUserFoldersForCollection_me_userFolders {
  __typename: "Folder";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Determines if a content or collection is included in subject folder (checks both parent_folder_id and associations)
   */
  includes: boolean;
  /**
   * Determines if a content or collection has an explicit association with the folder (excludes parent_folder_id)
   */
  hasAssociation: boolean;
}

export interface CurrentUserFoldersForCollection_me {
  __typename: "User";
  /**
   * Folders the user manages. With elementId, only the folders where that
   * element can be placed, by association or move: the folders of its workspace.
   */
  userFolders: CurrentUserFoldersForCollection_me_userFolders[];
  id: string;
}

export interface CurrentUserFoldersForCollection {
  /**
   * Currently authenticated user
   */
  me: CurrentUserFoldersForCollection_me | null;
}

export interface CurrentUserFoldersForCollectionVariables {
  includes: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ToggleCollectionFolderAssociation
// ====================================================

export interface ToggleCollectionFolderAssociation {
  toggleCollectionFolderAssociation: boolean;
}

export interface ToggleCollectionFolderAssociationVariables {
  collectionId: string;
  folderId: string;
  associated: boolean;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: GenerateAuthorizationTokenForCollection
// ====================================================

export interface GenerateAuthorizationTokenForCollection {
  token: string;
}

export interface GenerateAuthorizationTokenForCollectionVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: CurrentUserCollections
// ====================================================

export interface CurrentUserCollections_me_collections_edges_node_modules_edges_node {
  __typename: "Module";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Determines if a content is included in subject module
   */
  includes: boolean;
}

export interface CurrentUserCollections_me_collections_edges_node_modules_edges {
  __typename: "ModuleEdge";
  /**
   * The Module node.
   */
  node: CurrentUserCollections_me_collections_edges_node_modules_edges_node;
}

export interface CurrentUserCollections_me_collections_edges_node_modules {
  __typename: "ModuleConnection";
  /**
   * A list of Module edges.
   */
  edges: CurrentUserCollections_me_collections_edges_node_modules_edges[];
}

export interface CurrentUserCollections_me_collections_edges_node {
  __typename: "BlendedCollection" | "MixedCollection" | "VideoCollection";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Determines if a content is included in subject collection
   */
  includes: boolean;
  /**
   * Main title
   */
  title: string;
  /**
   * List of all the modules included in subject collection
   */
  modules: CurrentUserCollections_me_collections_edges_node_modules | null;
}

export interface CurrentUserCollections_me_collections_edges {
  __typename: "CollectionEdge";
  /**
   * The Collection node.
   */
  node: CurrentUserCollections_me_collections_edges_node;
}

export interface CurrentUserCollections_me_collections_pageInfo {
  __typename: "PageInfo";
  /**
   * When paginating forwards, are there more items?
   */
  hasNextPage: boolean;
  /**
   * The cursor to continue paginating forwards.
   */
  endCursor: string | null;
}

export interface CurrentUserCollections_me_collections {
  __typename: "CollectionConnection";
  /**
   * A list of Collection edges.
   */
  edges: CurrentUserCollections_me_collections_edges[];
  /**
   * Pagination information about the list of edges.
   */
  pageInfo: CurrentUserCollections_me_collections_pageInfo;
}

export interface CurrentUserCollections_me {
  __typename: "User";
  /**
   * Collections managed by the user
   */
  collections: CurrentUserCollections_me_collections;
  id: string;
}

export interface CurrentUserCollections {
  /**
   * Currently authenticated user
   */
  me: CurrentUserCollections_me | null;
}

export interface CurrentUserCollectionsVariables {
  includes: string;
  visibility?: Visibility[] | null;
  after?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ToggleContentCollectionAssociation
// ====================================================

export interface ToggleContentCollectionAssociation {
  toggleContentCollectionAssociation: boolean;
}

export interface ToggleContentCollectionAssociationVariables {
  associated: boolean;
  collectionId: string;
  contentId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: CurrentUserFoldersForContent
// ====================================================

export interface CurrentUserFoldersForContent_me_userFolders {
  __typename: "Folder";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Determines if a content or collection is included in subject folder (checks both parent_folder_id and associations)
   */
  includes: boolean;
  /**
   * Determines if a content or collection has an explicit association with the folder (excludes parent_folder_id)
   */
  hasAssociation: boolean;
}

export interface CurrentUserFoldersForContent_me {
  __typename: "User";
  /**
   * Folders the user manages. With elementId, only the folders where that
   * element can be placed, by association or move: the folders of its workspace.
   */
  userFolders: CurrentUserFoldersForContent_me_userFolders[];
  id: string;
}

export interface CurrentUserFoldersForContent {
  /**
   * Currently authenticated user
   */
  me: CurrentUserFoldersForContent_me | null;
}

export interface CurrentUserFoldersForContentVariables {
  includes: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ToggleContentFolderAssociation
// ====================================================

export interface ToggleContentFolderAssociation {
  toggleContentFolderAssociation: boolean;
}

export interface ToggleContentFolderAssociationVariables {
  contentId: string;
  folderId: string;
  associated: boolean;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: AddToCalendarData
// ====================================================

export interface AddToCalendarData_content_AudioContent {
  __typename: "AudioContent" | "ImageContent" | "LinkContent" | "PdfContent" | "QuizContent" | "ScormContent" | "TextContent" | "VideoContent";
  /**
   * Unique identifier
   */
  id: string;
}

export interface AddToCalendarData_content_EventContent {
  __typename: "EventContent";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Main description, if given
   */
  description: string | null;
  end: any | null;
  location: string | null;
  start: any | null;
  /**
   * Main title
   */
  title: string;
  /**
   * Destination link
   */
  url: any | null;
}

export type AddToCalendarData_content = AddToCalendarData_content_AudioContent | AddToCalendarData_content_EventContent;

export interface AddToCalendarData {
  /**
   * Get a content, identified by id or by slug,
   * optionally an authorization token can be used to enable access for current user.
   */
  content: AddToCalendarData_content | null;
}

export interface AddToCalendarDataVariables {
  identifier: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ConfirmCancelEvent
// ====================================================

export interface ConfirmCancelEvent_cancelEventContent_registeredUsers {
  __typename: "User";
  id: string;
}

export interface ConfirmCancelEvent_cancelEventContent_coverDimensions {
  __typename: "CoverDimensions";
  height: number | null;
  width: number | null;
}

export interface ConfirmCancelEvent_cancelEventContent_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface ConfirmCancelEvent_cancelEventContent_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
}

export interface ConfirmCancelEvent_cancelEventContent_creator {
  __typename: "User";
  /**
   * Self description of the user
   */
  bio: string | null;
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: ConfirmCancelEvent_cancelEventContent_creator_subscriptionPlan;
  /**
   * Main email address
   */
  email: any;
  workspace: ConfirmCancelEvent_cancelEventContent_creator_workspace | null;
}

export interface ConfirmCancelEvent_cancelEventContent_originalCreator {
  __typename: "User";
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
}

export interface ConfirmCancelEvent_cancelEventContent {
  __typename: "EventContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  expired: any | null;
  isCurrentUserRegistered: boolean;
  participants: number | null;
  registeredUsers: ConfirmCancelEvent_cancelEventContent_registeredUsers[];
  registration: boolean;
  status: EventContentStatus;
  /**
   * Content subtype
   */
  subtype: EventContentSubtype;
  /**
   * Destination link
   */
  url: any | null;
  end: any | null;
  start: any | null;
  location: string | null;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: ConfirmCancelEvent_cancelEventContent_coverDimensions | null;
  /**
   * Content creator
   */
  creator: ConfirmCancelEvent_cancelEventContent_creator;
  /**
   * Creator of the original content this is a copy of (null if this is not a copy)
   */
  originalCreator: ConfirmCancelEvent_cancelEventContent_originalCreator | null;
  hasUserCompleted: boolean | null;
  /**
   * Main description, if given
   */
  description: string | null;
  displayStatus: ContentDisplayStatus;
  label: string | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  tags: string[];
  /**
   * Main title
   */
  title: string;
}

export interface ConfirmCancelEvent {
  cancelEventContent: ConfirmCancelEvent_cancelEventContent;
}

export interface ConfirmCancelEventVariables {
  id: string;
  userId?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: RelatedContentsList
// ====================================================

export interface RelatedContentsList_content_relatedContents {
  __typename: "AudioContent" | "EventContent" | "ImageContent" | "LinkContent" | "PdfContent" | "QuizContent" | "ScormContent" | "TextContent" | "VideoContent";
  /**
   * Unique identifier
   */
  id: string;
}

export interface RelatedContentsList_content {
  __typename: "AudioContent" | "EventContent" | "ImageContent" | "LinkContent" | "PdfContent" | "QuizContent" | "ScormContent" | "TextContent" | "VideoContent";
  /**
   * Unique identifier
   */
  id: string;
  relatedContents: RelatedContentsList_content_relatedContents[];
}

export interface RelatedContentsList_user_contents_edges_node {
  __typename: "AudioContent" | "EventContent" | "ImageContent" | "LinkContent" | "PdfContent" | "QuizContent" | "ScormContent" | "TextContent" | "VideoContent";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Main title
   */
  title: string;
}

export interface RelatedContentsList_user_contents_edges {
  __typename: "ContentEdge";
  /**
   * The Content node.
   */
  node: RelatedContentsList_user_contents_edges_node;
}

export interface RelatedContentsList_user_contents {
  __typename: "ContentConnection";
  /**
   * A list of Content edges.
   */
  edges: RelatedContentsList_user_contents_edges[];
}

export interface RelatedContentsList_user {
  __typename: "User";
  /**
   * Contents managed by the user
   */
  contents: RelatedContentsList_user_contents;
  id: string;
}

export interface RelatedContentsList {
  /**
   * Get a content, identified by id or by slug,
   * optionally an authorization token can be used to enable access for current user.
   */
  content: RelatedContentsList_content | null;
  /**
   * Currently authenticated user
   */
  user: RelatedContentsList_user | null;
}

export interface RelatedContentsListVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ToggleRelatedContentAssociation
// ====================================================

export interface ToggleRelatedContentAssociation_toggleRelatedContentsAssociation_relatedContents_EventContent {
  __typename: "EventContent" | "ScormContent";
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
}

export interface ToggleRelatedContentAssociation_toggleRelatedContentsAssociation_relatedContents_AudioContent {
  __typename: "AudioContent";
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Total duration in seconds
   */
  duration: number | null;
}

export interface ToggleRelatedContentAssociation_toggleRelatedContentsAssociation_relatedContents_ImageContent {
  __typename: "ImageContent";
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
}

export interface ToggleRelatedContentAssociation_toggleRelatedContentsAssociation_relatedContents_LinkContent {
  __typename: "LinkContent";
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Destination domain
   */
  domain: string | null;
  /**
   * Total duration in seconds, alias of embed.estimatedReadingTime
   */
  duration: number | null;
}

export interface ToggleRelatedContentAssociation_toggleRelatedContentsAssociation_relatedContents_PdfContent_pdfDetails {
  __typename: "PdfDetails";
  pages: number;
}

export interface ToggleRelatedContentAssociation_toggleRelatedContentsAssociation_relatedContents_PdfContent {
  __typename: "PdfContent";
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Total duration in seconds, alias of pdfDetails.estimatedReadingTime
   */
  duration: number | null;
  /**
   * PDF document additional details
   */
  pdfDetails: ToggleRelatedContentAssociation_toggleRelatedContentsAssociation_relatedContents_PdfContent_pdfDetails | null;
  /**
   * Activate PDF download
   */
  canDownload: boolean | null;
}

export interface ToggleRelatedContentAssociation_toggleRelatedContentsAssociation_relatedContents_QuizContent_questions {
  __typename: "QuizContentQuestionEssay" | "QuizContentQuestionMatching" | "QuizContentQuestionMissingWord" | "QuizContentQuestionMultipleChoice" | "QuizContentQuestionNumerical" | "QuizContentQuestionSingleChoice" | "QuizContentQuestionTrueFalse";
}

export interface ToggleRelatedContentAssociation_toggleRelatedContentsAssociation_relatedContents_QuizContent {
  __typename: "QuizContent";
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  questions: ToggleRelatedContentAssociation_toggleRelatedContentsAssociation_relatedContents_QuizContent_questions[];
}

export interface ToggleRelatedContentAssociation_toggleRelatedContentsAssociation_relatedContents_TextContent {
  __typename: "TextContent";
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Total duration in seconds, alias of pdfDetails.estimatedReadingTime
   */
  duration: number | null;
}

export interface ToggleRelatedContentAssociation_toggleRelatedContentsAssociation_relatedContents_VideoContent {
  __typename: "VideoContent";
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Total duration in seconds
   */
  duration: number | null;
  /**
   * Destination link
   */
  url: any | null;
  /**
   * Cover picture
   */
  cover: any | null;
  aspectRatio: string | null;
}

export type ToggleRelatedContentAssociation_toggleRelatedContentsAssociation_relatedContents = ToggleRelatedContentAssociation_toggleRelatedContentsAssociation_relatedContents_EventContent | ToggleRelatedContentAssociation_toggleRelatedContentsAssociation_relatedContents_AudioContent | ToggleRelatedContentAssociation_toggleRelatedContentsAssociation_relatedContents_ImageContent | ToggleRelatedContentAssociation_toggleRelatedContentsAssociation_relatedContents_LinkContent | ToggleRelatedContentAssociation_toggleRelatedContentsAssociation_relatedContents_PdfContent | ToggleRelatedContentAssociation_toggleRelatedContentsAssociation_relatedContents_QuizContent | ToggleRelatedContentAssociation_toggleRelatedContentsAssociation_relatedContents_TextContent | ToggleRelatedContentAssociation_toggleRelatedContentsAssociation_relatedContents_VideoContent;

export interface ToggleRelatedContentAssociation_toggleRelatedContentsAssociation {
  __typename: "AudioContent" | "EventContent" | "ImageContent" | "LinkContent" | "PdfContent" | "QuizContent" | "ScormContent" | "TextContent" | "VideoContent";
  /**
   * Unique identifier
   */
  id: string;
  relatedContents: ToggleRelatedContentAssociation_toggleRelatedContentsAssociation_relatedContents[];
}

export interface ToggleRelatedContentAssociation {
  toggleRelatedContentsAssociation: ToggleRelatedContentAssociation_toggleRelatedContentsAssociation;
}

export interface ToggleRelatedContentAssociationVariables {
  associated: boolean;
  objectId: string;
  subjectId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: GenerateAuthorizationTokenForContent
// ====================================================

export interface GenerateAuthorizationTokenForContent {
  token: string;
}

export interface GenerateAuthorizationTokenForContentVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetApectRatio
// ====================================================

export interface GetApectRatio_content_AudioContent {
  __typename: "AudioContent" | "EventContent" | "ImageContent" | "LinkContent" | "PdfContent" | "QuizContent" | "ScormContent" | "TextContent";
  /**
   * Unique identifier
   */
  id: string;
}

export interface GetApectRatio_content_VideoContent {
  __typename: "VideoContent";
  /**
   * Unique identifier
   */
  id: string;
  aspectRatio: string | null;
}

export type GetApectRatio_content = GetApectRatio_content_AudioContent | GetApectRatio_content_VideoContent;

export interface GetApectRatio {
  /**
   * Get a content, identified by id or by slug,
   * optionally an authorization token can be used to enable access for current user.
   */
  content: GetApectRatio_content | null;
}

export interface GetApectRatioVariables {
  identifier: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: GenerateAuthorizationTokenForFolder
// ====================================================

export interface GenerateAuthorizationTokenForFolder {
  token: string;
}

export interface GenerateAuthorizationTokenForFolderVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: RemoveUserElement
// ====================================================

export interface RemoveUserElement {
  removeUserElement: boolean;
}

export interface RemoveUserElementVariables {
  id: string;
  type: RemoveUserElementType;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AddAuthorizationsGroups
// ====================================================

export interface AddAuthorizationsGroups {
  addAuthorizationsGroups: boolean;
}

export interface AddAuthorizationsGroupsVariables {
  elementId: string;
  groupsIds: string[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AddAuthorization
// ====================================================

export interface AddAuthorization_setAuthorization {
  __typename: "Authorization";
  id: string;
}

export interface AddAuthorization {
  setAuthorization: AddAuthorization_setAuthorization;
}

export interface AddAuthorizationVariables {
  object: string;
  user: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AddAuthorizationsAndInvites
// ====================================================

export interface AddAuthorizationsAndInvites {
  addAuthorizationsAndInvites: boolean;
}

export interface AddAuthorizationsAndInvitesVariables {
  elementId: string;
  emails: any[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: UserForTag
// ====================================================

export interface UserForTag_user {
  __typename: "User";
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
}

export interface UserForTag {
  user: UserForTag_user | null;
}

export interface UserForTagVariables {
  identifier: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: FetchElementAuthorizations
// ====================================================

export interface FetchElementAuthorizations_element_MixedCollection {
  __typename: "MixedCollection" | "BlendedCollection" | "VideoCollection";
  /**
   * Defines if current user has a specific permission on the collection
   */
  canManage: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  selling: boolean;
  sellingPricing: number | null;
  sellingMethod: string | null;
  /**
   * When visibility is public and this flag is set to true require registration to view all content
   */
  need_registration: boolean | null;
}

export interface FetchElementAuthorizations_element_AudioContent {
  __typename: "AudioContent" | "EventContent" | "ImageContent" | "LinkContent" | "PdfContent" | "QuizContent" | "ScormContent" | "TextContent" | "VideoContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * When visibility is public and this flag is set to true require registration to view all content
   */
  need_registration: boolean | null;
}

export interface FetchElementAuthorizations_element_Folder {
  __typename: "Folder";
  canManage: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
}

export type FetchElementAuthorizations_element = FetchElementAuthorizations_element_MixedCollection | FetchElementAuthorizations_element_AudioContent | FetchElementAuthorizations_element_Folder;

export interface FetchElementAuthorizations {
  element: FetchElementAuthorizations_element | null;
}

export interface FetchElementAuthorizationsVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: RemoveAuthorizationGroup
// ====================================================

export interface RemoveAuthorizationGroup {
  removeAuthorizationGroup: boolean;
}

export interface RemoveAuthorizationGroupVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SetAuthorizationGroup
// ====================================================

export interface SetAuthorizationGroup_setAuthorizationGroup {
  __typename: "Authorization";
  id: string;
}

export interface SetAuthorizationGroup {
  setAuthorizationGroup: SetAuthorizationGroup_setAuthorizationGroup;
}

export interface SetAuthorizationGroupVariables {
  groupId: string;
  value: number;
  objectId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: RemoveAuthorization
// ====================================================

export interface RemoveAuthorization {
  removeAuthorization: boolean;
}

export interface RemoveAuthorizationVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SetAuthorization
// ====================================================

export interface SetAuthorization_setAuthorization_object_Folder {
  __typename: "Folder";
}

export interface SetAuthorization_setAuthorization_object_MixedCollection {
  __typename: "MixedCollection" | "BlendedCollection" | "VideoCollection";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Defines if current user has a specific permission on the collection
   */
  canRead: boolean;
}

export interface SetAuthorization_setAuthorization_object_AudioContent {
  __typename: "AudioContent" | "EventContent" | "ImageContent" | "LinkContent" | "PdfContent" | "QuizContent" | "ScormContent" | "TextContent" | "VideoContent";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean;
}

export type SetAuthorization_setAuthorization_object = SetAuthorization_setAuthorization_object_Folder | SetAuthorization_setAuthorization_object_MixedCollection | SetAuthorization_setAuthorization_object_AudioContent;

export interface SetAuthorization_setAuthorization {
  __typename: "Authorization";
  id: string;
  object: SetAuthorization_setAuthorization_object;
}

export interface SetAuthorization {
  setAuthorization: SetAuthorization_setAuthorization;
}

export interface SetAuthorizationVariables {
  object: string;
  user: string;
  value: number;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: RemoveInviteAuthorization
// ====================================================

export interface RemoveInviteAuthorization {
  removeInviteAuthorization: boolean;
}

export interface RemoveInviteAuthorizationVariables {
  elementId: string;
  email: any;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SetInviteAuthorization
// ====================================================

export interface SetInviteAuthorization {
  setInviteAuthorization: boolean;
}

export interface SetInviteAuthorizationVariables {
  elementId: string;
  email: any;
  value: number;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetElementAuthorizationForUsers
// ====================================================

export interface GetElementAuthorizationForUsers_user_emails {
  __typename: "UserEmail";
  email: any;
  id: string;
  primary: boolean;
  verifiedAt: any | null;
}

export interface GetElementAuthorizationForUsers_user {
  __typename: "User";
  emails: GetElementAuthorizationForUsers_user_emails[];
  id: string;
}

export interface GetElementAuthorizationForUsers_element_MixedCollection_paginatedAuthorizations_data_Authorization_user {
  __typename: "User";
  /**
   * Main email address
   */
  email: any;
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
}

export interface GetElementAuthorizationForUsers_element_MixedCollection_paginatedAuthorizations_data_Authorization_authorizationGroup_group {
  __typename: "Group";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Name
   */
  name: string;
  /**
   * Total users in the group
   */
  usersCount: number;
}

export interface GetElementAuthorizationForUsers_element_MixedCollection_paginatedAuthorizations_data_Authorization_authorizationGroup {
  __typename: "AuthorizationGroup";
  id: string;
  group: GetElementAuthorizationForUsers_element_MixedCollection_paginatedAuthorizations_data_Authorization_authorizationGroup_group;
}

export interface GetElementAuthorizationForUsers_element_MixedCollection_paginatedAuthorizations_data_Authorization {
  __typename: "Authorization";
  id: string;
  user: GetElementAuthorizationForUsers_element_MixedCollection_paginatedAuthorizations_data_Authorization_user;
  authorizationGroup: GetElementAuthorizationForUsers_element_MixedCollection_paginatedAuthorizations_data_Authorization_authorizationGroup | null;
  value: number;
}

export interface GetElementAuthorizationForUsers_element_MixedCollection_paginatedAuthorizations_data_Invite {
  __typename: "Invite";
  authorization: number | null;
  id: string;
}

export type GetElementAuthorizationForUsers_element_MixedCollection_paginatedAuthorizations_data = GetElementAuthorizationForUsers_element_MixedCollection_paginatedAuthorizations_data_Authorization | GetElementAuthorizationForUsers_element_MixedCollection_paginatedAuthorizations_data_Invite;

export interface GetElementAuthorizationForUsers_element_MixedCollection_paginatedAuthorizations_paginatorInfo {
  __typename: "PaginatorInfo";
  currentPage: number;
  lastPage: number;
  perPage: number;
  total: number;
  count: number;
  hasMorePages: boolean;
}

export interface GetElementAuthorizationForUsers_element_MixedCollection_paginatedAuthorizations {
  __typename: "PaginatedAuthorizationsAndInvites";
  data: GetElementAuthorizationForUsers_element_MixedCollection_paginatedAuthorizations_data[];
  paginatorInfo: GetElementAuthorizationForUsers_element_MixedCollection_paginatedAuthorizations_paginatorInfo;
}

export interface GetElementAuthorizationForUsers_element_MixedCollection_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface GetElementAuthorizationForUsers_element_MixedCollection_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
}

export interface GetElementAuthorizationForUsers_element_MixedCollection_creator {
  __typename: "User";
  /**
   * Self description of the user
   */
  bio: string | null;
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: GetElementAuthorizationForUsers_element_MixedCollection_creator_subscriptionPlan;
  /**
   * Main email address
   */
  email: any;
  workspace: GetElementAuthorizationForUsers_element_MixedCollection_creator_workspace | null;
}

export interface GetElementAuthorizationForUsers_element_MixedCollection {
  __typename: "MixedCollection" | "BlendedCollection" | "VideoCollection";
  /**
   * Unique identifier
   */
  id: string;
  paginatedAuthorizations: GetElementAuthorizationForUsers_element_MixedCollection_paginatedAuthorizations;
  /**
   * Collection creator
   */
  creator: GetElementAuthorizationForUsers_element_MixedCollection_creator;
}

export interface GetElementAuthorizationForUsers_element_AudioContent_paginatedAuthorizations_data_Authorization_user {
  __typename: "User";
  /**
   * Main email address
   */
  email: any;
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
}

export interface GetElementAuthorizationForUsers_element_AudioContent_paginatedAuthorizations_data_Authorization_authorizationGroup_group {
  __typename: "Group";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Name
   */
  name: string;
  /**
   * Total users in the group
   */
  usersCount: number;
}

export interface GetElementAuthorizationForUsers_element_AudioContent_paginatedAuthorizations_data_Authorization_authorizationGroup {
  __typename: "AuthorizationGroup";
  id: string;
  group: GetElementAuthorizationForUsers_element_AudioContent_paginatedAuthorizations_data_Authorization_authorizationGroup_group;
}

export interface GetElementAuthorizationForUsers_element_AudioContent_paginatedAuthorizations_data_Authorization {
  __typename: "Authorization";
  id: string;
  user: GetElementAuthorizationForUsers_element_AudioContent_paginatedAuthorizations_data_Authorization_user;
  authorizationGroup: GetElementAuthorizationForUsers_element_AudioContent_paginatedAuthorizations_data_Authorization_authorizationGroup | null;
  value: number;
}

export interface GetElementAuthorizationForUsers_element_AudioContent_paginatedAuthorizations_data_Invite {
  __typename: "Invite";
  authorization: number | null;
  id: string;
}

export type GetElementAuthorizationForUsers_element_AudioContent_paginatedAuthorizations_data = GetElementAuthorizationForUsers_element_AudioContent_paginatedAuthorizations_data_Authorization | GetElementAuthorizationForUsers_element_AudioContent_paginatedAuthorizations_data_Invite;

export interface GetElementAuthorizationForUsers_element_AudioContent_paginatedAuthorizations_paginatorInfo {
  __typename: "PaginatorInfo";
  currentPage: number;
  lastPage: number;
  perPage: number;
  total: number;
  count: number;
  hasMorePages: boolean;
}

export interface GetElementAuthorizationForUsers_element_AudioContent_paginatedAuthorizations {
  __typename: "PaginatedAuthorizationsAndInvites";
  data: GetElementAuthorizationForUsers_element_AudioContent_paginatedAuthorizations_data[];
  paginatorInfo: GetElementAuthorizationForUsers_element_AudioContent_paginatedAuthorizations_paginatorInfo;
}

export interface GetElementAuthorizationForUsers_element_AudioContent_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface GetElementAuthorizationForUsers_element_AudioContent_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
}

export interface GetElementAuthorizationForUsers_element_AudioContent_creator {
  __typename: "User";
  /**
   * Self description of the user
   */
  bio: string | null;
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: GetElementAuthorizationForUsers_element_AudioContent_creator_subscriptionPlan;
  /**
   * Main email address
   */
  email: any;
  workspace: GetElementAuthorizationForUsers_element_AudioContent_creator_workspace | null;
}

export interface GetElementAuthorizationForUsers_element_AudioContent {
  __typename: "AudioContent" | "EventContent" | "ImageContent" | "LinkContent" | "PdfContent" | "QuizContent" | "ScormContent" | "TextContent" | "VideoContent";
  /**
   * Unique identifier
   */
  id: string;
  paginatedAuthorizations: GetElementAuthorizationForUsers_element_AudioContent_paginatedAuthorizations;
  /**
   * Content creator
   */
  creator: GetElementAuthorizationForUsers_element_AudioContent_creator;
}

export interface GetElementAuthorizationForUsers_element_Folder_paginatedAuthorizations_data_Authorization_user {
  __typename: "User";
  /**
   * Main email address
   */
  email: any;
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
}

export interface GetElementAuthorizationForUsers_element_Folder_paginatedAuthorizations_data_Authorization_authorizationGroup_group {
  __typename: "Group";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Name
   */
  name: string;
  /**
   * Total users in the group
   */
  usersCount: number;
}

export interface GetElementAuthorizationForUsers_element_Folder_paginatedAuthorizations_data_Authorization_authorizationGroup {
  __typename: "AuthorizationGroup";
  id: string;
  group: GetElementAuthorizationForUsers_element_Folder_paginatedAuthorizations_data_Authorization_authorizationGroup_group;
}

export interface GetElementAuthorizationForUsers_element_Folder_paginatedAuthorizations_data_Authorization {
  __typename: "Authorization";
  id: string;
  user: GetElementAuthorizationForUsers_element_Folder_paginatedAuthorizations_data_Authorization_user;
  authorizationGroup: GetElementAuthorizationForUsers_element_Folder_paginatedAuthorizations_data_Authorization_authorizationGroup | null;
  value: number;
}

export interface GetElementAuthorizationForUsers_element_Folder_paginatedAuthorizations_data_Invite {
  __typename: "Invite";
  authorization: number | null;
  id: string;
}

export type GetElementAuthorizationForUsers_element_Folder_paginatedAuthorizations_data = GetElementAuthorizationForUsers_element_Folder_paginatedAuthorizations_data_Authorization | GetElementAuthorizationForUsers_element_Folder_paginatedAuthorizations_data_Invite;

export interface GetElementAuthorizationForUsers_element_Folder_paginatedAuthorizations_paginatorInfo {
  __typename: "PaginatorInfo";
  currentPage: number;
  lastPage: number;
  perPage: number;
  total: number;
  count: number;
  hasMorePages: boolean;
}

export interface GetElementAuthorizationForUsers_element_Folder_paginatedAuthorizations {
  __typename: "PaginatedAuthorizationsAndInvites";
  data: GetElementAuthorizationForUsers_element_Folder_paginatedAuthorizations_data[];
  paginatorInfo: GetElementAuthorizationForUsers_element_Folder_paginatedAuthorizations_paginatorInfo;
}

export interface GetElementAuthorizationForUsers_element_Folder_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface GetElementAuthorizationForUsers_element_Folder_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
}

export interface GetElementAuthorizationForUsers_element_Folder_creator {
  __typename: "User";
  /**
   * Self description of the user
   */
  bio: string | null;
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: GetElementAuthorizationForUsers_element_Folder_creator_subscriptionPlan;
  /**
   * Main email address
   */
  email: any;
  workspace: GetElementAuthorizationForUsers_element_Folder_creator_workspace | null;
}

export interface GetElementAuthorizationForUsers_element_Folder {
  __typename: "Folder";
  /**
   * Unique identifier
   */
  id: string;
  paginatedAuthorizations: GetElementAuthorizationForUsers_element_Folder_paginatedAuthorizations;
  /**
   * Folder creator
   */
  creator: GetElementAuthorizationForUsers_element_Folder_creator;
}

export type GetElementAuthorizationForUsers_element = GetElementAuthorizationForUsers_element_MixedCollection | GetElementAuthorizationForUsers_element_AudioContent | GetElementAuthorizationForUsers_element_Folder;

export interface GetElementAuthorizationForUsers_knownUsers {
  __typename: "User";
  /**
   * Main email address
   */
  email: any;
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
}

export interface GetElementAuthorizationForUsers {
  /**
   * Currently authenticated user
   */
  user: GetElementAuthorizationForUsers_user | null;
  element: GetElementAuthorizationForUsers_element | null;
  knownUsers: GetElementAuthorizationForUsers_knownUsers[];
}

export interface GetElementAuthorizationForUsersVariables {
  id: string;
  page?: number | null;
  first?: number | null;
  search?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: MoveElementToHomePage
// ====================================================

export interface MoveElementToHomePage {
  moveElementToHome: boolean;
}

export interface MoveElementToHomePageVariables {
  elementId: string;
  type?: ElementToHomeType | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: MoveToTargets
// ====================================================

export interface MoveToTargets_me_userFolders {
  __typename: "Folder";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
}

export interface MoveToTargets_me {
  __typename: "User";
  /**
   * Folders the user manages. With elementId, only the folders where that
   * element can be placed, by association or move: the folders of its workspace.
   */
  userFolders: MoveToTargets_me_userFolders[];
  id: string;
  /**
   * When user registered
   */
  createdAt: any;
}

export interface MoveToTargets {
  /**
   * Currently authenticated user
   */
  me: MoveToTargets_me | null;
}

export interface MoveToTargetsVariables {
  elementId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: ContentNote
// ====================================================

export interface ContentNote_content {
  __typename: "AudioContent" | "EventContent" | "ImageContent" | "LinkContent" | "PdfContent" | "QuizContent" | "ScormContent" | "TextContent" | "VideoContent";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Notes of the current user about this content
   */
  note: string | null;
}

export interface ContentNote {
  /**
   * Get a content, identified by id or by slug,
   * optionally an authorization token can be used to enable access for current user.
   */
  content: ContentNote_content | null;
}

export interface ContentNoteVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateContentNote
// ====================================================

export interface UpdateContentNote_updateContentNote {
  __typename: "AudioContent" | "EventContent" | "ImageContent" | "LinkContent" | "PdfContent" | "QuizContent" | "ScormContent" | "TextContent" | "VideoContent";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Notes of the current user about this content
   */
  note: string | null;
}

export interface UpdateContentNote {
  /**
   * Change notes related to content for current user
   */
  updateContentNote: UpdateContentNote_updateContentNote;
}

export interface UpdateContentNoteVariables {
  id: string;
  note?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AddCustomDomain
// ====================================================

export interface AddCustomDomain_createDomain_domain_workspace_domain {
  __typename: "Domain";
  /**
   * Unique identifier
   */
  id: string;
}

export interface AddCustomDomain_createDomain_domain_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Domain for white label
   */
  domain: AddCustomDomain_createDomain_domain_workspace_domain | null;
}

export interface AddCustomDomain_createDomain_domain {
  __typename: "Domain";
  /**
   * Workspace belongs to
   */
  workspace: AddCustomDomain_createDomain_domain_workspace;
}

export interface AddCustomDomain_createDomain {
  __typename: "CreateDomainPayload";
  domain: AddCustomDomain_createDomain_domain | null;
  resultCode: number;
  message: string | null;
}

export interface AddCustomDomain {
  createDomain: AddCustomDomain_createDomain;
}

export interface AddCustomDomainVariables {
  input: CreateDomainInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DeleteCustomDomain
// ====================================================

export interface DeleteCustomDomain {
  removeDomain: boolean;
}

export interface DeleteCustomDomainVariables {
  domainId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: StatsLastUpdate
// ====================================================

export interface StatsLastUpdate {
  /**
   * Timestamp of the last data-warehouse refresh backing the stats pages and the CSV report dialog. Global (identical for every content/collection); null when the warehouse is unavailable or when neither warehouse-backed feature (stats, reports) is enabled.
   */
  statsLastUpdate: any | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AddRegistration
// ====================================================

export interface AddRegistration_addEventContentRegistration_registeredUsers {
  __typename: "User";
  id: string;
}

export interface AddRegistration_addEventContentRegistration {
  __typename: "EventContent";
  expired: any | null;
  /**
   * Unique identifier
   */
  id: string;
  isCurrentUserRegistered: boolean;
  participants: number | null;
  registeredUsers: AddRegistration_addEventContentRegistration_registeredUsers[];
  registration: boolean;
  status: EventContentStatus;
  /**
   * Content subtype
   */
  subtype: EventContentSubtype;
  /**
   * Destination link
   */
  url: any | null;
}

export interface AddRegistration {
  addEventContentRegistration: AddRegistration_addEventContentRegistration;
}

export interface AddRegistrationVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: RemoveRegistration
// ====================================================

export interface RemoveRegistration_removeEventContentRegistration_registeredUsers {
  __typename: "User";
  id: string;
}

export interface RemoveRegistration_removeEventContentRegistration {
  __typename: "EventContent";
  expired: any | null;
  /**
   * Unique identifier
   */
  id: string;
  isCurrentUserRegistered: boolean;
  participants: number | null;
  registeredUsers: RemoveRegistration_removeEventContentRegistration_registeredUsers[];
  registration: boolean;
  status: EventContentStatus;
  /**
   * Content subtype
   */
  subtype: EventContentSubtype;
  /**
   * Destination link
   */
  url: any | null;
}

export interface RemoveRegistration {
  removeEventContentRegistration: RemoveRegistration_removeEventContentRegistration;
}

export interface RemoveRegistrationVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UploadInlineImage
// ====================================================

export interface UploadInlineImage {
  /**
   * Upload a file that is publicly available
   */
  upload: any;
}

export interface UploadInlineImageVariables {
  file: any;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: AppFormPaymentsTab
// ====================================================

export interface AppFormPaymentsTab_user_stripeAccount {
  __typename: "StripeAccount";
  /**
   * Three-letter ISO currency code representing the default currency for the account.
   */
  currency: string;
  detailsSubmitted: boolean;
  /**
   * Unique identifier for the object.
   */
  id: string;
}

export interface AppFormPaymentsTab_user {
  __typename: "User";
  id: string;
  stripeAccount: AppFormPaymentsTab_user_stripeAccount;
  stripeAccountLink: any;
}

export interface AppFormPaymentsTab {
  /**
   * Currently authenticated user
   */
  user: AppFormPaymentsTab_user | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: CurrentUserTags
// ====================================================

export interface CurrentUserTags_me {
  __typename: "User";
  id: string;
  tags: string[];
}

export interface CurrentUserTags {
  /**
   * Currently authenticated user
   */
  me: CurrentUserTags_me | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UploadFile
// ====================================================

export interface UploadFile {
  /**
   * Upload a file that is publicly available
   */
  upload: any;
}

export interface UploadFileVariables {
  file: any;
  namespace: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: StoredFile
// ====================================================

export interface StoredFile_storedFile {
  __typename: "StoredFile";
  filename: string;
  id: string;
  isImage: boolean;
  url: any;
}

export interface StoredFile {
  storedFile: StoredFile_storedFile | null;
}

export interface StoredFileVariables {
  identifier: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetElementVisibility
// ====================================================

export interface GetElementVisibility_element_MixedCollection {
  __typename: "MixedCollection" | "BlendedCollection" | "VideoCollection";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * When visibility is public and this flag is set to true require registration to view all content
   */
  need_registration: boolean | null;
}

export interface GetElementVisibility_element_AudioContent {
  __typename: "AudioContent" | "EventContent" | "ImageContent" | "LinkContent" | "PdfContent" | "QuizContent" | "ScormContent" | "TextContent" | "VideoContent";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * When visibility is public and this flag is set to true require registration to view all content
   */
  need_registration: boolean | null;
}

export interface GetElementVisibility_element_Folder {
  __typename: "Folder";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
}

export type GetElementVisibility_element = GetElementVisibility_element_MixedCollection | GetElementVisibility_element_AudioContent | GetElementVisibility_element_Folder;

export interface GetElementVisibility {
  element: GetElementVisibility_element | null;
}

export interface GetElementVisibilityVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetElementVisibilityForCollection
// ====================================================

export interface GetElementVisibilityForCollection_element_MixedCollection {
  __typename: "MixedCollection" | "BlendedCollection" | "VideoCollection" | "Folder";
}

export interface GetElementVisibilityForCollection_element_AudioContent {
  __typename: "AudioContent" | "EventContent" | "ImageContent" | "LinkContent" | "PdfContent" | "QuizContent" | "ScormContent" | "TextContent" | "VideoContent";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Determines if subject content is visible in a collection
   */
  visibilityForCollection: Visibility | null;
}

export type GetElementVisibilityForCollection_element = GetElementVisibilityForCollection_element_MixedCollection | GetElementVisibilityForCollection_element_AudioContent;

export interface GetElementVisibilityForCollection {
  element: GetElementVisibilityForCollection_element | null;
}

export interface GetElementVisibilityForCollectionVariables {
  id: string;
  collectionId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: RemoveModuleAndContents
// ====================================================

export interface RemoveModuleAndContents {
  removeModuleAndContents: boolean;
}

export interface RemoveModuleAndContentsVariables {
  moduleId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: RemoveModule
// ====================================================

export interface RemoveModule {
  removeModule: boolean;
}

export interface RemoveModuleVariables {
  moduleId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateModule
// ====================================================

export interface UpdateModule_updateModule {
  __typename: "Module";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Main title
   */
  title: string;
}

export interface UpdateModule {
  updateModule: UpdateModule_updateModule;
}

export interface UpdateModuleVariables {
  moduleId: string;
  input: UpdateModuleInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ChangeCollectionModulesOrder
// ====================================================

export interface ChangeCollectionModulesOrder_changeCollectionModulesOrder {
  __typename: "BlendedCollection" | "MixedCollection" | "VideoCollection";
  /**
   * Unique identifier
   */
  id: string;
}

export interface ChangeCollectionModulesOrder {
  changeCollectionModulesOrder: ChangeCollectionModulesOrder_changeCollectionModulesOrder;
}

export interface ChangeCollectionModulesOrderVariables {
  modulesId: string[];
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: AppQuiz
// ====================================================

export interface AppQuiz_content_AudioContent {
  __typename: "AudioContent" | "EventContent" | "ImageContent" | "LinkContent" | "PdfContent" | "ScormContent" | "TextContent" | "VideoContent";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Last update of the content
   */
  updatedAt: any;
}

export interface AppQuiz_content_QuizContent_mySessions {
  __typename: "QuizContentSession";
  id: string;
}

export interface AppQuiz_content_QuizContent_questions_QuizContentQuestionEssay {
  __typename: "QuizContentQuestionEssay";
  canBeSkipped: boolean | null;
  id: string;
  image: any | null;
  missingPoints: number | null;
  title: string | null;
  successFeedback: string | null;
  successPoints: number | null;
  timeLimit: number | null;
}

export interface AppQuiz_content_QuizContent_questions_QuizContentQuestionMatching_matchPairs {
  __typename: "QuizContentQuestionMatchingRow";
  subanswer: string;
  subquestion: string;
}

export interface AppQuiz_content_QuizContent_questions_QuizContentQuestionMatching {
  __typename: "QuizContentQuestionMatching";
  canBeSkipped: boolean | null;
  failureFeedback: string | null;
  failurePoints: number | null;
  id: string;
  image: any | null;
  matchPairs: AppQuiz_content_QuizContent_questions_QuizContentQuestionMatching_matchPairs[];
  missingPoints: number | null;
  successFeedback: string | null;
  successPoints: number | null;
  title: string | null;
  timeLimit: number | null;
}

export interface AppQuiz_content_QuizContent_questions_QuizContentQuestionMissingWord {
  __typename: "QuizContentQuestionMissingWord";
  canBeSkipped: boolean | null;
  failureFeedback: string | null;
  failurePoints: number | null;
  id: string;
  image: any | null;
  missingPoints: number | null;
  successFeedback: string | null;
  successPoints: number | null;
  title: string | null;
  timeLimit: number | null;
}

export interface AppQuiz_content_QuizContent_questions_QuizContentQuestionMultipleChoice_choices {
  __typename: "QuizContentQuestionTextChoice";
  isCorrect: boolean;
  text: string;
}

export interface AppQuiz_content_QuizContent_questions_QuizContentQuestionMultipleChoice {
  __typename: "QuizContentQuestionMultipleChoice";
  canBeSkipped: boolean | null;
  choices: AppQuiz_content_QuizContent_questions_QuizContentQuestionMultipleChoice_choices[];
  failureFeedback: string | null;
  failurePoints: number | null;
  id: string;
  image: any | null;
  missingPoints: number | null;
  successFeedback: string | null;
  successPoints: number | null;
  title: string | null;
  timeLimit: number | null;
}

export interface AppQuiz_content_QuizContent_questions_QuizContentQuestionNumerical {
  __typename: "QuizContentQuestionNumerical";
  canBeSkipped: boolean | null;
  failureFeedback: string | null;
  failurePoints: number | null;
  id: string;
  image: any | null;
  missingPoints: number | null;
  number: number;
  range: number | null;
  successFeedback: string | null;
  successPoints: number | null;
  title: string | null;
  timeLimit: number | null;
}

export interface AppQuiz_content_QuizContent_questions_QuizContentQuestionSingleChoice_choices {
  __typename: "QuizContentQuestionTextChoice";
  isCorrect: boolean;
  text: string;
}

export interface AppQuiz_content_QuizContent_questions_QuizContentQuestionSingleChoice {
  __typename: "QuizContentQuestionSingleChoice";
  canBeSkipped: boolean | null;
  choices: AppQuiz_content_QuizContent_questions_QuizContentQuestionSingleChoice_choices[];
  failureFeedback: string | null;
  failurePoints: number | null;
  id: string;
  image: any | null;
  missingPoints: number | null;
  successFeedback: string | null;
  successPoints: number | null;
  title: string | null;
  timeLimit: number | null;
}

export interface AppQuiz_content_QuizContent_questions_QuizContentQuestionTrueFalse {
  __typename: "QuizContentQuestionTrueFalse";
  canBeSkipped: boolean | null;
  failureFeedback: string | null;
  failurePoints: number | null;
  id: string;
  image: any | null;
  isTrue: boolean;
  missingPoints: number | null;
  successFeedback: string | null;
  successPoints: number | null;
  title: string | null;
  timeLimit: number | null;
}

export type AppQuiz_content_QuizContent_questions = AppQuiz_content_QuizContent_questions_QuizContentQuestionEssay | AppQuiz_content_QuizContent_questions_QuizContentQuestionMatching | AppQuiz_content_QuizContent_questions_QuizContentQuestionMissingWord | AppQuiz_content_QuizContent_questions_QuizContentQuestionMultipleChoice | AppQuiz_content_QuizContent_questions_QuizContentQuestionNumerical | AppQuiz_content_QuizContent_questions_QuizContentQuestionSingleChoice | AppQuiz_content_QuizContent_questions_QuizContentQuestionTrueFalse;

export interface AppQuiz_content_QuizContent_session_questions_QuizContentQuestionEssay {
  __typename: "QuizContentQuestionEssay";
  canBeSkipped: boolean | null;
  id: string;
  image: any | null;
  missingPoints: number | null;
  title: string | null;
  successFeedback: string | null;
  successPoints: number | null;
  timeLimit: number | null;
}

export interface AppQuiz_content_QuizContent_session_questions_QuizContentQuestionMatching_matchPairs {
  __typename: "QuizContentQuestionMatchingRow";
  subanswer: string;
  subquestion: string;
}

export interface AppQuiz_content_QuizContent_session_questions_QuizContentQuestionMatching {
  __typename: "QuizContentQuestionMatching";
  canBeSkipped: boolean | null;
  failureFeedback: string | null;
  failurePoints: number | null;
  id: string;
  image: any | null;
  matchPairs: AppQuiz_content_QuizContent_session_questions_QuizContentQuestionMatching_matchPairs[];
  missingPoints: number | null;
  successFeedback: string | null;
  successPoints: number | null;
  title: string | null;
  timeLimit: number | null;
}

export interface AppQuiz_content_QuizContent_session_questions_QuizContentQuestionMissingWord {
  __typename: "QuizContentQuestionMissingWord";
  canBeSkipped: boolean | null;
  failureFeedback: string | null;
  failurePoints: number | null;
  id: string;
  image: any | null;
  missingPoints: number | null;
  successFeedback: string | null;
  successPoints: number | null;
  title: string | null;
  timeLimit: number | null;
}

export interface AppQuiz_content_QuizContent_session_questions_QuizContentQuestionMultipleChoice_choices {
  __typename: "QuizContentQuestionTextChoice";
  isCorrect: boolean;
  text: string;
}

export interface AppQuiz_content_QuizContent_session_questions_QuizContentQuestionMultipleChoice {
  __typename: "QuizContentQuestionMultipleChoice";
  canBeSkipped: boolean | null;
  choices: AppQuiz_content_QuizContent_session_questions_QuizContentQuestionMultipleChoice_choices[];
  failureFeedback: string | null;
  failurePoints: number | null;
  id: string;
  image: any | null;
  missingPoints: number | null;
  successFeedback: string | null;
  successPoints: number | null;
  title: string | null;
  timeLimit: number | null;
}

export interface AppQuiz_content_QuizContent_session_questions_QuizContentQuestionNumerical {
  __typename: "QuizContentQuestionNumerical";
  canBeSkipped: boolean | null;
  failureFeedback: string | null;
  failurePoints: number | null;
  id: string;
  image: any | null;
  missingPoints: number | null;
  number: number;
  range: number | null;
  successFeedback: string | null;
  successPoints: number | null;
  title: string | null;
  timeLimit: number | null;
}

export interface AppQuiz_content_QuizContent_session_questions_QuizContentQuestionSingleChoice_choices {
  __typename: "QuizContentQuestionTextChoice";
  isCorrect: boolean;
  text: string;
}

export interface AppQuiz_content_QuizContent_session_questions_QuizContentQuestionSingleChoice {
  __typename: "QuizContentQuestionSingleChoice";
  canBeSkipped: boolean | null;
  choices: AppQuiz_content_QuizContent_session_questions_QuizContentQuestionSingleChoice_choices[];
  failureFeedback: string | null;
  failurePoints: number | null;
  id: string;
  image: any | null;
  missingPoints: number | null;
  successFeedback: string | null;
  successPoints: number | null;
  title: string | null;
  timeLimit: number | null;
}

export interface AppQuiz_content_QuizContent_session_questions_QuizContentQuestionTrueFalse {
  __typename: "QuizContentQuestionTrueFalse";
  canBeSkipped: boolean | null;
  failureFeedback: string | null;
  failurePoints: number | null;
  id: string;
  image: any | null;
  isTrue: boolean;
  missingPoints: number | null;
  successFeedback: string | null;
  successPoints: number | null;
  title: string | null;
  timeLimit: number | null;
}

export type AppQuiz_content_QuizContent_session_questions = AppQuiz_content_QuizContent_session_questions_QuizContentQuestionEssay | AppQuiz_content_QuizContent_session_questions_QuizContentQuestionMatching | AppQuiz_content_QuizContent_session_questions_QuizContentQuestionMissingWord | AppQuiz_content_QuizContent_session_questions_QuizContentQuestionMultipleChoice | AppQuiz_content_QuizContent_session_questions_QuizContentQuestionNumerical | AppQuiz_content_QuizContent_session_questions_QuizContentQuestionSingleChoice | AppQuiz_content_QuizContent_session_questions_QuizContentQuestionTrueFalse;

export interface AppQuiz_content_QuizContent_session {
  __typename: "QuizContentSession";
  answers: any;
  completed: boolean;
  id: string;
  points: any;
  questions: AppQuiz_content_QuizContent_session_questions[];
  success: boolean;
}

export interface AppQuiz_content_QuizContent_coverDimensions {
  __typename: "CoverDimensions";
  height: number | null;
  width: number | null;
}

export interface AppQuiz_content_QuizContent {
  __typename: "QuizContent";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Last update of the content
   */
  updatedAt: any;
  canRepeat: boolean;
  canRepeatMaximum: number | null;
  canRepeatOnlyFailure: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  label: string | null;
  mySessions: AppQuiz_content_QuizContent_mySessions[];
  questions: AppQuiz_content_QuizContent_questions[];
  quizFeedbackFailureImage: any | null;
  quizFeedbackFailureMessage: string | null;
  quizFeedbackSuccessImage: any | null;
  quizFeedbackSuccessMessage: string | null;
  separateEvaluation: boolean;
  session: AppQuiz_content_QuizContent_session | null;
  showSummary: boolean;
  successPoints: number | null;
  /**
   * Main title
   */
  title: string;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: AppQuiz_content_QuizContent_coverDimensions | null;
  instructions: string | null;
  tags: string[];
  timeLimit: number | null;
  questionsNavigation: boolean;
  showAnswer: boolean;
  showProgress: boolean;
  appendRequiredQuestions: boolean;
  basket: number | null;
  extractProgress: any | null;
  /**
   * Content subtype
   */
  quizSubtype: QuizContentSubtype | null;
  randomOrder: boolean;
  restartFromBegin: boolean;
}

export type AppQuiz_content = AppQuiz_content_AudioContent | AppQuiz_content_QuizContent;

export interface AppQuiz {
  /**
   * Get a content, identified by id or by slug,
   * optionally an authorization token can be used to enable access for current user.
   */
  content: AppQuiz_content | null;
}

export interface AppQuizVariables {
  identifier: string;
  collectionIdentifier?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AppQuizStateContextStorage
// ====================================================

export interface AppQuizStateContextStorage {
  storeQuizProgress: boolean;
}

export interface AppQuizStateContextStorageVariables {
  id: string;
  status: any;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AppQuizCompletion
// ====================================================

export interface AppQuizCompletion_answerQuiz_mySessions {
  __typename: "QuizContentSession";
  id: string;
}

export interface AppQuizCompletion_answerQuiz {
  __typename: "QuizContent";
  /**
   * Unique identifier
   */
  id: string;
  mySessions: AppQuizCompletion_answerQuiz_mySessions[];
}

export interface AppQuizCompletion {
  /**
   * Track answer to all the questions of the quiz
   */
  answerQuiz: AppQuizCompletion_answerQuiz;
}

export interface AppQuizCompletionVariables {
  id: string;
  input: any;
  ip?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AppQuizAnswerQuestion
// ====================================================

export interface AppQuizAnswerQuestion_answerQuizQuestion {
  __typename: "QuizContent";
  /**
   * Unique identifier
   */
  id: string;
}

export interface AppQuizAnswerQuestion {
  /**
   * Track answer to single question
   */
  answerQuizQuestion: AppQuizAnswerQuestion_answerQuizQuestion;
}

export interface AppQuizAnswerQuestionVariables {
  id: string;
  questionIdentifier: string;
  input: any;
  ip?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: ScormPlayerLaunchUrl
// ====================================================

export interface ScormPlayerLaunchUrl_content_AudioContent {
  __typename: "AudioContent" | "EventContent" | "ImageContent" | "LinkContent" | "PdfContent" | "QuizContent" | "TextContent" | "VideoContent";
  /**
   * Unique identifier
   */
  id: string;
}

export interface ScormPlayerLaunchUrl_content_ScormContent {
  __typename: "ScormContent";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Absolute URL that opens this package in the SCORM player, or null when the caller may not.
   * 
   * Declared without @guard on purpose: throwing for anonymous callers would break the public
   * content pages. The permission check is server-side in the resolver, which makes this field
   * stricter than `url` — see follow-up #2 for that asymmetry.
   * 
   * Resolving this field creates the learner's registration row, so it is null for anyone who
   * cannot play the package.
   */
  launchUrl: any | null;
}

export type ScormPlayerLaunchUrl_content = ScormPlayerLaunchUrl_content_AudioContent | ScormPlayerLaunchUrl_content_ScormContent;

export interface ScormPlayerLaunchUrl {
  /**
   * Get a content, identified by id or by slug,
   * optionally an authorization token can be used to enable access for current user.
   */
  content: ScormPlayerLaunchUrl_content | null;
}

export interface ScormPlayerLaunchUrlVariables {
  identifier: string;
  collectionIdentifier?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetShareOrCopyElementVisibility
// ====================================================

export interface GetShareOrCopyElementVisibility_element_MixedCollection_creator {
  __typename: "User";
  id: string;
}

export interface GetShareOrCopyElementVisibility_element_MixedCollection {
  __typename: "MixedCollection" | "BlendedCollection" | "VideoCollection";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * When visibility is public and this flag is set to true require registration to view all content
   */
  need_registration: boolean | null;
  parent_folder_id: string | null;
  /**
   * Collection creator
   */
  creator: GetShareOrCopyElementVisibility_element_MixedCollection_creator;
}

export interface GetShareOrCopyElementVisibility_element_AudioContent_creator {
  __typename: "User";
  id: string;
}

export interface GetShareOrCopyElementVisibility_element_AudioContent {
  __typename: "AudioContent" | "EventContent" | "ImageContent" | "LinkContent" | "PdfContent" | "QuizContent" | "ScormContent" | "TextContent" | "VideoContent";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * When visibility is public and this flag is set to true require registration to view all content
   */
  need_registration: boolean | null;
  /**
   * Where the element is contained
   */
  parent_folder_id: string | null;
  /**
   * Content creator
   */
  creator: GetShareOrCopyElementVisibility_element_AudioContent_creator;
}

export interface GetShareOrCopyElementVisibility_element_Folder {
  __typename: "Folder";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
}

export type GetShareOrCopyElementVisibility_element = GetShareOrCopyElementVisibility_element_MixedCollection | GetShareOrCopyElementVisibility_element_AudioContent | GetShareOrCopyElementVisibility_element_Folder;

export interface GetShareOrCopyElementVisibility {
  element: GetShareOrCopyElementVisibility_element | null;
}

export interface GetShareOrCopyElementVisibilityVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetSidebarWorkspaceById
// ====================================================

export interface GetSidebarWorkspaceById_workspace_domain {
  __typename: "Domain";
  /**
   * Domain name
   */
  name: string;
  /**
   * Status of domain approval process
   */
  status: DomainStatus;
}

export interface GetSidebarWorkspaceById_workspace_user {
  __typename: "User";
  id: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
}

export interface GetSidebarWorkspaceById_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Small squared logo for white label
   */
  brandLogoSmall: any | null;
  /**
   * Brand Name for white label
   */
  brandName: string | null;
  /**
   * Domain for white label
   */
  domain: GetSidebarWorkspaceById_workspace_domain | null;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
  /**
   * Slug
   */
  slug: string | null;
  /**
   * Who created the workspace (or first related user if creator is null)
   */
  user: GetSidebarWorkspaceById_workspace_user | null;
}

export interface GetSidebarWorkspaceById {
  workspace: GetSidebarWorkspaceById_workspace | null;
}

export interface GetSidebarWorkspaceByIdVariables {
  workspaceId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetWorkspacesListForUser
// ====================================================

export interface GetWorkspacesListForUser_workspacesListForUser {
  __typename: "UserWorkspacePayload";
  id: string;
  name: string;
  role: string;
  slug: string;
  brandName: string | null;
  brandLogoSmall: any | null;
  autologin_link: any;
}

export interface GetWorkspacesListForUser {
  workspacesListForUser: GetWorkspacesListForUser_workspacesListForUser[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetUserBoards
// ====================================================

export interface GetUserBoards_elements_AudioContent {
  __typename: "AudioContent" | "EventContent" | "ImageContent" | "LinkContent" | "MixedCollection" | "BlendedCollection" | "PdfContent" | "QuizContent" | "ScormContent" | "TextContent" | "VideoCollection" | "VideoContent";
}

export interface GetUserBoards_elements_Folder {
  __typename: "Folder";
  /**
   * Get total contents for required type
   */
  totalContents: number;
  /**
   * Get total contents for required type
   */
  totalCollections: number;
  canManage: boolean;
  canRead: boolean;
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
}

export type GetUserBoards_elements = GetUserBoards_elements_AudioContent | GetUserBoards_elements_Folder;

export interface GetUserBoards_me_workspace_domain {
  __typename: "Domain";
  /**
   * Domain name
   */
  name: string;
  /**
   * Status of domain approval process
   */
  status: DomainStatus;
}

export interface GetUserBoards_me_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Brand Name for white label
   */
  brandName: string | null;
  /**
   * Small squared logo for white label
   */
  brandLogoSmall: any | null;
  /**
   * Domain for white label
   */
  domain: GetUserBoards_me_workspace_domain | null;
  /**
   * Slug
   */
  slug: string | null;
}

export interface GetUserBoards_me_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Internal code
   */
  code: string;
}

export interface GetUserBoards_me {
  __typename: "User";
  id: string;
  /**
   * Main email address
   */
  email: any;
  /**
   * First name
   */
  firstname: string;
  /**
   * Last name
   */
  lastname: string;
  /**
   * Full name
   */
  name: string;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Custom route
   */
  vanity_name: string | null;
  workspace: GetUserBoards_me_workspace | null;
  subscriptionPlan: GetUserBoards_me_subscriptionPlan;
}

export interface GetUserBoards {
  /**
   * All homepage elements, including:
   * * created contents
   * * visited contents
   * * created collections
   * * visited collections
   * 
   * If createdByMe or community are defined, elements will be filtered.
   */
  elements: GetUserBoards_elements[];
  /**
   * Currently authenticated user
   */
  me: GetUserBoards_me | null;
  /**
   * Total homepage elements, including:
   * * created contents
   * * visited contents
   * * created collections
   * * visited collections
   * 
   * If createdByMe is defined, elements will be filtered.
   */
  totalElements: number;
}

export interface GetUserBoardsVariables {
  createdByMe?: boolean | null;
  limit?: number | null;
  offset?: number | null;
  workspaceUserId?: string | null;
  filterByElementType?: (ElementTypeFilter | null)[] | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SendAdditionalEmailConfirmation
// ====================================================

export interface SendAdditionalEmailConfirmation {
  confirmAdditionalEmail: boolean;
}

export interface SendAdditionalEmailConfirmationVariables {
  sha1: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AssociateCertificateToElement
// ====================================================

export interface AssociateCertificateToElement {
  associateCertificateToElement: boolean;
}

export interface AssociateCertificateToElementVariables {
  certificateId: string;
  elementId: string;
  elementType: AssociateCertificateToElementType;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateCertificate
// ====================================================

export interface CreateCertificate_createCertificate {
  __typename: "Certificate";
  /**
   * Unique identifier
   */
  id: string;
}

export interface CreateCertificate {
  createCertificate: CreateCertificate_createCertificate;
}

export interface CreateCertificateVariables {
  input: CreateCertificateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetCertificateForEdit
// ====================================================

export interface GetCertificateForEdit_certificate {
  __typename: "Certificate";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Main title
   */
  title: string;
  /**
   * First phrase
   */
  type: string | null;
  /**
   * First phrase
   */
  first_phrase: string | null;
  /**
   * Second phrase
   */
  second_phrase: string | null;
  /**
   * Third phrase
   */
  third_phrase: string | null;
  /**
   * Background image
   */
  background_image: any | null;
  /**
   * Notes of the current user about this collection
   */
  note: string | null;
  /**
   * Certificate template
   */
  template: CertificateTemplate;
}

export interface GetCertificateForEdit {
  /**
   * Get a certificate, identified by id
   */
  certificate: GetCertificateForEdit_certificate | null;
}

export interface GetCertificateForEditVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateCertificate
// ====================================================

export interface UpdateCertificate_updateCertificate {
  __typename: "Certificate";
  /**
   * Unique identifier
   */
  id: string;
}

export interface UpdateCertificate {
  updateCertificate: UpdateCertificate_updateCertificate;
}

export interface UpdateCertificateVariables {
  id: string;
  input: UpdateCertificateInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetCertificatesCreatedByMe
// ====================================================

export interface GetCertificatesCreatedByMe_user_certificates_edges_node {
  __typename: "Certificate";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Main title
   */
  title: string;
  /**
   * First phrase
   */
  type: string | null;
  /**
   * First phrase
   */
  first_phrase: string | null;
  /**
   * Second phrase
   */
  second_phrase: string | null;
  /**
   * Third phrase
   */
  third_phrase: string | null;
  /**
   * Background image
   */
  background_image: any | null;
  /**
   * Notes of the current user about this collection
   */
  note: string | null;
}

export interface GetCertificatesCreatedByMe_user_certificates_edges {
  __typename: "CertificateEdge";
  /**
   * The Certificate node.
   */
  node: GetCertificatesCreatedByMe_user_certificates_edges_node;
}

export interface GetCertificatesCreatedByMe_user_certificates {
  __typename: "CertificateConnection";
  /**
   * A list of Certificate edges.
   */
  edges: GetCertificatesCreatedByMe_user_certificates_edges[];
}

export interface GetCertificatesCreatedByMe_user {
  __typename: "User";
  id: string;
  /**
   * Certificates created by the user
   */
  certificates: GetCertificatesCreatedByMe_user_certificates;
}

export interface GetCertificatesCreatedByMe {
  /**
   * Currently authenticated user
   */
  user: GetCertificatesCreatedByMe_user | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: RemoveCertificateFromElement
// ====================================================

export interface RemoveCertificateFromElement {
  removeCertificateFromElement: boolean;
}

export interface RemoveCertificateFromElementVariables {
  elementId: string;
  elementType: RemoveCertificateToElementType;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: CollectionPageContents
// ====================================================

export interface CollectionPageContents_collection_contents_edges_node_AudioContent {
  __typename: "AudioContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * Determines if subject content is visible in a collection
   */
  visibilityForCollection: Visibility | null;
  /**
   * Total duration in seconds
   */
  duration: number | null;
  hasUserCompleted: boolean | null;
}

export interface CollectionPageContents_collection_contents_edges_node_EventContent_presences_event {
  __typename: "EventContent";
  /**
   * Unique identifier
   */
  id: string;
}

export interface CollectionPageContents_collection_contents_edges_node_EventContent_presences_user {
  __typename: "User";
  id: string;
}

export interface CollectionPageContents_collection_contents_edges_node_EventContent_presences {
  __typename: "EventContentPresence";
  event: CollectionPageContents_collection_contents_edges_node_EventContent_presences_event;
  user: CollectionPageContents_collection_contents_edges_node_EventContent_presences_user;
  presence: boolean | null;
}

export interface CollectionPageContents_collection_contents_edges_node_EventContent {
  __typename: "EventContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * Determines if subject content is visible in a collection
   */
  visibilityForCollection: Visibility | null;
  isCurrentUserRegistered: boolean;
  hasUserCompleted: boolean | null;
  presences: CollectionPageContents_collection_contents_edges_node_EventContent_presences[];
}

export interface CollectionPageContents_collection_contents_edges_node_ImageContent {
  __typename: "ImageContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * Determines if subject content is visible in a collection
   */
  visibilityForCollection: Visibility | null;
  hasUserVisited: boolean;
}

export interface CollectionPageContents_collection_contents_edges_node_LinkContent {
  __typename: "LinkContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * Determines if subject content is visible in a collection
   */
  visibilityForCollection: Visibility | null;
  /**
   * Destination domain
   */
  domain: string | null;
  /**
   * Total duration in seconds, alias of embed.estimatedReadingTime
   */
  duration: number | null;
  hasUserVisited: boolean;
}

export interface CollectionPageContents_collection_contents_edges_node_PdfContent_pdfDetails {
  __typename: "PdfDetails";
  pages: number;
}

export interface CollectionPageContents_collection_contents_edges_node_PdfContent {
  __typename: "PdfContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * Determines if subject content is visible in a collection
   */
  visibilityForCollection: Visibility | null;
  /**
   * Total duration in seconds, alias of pdfDetails.estimatedReadingTime
   */
  duration: number | null;
  /**
   * PDF document additional details
   */
  pdfDetails: CollectionPageContents_collection_contents_edges_node_PdfContent_pdfDetails | null;
  /**
   * Activate PDF download
   */
  canDownload: boolean | null;
  hasUserVisited: boolean;
}

export interface CollectionPageContents_collection_contents_edges_node_QuizContent_questions {
  __typename: "QuizContentQuestionEssay" | "QuizContentQuestionMatching" | "QuizContentQuestionMissingWord" | "QuizContentQuestionMultipleChoice" | "QuizContentQuestionNumerical" | "QuizContentQuestionSingleChoice" | "QuizContentQuestionTrueFalse";
}

export interface CollectionPageContents_collection_contents_edges_node_QuizContent {
  __typename: "QuizContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * Determines if subject content is visible in a collection
   */
  visibilityForCollection: Visibility | null;
  questions: CollectionPageContents_collection_contents_edges_node_QuizContent_questions[];
  hasUserCompleted: boolean | null;
}

export interface CollectionPageContents_collection_contents_edges_node_ScormContent {
  __typename: "ScormContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * Determines if subject content is visible in a collection
   */
  visibilityForCollection: Visibility | null;
  /**
   * Expected time to complete the package, in seconds: the LOM typicalLearningTime the package declares, read on import, or what the author set by hand; null when unknown. Unrelated to timeLimit
   */
  duration: number | null;
  /**
   * Whether the user completed the package. Only the runtime can report it: a visit never counts,
   * so a preparatory course keeps the next element locked until the package is completed.
   */
  hasUserCompleted: boolean | null;
}

export interface CollectionPageContents_collection_contents_edges_node_TextContent {
  __typename: "TextContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * Determines if subject content is visible in a collection
   */
  visibilityForCollection: Visibility | null;
  /**
   * Total duration in seconds, alias of pdfDetails.estimatedReadingTime
   */
  duration: number | null;
  hasUserVisited: boolean;
}

export interface CollectionPageContents_collection_contents_edges_node_VideoContent {
  __typename: "VideoContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * Determines if subject content is visible in a collection
   */
  visibilityForCollection: Visibility | null;
  /**
   * Total duration in seconds
   */
  duration: number | null;
  /**
   * Destination link
   */
  url: any | null;
  /**
   * Cover picture
   */
  cover: any | null;
  aspectRatio: string | null;
  hasUserCompleted: boolean | null;
}

export type CollectionPageContents_collection_contents_edges_node = CollectionPageContents_collection_contents_edges_node_AudioContent | CollectionPageContents_collection_contents_edges_node_EventContent | CollectionPageContents_collection_contents_edges_node_ImageContent | CollectionPageContents_collection_contents_edges_node_LinkContent | CollectionPageContents_collection_contents_edges_node_PdfContent | CollectionPageContents_collection_contents_edges_node_QuizContent | CollectionPageContents_collection_contents_edges_node_ScormContent | CollectionPageContents_collection_contents_edges_node_TextContent | CollectionPageContents_collection_contents_edges_node_VideoContent;

export interface CollectionPageContents_collection_contents_edges {
  __typename: "ContentEdge";
  /**
   * The Content node.
   */
  node: CollectionPageContents_collection_contents_edges_node;
}

export interface CollectionPageContents_collection_contents {
  __typename: "ContentConnection";
  /**
   * A list of Content edges.
   */
  edges: CollectionPageContents_collection_contents_edges[];
}

export interface CollectionPageContents_collection_modules_edges_node_contents_edges_node_AudioContent {
  __typename: "AudioContent";
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * Determines if subject content is visible in a collection
   */
  visibilityForCollection: Visibility | null;
  /**
   * Total duration in seconds
   */
  duration: number | null;
  hasUserCompleted: boolean | null;
}

export interface CollectionPageContents_collection_modules_edges_node_contents_edges_node_EventContent {
  __typename: "EventContent";
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * Determines if subject content is visible in a collection
   */
  visibilityForCollection: Visibility | null;
  isCurrentUserRegistered: boolean;
  hasUserCompleted: boolean | null;
}

export interface CollectionPageContents_collection_modules_edges_node_contents_edges_node_ImageContent {
  __typename: "ImageContent";
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * Determines if subject content is visible in a collection
   */
  visibilityForCollection: Visibility | null;
  hasUserVisited: boolean;
}

export interface CollectionPageContents_collection_modules_edges_node_contents_edges_node_LinkContent {
  __typename: "LinkContent";
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * Determines if subject content is visible in a collection
   */
  visibilityForCollection: Visibility | null;
  /**
   * Destination domain
   */
  domain: string | null;
  /**
   * Total duration in seconds, alias of embed.estimatedReadingTime
   */
  duration: number | null;
  hasUserVisited: boolean;
}

export interface CollectionPageContents_collection_modules_edges_node_contents_edges_node_PdfContent_pdfDetails {
  __typename: "PdfDetails";
  pages: number;
}

export interface CollectionPageContents_collection_modules_edges_node_contents_edges_node_PdfContent {
  __typename: "PdfContent";
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * Determines if subject content is visible in a collection
   */
  visibilityForCollection: Visibility | null;
  /**
   * Total duration in seconds, alias of pdfDetails.estimatedReadingTime
   */
  duration: number | null;
  /**
   * PDF document additional details
   */
  pdfDetails: CollectionPageContents_collection_modules_edges_node_contents_edges_node_PdfContent_pdfDetails | null;
  /**
   * Activate PDF download
   */
  canDownload: boolean | null;
  hasUserVisited: boolean;
}

export interface CollectionPageContents_collection_modules_edges_node_contents_edges_node_QuizContent_questions {
  __typename: "QuizContentQuestionEssay" | "QuizContentQuestionMatching" | "QuizContentQuestionMissingWord" | "QuizContentQuestionMultipleChoice" | "QuizContentQuestionNumerical" | "QuizContentQuestionSingleChoice" | "QuizContentQuestionTrueFalse";
}

export interface CollectionPageContents_collection_modules_edges_node_contents_edges_node_QuizContent {
  __typename: "QuizContent";
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * Determines if subject content is visible in a collection
   */
  visibilityForCollection: Visibility | null;
  questions: CollectionPageContents_collection_modules_edges_node_contents_edges_node_QuizContent_questions[];
  hasUserCompleted: boolean | null;
}

export interface CollectionPageContents_collection_modules_edges_node_contents_edges_node_ScormContent {
  __typename: "ScormContent";
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * Determines if subject content is visible in a collection
   */
  visibilityForCollection: Visibility | null;
  /**
   * Expected time to complete the package, in seconds: the LOM typicalLearningTime the package declares, read on import, or what the author set by hand; null when unknown. Unrelated to timeLimit
   */
  duration: number | null;
  /**
   * Whether the user completed the package. Only the runtime can report it: a visit never counts,
   * so a preparatory course keeps the next element locked until the package is completed.
   */
  hasUserCompleted: boolean | null;
}

export interface CollectionPageContents_collection_modules_edges_node_contents_edges_node_TextContent {
  __typename: "TextContent";
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * Determines if subject content is visible in a collection
   */
  visibilityForCollection: Visibility | null;
  /**
   * Total duration in seconds, alias of pdfDetails.estimatedReadingTime
   */
  duration: number | null;
  hasUserVisited: boolean;
}

export interface CollectionPageContents_collection_modules_edges_node_contents_edges_node_VideoContent {
  __typename: "VideoContent";
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * Determines if subject content is visible in a collection
   */
  visibilityForCollection: Visibility | null;
  /**
   * Total duration in seconds
   */
  duration: number | null;
  /**
   * Destination link
   */
  url: any | null;
  /**
   * Cover picture
   */
  cover: any | null;
  aspectRatio: string | null;
  hasUserCompleted: boolean | null;
}

export type CollectionPageContents_collection_modules_edges_node_contents_edges_node = CollectionPageContents_collection_modules_edges_node_contents_edges_node_AudioContent | CollectionPageContents_collection_modules_edges_node_contents_edges_node_EventContent | CollectionPageContents_collection_modules_edges_node_contents_edges_node_ImageContent | CollectionPageContents_collection_modules_edges_node_contents_edges_node_LinkContent | CollectionPageContents_collection_modules_edges_node_contents_edges_node_PdfContent | CollectionPageContents_collection_modules_edges_node_contents_edges_node_QuizContent | CollectionPageContents_collection_modules_edges_node_contents_edges_node_ScormContent | CollectionPageContents_collection_modules_edges_node_contents_edges_node_TextContent | CollectionPageContents_collection_modules_edges_node_contents_edges_node_VideoContent;

export interface CollectionPageContents_collection_modules_edges_node_contents_edges {
  __typename: "ContentEdge";
  /**
   * The Content node.
   */
  node: CollectionPageContents_collection_modules_edges_node_contents_edges_node;
}

export interface CollectionPageContents_collection_modules_edges_node_contents {
  __typename: "ContentConnection";
  /**
   * A list of Content edges.
   */
  edges: CollectionPageContents_collection_modules_edges_node_contents_edges[];
}

export interface CollectionPageContents_collection_modules_edges_node {
  __typename: "Module";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Module position order inside collection
   */
  position: number;
  /**
   * Total duration of all the audio and video contents included
   */
  duration: number | null;
  /**
   * List of all the contents included in subject Module
   */
  contents: CollectionPageContents_collection_modules_edges_node_contents;
}

export interface CollectionPageContents_collection_modules_edges {
  __typename: "ModuleEdge";
  /**
   * The Module node.
   */
  node: CollectionPageContents_collection_modules_edges_node;
}

export interface CollectionPageContents_collection_modules {
  __typename: "ModuleConnection";
  /**
   * A list of Module edges.
   */
  edges: CollectionPageContents_collection_modules_edges[];
}

export interface CollectionPageContents_collection_coverDimensions {
  __typename: "CoverDimensions";
  height: number | null;
  width: number | null;
}

export interface CollectionPageContents_collection_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface CollectionPageContents_collection_creator_workspace_user {
  __typename: "User";
  id: string;
  /**
   * Self description of the user
   */
  bio: string | null;
  /**
   * Custom route
   */
  vanity_name: string | null;
}

export interface CollectionPageContents_collection_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
  /**
   * Brand Name for white label
   */
  brandName: string | null;
  /**
   * Small squared logo for white label
   */
  brandLogoSmall: any | null;
  /**
   * Who created the workspace (or first related user if creator is null)
   */
  user: CollectionPageContents_collection_creator_workspace_user | null;
}

export interface CollectionPageContents_collection_creator_stripeAccount {
  __typename: "StripeAccount";
  /**
   * Unique identifier for the object.
   */
  id: string;
}

export interface CollectionPageContents_collection_creator_preferences {
  __typename: "UserPreferences";
  hidePromoFooter: boolean;
}

export interface CollectionPageContents_collection_creator {
  __typename: "User";
  /**
   * Self description of the user
   */
  bio: string | null;
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: CollectionPageContents_collection_creator_subscriptionPlan;
  /**
   * Main email address
   */
  email: any;
  workspace: CollectionPageContents_collection_creator_workspace | null;
  stripeAccount: CollectionPageContents_collection_creator_stripeAccount;
  preferences: CollectionPageContents_collection_creator_preferences;
}

export interface CollectionPageContents_collection_originalCreator {
  __typename: "User";
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
}

export interface CollectionPageContents_collection {
  __typename: "BlendedCollection" | "MixedCollection" | "VideoCollection";
  /**
   * Defines if current user has a specific permission on the collection
   */
  canManage: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  selling: boolean;
  sellingPricing: number | null;
  sellingMethod: string | null;
  /**
   * When visibility is public and this flag is set to true require registration to view all content
   */
  need_registration: boolean | null;
  /**
   * List of all the contents included in subject collection
   */
  contents: CollectionPageContents_collection_contents | null;
  /**
   * Total duration of all the audio and video contents included
   */
  duration: number | null;
  /**
   * Get total contents for required type
   */
  totalAudio: number;
  /**
   * Get total contents for required type
   */
  totalImage: number;
  /**
   * Get total contents for required type
   */
  totalLink: number;
  /**
   * Get total contents for required type
   */
  totalPdf: number;
  /**
   * Get total contents for required type
   */
  totalQuiz: number;
  /**
   * Get total contents for required type
   */
  totalScorm: number;
  /**
   * Get total contents for required type
   */
  totalText: number;
  /**
   * Get total contents for required type
   */
  totalVideo: number;
  /**
   * List of all the modules included in subject collection
   */
  modules: CollectionPageContents_collection_modules | null;
  /**
   * Defines if current user has a specific permission on the collection
   */
  canRead: boolean;
  /**
   * Defines if current user has a specific permission on the collection
   */
  canKeepAccess: boolean;
  collectionDisplayStatus: CollectionDisplayStatus;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: CollectionPageContents_collection_coverDimensions | null;
  preparatory: string | null;
  /**
   * Collection creator
   */
  creator: CollectionPageContents_collection_creator;
  /**
   * Creator of the original collection this is a copy of (null if this is not a copy)
   */
  originalCreator: CollectionPageContents_collection_originalCreator | null;
  certificate_id: string | null;
  label: string | null;
  presentation: string | null;
  sellingCurrency: string | null;
  privacyPolicy: string | null;
  tags: string[];
}

export interface CollectionPageContents_me {
  __typename: "User";
  id: string;
}

export interface CollectionPageContents {
  /**
   * Get a collection, identified by id or by slug,
   * optionally an authorization token can be used to enable access for current user.
   */
  collection: CollectionPageContents_collection | null;
  /**
   * Currently authenticated user
   */
  me: CollectionPageContents_me | null;
}

export interface CollectionPageContentsVariables {
  identifier: string;
  token?: string | null;
  userId?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: ContentsForCollectionAssociation
// ====================================================

export interface ContentsForCollectionAssociation_contentsForCollectionAssociation_edges_node_originalCreator {
  __typename: "User";
  id: string;
}

export interface ContentsForCollectionAssociation_contentsForCollectionAssociation_edges_node {
  __typename: "AudioContent" | "EventContent" | "ImageContent" | "LinkContent" | "PdfContent" | "QuizContent" | "ScormContent" | "TextContent" | "VideoContent";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Determines if subject content is included in a collection
   */
  isInCollection: boolean;
  /**
   * Determines if subject content is included in a collection module
   */
  isInModule: boolean;
  /**
   * Main title
   */
  title: string;
  /**
   * Creator of the original content this is a copy of (null if this is not a copy)
   */
  originalCreator: ContentsForCollectionAssociation_contentsForCollectionAssociation_edges_node_originalCreator | null;
}

export interface ContentsForCollectionAssociation_contentsForCollectionAssociation_edges {
  __typename: "ContentEdge";
  /**
   * The Content node.
   */
  node: ContentsForCollectionAssociation_contentsForCollectionAssociation_edges_node;
}

export interface ContentsForCollectionAssociation_contentsForCollectionAssociation_pageInfo {
  __typename: "PageInfo";
  /**
   * When paginating forwards, are there more items?
   */
  hasNextPage: boolean;
  /**
   * The cursor to continue paginating forwards.
   */
  endCursor: string | null;
}

export interface ContentsForCollectionAssociation_contentsForCollectionAssociation {
  __typename: "ContentConnection";
  /**
   * A list of Content edges.
   */
  edges: ContentsForCollectionAssociation_contentsForCollectionAssociation_edges[];
  /**
   * Pagination information about the list of edges.
   */
  pageInfo: ContentsForCollectionAssociation_contentsForCollectionAssociation_pageInfo;
}

export interface ContentsForCollectionAssociation {
  /**
   * Contents the current user can add to, or remove from, the given course (by
   * id or slug), for the course and module association dialogs: those of the
   * course's workspace they create or manage, including the ones already in the
   * course (read isInCollection / isInModule), saved copies excluded. Empty when
   * the user cannot manage the course. Newest first.
   */
  contentsForCollectionAssociation: ContentsForCollectionAssociation_contentsForCollectionAssociation;
}

export interface ContentsForCollectionAssociationVariables {
  collectionId: string;
  visibility?: Visibility[] | null;
  moduleIncludes?: string | null;
  after?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ToggleCollectionContentAssociation
// ====================================================

export interface ToggleCollectionContentAssociation {
  toggleContentCollectionAssociation: boolean;
}

export interface ToggleCollectionContentAssociationVariables {
  associated: boolean;
  collectionId: string;
  contentId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ToggleContentCollectionModuleAssociation
// ====================================================

export interface ToggleContentCollectionModuleAssociation {
  toggleContentModuleAssociation: boolean;
}

export interface ToggleContentCollectionModuleAssociationVariables {
  associated: boolean;
  collectionId: string;
  moduleId: string;
  contentId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateModule
// ====================================================

export interface CreateModule_module {
  __typename: "Module";
  /**
   * Unique identifier
   */
  id: string;
}

export interface CreateModule {
  module: CreateModule_module;
}

export interface CreateModuleVariables {
  collectionId: string;
  input: CreateModuleInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateVisibilityForCollection
// ====================================================

export interface UpdateVisibilityForCollection {
  updateVisibilityForCollection: boolean;
}

export interface UpdateVisibilityForCollectionVariables {
  contentId: string;
  collectionId: string;
  visibility: Visibility;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ChangeCollectionContentsOrder
// ====================================================

export interface ChangeCollectionContentsOrder_changeCollectionContentsOrder {
  __typename: "BlendedCollection" | "MixedCollection" | "VideoCollection";
  /**
   * Unique identifier
   */
  id: string;
}

export interface ChangeCollectionContentsOrder {
  changeCollectionContentsOrder: ChangeCollectionContentsOrder_changeCollectionContentsOrder;
}

export interface ChangeCollectionContentsOrderVariables {
  contentsId: string[];
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: ChangeModuleContentsOrder
// ====================================================

export interface ChangeModuleContentsOrder_changeModuleContentsOrder {
  __typename: "Module";
  /**
   * Unique identifier
   */
  id: string;
}

export interface ChangeModuleContentsOrder {
  changeModuleContentsOrder: ChangeModuleContentsOrder_changeModuleContentsOrder;
}

export interface ChangeModuleContentsOrderVariables {
  contentsId: string[];
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SendCollectionSellingContactRequest
// ====================================================

export interface SendCollectionSellingContactRequest {
  sendCollectionSellingContactRequest: boolean;
}

export interface SendCollectionSellingContactRequestVariables {
  input: SellingContactRequestInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateCollection
// ====================================================

export interface CreateCollection_createCollection {
  __typename: "BlendedCollection" | "MixedCollection" | "VideoCollection";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
}

export interface CreateCollection {
  createCollection: CreateCollection_createCollection;
}

export interface CreateCollectionVariables {
  input: CreateCollectionInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: CollectionForEdit
// ====================================================

export interface CollectionForEdit_collection {
  __typename: "BlendedCollection" | "MixedCollection" | "VideoCollection";
  /**
   * Defines if current user has a specific permission on the collection
   */
  canManage: boolean;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  presentation: string | null;
  selling: boolean;
  sellingCurrency: string | null;
  sellingMethod: string | null;
  sellingPricing: number | null;
  privacyPolicy: string | null;
  tags: string[];
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  certificate_id: string | null;
  preparatory: string | null;
}

export interface CollectionForEdit {
  /**
   * Get a collection, identified by id or by slug,
   * optionally an authorization token can be used to enable access for current user.
   */
  collection: CollectionForEdit_collection | null;
}

export interface CollectionForEditVariables {
  identifier: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateCollection
// ====================================================

export interface UpdateCollection_updateCollection {
  __typename: "BlendedCollection" | "MixedCollection" | "VideoCollection";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * When visibility is public and this flag is set to true require registration to view all content
   */
  need_registration: boolean | null;
}

export interface UpdateCollection {
  updateCollection: UpdateCollection_updateCollection;
}

export interface UpdateCollectionVariables {
  id: string;
  input: UpdateCollectionInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SaveCollection
// ====================================================

export interface SaveCollection_saveCollection_creator {
  __typename: "User";
  id: string;
  /**
   * Full name
   */
  name: string;
}

export interface SaveCollection_saveCollection_originalCreator {
  __typename: "User";
  id: string;
  /**
   * Full name
   */
  name: string;
}

export interface SaveCollection_saveCollection {
  __typename: "BlendedCollection" | "MixedCollection" | "VideoCollection";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * Collection creator
   */
  creator: SaveCollection_saveCollection_creator;
  /**
   * Creator of the original collection this is a copy of (null if this is not a copy)
   */
  originalCreator: SaveCollection_saveCollection_originalCreator | null;
}

export interface SaveCollection {
  /**
   * Copy a collection from another creator into the authenticated user's workspace
   */
  saveCollection: SaveCollection_saveCollection;
}

export interface SaveCollectionVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: CollectionContentPage
// ====================================================

export interface CollectionContentPage_content_EventContent_coverDimensions {
  __typename: "CoverDimensions";
  height: number | null;
  width: number | null;
}

export interface CollectionContentPage_content_EventContent_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface CollectionContentPage_content_EventContent_creator_workspace_user {
  __typename: "User";
  id: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
}

export interface CollectionContentPage_content_EventContent_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
  /**
   * Brand Name for white label
   */
  brandName: string | null;
  /**
   * Small squared logo for white label
   */
  brandLogoSmall: any | null;
  /**
   * Who created the workspace (or first related user if creator is null)
   */
  user: CollectionContentPage_content_EventContent_creator_workspace_user | null;
}

export interface CollectionContentPage_content_EventContent_creator {
  __typename: "User";
  /**
   * Self description of the user
   */
  bio: string | null;
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: CollectionContentPage_content_EventContent_creator_subscriptionPlan;
  /**
   * Main email address
   */
  email: any;
  workspace: CollectionContentPage_content_EventContent_creator_workspace | null;
}

export interface CollectionContentPage_content_EventContent_registeredUsers {
  __typename: "User";
  id: string;
}

export interface CollectionContentPage_content_EventContent_presences_event {
  __typename: "EventContent";
  /**
   * Unique identifier
   */
  id: string;
}

export interface CollectionContentPage_content_EventContent_presences_user {
  __typename: "User";
  id: string;
}

export interface CollectionContentPage_content_EventContent_presences {
  __typename: "EventContentPresence";
  event: CollectionContentPage_content_EventContent_presences_event;
  user: CollectionContentPage_content_EventContent_presences_user;
  presence: boolean | null;
}

export interface CollectionContentPage_content_EventContent_relatedContents_EventContent {
  __typename: "EventContent" | "ScormContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
}

export interface CollectionContentPage_content_EventContent_relatedContents_AudioContent {
  __typename: "AudioContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Total duration in seconds
   */
  duration: number | null;
}

export interface CollectionContentPage_content_EventContent_relatedContents_ImageContent {
  __typename: "ImageContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
}

export interface CollectionContentPage_content_EventContent_relatedContents_LinkContent {
  __typename: "LinkContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Destination domain
   */
  domain: string | null;
  /**
   * Total duration in seconds, alias of embed.estimatedReadingTime
   */
  duration: number | null;
}

export interface CollectionContentPage_content_EventContent_relatedContents_PdfContent_pdfDetails {
  __typename: "PdfDetails";
  pages: number;
}

export interface CollectionContentPage_content_EventContent_relatedContents_PdfContent {
  __typename: "PdfContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Total duration in seconds, alias of pdfDetails.estimatedReadingTime
   */
  duration: number | null;
  /**
   * PDF document additional details
   */
  pdfDetails: CollectionContentPage_content_EventContent_relatedContents_PdfContent_pdfDetails | null;
  /**
   * Activate PDF download
   */
  canDownload: boolean | null;
}

export interface CollectionContentPage_content_EventContent_relatedContents_QuizContent_questions {
  __typename: "QuizContentQuestionEssay" | "QuizContentQuestionMatching" | "QuizContentQuestionMissingWord" | "QuizContentQuestionMultipleChoice" | "QuizContentQuestionNumerical" | "QuizContentQuestionSingleChoice" | "QuizContentQuestionTrueFalse";
}

export interface CollectionContentPage_content_EventContent_relatedContents_QuizContent {
  __typename: "QuizContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  questions: CollectionContentPage_content_EventContent_relatedContents_QuizContent_questions[];
}

export interface CollectionContentPage_content_EventContent_relatedContents_TextContent {
  __typename: "TextContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Total duration in seconds, alias of pdfDetails.estimatedReadingTime
   */
  duration: number | null;
}

export interface CollectionContentPage_content_EventContent_relatedContents_VideoContent {
  __typename: "VideoContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Total duration in seconds
   */
  duration: number | null;
  /**
   * Destination link
   */
  url: any | null;
  /**
   * Cover picture
   */
  cover: any | null;
  aspectRatio: string | null;
}

export type CollectionContentPage_content_EventContent_relatedContents = CollectionContentPage_content_EventContent_relatedContents_EventContent | CollectionContentPage_content_EventContent_relatedContents_AudioContent | CollectionContentPage_content_EventContent_relatedContents_ImageContent | CollectionContentPage_content_EventContent_relatedContents_LinkContent | CollectionContentPage_content_EventContent_relatedContents_PdfContent | CollectionContentPage_content_EventContent_relatedContents_QuizContent | CollectionContentPage_content_EventContent_relatedContents_TextContent | CollectionContentPage_content_EventContent_relatedContents_VideoContent;

export interface CollectionContentPage_content_EventContent {
  __typename: "EventContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean;
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: CollectionContentPage_content_EventContent_coverDimensions | null;
  /**
   * Content creator
   */
  creator: CollectionContentPage_content_EventContent_creator;
  /**
   * Main description, if given
   */
  description: string | null;
  displayStatus: ContentDisplayStatus;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Notes of the current user about this content
   */
  note: string | null;
  /**
   * Where the element is contained
   */
  parent_folder_id: string | null;
  /**
   * Id of the saved collection copy (in the user's workspace) this content was copied as part of; null if the content is not a copy or was saved individually
   */
  parentSavedCollectionId: string | null;
  tags: string[];
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * Determines if subject content is visible in a collection
   */
  visibilityForCollection: Visibility | null;
  /**
   * Last update of the content
   */
  updatedAt: any;
  eventStatusForMenu: EventContentStatus;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * When visibility is public and this flag is set to true require registration to view all content
   */
  need_registration: boolean | null;
  expired: any | null;
  isCurrentUserRegistered: boolean;
  participants: number | null;
  registeredUsers: CollectionContentPage_content_EventContent_registeredUsers[];
  registration: boolean;
  status: EventContentStatus;
  /**
   * Content subtype
   */
  subtype: EventContentSubtype;
  /**
   * Destination link
   */
  url: any | null;
  end: any | null;
  start: any | null;
  location: string | null;
  presentation: string | null;
  presences: CollectionContentPage_content_EventContent_presences[];
  relatedContents: CollectionContentPage_content_EventContent_relatedContents[];
  hasUserCompleted: boolean | null;
}

export interface CollectionContentPage_content_QuizContent_coverDimensions {
  __typename: "CoverDimensions";
  height: number | null;
  width: number | null;
}

export interface CollectionContentPage_content_QuizContent_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface CollectionContentPage_content_QuizContent_creator_workspace_user {
  __typename: "User";
  id: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
}

export interface CollectionContentPage_content_QuizContent_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
  /**
   * Brand Name for white label
   */
  brandName: string | null;
  /**
   * Small squared logo for white label
   */
  brandLogoSmall: any | null;
  /**
   * Who created the workspace (or first related user if creator is null)
   */
  user: CollectionContentPage_content_QuizContent_creator_workspace_user | null;
}

export interface CollectionContentPage_content_QuizContent_creator {
  __typename: "User";
  /**
   * Self description of the user
   */
  bio: string | null;
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: CollectionContentPage_content_QuizContent_creator_subscriptionPlan;
  /**
   * Main email address
   */
  email: any;
  workspace: CollectionContentPage_content_QuizContent_creator_workspace | null;
}

export interface CollectionContentPage_content_QuizContent {
  __typename: "QuizContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean;
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: CollectionContentPage_content_QuizContent_coverDimensions | null;
  /**
   * Content creator
   */
  creator: CollectionContentPage_content_QuizContent_creator;
  /**
   * Main description, if given
   */
  description: string | null;
  displayStatus: ContentDisplayStatus;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Notes of the current user about this content
   */
  note: string | null;
  /**
   * Where the element is contained
   */
  parent_folder_id: string | null;
  /**
   * Id of the saved collection copy (in the user's workspace) this content was copied as part of; null if the content is not a copy or was saved individually
   */
  parentSavedCollectionId: string | null;
  tags: string[];
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * Determines if subject content is visible in a collection
   */
  visibilityForCollection: Visibility | null;
  /**
   * Last update of the content
   */
  updatedAt: any;
  /**
   * Content subtype
   */
  quizSubtypeForMenu: QuizContentSubtype | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * When visibility is public and this flag is set to true require registration to view all content
   */
  need_registration: boolean | null;
  /**
   * Content subtype
   */
  quizSubtype: QuizContentSubtype | null;
  hasUserCompleted: boolean | null;
}

export interface CollectionContentPage_content_AudioContent_coverDimensions {
  __typename: "CoverDimensions";
  height: number | null;
  width: number | null;
}

export interface CollectionContentPage_content_AudioContent_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface CollectionContentPage_content_AudioContent_creator_workspace_user {
  __typename: "User";
  id: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
}

export interface CollectionContentPage_content_AudioContent_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
  /**
   * Brand Name for white label
   */
  brandName: string | null;
  /**
   * Small squared logo for white label
   */
  brandLogoSmall: any | null;
  /**
   * Who created the workspace (or first related user if creator is null)
   */
  user: CollectionContentPage_content_AudioContent_creator_workspace_user | null;
}

export interface CollectionContentPage_content_AudioContent_creator {
  __typename: "User";
  /**
   * Self description of the user
   */
  bio: string | null;
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: CollectionContentPage_content_AudioContent_creator_subscriptionPlan;
  /**
   * Main email address
   */
  email: any;
  workspace: CollectionContentPage_content_AudioContent_creator_workspace | null;
}

export interface CollectionContentPage_content_AudioContent {
  __typename: "AudioContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean;
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: CollectionContentPage_content_AudioContent_coverDimensions | null;
  /**
   * Content creator
   */
  creator: CollectionContentPage_content_AudioContent_creator;
  /**
   * Main description, if given
   */
  description: string | null;
  displayStatus: ContentDisplayStatus;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Notes of the current user about this content
   */
  note: string | null;
  /**
   * Where the element is contained
   */
  parent_folder_id: string | null;
  /**
   * Id of the saved collection copy (in the user's workspace) this content was copied as part of; null if the content is not a copy or was saved individually
   */
  parentSavedCollectionId: string | null;
  tags: string[];
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * Determines if subject content is visible in a collection
   */
  visibilityForCollection: Visibility | null;
  /**
   * Last update of the content
   */
  updatedAt: any;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * When visibility is public and this flag is set to true require registration to view all content
   */
  need_registration: boolean | null;
  /**
   * Total duration in seconds
   */
  duration: number | null;
  /**
   * Destination link
   */
  url: any | null;
  hasUserCompleted: boolean | null;
}

export interface CollectionContentPage_content_ImageContent_coverDimensions {
  __typename: "CoverDimensions";
  height: number | null;
  width: number | null;
}

export interface CollectionContentPage_content_ImageContent_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface CollectionContentPage_content_ImageContent_creator_workspace_user {
  __typename: "User";
  id: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
}

export interface CollectionContentPage_content_ImageContent_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
  /**
   * Brand Name for white label
   */
  brandName: string | null;
  /**
   * Small squared logo for white label
   */
  brandLogoSmall: any | null;
  /**
   * Who created the workspace (or first related user if creator is null)
   */
  user: CollectionContentPage_content_ImageContent_creator_workspace_user | null;
}

export interface CollectionContentPage_content_ImageContent_creator {
  __typename: "User";
  /**
   * Self description of the user
   */
  bio: string | null;
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: CollectionContentPage_content_ImageContent_creator_subscriptionPlan;
  /**
   * Main email address
   */
  email: any;
  workspace: CollectionContentPage_content_ImageContent_creator_workspace | null;
}

export interface CollectionContentPage_content_ImageContent {
  __typename: "ImageContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean;
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: CollectionContentPage_content_ImageContent_coverDimensions | null;
  /**
   * Content creator
   */
  creator: CollectionContentPage_content_ImageContent_creator;
  /**
   * Main description, if given
   */
  description: string | null;
  displayStatus: ContentDisplayStatus;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Notes of the current user about this content
   */
  note: string | null;
  /**
   * Where the element is contained
   */
  parent_folder_id: string | null;
  /**
   * Id of the saved collection copy (in the user's workspace) this content was copied as part of; null if the content is not a copy or was saved individually
   */
  parentSavedCollectionId: string | null;
  tags: string[];
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * Determines if subject content is visible in a collection
   */
  visibilityForCollection: Visibility | null;
  /**
   * Last update of the content
   */
  updatedAt: any;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * When visibility is public and this flag is set to true require registration to view all content
   */
  need_registration: boolean | null;
  /**
   * Content subtype
   */
  imageSubtype: string | null;
  /**
   * Destination link
   */
  url: any | null;
  /**
   * Effective images URL
   */
  urls: any[];
  hasUserVisited: boolean;
}

export interface CollectionContentPage_content_VideoContent_coverDimensions {
  __typename: "CoverDimensions";
  height: number | null;
  width: number | null;
}

export interface CollectionContentPage_content_VideoContent_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface CollectionContentPage_content_VideoContent_creator_workspace_user {
  __typename: "User";
  id: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
}

export interface CollectionContentPage_content_VideoContent_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
  /**
   * Brand Name for white label
   */
  brandName: string | null;
  /**
   * Small squared logo for white label
   */
  brandLogoSmall: any | null;
  /**
   * Who created the workspace (or first related user if creator is null)
   */
  user: CollectionContentPage_content_VideoContent_creator_workspace_user | null;
}

export interface CollectionContentPage_content_VideoContent_creator {
  __typename: "User";
  /**
   * Self description of the user
   */
  bio: string | null;
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: CollectionContentPage_content_VideoContent_creator_subscriptionPlan;
  /**
   * Main email address
   */
  email: any;
  workspace: CollectionContentPage_content_VideoContent_creator_workspace | null;
}

export interface CollectionContentPage_content_VideoContent {
  __typename: "VideoContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean;
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: CollectionContentPage_content_VideoContent_coverDimensions | null;
  /**
   * Content creator
   */
  creator: CollectionContentPage_content_VideoContent_creator;
  /**
   * Main description, if given
   */
  description: string | null;
  displayStatus: ContentDisplayStatus;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Notes of the current user about this content
   */
  note: string | null;
  /**
   * Where the element is contained
   */
  parent_folder_id: string | null;
  /**
   * Id of the saved collection copy (in the user's workspace) this content was copied as part of; null if the content is not a copy or was saved individually
   */
  parentSavedCollectionId: string | null;
  tags: string[];
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * Determines if subject content is visible in a collection
   */
  visibilityForCollection: Visibility | null;
  /**
   * Last update of the content
   */
  updatedAt: any;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * When visibility is public and this flag is set to true require registration to view all content
   */
  need_registration: boolean | null;
  /**
   * Total duration in seconds
   */
  duration: number | null;
  /**
   * Destination link
   */
  url: any | null;
  aspectRatio: string | null;
  hasUserCompleted: boolean | null;
}

export interface CollectionContentPage_content_LinkContent_coverDimensions {
  __typename: "CoverDimensions";
  height: number | null;
  width: number | null;
}

export interface CollectionContentPage_content_LinkContent_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface CollectionContentPage_content_LinkContent_creator_workspace_user {
  __typename: "User";
  id: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
}

export interface CollectionContentPage_content_LinkContent_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
  /**
   * Brand Name for white label
   */
  brandName: string | null;
  /**
   * Small squared logo for white label
   */
  brandLogoSmall: any | null;
  /**
   * Who created the workspace (or first related user if creator is null)
   */
  user: CollectionContentPage_content_LinkContent_creator_workspace_user | null;
}

export interface CollectionContentPage_content_LinkContent_creator {
  __typename: "User";
  /**
   * Self description of the user
   */
  bio: string | null;
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: CollectionContentPage_content_LinkContent_creator_subscriptionPlan;
  /**
   * Main email address
   */
  email: any;
  workspace: CollectionContentPage_content_LinkContent_creator_workspace | null;
}

export interface CollectionContentPage_content_LinkContent {
  __typename: "LinkContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean;
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: CollectionContentPage_content_LinkContent_coverDimensions | null;
  /**
   * Content creator
   */
  creator: CollectionContentPage_content_LinkContent_creator;
  /**
   * Main description, if given
   */
  description: string | null;
  displayStatus: ContentDisplayStatus;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Notes of the current user about this content
   */
  note: string | null;
  /**
   * Where the element is contained
   */
  parent_folder_id: string | null;
  /**
   * Id of the saved collection copy (in the user's workspace) this content was copied as part of; null if the content is not a copy or was saved individually
   */
  parentSavedCollectionId: string | null;
  tags: string[];
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * Determines if subject content is visible in a collection
   */
  visibilityForCollection: Visibility | null;
  /**
   * Last update of the content
   */
  updatedAt: any;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * When visibility is public and this flag is set to true require registration to view all content
   */
  need_registration: boolean | null;
  /**
   * Destination domain
   */
  domain: string | null;
  /**
   * Total duration in seconds, alias of embed.estimatedReadingTime
   */
  duration: number | null;
  /**
   * Destination link
   */
  url: any | null;
  hasUserVisited: boolean;
}

export interface CollectionContentPage_content_PdfContent_coverDimensions {
  __typename: "CoverDimensions";
  height: number | null;
  width: number | null;
}

export interface CollectionContentPage_content_PdfContent_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface CollectionContentPage_content_PdfContent_creator_workspace_user {
  __typename: "User";
  id: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
}

export interface CollectionContentPage_content_PdfContent_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
  /**
   * Brand Name for white label
   */
  brandName: string | null;
  /**
   * Small squared logo for white label
   */
  brandLogoSmall: any | null;
  /**
   * Who created the workspace (or first related user if creator is null)
   */
  user: CollectionContentPage_content_PdfContent_creator_workspace_user | null;
}

export interface CollectionContentPage_content_PdfContent_creator {
  __typename: "User";
  /**
   * Self description of the user
   */
  bio: string | null;
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: CollectionContentPage_content_PdfContent_creator_subscriptionPlan;
  /**
   * Main email address
   */
  email: any;
  workspace: CollectionContentPage_content_PdfContent_creator_workspace | null;
}

export interface CollectionContentPage_content_PdfContent_pdfDetails {
  __typename: "PdfDetails";
  pages: number;
}

export interface CollectionContentPage_content_PdfContent {
  __typename: "PdfContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean;
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: CollectionContentPage_content_PdfContent_coverDimensions | null;
  /**
   * Content creator
   */
  creator: CollectionContentPage_content_PdfContent_creator;
  /**
   * Main description, if given
   */
  description: string | null;
  displayStatus: ContentDisplayStatus;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Notes of the current user about this content
   */
  note: string | null;
  /**
   * Where the element is contained
   */
  parent_folder_id: string | null;
  /**
   * Id of the saved collection copy (in the user's workspace) this content was copied as part of; null if the content is not a copy or was saved individually
   */
  parentSavedCollectionId: string | null;
  tags: string[];
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * Determines if subject content is visible in a collection
   */
  visibilityForCollection: Visibility | null;
  /**
   * Last update of the content
   */
  updatedAt: any;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * When visibility is public and this flag is set to true require registration to view all content
   */
  need_registration: boolean | null;
  /**
   * Total duration in seconds, alias of pdfDetails.estimatedReadingTime
   */
  duration: number | null;
  /**
   * PDF document additional details
   */
  pdfDetails: CollectionContentPage_content_PdfContent_pdfDetails | null;
  /**
   * Destination link
   */
  url: any | null;
  /**
   * Activate PDF download
   */
  canDownload: boolean | null;
  hasUserVisited: boolean;
}

export interface CollectionContentPage_content_ScormContent_coverDimensions {
  __typename: "CoverDimensions";
  height: number | null;
  width: number | null;
}

export interface CollectionContentPage_content_ScormContent_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface CollectionContentPage_content_ScormContent_creator_workspace_user {
  __typename: "User";
  id: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
}

export interface CollectionContentPage_content_ScormContent_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
  /**
   * Brand Name for white label
   */
  brandName: string | null;
  /**
   * Small squared logo for white label
   */
  brandLogoSmall: any | null;
  /**
   * Who created the workspace (or first related user if creator is null)
   */
  user: CollectionContentPage_content_ScormContent_creator_workspace_user | null;
}

export interface CollectionContentPage_content_ScormContent_creator {
  __typename: "User";
  /**
   * Self description of the user
   */
  bio: string | null;
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: CollectionContentPage_content_ScormContent_creator_subscriptionPlan;
  /**
   * Main email address
   */
  email: any;
  workspace: CollectionContentPage_content_ScormContent_creator_workspace | null;
}

export interface CollectionContentPage_content_ScormContent {
  __typename: "ScormContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean;
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: CollectionContentPage_content_ScormContent_coverDimensions | null;
  /**
   * Content creator
   */
  creator: CollectionContentPage_content_ScormContent_creator;
  /**
   * Main description, if given
   */
  description: string | null;
  displayStatus: ContentDisplayStatus;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Notes of the current user about this content
   */
  note: string | null;
  /**
   * Where the element is contained
   */
  parent_folder_id: string | null;
  /**
   * Id of the saved collection copy (in the user's workspace) this content was copied as part of; null if the content is not a copy or was saved individually
   */
  parentSavedCollectionId: string | null;
  tags: string[];
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * Determines if subject content is visible in a collection
   */
  visibilityForCollection: Visibility | null;
  /**
   * Last update of the content
   */
  updatedAt: any;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * When visibility is public and this flag is set to true require registration to view all content
   */
  need_registration: boolean | null;
  /**
   * Expected time to complete the package, in seconds: the LOM typicalLearningTime the package declares, read on import, or what the author set by hand; null when unknown. Unrelated to timeLimit
   */
  duration: number | null;
  /**
   * Whether the user completed the package. Only the runtime can report it: a visit never counts,
   * so a preparatory course keeps the next element locked until the package is completed.
   */
  hasUserCompleted: boolean | null;
}

export interface CollectionContentPage_content_TextContent_coverDimensions {
  __typename: "CoverDimensions";
  height: number | null;
  width: number | null;
}

export interface CollectionContentPage_content_TextContent_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface CollectionContentPage_content_TextContent_creator_workspace_user {
  __typename: "User";
  id: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
}

export interface CollectionContentPage_content_TextContent_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
  /**
   * Brand Name for white label
   */
  brandName: string | null;
  /**
   * Small squared logo for white label
   */
  brandLogoSmall: any | null;
  /**
   * Who created the workspace (or first related user if creator is null)
   */
  user: CollectionContentPage_content_TextContent_creator_workspace_user | null;
}

export interface CollectionContentPage_content_TextContent_creator {
  __typename: "User";
  /**
   * Self description of the user
   */
  bio: string | null;
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: CollectionContentPage_content_TextContent_creator_subscriptionPlan;
  /**
   * Main email address
   */
  email: any;
  workspace: CollectionContentPage_content_TextContent_creator_workspace | null;
}

export interface CollectionContentPage_content_TextContent {
  __typename: "TextContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean;
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: CollectionContentPage_content_TextContent_coverDimensions | null;
  /**
   * Content creator
   */
  creator: CollectionContentPage_content_TextContent_creator;
  /**
   * Main description, if given
   */
  description: string | null;
  displayStatus: ContentDisplayStatus;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Notes of the current user about this content
   */
  note: string | null;
  /**
   * Where the element is contained
   */
  parent_folder_id: string | null;
  /**
   * Id of the saved collection copy (in the user's workspace) this content was copied as part of; null if the content is not a copy or was saved individually
   */
  parentSavedCollectionId: string | null;
  tags: string[];
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * Determines if subject content is visible in a collection
   */
  visibilityForCollection: Visibility | null;
  /**
   * Last update of the content
   */
  updatedAt: any;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * When visibility is public and this flag is set to true require registration to view all content
   */
  need_registration: boolean | null;
  body: string;
  /**
   * Total duration in seconds, alias of pdfDetails.estimatedReadingTime
   */
  duration: number | null;
  hasUserVisited: boolean;
}

export type CollectionContentPage_content = CollectionContentPage_content_EventContent | CollectionContentPage_content_QuizContent | CollectionContentPage_content_AudioContent | CollectionContentPage_content_ImageContent | CollectionContentPage_content_VideoContent | CollectionContentPage_content_LinkContent | CollectionContentPage_content_PdfContent | CollectionContentPage_content_ScormContent | CollectionContentPage_content_TextContent;

export interface CollectionContentPage {
  /**
   * Get a content, identified by id or by slug,
   * optionally an authorization token can be used to enable access for current user.
   */
  content: CollectionContentPage_content | null;
}

export interface CollectionContentPageVariables {
  identifier: string;
  token?: string | null;
  collectionIdentifier: string;
  userId?: string | null;
  withContents: boolean;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: ContentPage
// ====================================================

export interface ContentPage_content_EventContent_coverDimensions {
  __typename: "CoverDimensions";
  height: number | null;
  width: number | null;
}

export interface ContentPage_content_EventContent_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface ContentPage_content_EventContent_creator_workspace_user {
  __typename: "User";
  id: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
}

export interface ContentPage_content_EventContent_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
  /**
   * Brand Name for white label
   */
  brandName: string | null;
  /**
   * Small squared logo for white label
   */
  brandLogoSmall: any | null;
  /**
   * Who created the workspace (or first related user if creator is null)
   */
  user: ContentPage_content_EventContent_creator_workspace_user | null;
  /**
   * Slug
   */
  slug: string | null;
}

export interface ContentPage_content_EventContent_creator_preferences {
  __typename: "UserPreferences";
  hidePromoFooter: boolean;
}

export interface ContentPage_content_EventContent_creator {
  __typename: "User";
  /**
   * Self description of the user
   */
  bio: string | null;
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: ContentPage_content_EventContent_creator_subscriptionPlan;
  /**
   * Main email address
   */
  email: any;
  workspace: ContentPage_content_EventContent_creator_workspace | null;
  preferences: ContentPage_content_EventContent_creator_preferences;
}

export interface ContentPage_content_EventContent_originalCreator {
  __typename: "User";
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
}

export interface ContentPage_content_EventContent_registeredUsers {
  __typename: "User";
  id: string;
}

export interface ContentPage_content_EventContent_presences_event {
  __typename: "EventContent";
  /**
   * Unique identifier
   */
  id: string;
}

export interface ContentPage_content_EventContent_presences_user {
  __typename: "User";
  id: string;
}

export interface ContentPage_content_EventContent_presences {
  __typename: "EventContentPresence";
  event: ContentPage_content_EventContent_presences_event;
  user: ContentPage_content_EventContent_presences_user;
  presence: boolean | null;
}

export interface ContentPage_content_EventContent_relatedContents_EventContent {
  __typename: "EventContent" | "ScormContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
}

export interface ContentPage_content_EventContent_relatedContents_AudioContent {
  __typename: "AudioContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Total duration in seconds
   */
  duration: number | null;
}

export interface ContentPage_content_EventContent_relatedContents_ImageContent {
  __typename: "ImageContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
}

export interface ContentPage_content_EventContent_relatedContents_LinkContent {
  __typename: "LinkContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Destination domain
   */
  domain: string | null;
  /**
   * Total duration in seconds, alias of embed.estimatedReadingTime
   */
  duration: number | null;
}

export interface ContentPage_content_EventContent_relatedContents_PdfContent_pdfDetails {
  __typename: "PdfDetails";
  pages: number;
}

export interface ContentPage_content_EventContent_relatedContents_PdfContent {
  __typename: "PdfContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Total duration in seconds, alias of pdfDetails.estimatedReadingTime
   */
  duration: number | null;
  /**
   * PDF document additional details
   */
  pdfDetails: ContentPage_content_EventContent_relatedContents_PdfContent_pdfDetails | null;
  /**
   * Activate PDF download
   */
  canDownload: boolean | null;
}

export interface ContentPage_content_EventContent_relatedContents_QuizContent_questions {
  __typename: "QuizContentQuestionEssay" | "QuizContentQuestionMatching" | "QuizContentQuestionMissingWord" | "QuizContentQuestionMultipleChoice" | "QuizContentQuestionNumerical" | "QuizContentQuestionSingleChoice" | "QuizContentQuestionTrueFalse";
}

export interface ContentPage_content_EventContent_relatedContents_QuizContent {
  __typename: "QuizContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  questions: ContentPage_content_EventContent_relatedContents_QuizContent_questions[];
}

export interface ContentPage_content_EventContent_relatedContents_TextContent {
  __typename: "TextContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Total duration in seconds, alias of pdfDetails.estimatedReadingTime
   */
  duration: number | null;
}

export interface ContentPage_content_EventContent_relatedContents_VideoContent {
  __typename: "VideoContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Total duration in seconds
   */
  duration: number | null;
  /**
   * Destination link
   */
  url: any | null;
  /**
   * Cover picture
   */
  cover: any | null;
  aspectRatio: string | null;
}

export type ContentPage_content_EventContent_relatedContents = ContentPage_content_EventContent_relatedContents_EventContent | ContentPage_content_EventContent_relatedContents_AudioContent | ContentPage_content_EventContent_relatedContents_ImageContent | ContentPage_content_EventContent_relatedContents_LinkContent | ContentPage_content_EventContent_relatedContents_PdfContent | ContentPage_content_EventContent_relatedContents_QuizContent | ContentPage_content_EventContent_relatedContents_TextContent | ContentPage_content_EventContent_relatedContents_VideoContent;

export interface ContentPage_content_EventContent {
  __typename: "EventContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean;
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: ContentPage_content_EventContent_coverDimensions | null;
  /**
   * Content creator
   */
  creator: ContentPage_content_EventContent_creator;
  /**
   * Creator of the original content this is a copy of (null if this is not a copy)
   */
  originalCreator: ContentPage_content_EventContent_originalCreator | null;
  /**
   * Id of the saved collection copy (in the user's workspace) this content was copied as part of; null if the content is not a copy or was saved individually
   */
  parentSavedCollectionId: string | null;
  /**
   * Main description, if given
   */
  description: string | null;
  displayStatus: ContentDisplayStatus;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Notes of the current user about this content
   */
  note: string | null;
  /**
   * Where the element is contained
   */
  parent_folder_id: string | null;
  tags: string[];
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  certificate_id: string | null;
  /**
   * When visibility is public and this flag is set to true require registration to view all content
   */
  need_registration: boolean | null;
  eventStatusForMenu: EventContentStatus;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  expired: any | null;
  isCurrentUserRegistered: boolean;
  participants: number | null;
  registeredUsers: ContentPage_content_EventContent_registeredUsers[];
  registration: boolean;
  status: EventContentStatus;
  /**
   * Content subtype
   */
  subtype: EventContentSubtype;
  /**
   * Destination link
   */
  url: any | null;
  end: any | null;
  start: any | null;
  location: string | null;
  presentation: string | null;
  presences: ContentPage_content_EventContent_presences[];
  relatedContents: ContentPage_content_EventContent_relatedContents[];
}

export interface ContentPage_content_QuizContent_coverDimensions {
  __typename: "CoverDimensions";
  height: number | null;
  width: number | null;
}

export interface ContentPage_content_QuizContent_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface ContentPage_content_QuizContent_creator_workspace_user {
  __typename: "User";
  id: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
}

export interface ContentPage_content_QuizContent_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
  /**
   * Brand Name for white label
   */
  brandName: string | null;
  /**
   * Small squared logo for white label
   */
  brandLogoSmall: any | null;
  /**
   * Who created the workspace (or first related user if creator is null)
   */
  user: ContentPage_content_QuizContent_creator_workspace_user | null;
  /**
   * Slug
   */
  slug: string | null;
}

export interface ContentPage_content_QuizContent_creator_preferences {
  __typename: "UserPreferences";
  hidePromoFooter: boolean;
}

export interface ContentPage_content_QuizContent_creator {
  __typename: "User";
  /**
   * Self description of the user
   */
  bio: string | null;
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: ContentPage_content_QuizContent_creator_subscriptionPlan;
  /**
   * Main email address
   */
  email: any;
  workspace: ContentPage_content_QuizContent_creator_workspace | null;
  preferences: ContentPage_content_QuizContent_creator_preferences;
}

export interface ContentPage_content_QuizContent_originalCreator {
  __typename: "User";
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
}

export interface ContentPage_content_QuizContent {
  __typename: "QuizContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean;
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: ContentPage_content_QuizContent_coverDimensions | null;
  /**
   * Content creator
   */
  creator: ContentPage_content_QuizContent_creator;
  /**
   * Creator of the original content this is a copy of (null if this is not a copy)
   */
  originalCreator: ContentPage_content_QuizContent_originalCreator | null;
  /**
   * Id of the saved collection copy (in the user's workspace) this content was copied as part of; null if the content is not a copy or was saved individually
   */
  parentSavedCollectionId: string | null;
  /**
   * Main description, if given
   */
  description: string | null;
  displayStatus: ContentDisplayStatus;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Notes of the current user about this content
   */
  note: string | null;
  /**
   * Where the element is contained
   */
  parent_folder_id: string | null;
  tags: string[];
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  certificate_id: string | null;
  /**
   * When visibility is public and this flag is set to true require registration to view all content
   */
  need_registration: boolean | null;
  /**
   * Content subtype
   */
  quizSubtypeForMenu: QuizContentSubtype | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Content subtype
   */
  quizSubtype: QuizContentSubtype | null;
}

export interface ContentPage_content_AudioContent_coverDimensions {
  __typename: "CoverDimensions";
  height: number | null;
  width: number | null;
}

export interface ContentPage_content_AudioContent_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface ContentPage_content_AudioContent_creator_workspace_user {
  __typename: "User";
  id: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
}

export interface ContentPage_content_AudioContent_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
  /**
   * Brand Name for white label
   */
  brandName: string | null;
  /**
   * Small squared logo for white label
   */
  brandLogoSmall: any | null;
  /**
   * Who created the workspace (or first related user if creator is null)
   */
  user: ContentPage_content_AudioContent_creator_workspace_user | null;
  /**
   * Slug
   */
  slug: string | null;
}

export interface ContentPage_content_AudioContent_creator_preferences {
  __typename: "UserPreferences";
  hidePromoFooter: boolean;
}

export interface ContentPage_content_AudioContent_creator {
  __typename: "User";
  /**
   * Self description of the user
   */
  bio: string | null;
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: ContentPage_content_AudioContent_creator_subscriptionPlan;
  /**
   * Main email address
   */
  email: any;
  workspace: ContentPage_content_AudioContent_creator_workspace | null;
  preferences: ContentPage_content_AudioContent_creator_preferences;
}

export interface ContentPage_content_AudioContent_originalCreator {
  __typename: "User";
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
}

export interface ContentPage_content_AudioContent {
  __typename: "AudioContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean;
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: ContentPage_content_AudioContent_coverDimensions | null;
  /**
   * Content creator
   */
  creator: ContentPage_content_AudioContent_creator;
  /**
   * Creator of the original content this is a copy of (null if this is not a copy)
   */
  originalCreator: ContentPage_content_AudioContent_originalCreator | null;
  /**
   * Id of the saved collection copy (in the user's workspace) this content was copied as part of; null if the content is not a copy or was saved individually
   */
  parentSavedCollectionId: string | null;
  /**
   * Main description, if given
   */
  description: string | null;
  displayStatus: ContentDisplayStatus;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Notes of the current user about this content
   */
  note: string | null;
  /**
   * Where the element is contained
   */
  parent_folder_id: string | null;
  tags: string[];
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  certificate_id: string | null;
  /**
   * When visibility is public and this flag is set to true require registration to view all content
   */
  need_registration: boolean | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Total duration in seconds
   */
  duration: number | null;
  /**
   * Destination link
   */
  url: any | null;
}

export interface ContentPage_content_ImageContent_coverDimensions {
  __typename: "CoverDimensions";
  height: number | null;
  width: number | null;
}

export interface ContentPage_content_ImageContent_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface ContentPage_content_ImageContent_creator_workspace_user {
  __typename: "User";
  id: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
}

export interface ContentPage_content_ImageContent_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
  /**
   * Brand Name for white label
   */
  brandName: string | null;
  /**
   * Small squared logo for white label
   */
  brandLogoSmall: any | null;
  /**
   * Who created the workspace (or first related user if creator is null)
   */
  user: ContentPage_content_ImageContent_creator_workspace_user | null;
  /**
   * Slug
   */
  slug: string | null;
}

export interface ContentPage_content_ImageContent_creator_preferences {
  __typename: "UserPreferences";
  hidePromoFooter: boolean;
}

export interface ContentPage_content_ImageContent_creator {
  __typename: "User";
  /**
   * Self description of the user
   */
  bio: string | null;
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: ContentPage_content_ImageContent_creator_subscriptionPlan;
  /**
   * Main email address
   */
  email: any;
  workspace: ContentPage_content_ImageContent_creator_workspace | null;
  preferences: ContentPage_content_ImageContent_creator_preferences;
}

export interface ContentPage_content_ImageContent_originalCreator {
  __typename: "User";
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
}

export interface ContentPage_content_ImageContent {
  __typename: "ImageContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean;
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: ContentPage_content_ImageContent_coverDimensions | null;
  /**
   * Content creator
   */
  creator: ContentPage_content_ImageContent_creator;
  /**
   * Creator of the original content this is a copy of (null if this is not a copy)
   */
  originalCreator: ContentPage_content_ImageContent_originalCreator | null;
  /**
   * Id of the saved collection copy (in the user's workspace) this content was copied as part of; null if the content is not a copy or was saved individually
   */
  parentSavedCollectionId: string | null;
  /**
   * Main description, if given
   */
  description: string | null;
  displayStatus: ContentDisplayStatus;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Notes of the current user about this content
   */
  note: string | null;
  /**
   * Where the element is contained
   */
  parent_folder_id: string | null;
  tags: string[];
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  certificate_id: string | null;
  /**
   * When visibility is public and this flag is set to true require registration to view all content
   */
  need_registration: boolean | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Content subtype
   */
  imageSubtype: string | null;
  /**
   * Destination link
   */
  url: any | null;
  /**
   * Effective images URL
   */
  urls: any[];
}

export interface ContentPage_content_VideoContent_coverDimensions {
  __typename: "CoverDimensions";
  height: number | null;
  width: number | null;
}

export interface ContentPage_content_VideoContent_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface ContentPage_content_VideoContent_creator_workspace_user {
  __typename: "User";
  id: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
}

export interface ContentPage_content_VideoContent_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
  /**
   * Brand Name for white label
   */
  brandName: string | null;
  /**
   * Small squared logo for white label
   */
  brandLogoSmall: any | null;
  /**
   * Who created the workspace (or first related user if creator is null)
   */
  user: ContentPage_content_VideoContent_creator_workspace_user | null;
  /**
   * Slug
   */
  slug: string | null;
}

export interface ContentPage_content_VideoContent_creator_preferences {
  __typename: "UserPreferences";
  hidePromoFooter: boolean;
}

export interface ContentPage_content_VideoContent_creator {
  __typename: "User";
  /**
   * Self description of the user
   */
  bio: string | null;
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: ContentPage_content_VideoContent_creator_subscriptionPlan;
  /**
   * Main email address
   */
  email: any;
  workspace: ContentPage_content_VideoContent_creator_workspace | null;
  preferences: ContentPage_content_VideoContent_creator_preferences;
}

export interface ContentPage_content_VideoContent_originalCreator {
  __typename: "User";
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
}

export interface ContentPage_content_VideoContent {
  __typename: "VideoContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean;
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: ContentPage_content_VideoContent_coverDimensions | null;
  /**
   * Content creator
   */
  creator: ContentPage_content_VideoContent_creator;
  /**
   * Creator of the original content this is a copy of (null if this is not a copy)
   */
  originalCreator: ContentPage_content_VideoContent_originalCreator | null;
  /**
   * Id of the saved collection copy (in the user's workspace) this content was copied as part of; null if the content is not a copy or was saved individually
   */
  parentSavedCollectionId: string | null;
  /**
   * Main description, if given
   */
  description: string | null;
  displayStatus: ContentDisplayStatus;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Notes of the current user about this content
   */
  note: string | null;
  /**
   * Where the element is contained
   */
  parent_folder_id: string | null;
  tags: string[];
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  certificate_id: string | null;
  /**
   * When visibility is public and this flag is set to true require registration to view all content
   */
  need_registration: boolean | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Total duration in seconds
   */
  duration: number | null;
  /**
   * Destination link
   */
  url: any | null;
  aspectRatio: string | null;
}

export interface ContentPage_content_LinkContent_coverDimensions {
  __typename: "CoverDimensions";
  height: number | null;
  width: number | null;
}

export interface ContentPage_content_LinkContent_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface ContentPage_content_LinkContent_creator_workspace_user {
  __typename: "User";
  id: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
}

export interface ContentPage_content_LinkContent_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
  /**
   * Brand Name for white label
   */
  brandName: string | null;
  /**
   * Small squared logo for white label
   */
  brandLogoSmall: any | null;
  /**
   * Who created the workspace (or first related user if creator is null)
   */
  user: ContentPage_content_LinkContent_creator_workspace_user | null;
  /**
   * Slug
   */
  slug: string | null;
}

export interface ContentPage_content_LinkContent_creator_preferences {
  __typename: "UserPreferences";
  hidePromoFooter: boolean;
}

export interface ContentPage_content_LinkContent_creator {
  __typename: "User";
  /**
   * Self description of the user
   */
  bio: string | null;
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: ContentPage_content_LinkContent_creator_subscriptionPlan;
  /**
   * Main email address
   */
  email: any;
  workspace: ContentPage_content_LinkContent_creator_workspace | null;
  preferences: ContentPage_content_LinkContent_creator_preferences;
}

export interface ContentPage_content_LinkContent_originalCreator {
  __typename: "User";
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
}

export interface ContentPage_content_LinkContent {
  __typename: "LinkContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean;
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: ContentPage_content_LinkContent_coverDimensions | null;
  /**
   * Content creator
   */
  creator: ContentPage_content_LinkContent_creator;
  /**
   * Creator of the original content this is a copy of (null if this is not a copy)
   */
  originalCreator: ContentPage_content_LinkContent_originalCreator | null;
  /**
   * Id of the saved collection copy (in the user's workspace) this content was copied as part of; null if the content is not a copy or was saved individually
   */
  parentSavedCollectionId: string | null;
  /**
   * Main description, if given
   */
  description: string | null;
  displayStatus: ContentDisplayStatus;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Notes of the current user about this content
   */
  note: string | null;
  /**
   * Where the element is contained
   */
  parent_folder_id: string | null;
  tags: string[];
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  certificate_id: string | null;
  /**
   * When visibility is public and this flag is set to true require registration to view all content
   */
  need_registration: boolean | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Destination domain
   */
  domain: string | null;
  /**
   * Total duration in seconds, alias of embed.estimatedReadingTime
   */
  duration: number | null;
  /**
   * Destination link
   */
  url: any | null;
}

export interface ContentPage_content_PdfContent_coverDimensions {
  __typename: "CoverDimensions";
  height: number | null;
  width: number | null;
}

export interface ContentPage_content_PdfContent_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface ContentPage_content_PdfContent_creator_workspace_user {
  __typename: "User";
  id: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
}

export interface ContentPage_content_PdfContent_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
  /**
   * Brand Name for white label
   */
  brandName: string | null;
  /**
   * Small squared logo for white label
   */
  brandLogoSmall: any | null;
  /**
   * Who created the workspace (or first related user if creator is null)
   */
  user: ContentPage_content_PdfContent_creator_workspace_user | null;
  /**
   * Slug
   */
  slug: string | null;
}

export interface ContentPage_content_PdfContent_creator_preferences {
  __typename: "UserPreferences";
  hidePromoFooter: boolean;
}

export interface ContentPage_content_PdfContent_creator {
  __typename: "User";
  /**
   * Self description of the user
   */
  bio: string | null;
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: ContentPage_content_PdfContent_creator_subscriptionPlan;
  /**
   * Main email address
   */
  email: any;
  workspace: ContentPage_content_PdfContent_creator_workspace | null;
  preferences: ContentPage_content_PdfContent_creator_preferences;
}

export interface ContentPage_content_PdfContent_originalCreator {
  __typename: "User";
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
}

export interface ContentPage_content_PdfContent_pdfDetails {
  __typename: "PdfDetails";
  pages: number;
}

export interface ContentPage_content_PdfContent {
  __typename: "PdfContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean;
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: ContentPage_content_PdfContent_coverDimensions | null;
  /**
   * Content creator
   */
  creator: ContentPage_content_PdfContent_creator;
  /**
   * Creator of the original content this is a copy of (null if this is not a copy)
   */
  originalCreator: ContentPage_content_PdfContent_originalCreator | null;
  /**
   * Id of the saved collection copy (in the user's workspace) this content was copied as part of; null if the content is not a copy or was saved individually
   */
  parentSavedCollectionId: string | null;
  /**
   * Main description, if given
   */
  description: string | null;
  displayStatus: ContentDisplayStatus;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Notes of the current user about this content
   */
  note: string | null;
  /**
   * Where the element is contained
   */
  parent_folder_id: string | null;
  tags: string[];
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  certificate_id: string | null;
  /**
   * When visibility is public and this flag is set to true require registration to view all content
   */
  need_registration: boolean | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Total duration in seconds, alias of pdfDetails.estimatedReadingTime
   */
  duration: number | null;
  /**
   * PDF document additional details
   */
  pdfDetails: ContentPage_content_PdfContent_pdfDetails | null;
  /**
   * Destination link
   */
  url: any | null;
  /**
   * Activate PDF download
   */
  canDownload: boolean | null;
}

export interface ContentPage_content_ScormContent_coverDimensions {
  __typename: "CoverDimensions";
  height: number | null;
  width: number | null;
}

export interface ContentPage_content_ScormContent_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface ContentPage_content_ScormContent_creator_workspace_user {
  __typename: "User";
  id: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
}

export interface ContentPage_content_ScormContent_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
  /**
   * Brand Name for white label
   */
  brandName: string | null;
  /**
   * Small squared logo for white label
   */
  brandLogoSmall: any | null;
  /**
   * Who created the workspace (or first related user if creator is null)
   */
  user: ContentPage_content_ScormContent_creator_workspace_user | null;
  /**
   * Slug
   */
  slug: string | null;
}

export interface ContentPage_content_ScormContent_creator_preferences {
  __typename: "UserPreferences";
  hidePromoFooter: boolean;
}

export interface ContentPage_content_ScormContent_creator {
  __typename: "User";
  /**
   * Self description of the user
   */
  bio: string | null;
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: ContentPage_content_ScormContent_creator_subscriptionPlan;
  /**
   * Main email address
   */
  email: any;
  workspace: ContentPage_content_ScormContent_creator_workspace | null;
  preferences: ContentPage_content_ScormContent_creator_preferences;
}

export interface ContentPage_content_ScormContent_originalCreator {
  __typename: "User";
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
}

export interface ContentPage_content_ScormContent {
  __typename: "ScormContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean;
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: ContentPage_content_ScormContent_coverDimensions | null;
  /**
   * Content creator
   */
  creator: ContentPage_content_ScormContent_creator;
  /**
   * Creator of the original content this is a copy of (null if this is not a copy)
   */
  originalCreator: ContentPage_content_ScormContent_originalCreator | null;
  /**
   * Id of the saved collection copy (in the user's workspace) this content was copied as part of; null if the content is not a copy or was saved individually
   */
  parentSavedCollectionId: string | null;
  /**
   * Main description, if given
   */
  description: string | null;
  displayStatus: ContentDisplayStatus;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Notes of the current user about this content
   */
  note: string | null;
  /**
   * Where the element is contained
   */
  parent_folder_id: string | null;
  tags: string[];
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  certificate_id: string | null;
  /**
   * When visibility is public and this flag is set to true require registration to view all content
   */
  need_registration: boolean | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Expected time to complete the package, in seconds: the LOM typicalLearningTime the package declares, read on import, or what the author set by hand; null when unknown. Unrelated to timeLimit
   */
  duration: number | null;
}

export interface ContentPage_content_TextContent_coverDimensions {
  __typename: "CoverDimensions";
  height: number | null;
  width: number | null;
}

export interface ContentPage_content_TextContent_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface ContentPage_content_TextContent_creator_workspace_user {
  __typename: "User";
  id: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
}

export interface ContentPage_content_TextContent_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
  /**
   * Brand Name for white label
   */
  brandName: string | null;
  /**
   * Small squared logo for white label
   */
  brandLogoSmall: any | null;
  /**
   * Who created the workspace (or first related user if creator is null)
   */
  user: ContentPage_content_TextContent_creator_workspace_user | null;
  /**
   * Slug
   */
  slug: string | null;
}

export interface ContentPage_content_TextContent_creator_preferences {
  __typename: "UserPreferences";
  hidePromoFooter: boolean;
}

export interface ContentPage_content_TextContent_creator {
  __typename: "User";
  /**
   * Self description of the user
   */
  bio: string | null;
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: ContentPage_content_TextContent_creator_subscriptionPlan;
  /**
   * Main email address
   */
  email: any;
  workspace: ContentPage_content_TextContent_creator_workspace | null;
  preferences: ContentPage_content_TextContent_creator_preferences;
}

export interface ContentPage_content_TextContent_originalCreator {
  __typename: "User";
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
}

export interface ContentPage_content_TextContent {
  __typename: "TextContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean;
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: ContentPage_content_TextContent_coverDimensions | null;
  /**
   * Content creator
   */
  creator: ContentPage_content_TextContent_creator;
  /**
   * Creator of the original content this is a copy of (null if this is not a copy)
   */
  originalCreator: ContentPage_content_TextContent_originalCreator | null;
  /**
   * Id of the saved collection copy (in the user's workspace) this content was copied as part of; null if the content is not a copy or was saved individually
   */
  parentSavedCollectionId: string | null;
  /**
   * Main description, if given
   */
  description: string | null;
  displayStatus: ContentDisplayStatus;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Notes of the current user about this content
   */
  note: string | null;
  /**
   * Where the element is contained
   */
  parent_folder_id: string | null;
  tags: string[];
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  certificate_id: string | null;
  /**
   * When visibility is public and this flag is set to true require registration to view all content
   */
  need_registration: boolean | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  body: string;
  /**
   * Total duration in seconds, alias of pdfDetails.estimatedReadingTime
   */
  duration: number | null;
}

export type ContentPage_content = ContentPage_content_EventContent | ContentPage_content_QuizContent | ContentPage_content_AudioContent | ContentPage_content_ImageContent | ContentPage_content_VideoContent | ContentPage_content_LinkContent | ContentPage_content_PdfContent | ContentPage_content_ScormContent | ContentPage_content_TextContent;

export interface ContentPage {
  /**
   * Get a content, identified by id or by slug,
   * optionally an authorization token can be used to enable access for current user.
   */
  content: ContentPage_content | null;
}

export interface ContentPageVariables {
  identifier: string;
  token?: string | null;
  withContents: boolean;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateContent
// ====================================================

export interface CreateContent_content {
  __typename: "AudioContent" | "EventContent" | "ImageContent" | "LinkContent" | "PdfContent" | "QuizContent" | "ScormContent" | "TextContent" | "VideoContent";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
}

export interface CreateContent {
  content: CreateContent_content;
}

export interface CreateContentVariables {
  input: CreateContentInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateEventContent
// ====================================================

export interface CreateEventContent_content {
  __typename: "EventContent";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
}

export interface CreateEventContent {
  content: CreateEventContent_content;
}

export interface CreateEventContentVariables {
  input: CreateEventContentInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AppCreateContentImage
// ====================================================

export interface AppCreateContentImage_content {
  __typename: "ImageContent";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
}

export interface AppCreateContentImage {
  content: AppCreateContentImage_content;
}

export interface AppCreateContentImageVariables {
  input: CreateImageContentInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: Oembed
// ====================================================

export interface Oembed_oEmbed {
  __typename: "OEmbed";
  /**
   * The resource description
   */
  description: string | null;
  /**
   * Canonical URL
   */
  id: any;
  /**
   * A URL to a thumbnail image representing the resource.
   */
  image: any | null;
  /**
   * A text title, describing the resource.
   */
  title: string | null;
}

export interface Oembed {
  /**
   * Extract oEmbed data from URL
   * https: // oembed.com/
   */
  oEmbed: Oembed_oEmbed | null;
}

export interface OembedVariables {
  url: any;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateQuizContent
// ====================================================

export interface CreateQuizContent_content {
  __typename: "QuizContent";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
}

export interface CreateQuizContent {
  content: CreateQuizContent_content;
}

export interface CreateQuizContentVariables {
  input: CreateQuizContentInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: GenerateScormUploadUrl
// ====================================================

export interface GenerateScormUploadUrl_generateScormUploadUrl {
  __typename: "ScormUploadSession";
  /**
   * Pass it to initiateScormImport once the archive is uploaded
   */
  importId: string;
  /**
   * Presigned URL the zip archive is PUT to
   */
  uploadUrl: string;
  /**
   * Seconds before uploadUrl expires
   */
  expiresIn: number;
  /**
   * Largest archive the import accepts, in bytes
   */
  maxPackageBytes: number;
}

export interface GenerateScormUploadUrl {
  /**
   * Presign the upload of a SCORM package archive (.zip)
   */
  generateScormUploadUrl: GenerateScormUploadUrl_generateScormUploadUrl;
}

export interface GenerateScormUploadUrlVariables {
  parentFolderId?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: InitiateScormImport
// ====================================================

export interface InitiateScormImport_initiateScormImport_errors {
  __typename: "ImportJobError";
  id: string;
  errorMessage: string;
}

export interface InitiateScormImport_initiateScormImport {
  __typename: "ImportJob";
  id: string;
  status: ImportJobStatus;
  metadata: any | null;
  errors: InitiateScormImport_initiateScormImport_errors[];
}

export interface InitiateScormImport {
  /**
   * Import a SCORM package uploaded through generateScormUploadUrl.
   * Poll importJob(id) for the outcome: on success its metadata.result carries the contentId,
   * the unsupported features and the warnings for the author.
   */
  initiateScormImport: InitiateScormImport_initiateScormImport;
}

export interface InitiateScormImportVariables {
  importId: string;
  filename?: string | null;
  parentFolderId?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: ScormImportFolder
// ====================================================

export interface ScormImportFolder_folder {
  __typename: "Folder";
  /**
   * Unique identifier
   */
  id: string;
}

export interface ScormImportFolder {
  /**
   * Get a folder, identified by id or by slug,
   * optionally an authorization token can be used to enable access for current user.
   */
  folder: ScormImportFolder_folder | null;
}

export interface ScormImportFolderVariables {
  identifier: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: ScormImportJob
// ====================================================

export interface ScormImportJob_importJob_errors {
  __typename: "ImportJobError";
  id: string;
  errorMessage: string;
}

export interface ScormImportJob_importJob {
  __typename: "ImportJob";
  id: string;
  status: ImportJobStatus;
  metadata: any | null;
  errors: ScormImportJob_importJob_errors[];
}

export interface ScormImportJob {
  importJob: ScormImportJob_importJob | null;
}

export interface ScormImportJobVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: ScormImportedContent
// ====================================================

export interface ScormImportedContent_content {
  __typename: "AudioContent" | "EventContent" | "ImageContent" | "LinkContent" | "PdfContent" | "QuizContent" | "ScormContent" | "TextContent" | "VideoContent";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
}

export interface ScormImportedContent {
  /**
   * Get a content, identified by id or by slug,
   * optionally an authorization token can be used to enable access for current user.
   */
  content: ScormImportedContent_content | null;
}

export interface ScormImportedContentVariables {
  identifier: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateTextContent
// ====================================================

export interface CreateTextContent_createTextContent {
  __typename: "AudioContent" | "EventContent" | "ImageContent" | "LinkContent" | "PdfContent" | "QuizContent" | "ScormContent" | "TextContent" | "VideoContent";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
}

export interface CreateTextContent {
  createTextContent: CreateTextContent_createTextContent;
}

export interface CreateTextContentVariables {
  input: CreateTextContentInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: ContentForEdit
// ====================================================

export interface ContentForEdit_content_AudioContent {
  __typename: "AudioContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  tags: string[];
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  certificate_id: string | null;
  /**
   * Destination link
   */
  url: any | null;
}

export interface ContentForEdit_content_EventContent {
  __typename: "EventContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  tags: string[];
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  certificate_id: string | null;
  end: any | null;
  /**
   * Content subtype
   */
  eventSubtype: EventContentSubtype;
  location: string | null;
  participants: number | null;
  presentation: string | null;
  registration: boolean;
  start: any | null;
  /**
   * Destination link
   */
  url: any | null;
}

export interface ContentForEdit_content_LinkContent {
  __typename: "LinkContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  tags: string[];
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  certificate_id: string | null;
  /**
   * Destination link
   */
  url: any | null;
}

export interface ContentForEdit_content_PdfContent {
  __typename: "PdfContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  tags: string[];
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  certificate_id: string | null;
  /**
   * Destination link
   */
  url: any | null;
  /**
   * Activate PDF download
   */
  canDownload: boolean | null;
}

export interface ContentForEdit_content_ScormContent {
  __typename: "ScormContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  tags: string[];
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  certificate_id: string | null;
  /**
   * Expected time to complete the package, in seconds: the LOM typicalLearningTime the package declares, read on import, or what the author set by hand; null when unknown. Unrelated to timeLimit
   */
  duration: number | null;
}

export interface ContentForEdit_content_ImageContent {
  __typename: "ImageContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  tags: string[];
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  certificate_id: string | null;
  /**
   * Content subtype
   */
  imageSubtype: string | null;
  /**
   * Destination link
   */
  url: any | null;
  /**
   * Effective images URL
   */
  urls: any[];
}

export interface ContentForEdit_content_TextContent {
  __typename: "TextContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  tags: string[];
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  certificate_id: string | null;
  body: string;
  /**
   * Destination link
   */
  url: any | null;
}

export interface ContentForEdit_content_VideoContent {
  __typename: "VideoContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  tags: string[];
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  certificate_id: string | null;
  /**
   * Destination link
   */
  url: any | null;
}

export interface ContentForEdit_content_QuizContent_questions_QuizContentQuestionEssay {
  __typename: "QuizContentQuestionEssay";
  canBeSkipped: boolean | null;
  failureFeedback: string | null;
  failurePoints: number | null;
  id: string;
  image: any | null;
  missingPoints: number | null;
  successFeedback: string | null;
  successPoints: number | null;
  timeLimit: number | null;
  title: string | null;
  type: QuizContentQuestionType;
}

export interface ContentForEdit_content_QuizContent_questions_QuizContentQuestionMatching_matchPairs {
  __typename: "QuizContentQuestionMatchingRow";
  subanswer: string;
  subquestion: string;
}

export interface ContentForEdit_content_QuizContent_questions_QuizContentQuestionMatching {
  __typename: "QuizContentQuestionMatching";
  canBeSkipped: boolean | null;
  failureFeedback: string | null;
  failurePoints: number | null;
  id: string;
  image: any | null;
  matchPairs: ContentForEdit_content_QuizContent_questions_QuizContentQuestionMatching_matchPairs[];
  missingPoints: number | null;
  successFeedback: string | null;
  successPoints: number | null;
  timeLimit: number | null;
  title: string | null;
  type: QuizContentQuestionType;
}

export interface ContentForEdit_content_QuizContent_questions_QuizContentQuestionMissingWord {
  __typename: "QuizContentQuestionMissingWord";
  canBeSkipped: boolean | null;
  failureFeedback: string | null;
  failurePoints: number | null;
  id: string;
  image: any | null;
  missingPoints: number | null;
  successFeedback: string | null;
  successPoints: number | null;
  timeLimit: number | null;
  title: string | null;
  type: QuizContentQuestionType;
}

export interface ContentForEdit_content_QuizContent_questions_QuizContentQuestionMultipleChoice_choices {
  __typename: "QuizContentQuestionTextChoice";
  isCorrect: boolean;
  text: string;
}

export interface ContentForEdit_content_QuizContent_questions_QuizContentQuestionMultipleChoice {
  __typename: "QuizContentQuestionMultipleChoice";
  canBeSkipped: boolean | null;
  choices: ContentForEdit_content_QuizContent_questions_QuizContentQuestionMultipleChoice_choices[];
  failureFeedback: string | null;
  failurePoints: number | null;
  id: string;
  missingPoints: number | null;
  successFeedback: string | null;
  successPoints: number | null;
  timeLimit: number | null;
  title: string | null;
  type: QuizContentQuestionType;
}

export interface ContentForEdit_content_QuizContent_questions_QuizContentQuestionNumerical {
  __typename: "QuizContentQuestionNumerical";
  canBeSkipped: boolean | null;
  failureFeedback: string | null;
  failurePoints: number | null;
  id: string;
  missingPoints: number | null;
  number: number;
  range: number | null;
  successFeedback: string | null;
  successPoints: number | null;
  timeLimit: number | null;
  title: string | null;
  type: QuizContentQuestionType;
}

export interface ContentForEdit_content_QuizContent_questions_QuizContentQuestionSingleChoice_choices {
  __typename: "QuizContentQuestionTextChoice";
  isCorrect: boolean;
  text: string;
}

export interface ContentForEdit_content_QuizContent_questions_QuizContentQuestionSingleChoice {
  __typename: "QuizContentQuestionSingleChoice";
  canBeSkipped: boolean | null;
  choices: ContentForEdit_content_QuizContent_questions_QuizContentQuestionSingleChoice_choices[];
  failureFeedback: string | null;
  failurePoints: number | null;
  id: string;
  missingPoints: number | null;
  successFeedback: string | null;
  successPoints: number | null;
  timeLimit: number | null;
  title: string | null;
  type: QuizContentQuestionType;
}

export interface ContentForEdit_content_QuizContent_questions_QuizContentQuestionTrueFalse {
  __typename: "QuizContentQuestionTrueFalse";
  canBeSkipped: boolean | null;
  failureFeedback: string | null;
  failurePoints: number | null;
  id: string;
  isTrue: boolean;
  missingPoints: number | null;
  successFeedback: string | null;
  successPoints: number | null;
  timeLimit: number | null;
  title: string | null;
  type: QuizContentQuestionType;
}

export type ContentForEdit_content_QuizContent_questions = ContentForEdit_content_QuizContent_questions_QuizContentQuestionEssay | ContentForEdit_content_QuizContent_questions_QuizContentQuestionMatching | ContentForEdit_content_QuizContent_questions_QuizContentQuestionMissingWord | ContentForEdit_content_QuizContent_questions_QuizContentQuestionMultipleChoice | ContentForEdit_content_QuizContent_questions_QuizContentQuestionNumerical | ContentForEdit_content_QuizContent_questions_QuizContentQuestionSingleChoice | ContentForEdit_content_QuizContent_questions_QuizContentQuestionTrueFalse;

export interface ContentForEdit_content_QuizContent {
  __typename: "QuizContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  tags: string[];
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  certificate_id: string | null;
  appendRequiredQuestions: boolean;
  basket: number | null;
  canRepeat: boolean;
  canRepeatMaximum: number | null;
  canRepeatOnlyFailure: boolean;
  instructions: string | null;
  questions: ContentForEdit_content_QuizContent_questions[];
  questionsNavigation: boolean;
  quizFeedbackFailureImage: any | null;
  quizFeedbackFailureMessage: string | null;
  quizFeedbackSuccessImage: any | null;
  quizFeedbackSuccessMessage: string | null;
  /**
   * Content subtype
   */
  quizSubtype: QuizContentSubtype | null;
  randomOrder: boolean;
  restartFromBegin: boolean;
  separateEvaluation: boolean;
  showAnswer: boolean;
  showProgress: boolean;
  showSummary: boolean;
  successPoints: number | null;
  timeLimit: number | null;
}

export type ContentForEdit_content = ContentForEdit_content_AudioContent | ContentForEdit_content_EventContent | ContentForEdit_content_LinkContent | ContentForEdit_content_PdfContent | ContentForEdit_content_ScormContent | ContentForEdit_content_ImageContent | ContentForEdit_content_TextContent | ContentForEdit_content_VideoContent | ContentForEdit_content_QuizContent;

export interface ContentForEdit {
  /**
   * Get a content, identified by id or by slug,
   * optionally an authorization token can be used to enable access for current user.
   */
  content: ContentForEdit_content | null;
}

export interface ContentForEditVariables {
  identifier: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateEventContent
// ====================================================

export interface UpdateEventContent_content {
  __typename: "EventContent";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
}

export interface UpdateEventContent {
  content: UpdateEventContent_content;
}

export interface UpdateEventContentVariables {
  id: string;
  input: UpdateEventContentInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateImageContent
// ====================================================

export interface UpdateImageContent_content {
  __typename: "AudioContent" | "EventContent" | "ImageContent" | "LinkContent" | "PdfContent" | "QuizContent" | "ScormContent" | "TextContent" | "VideoContent";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
}

export interface UpdateImageContent {
  content: UpdateImageContent_content;
}

export interface UpdateImageContentVariables {
  id: string;
  input: UpdateImageContentInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateQuizContent
// ====================================================

export interface UpdateQuizContent_content_questions {
  __typename: "QuizContentQuestionEssay" | "QuizContentQuestionMatching" | "QuizContentQuestionMissingWord" | "QuizContentQuestionMultipleChoice" | "QuizContentQuestionNumerical" | "QuizContentQuestionSingleChoice" | "QuizContentQuestionTrueFalse";
  id: string;
  title: string | null;
}

export interface UpdateQuizContent_content {
  __typename: "QuizContent";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  questions: UpdateQuizContent_content_questions[];
}

export interface UpdateQuizContent {
  content: UpdateQuizContent_content;
}

export interface UpdateQuizContentVariables {
  id: string;
  input: UpdateQuizContentInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateTextContent
// ====================================================

export interface UpdateTextContent_content {
  __typename: "AudioContent" | "EventContent" | "ImageContent" | "LinkContent" | "PdfContent" | "QuizContent" | "ScormContent" | "TextContent" | "VideoContent";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
}

export interface UpdateTextContent {
  content: UpdateTextContent_content;
}

export interface UpdateTextContentVariables {
  id: string;
  input: UpdateTextContentInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateContent
// ====================================================

export interface UpdateContent_content {
  __typename: "AudioContent" | "EventContent" | "ImageContent" | "LinkContent" | "PdfContent" | "QuizContent" | "ScormContent" | "TextContent" | "VideoContent";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * When visibility is public and this flag is set to true require registration to view all content
   */
  need_registration: boolean | null;
}

export interface UpdateContent {
  content: UpdateContent_content;
}

export interface UpdateContentVariables {
  id: string;
  input: UpdateContentInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: AppEventPresences
// ====================================================

export interface AppEventPresences_content_AudioContent {
  __typename: "AudioContent" | "ImageContent" | "LinkContent" | "PdfContent" | "QuizContent" | "ScormContent" | "TextContent" | "VideoContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Main title
   */
  title: string;
}

export interface AppEventPresences_content_EventContent_presences_user {
  __typename: "User";
  /**
   * Main email address
   */
  email: any;
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
}

export interface AppEventPresences_content_EventContent_presences {
  __typename: "EventContentPresence";
  presence: boolean | null;
  user: AppEventPresences_content_EventContent_presences_user;
}

export interface AppEventPresences_content_EventContent {
  __typename: "EventContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Main title
   */
  title: string;
  presences: AppEventPresences_content_EventContent_presences[];
}

export type AppEventPresences_content = AppEventPresences_content_AudioContent | AppEventPresences_content_EventContent;

export interface AppEventPresences {
  /**
   * Get a content, identified by id or by slug,
   * optionally an authorization token can be used to enable access for current user.
   */
  content: AppEventPresences_content | null;
}

export interface AppEventPresencesVariables {
  identifier: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AppEventPresencesToggle
// ====================================================

export interface AppEventPresencesToggle_toggleEventContentUserPresence {
  __typename: "EventContent";
  /**
   * Unique identifier
   */
  id: string;
}

export interface AppEventPresencesToggle {
  toggleEventContentUserPresence: AppEventPresencesToggle_toggleEventContentUserPresence;
}

export interface AppEventPresencesToggleVariables {
  eventId: string;
  presence: boolean;
  userId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: SaveContent
// ====================================================

export interface SaveContent_saveContent_creator {
  __typename: "User";
  id: string;
  /**
   * Full name
   */
  name: string;
}

export interface SaveContent_saveContent_originalCreator {
  __typename: "User";
  id: string;
  /**
   * Full name
   */
  name: string;
}

export interface SaveContent_saveContent {
  __typename: "AudioContent" | "EventContent" | "ImageContent" | "LinkContent" | "PdfContent" | "QuizContent" | "ScormContent" | "TextContent" | "VideoContent";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * Content creator
   */
  creator: SaveContent_saveContent_creator;
  /**
   * Creator of the original content this is a copy of (null if this is not a copy)
   */
  originalCreator: SaveContent_saveContent_originalCreator | null;
}

export interface SaveContent {
  /**
   * Copy a content from another creator into the authenticated user's workspace
   */
  saveContent: SaveContent_saveContent;
}

export interface SaveContentVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: AppQuizSessionsEvaluation
// ====================================================

export interface AppQuizSessionsEvaluation_content_AudioContent {
  __typename: "AudioContent" | "EventContent" | "ImageContent" | "LinkContent" | "PdfContent" | "ScormContent" | "TextContent" | "VideoContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Main title
   */
  title: string;
}

export interface AppQuizSessionsEvaluation_content_QuizContent_paginatedSessions_data_questions {
  __typename: "QuizContentQuestionEssay" | "QuizContentQuestionMatching" | "QuizContentQuestionMissingWord" | "QuizContentQuestionMultipleChoice" | "QuizContentQuestionNumerical" | "QuizContentQuestionSingleChoice" | "QuizContentQuestionTrueFalse";
  id: string;
}

export interface AppQuizSessionsEvaluation_content_QuizContent_paginatedSessions_data_quiz {
  __typename: "QuizContent";
  /**
   * Unique identifier
   */
  id: string;
}

export interface AppQuizSessionsEvaluation_content_QuizContent_paginatedSessions_data_user {
  __typename: "User";
  /**
   * Main email address
   */
  email: any;
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
}

export interface AppQuizSessionsEvaluation_content_QuizContent_paginatedSessions_data {
  __typename: "QuizContentSession";
  answers: any;
  completed: boolean;
  /**
   * When session was created
   */
  createdAt: any;
  id: string;
  points: any;
  questions: AppQuizSessionsEvaluation_content_QuizContent_paginatedSessions_data_questions[];
  quiz: AppQuizSessionsEvaluation_content_QuizContent_paginatedSessions_data_quiz;
  success: boolean;
  user: AppQuizSessionsEvaluation_content_QuizContent_paginatedSessions_data_user;
}

export interface AppQuizSessionsEvaluation_content_QuizContent_paginatedSessions_paginatorInfo {
  __typename: "PaginatorInfo";
  currentPage: number;
  lastPage: number;
  perPage: number;
  total: number;
  count: number;
  hasMorePages: boolean;
}

export interface AppQuizSessionsEvaluation_content_QuizContent_paginatedSessions {
  __typename: "PaginatedQuizContentSessions";
  data: AppQuizSessionsEvaluation_content_QuizContent_paginatedSessions_data[];
  paginatorInfo: AppQuizSessionsEvaluation_content_QuizContent_paginatedSessions_paginatorInfo;
}

export interface AppQuizSessionsEvaluation_content_QuizContent {
  __typename: "QuizContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Main title
   */
  title: string;
  paginatedSessions: AppQuizSessionsEvaluation_content_QuizContent_paginatedSessions;
}

export type AppQuizSessionsEvaluation_content = AppQuizSessionsEvaluation_content_AudioContent | AppQuizSessionsEvaluation_content_QuizContent;

export interface AppQuizSessionsEvaluation {
  /**
   * Get a content, identified by id or by slug,
   * optionally an authorization token can be used to enable access for current user.
   */
  content: AppQuizSessionsEvaluation_content | null;
}

export interface AppQuizSessionsEvaluationVariables {
  identifier: string;
  page?: number | null;
  first?: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: AppQuizSession
// ====================================================

export interface AppQuizSession_session_questions {
  __typename: "QuizContentQuestionEssay" | "QuizContentQuestionMatching" | "QuizContentQuestionMissingWord" | "QuizContentQuestionMultipleChoice" | "QuizContentQuestionNumerical" | "QuizContentQuestionSingleChoice" | "QuizContentQuestionTrueFalse";
  id: string;
  title: string | null;
}

export interface AppQuizSession_session_quiz {
  __typename: "QuizContent";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Main title
   */
  title: string;
}

export interface AppQuizSession_session_user {
  __typename: "User";
  id: string;
  /**
   * Full name
   */
  name: string;
}

export interface AppQuizSession_session {
  __typename: "QuizContentSession";
  answers: any;
  completed: boolean;
  /**
   * When session was created
   */
  createdAt: any;
  id: string;
  points: any;
  questions: AppQuizSession_session_questions[];
  quiz: AppQuizSession_session_quiz;
  success: boolean;
  user: AppQuizSession_session_user;
}

export interface AppQuizSession {
  session: AppQuizSession_session | null;
}

export interface AppQuizSessionVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetQuizQuestions
// ====================================================

export interface GetQuizQuestions_content_AudioContent {
  __typename: "AudioContent" | "EventContent" | "ImageContent" | "LinkContent" | "PdfContent" | "ScormContent" | "TextContent" | "VideoContent";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Last update of the content
   */
  updatedAt: any;
}

export interface GetQuizQuestions_content_QuizContent_questions {
  __typename: "QuizContentQuestionEssay" | "QuizContentQuestionMatching" | "QuizContentQuestionMissingWord" | "QuizContentQuestionMultipleChoice" | "QuizContentQuestionNumerical" | "QuizContentQuestionSingleChoice" | "QuizContentQuestionTrueFalse";
  id: string;
  title: string | null;
}

export interface GetQuizQuestions_content_QuizContent {
  __typename: "QuizContent";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Last update of the content
   */
  updatedAt: any;
  questions: GetQuizQuestions_content_QuizContent_questions[];
}

export type GetQuizQuestions_content = GetQuizQuestions_content_AudioContent | GetQuizQuestions_content_QuizContent;

export interface GetQuizQuestions {
  /**
   * Get a content, identified by id or by slug,
   * optionally an authorization token can be used to enable access for current user.
   */
  content: GetQuizQuestions_content | null;
}

export interface GetQuizQuestionsVariables {
  quizId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: QuizSessionEvaluation
// ====================================================

export interface QuizSessionEvaluation_session_quiz {
  __typename: "QuizContent";
  /**
   * Unique identifier
   */
  id: string;
}

export interface QuizSessionEvaluation_session {
  __typename: "QuizContentSession";
  id: string;
  quiz: QuizSessionEvaluation_session_quiz;
}

export interface QuizSessionEvaluation {
  session: QuizSessionEvaluation_session;
}

export interface QuizSessionEvaluationVariables {
  id: string;
  input: any;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: ElementsAddableToFolder
// ====================================================

export interface ElementsAddableToFolder_elementsAddableToFolder_Folder {
  __typename: "Folder";
}

export interface ElementsAddableToFolder_elementsAddableToFolder_AudioContent_creator {
  __typename: "User";
  id: string;
}

export interface ElementsAddableToFolder_elementsAddableToFolder_AudioContent {
  __typename: "AudioContent" | "EventContent" | "ImageContent" | "LinkContent" | "PdfContent" | "QuizContent" | "ScormContent" | "TextContent" | "VideoContent";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * Content creator
   */
  creator: ElementsAddableToFolder_elementsAddableToFolder_AudioContent_creator;
}

export interface ElementsAddableToFolder_elementsAddableToFolder_MixedCollection_creator {
  __typename: "User";
  id: string;
}

export interface ElementsAddableToFolder_elementsAddableToFolder_MixedCollection {
  __typename: "MixedCollection" | "BlendedCollection" | "VideoCollection";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Main title
   */
  title: string;
  selling: boolean;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * Collection creator
   */
  creator: ElementsAddableToFolder_elementsAddableToFolder_MixedCollection_creator;
}

export type ElementsAddableToFolder_elementsAddableToFolder = ElementsAddableToFolder_elementsAddableToFolder_Folder | ElementsAddableToFolder_elementsAddableToFolder_AudioContent | ElementsAddableToFolder_elementsAddableToFolder_MixedCollection;

export interface ElementsAddableToFolder {
  elementsAddableToFolder: ElementsAddableToFolder_elementsAddableToFolder[];
}

export interface ElementsAddableToFolderVariables {
  folderId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: MoveElementsToFolder
// ====================================================

export interface MoveElementsToFolder {
  moveElementsToFolder: boolean;
}

export interface MoveElementsToFolderVariables {
  folderId: string;
  elements?: (ElementToFolder | null)[] | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateFolder
// ====================================================

export interface CreateFolder_createFolder {
  __typename: "Folder";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
}

export interface CreateFolder {
  createFolder: CreateFolder_createFolder;
}

export interface CreateFolderVariables {
  input: CreateFolderInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: FolderForEdit
// ====================================================

export interface FolderForEdit_folder_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface FolderForEdit_folder_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
}

export interface FolderForEdit_folder_creator {
  __typename: "User";
  /**
   * Self description of the user
   */
  bio: string | null;
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: FolderForEdit_folder_creator_subscriptionPlan;
  /**
   * Main email address
   */
  email: any;
  workspace: FolderForEdit_folder_creator_workspace | null;
}

export interface FolderForEdit_folder {
  __typename: "Folder";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Main title
   */
  title: string;
  label: string | null;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  tags: string[];
  /**
   * Folder creator
   */
  creator: FolderForEdit_folder_creator;
}

export interface FolderForEdit {
  /**
   * Get a folder, identified by id or by slug,
   * optionally an authorization token can be used to enable access for current user.
   */
  folder: FolderForEdit_folder | null;
}

export interface FolderForEditVariables {
  identifier: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateFolder
// ====================================================

export interface UpdateFolder_updateFolder {
  __typename: "Folder";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
}

export interface UpdateFolder {
  updateFolder: UpdateFolder_updateFolder;
}

export interface UpdateFolderVariables {
  id: string;
  input: UpdateFolderInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: FolderPage
// ====================================================

export interface FolderPage_folder_availableTags {
  __typename: "FolderTag";
  tag: string;
  count: number;
}

export interface FolderPage_folder_availableContentTypes {
  __typename: "ElementContentTypeFacet";
  type: ElementContentType;
  count: number;
}

export interface FolderPage_folder_availableCreators {
  __typename: "User";
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
}

export interface FolderPage_folder_elements_data_AudioContent_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface FolderPage_folder_elements_data_AudioContent_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
}

export interface FolderPage_folder_elements_data_AudioContent_creator {
  __typename: "User";
  id: string;
  /**
   * Main email address
   */
  email: any;
  /**
   * Self description of the user
   */
  bio: string | null;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: FolderPage_folder_elements_data_AudioContent_creator_subscriptionPlan;
  workspace: FolderPage_folder_elements_data_AudioContent_creator_workspace | null;
}

export interface FolderPage_folder_elements_data_AudioContent_originalCreator {
  __typename: "User";
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
}

export interface FolderPage_folder_elements_data_AudioContent {
  __typename: "AudioContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * When visibility is public and this flag is set to true require registration to view all content
   */
  need_registration: boolean | null;
  /**
   * Content creator
   */
  creator: FolderPage_folder_elements_data_AudioContent_creator;
  /**
   * Where the element is contained
   */
  parent_folder_id: string | null;
  /**
   * Id of the saved collection copy (in the user's workspace) this content was copied as part of; null if the content is not a copy or was saved individually
   */
  parentSavedCollectionId: string | null;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Creator of the original content this is a copy of (null if this is not a copy)
   */
  originalCreator: FolderPage_folder_elements_data_AudioContent_originalCreator | null;
  displayStatus: ContentDisplayStatus;
  /**
   * Total duration in seconds
   */
  duration: number | null;
  label: string | null;
  tags: string[];
  /**
   * Destination link
   */
  url: any | null;
}

export interface FolderPage_folder_elements_data_EventContent_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface FolderPage_folder_elements_data_EventContent_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
}

export interface FolderPage_folder_elements_data_EventContent_creator {
  __typename: "User";
  id: string;
  /**
   * Main email address
   */
  email: any;
  /**
   * Self description of the user
   */
  bio: string | null;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: FolderPage_folder_elements_data_EventContent_creator_subscriptionPlan;
  workspace: FolderPage_folder_elements_data_EventContent_creator_workspace | null;
}

export interface FolderPage_folder_elements_data_EventContent_registeredUsers {
  __typename: "User";
  id: string;
}

export interface FolderPage_folder_elements_data_EventContent_coverDimensions {
  __typename: "CoverDimensions";
  height: number | null;
  width: number | null;
}

export interface FolderPage_folder_elements_data_EventContent_originalCreator {
  __typename: "User";
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
}

export interface FolderPage_folder_elements_data_EventContent {
  __typename: "EventContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * When visibility is public and this flag is set to true require registration to view all content
   */
  need_registration: boolean | null;
  /**
   * Content creator
   */
  creator: FolderPage_folder_elements_data_EventContent_creator;
  /**
   * Where the element is contained
   */
  parent_folder_id: string | null;
  /**
   * Id of the saved collection copy (in the user's workspace) this content was copied as part of; null if the content is not a copy or was saved individually
   */
  parentSavedCollectionId: string | null;
  eventStatusForMenu: EventContentStatus;
  expired: any | null;
  isCurrentUserRegistered: boolean;
  participants: number | null;
  registeredUsers: FolderPage_folder_elements_data_EventContent_registeredUsers[];
  registration: boolean;
  status: EventContentStatus;
  /**
   * Content subtype
   */
  subtype: EventContentSubtype;
  /**
   * Destination link
   */
  url: any | null;
  end: any | null;
  start: any | null;
  location: string | null;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: FolderPage_folder_elements_data_EventContent_coverDimensions | null;
  /**
   * Creator of the original content this is a copy of (null if this is not a copy)
   */
  originalCreator: FolderPage_folder_elements_data_EventContent_originalCreator | null;
  hasUserCompleted: boolean | null;
  displayStatus: ContentDisplayStatus;
  label: string | null;
  tags: string[];
  certificate_id: string | null;
}

export interface FolderPage_folder_elements_data_ImageContent_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface FolderPage_folder_elements_data_ImageContent_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
}

export interface FolderPage_folder_elements_data_ImageContent_creator {
  __typename: "User";
  id: string;
  /**
   * Main email address
   */
  email: any;
  /**
   * Self description of the user
   */
  bio: string | null;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: FolderPage_folder_elements_data_ImageContent_creator_subscriptionPlan;
  workspace: FolderPage_folder_elements_data_ImageContent_creator_workspace | null;
}

export interface FolderPage_folder_elements_data_ImageContent_coverDimensions {
  __typename: "CoverDimensions";
  height: number | null;
  width: number | null;
}

export interface FolderPage_folder_elements_data_ImageContent_originalCreator {
  __typename: "User";
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
}

export interface FolderPage_folder_elements_data_ImageContent {
  __typename: "ImageContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * When visibility is public and this flag is set to true require registration to view all content
   */
  need_registration: boolean | null;
  /**
   * Content creator
   */
  creator: FolderPage_folder_elements_data_ImageContent_creator;
  /**
   * Where the element is contained
   */
  parent_folder_id: string | null;
  /**
   * Id of the saved collection copy (in the user's workspace) this content was copied as part of; null if the content is not a copy or was saved individually
   */
  parentSavedCollectionId: string | null;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: FolderPage_folder_elements_data_ImageContent_coverDimensions | null;
  /**
   * Creator of the original content this is a copy of (null if this is not a copy)
   */
  originalCreator: FolderPage_folder_elements_data_ImageContent_originalCreator | null;
  displayStatus: ContentDisplayStatus;
  /**
   * Content subtype
   */
  imageSubtype: string | null;
  label: string | null;
  tags: string[];
  /**
   * Destination link
   */
  url: any | null;
  /**
   * Effective images URL
   */
  urls: any[];
}

export interface FolderPage_folder_elements_data_LinkContent_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface FolderPage_folder_elements_data_LinkContent_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
}

export interface FolderPage_folder_elements_data_LinkContent_creator {
  __typename: "User";
  id: string;
  /**
   * Main email address
   */
  email: any;
  /**
   * Self description of the user
   */
  bio: string | null;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: FolderPage_folder_elements_data_LinkContent_creator_subscriptionPlan;
  workspace: FolderPage_folder_elements_data_LinkContent_creator_workspace | null;
}

export interface FolderPage_folder_elements_data_LinkContent_coverDimensions {
  __typename: "CoverDimensions";
  height: number | null;
  width: number | null;
}

export interface FolderPage_folder_elements_data_LinkContent_originalCreator {
  __typename: "User";
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
}

export interface FolderPage_folder_elements_data_LinkContent {
  __typename: "LinkContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * When visibility is public and this flag is set to true require registration to view all content
   */
  need_registration: boolean | null;
  /**
   * Content creator
   */
  creator: FolderPage_folder_elements_data_LinkContent_creator;
  /**
   * Where the element is contained
   */
  parent_folder_id: string | null;
  /**
   * Id of the saved collection copy (in the user's workspace) this content was copied as part of; null if the content is not a copy or was saved individually
   */
  parentSavedCollectionId: string | null;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: FolderPage_folder_elements_data_LinkContent_coverDimensions | null;
  /**
   * Creator of the original content this is a copy of (null if this is not a copy)
   */
  originalCreator: FolderPage_folder_elements_data_LinkContent_originalCreator | null;
  displayStatus: ContentDisplayStatus;
  /**
   * Destination domain
   */
  domain: string | null;
  /**
   * Total duration in seconds, alias of embed.estimatedReadingTime
   */
  duration: number | null;
  label: string | null;
  tags: string[];
  /**
   * Destination link
   */
  url: any | null;
}

export interface FolderPage_folder_elements_data_PdfContent_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface FolderPage_folder_elements_data_PdfContent_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
}

export interface FolderPage_folder_elements_data_PdfContent_creator {
  __typename: "User";
  id: string;
  /**
   * Main email address
   */
  email: any;
  /**
   * Self description of the user
   */
  bio: string | null;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: FolderPage_folder_elements_data_PdfContent_creator_subscriptionPlan;
  workspace: FolderPage_folder_elements_data_PdfContent_creator_workspace | null;
}

export interface FolderPage_folder_elements_data_PdfContent_coverDimensions {
  __typename: "CoverDimensions";
  height: number | null;
  width: number | null;
}

export interface FolderPage_folder_elements_data_PdfContent_originalCreator {
  __typename: "User";
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
}

export interface FolderPage_folder_elements_data_PdfContent_pdfDetails {
  __typename: "PdfDetails";
  pages: number;
}

export interface FolderPage_folder_elements_data_PdfContent {
  __typename: "PdfContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * When visibility is public and this flag is set to true require registration to view all content
   */
  need_registration: boolean | null;
  /**
   * Content creator
   */
  creator: FolderPage_folder_elements_data_PdfContent_creator;
  /**
   * Where the element is contained
   */
  parent_folder_id: string | null;
  /**
   * Id of the saved collection copy (in the user's workspace) this content was copied as part of; null if the content is not a copy or was saved individually
   */
  parentSavedCollectionId: string | null;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: FolderPage_folder_elements_data_PdfContent_coverDimensions | null;
  /**
   * Creator of the original content this is a copy of (null if this is not a copy)
   */
  originalCreator: FolderPage_folder_elements_data_PdfContent_originalCreator | null;
  displayStatus: ContentDisplayStatus;
  /**
   * Total duration in seconds, alias of pdfDetails.estimatedReadingTime
   */
  duration: number | null;
  label: string | null;
  /**
   * PDF document additional details
   */
  pdfDetails: FolderPage_folder_elements_data_PdfContent_pdfDetails | null;
  tags: string[];
  /**
   * Destination link
   */
  url: any | null;
  /**
   * Activate PDF download
   */
  canDownload: boolean | null;
}

export interface FolderPage_folder_elements_data_QuizContent_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface FolderPage_folder_elements_data_QuizContent_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
}

export interface FolderPage_folder_elements_data_QuizContent_creator {
  __typename: "User";
  id: string;
  /**
   * Main email address
   */
  email: any;
  /**
   * Self description of the user
   */
  bio: string | null;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: FolderPage_folder_elements_data_QuizContent_creator_subscriptionPlan;
  workspace: FolderPage_folder_elements_data_QuizContent_creator_workspace | null;
}

export interface FolderPage_folder_elements_data_QuizContent_coverDimensions {
  __typename: "CoverDimensions";
  height: number | null;
  width: number | null;
}

export interface FolderPage_folder_elements_data_QuizContent_originalCreator {
  __typename: "User";
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
}

export interface FolderPage_folder_elements_data_QuizContent_questions_QuizContentQuestionEssay {
  __typename: "QuizContentQuestionEssay" | "QuizContentQuestionMatching" | "QuizContentQuestionMissingWord" | "QuizContentQuestionNumerical";
}

export interface FolderPage_folder_elements_data_QuizContent_questions_QuizContentQuestionSingleChoice_choices {
  __typename: "QuizContentQuestionTextChoice";
  isCorrect: boolean;
  text: string;
}

export interface FolderPage_folder_elements_data_QuizContent_questions_QuizContentQuestionSingleChoice {
  __typename: "QuizContentQuestionSingleChoice";
  choices: FolderPage_folder_elements_data_QuizContent_questions_QuizContentQuestionSingleChoice_choices[];
  title: string | null;
}

export interface FolderPage_folder_elements_data_QuizContent_questions_QuizContentQuestionMultipleChoice_choices {
  __typename: "QuizContentQuestionTextChoice";
  isCorrect: boolean;
  text: string;
}

export interface FolderPage_folder_elements_data_QuizContent_questions_QuizContentQuestionMultipleChoice {
  __typename: "QuizContentQuestionMultipleChoice";
  choices: FolderPage_folder_elements_data_QuizContent_questions_QuizContentQuestionMultipleChoice_choices[];
  title: string | null;
}

export interface FolderPage_folder_elements_data_QuizContent_questions_QuizContentQuestionTrueFalse {
  __typename: "QuizContentQuestionTrueFalse";
  isTrue: boolean;
  title: string | null;
}

export type FolderPage_folder_elements_data_QuizContent_questions = FolderPage_folder_elements_data_QuizContent_questions_QuizContentQuestionEssay | FolderPage_folder_elements_data_QuizContent_questions_QuizContentQuestionSingleChoice | FolderPage_folder_elements_data_QuizContent_questions_QuizContentQuestionMultipleChoice | FolderPage_folder_elements_data_QuizContent_questions_QuizContentQuestionTrueFalse;

export interface FolderPage_folder_elements_data_QuizContent {
  __typename: "QuizContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * When visibility is public and this flag is set to true require registration to view all content
   */
  need_registration: boolean | null;
  /**
   * Content creator
   */
  creator: FolderPage_folder_elements_data_QuizContent_creator;
  /**
   * Where the element is contained
   */
  parent_folder_id: string | null;
  /**
   * Id of the saved collection copy (in the user's workspace) this content was copied as part of; null if the content is not a copy or was saved individually
   */
  parentSavedCollectionId: string | null;
  /**
   * Content subtype
   */
  quizSubtypeForMenu: QuizContentSubtype | null;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: FolderPage_folder_elements_data_QuizContent_coverDimensions | null;
  /**
   * Creator of the original content this is a copy of (null if this is not a copy)
   */
  originalCreator: FolderPage_folder_elements_data_QuizContent_originalCreator | null;
  displayStatus: ContentDisplayStatus;
  label: string | null;
  basket: number | null;
  questions: FolderPage_folder_elements_data_QuizContent_questions[];
  /**
   * Content subtype
   */
  quizSubtype: QuizContentSubtype | null;
  tags: string[];
}

export interface FolderPage_folder_elements_data_ScormContent_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface FolderPage_folder_elements_data_ScormContent_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
}

export interface FolderPage_folder_elements_data_ScormContent_creator {
  __typename: "User";
  id: string;
  /**
   * Main email address
   */
  email: any;
  /**
   * Self description of the user
   */
  bio: string | null;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: FolderPage_folder_elements_data_ScormContent_creator_subscriptionPlan;
  workspace: FolderPage_folder_elements_data_ScormContent_creator_workspace | null;
}

export interface FolderPage_folder_elements_data_ScormContent_coverDimensions {
  __typename: "CoverDimensions";
  height: number | null;
  width: number | null;
}

export interface FolderPage_folder_elements_data_ScormContent_originalCreator {
  __typename: "User";
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
}

export interface FolderPage_folder_elements_data_ScormContent {
  __typename: "ScormContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * When visibility is public and this flag is set to true require registration to view all content
   */
  need_registration: boolean | null;
  /**
   * Content creator
   */
  creator: FolderPage_folder_elements_data_ScormContent_creator;
  /**
   * Where the element is contained
   */
  parent_folder_id: string | null;
  /**
   * Id of the saved collection copy (in the user's workspace) this content was copied as part of; null if the content is not a copy or was saved individually
   */
  parentSavedCollectionId: string | null;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: FolderPage_folder_elements_data_ScormContent_coverDimensions | null;
  /**
   * Creator of the original content this is a copy of (null if this is not a copy)
   */
  originalCreator: FolderPage_folder_elements_data_ScormContent_originalCreator | null;
  displayStatus: ContentDisplayStatus;
  /**
   * Expected time to complete the package, in seconds: the LOM typicalLearningTime the package declares, read on import, or what the author set by hand; null when unknown. Unrelated to timeLimit
   */
  duration: number | null;
  label: string | null;
  tags: string[];
}

export interface FolderPage_folder_elements_data_TextContent_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface FolderPage_folder_elements_data_TextContent_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
}

export interface FolderPage_folder_elements_data_TextContent_creator {
  __typename: "User";
  id: string;
  /**
   * Main email address
   */
  email: any;
  /**
   * Self description of the user
   */
  bio: string | null;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: FolderPage_folder_elements_data_TextContent_creator_subscriptionPlan;
  workspace: FolderPage_folder_elements_data_TextContent_creator_workspace | null;
}

export interface FolderPage_folder_elements_data_TextContent_coverDimensions {
  __typename: "CoverDimensions";
  height: number | null;
  width: number | null;
}

export interface FolderPage_folder_elements_data_TextContent_originalCreator {
  __typename: "User";
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
}

export interface FolderPage_folder_elements_data_TextContent {
  __typename: "TextContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * When visibility is public and this flag is set to true require registration to view all content
   */
  need_registration: boolean | null;
  /**
   * Content creator
   */
  creator: FolderPage_folder_elements_data_TextContent_creator;
  /**
   * Where the element is contained
   */
  parent_folder_id: string | null;
  /**
   * Id of the saved collection copy (in the user's workspace) this content was copied as part of; null if the content is not a copy or was saved individually
   */
  parentSavedCollectionId: string | null;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: FolderPage_folder_elements_data_TextContent_coverDimensions | null;
  /**
   * Creator of the original content this is a copy of (null if this is not a copy)
   */
  originalCreator: FolderPage_folder_elements_data_TextContent_originalCreator | null;
  displayStatus: ContentDisplayStatus;
  /**
   * Total duration in seconds, alias of pdfDetails.estimatedReadingTime
   */
  duration: number | null;
  label: string | null;
  tags: string[];
  /**
   * Destination link
   */
  url: any | null;
}

export interface FolderPage_folder_elements_data_VideoContent_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface FolderPage_folder_elements_data_VideoContent_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
}

export interface FolderPage_folder_elements_data_VideoContent_creator {
  __typename: "User";
  id: string;
  /**
   * Main email address
   */
  email: any;
  /**
   * Self description of the user
   */
  bio: string | null;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: FolderPage_folder_elements_data_VideoContent_creator_subscriptionPlan;
  workspace: FolderPage_folder_elements_data_VideoContent_creator_workspace | null;
}

export interface FolderPage_folder_elements_data_VideoContent_coverDimensions {
  __typename: "CoverDimensions";
  height: number | null;
  width: number | null;
}

export interface FolderPage_folder_elements_data_VideoContent_originalCreator {
  __typename: "User";
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
}

export interface FolderPage_folder_elements_data_VideoContent {
  __typename: "VideoContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * When visibility is public and this flag is set to true require registration to view all content
   */
  need_registration: boolean | null;
  /**
   * Content creator
   */
  creator: FolderPage_folder_elements_data_VideoContent_creator;
  /**
   * Where the element is contained
   */
  parent_folder_id: string | null;
  /**
   * Id of the saved collection copy (in the user's workspace) this content was copied as part of; null if the content is not a copy or was saved individually
   */
  parentSavedCollectionId: string | null;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: FolderPage_folder_elements_data_VideoContent_coverDimensions | null;
  /**
   * Creator of the original content this is a copy of (null if this is not a copy)
   */
  originalCreator: FolderPage_folder_elements_data_VideoContent_originalCreator | null;
  displayStatus: ContentDisplayStatus;
  /**
   * Total duration in seconds
   */
  duration: number | null;
  label: string | null;
  tags: string[];
  /**
   * Destination link
   */
  url: any | null;
  aspectRatio: string | null;
}

export interface FolderPage_folder_elements_data_MixedCollection_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface FolderPage_folder_elements_data_MixedCollection_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
}

export interface FolderPage_folder_elements_data_MixedCollection_creator {
  __typename: "User";
  id: string;
  /**
   * Main email address
   */
  email: any;
  /**
   * Self description of the user
   */
  bio: string | null;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: FolderPage_folder_elements_data_MixedCollection_creator_subscriptionPlan;
  workspace: FolderPage_folder_elements_data_MixedCollection_creator_workspace | null;
}

export interface FolderPage_folder_elements_data_MixedCollection_coverDimensions {
  __typename: "CoverDimensions";
  height: number | null;
  width: number | null;
}

export interface FolderPage_folder_elements_data_MixedCollection_originalCreator {
  __typename: "User";
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
}

export interface FolderPage_folder_elements_data_MixedCollection {
  __typename: "MixedCollection" | "BlendedCollection" | "VideoCollection";
  /**
   * Defines if current user has a specific permission on the collection
   */
  canManage: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  selling: boolean;
  sellingPricing: number | null;
  sellingMethod: string | null;
  /**
   * When visibility is public and this flag is set to true require registration to view all content
   */
  need_registration: boolean | null;
  /**
   * Total duration of all the audio and video contents included
   */
  duration: number | null;
  /**
   * Get total contents for required type
   */
  totalAudio: number;
  /**
   * Get total contents for required type
   */
  totalImage: number;
  /**
   * Get total contents for required type
   */
  totalLink: number;
  /**
   * Get total contents for required type
   */
  totalPdf: number;
  /**
   * Get total contents for required type
   */
  totalQuiz: number;
  /**
   * Get total contents for required type
   */
  totalScorm: number;
  /**
   * Get total contents for required type
   */
  totalText: number;
  /**
   * Get total contents for required type
   */
  totalVideo: number;
  /**
   * Collection creator
   */
  creator: FolderPage_folder_elements_data_MixedCollection_creator;
  sellingCurrency: string | null;
  /**
   * Defines if current user has a specific permission on the collection
   */
  canRead: boolean;
  collectionDisplayStatus: CollectionDisplayStatus;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: FolderPage_folder_elements_data_MixedCollection_coverDimensions | null;
  /**
   * Creator of the original collection this is a copy of (null if this is not a copy)
   */
  originalCreator: FolderPage_folder_elements_data_MixedCollection_originalCreator | null;
  label: string | null;
  tags: string[];
  parent_folder_id: string | null;
  certificate_id: string | null;
}

export interface FolderPage_folder_elements_data_Folder_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface FolderPage_folder_elements_data_Folder_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
}

export interface FolderPage_folder_elements_data_Folder_creator {
  __typename: "User";
  /**
   * Self description of the user
   */
  bio: string | null;
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: FolderPage_folder_elements_data_Folder_creator_subscriptionPlan;
  /**
   * Main email address
   */
  email: any;
  workspace: FolderPage_folder_elements_data_Folder_creator_workspace | null;
}

export interface FolderPage_folder_elements_data_Folder {
  __typename: "Folder";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Main title
   */
  title: string;
  label: string | null;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  tags: string[];
  /**
   * Where the element is contained
   */
  parent_folder_id: string | null;
  canManage: boolean;
  canRead: boolean;
  /**
   * Folder creator
   */
  creator: FolderPage_folder_elements_data_Folder_creator;
  /**
   * Get total contents for required type
   */
  totalContents: number;
  /**
   * Get total contents for required type
   */
  totalCollections: number;
  /**
   * Get total contents for required type
   */
  totalFolders: number;
}

export type FolderPage_folder_elements_data = FolderPage_folder_elements_data_AudioContent | FolderPage_folder_elements_data_EventContent | FolderPage_folder_elements_data_ImageContent | FolderPage_folder_elements_data_LinkContent | FolderPage_folder_elements_data_PdfContent | FolderPage_folder_elements_data_QuizContent | FolderPage_folder_elements_data_ScormContent | FolderPage_folder_elements_data_TextContent | FolderPage_folder_elements_data_VideoContent | FolderPage_folder_elements_data_MixedCollection | FolderPage_folder_elements_data_Folder;

export interface FolderPage_folder_elements_paginatorInfo {
  __typename: "PaginatorInfo";
  total: number;
  currentPage: number;
  lastPage: number;
  hasMorePages: boolean;
}

export interface FolderPage_folder_elements {
  __typename: "PaginatedFolderElements";
  data: FolderPage_folder_elements_data[];
  paginatorInfo: FolderPage_folder_elements_paginatorInfo;
}

export interface FolderPage_folder_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface FolderPage_folder_creator_workspace_user {
  __typename: "User";
  id: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
}

export interface FolderPage_folder_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
  /**
   * Brand Name for white label
   */
  brandName: string | null;
  /**
   * Small squared logo for white label
   */
  brandLogoSmall: any | null;
  /**
   * Who created the workspace (or first related user if creator is null)
   */
  user: FolderPage_folder_creator_workspace_user | null;
  /**
   * Slug
   */
  slug: string | null;
}

export interface FolderPage_folder_creator {
  __typename: "User";
  /**
   * Self description of the user
   */
  bio: string | null;
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: FolderPage_folder_creator_subscriptionPlan;
  /**
   * Main email address
   */
  email: any;
  workspace: FolderPage_folder_creator_workspace | null;
}

export interface FolderPage_folder {
  __typename: "Folder";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Main title
   */
  title: string;
  label: string | null;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  tags: string[];
  /**
   * Get total contents for required type
   */
  totalContents: number;
  /**
   * Get total contents for required type
   */
  totalCollections: number;
  /**
   * Get total contents for required type
   */
  totalFolders: number;
  /**
   * List of tags used by the contents and collections contained in this folder,
   * merged and counted, ordered by descending usage count.
   */
  availableTags: FolderPage_folder_availableTags[];
  /**
   * Content types present among the elements contained in this folder (direct
   * and associated), with counts. Only supported content-type facets are
   * returned, and only those actually present.
   */
  availableContentTypes: FolderPage_folder_availableContentTypes[];
  /**
   * Distinct creators of the elements contained in this folder (direct and associated).
   */
  availableCreators: FolderPage_folder_availableCreators[];
  elements: FolderPage_folder_elements;
  canManage: boolean;
  canRead: boolean;
  /**
   * Folder creator
   */
  creator: FolderPage_folder_creator;
}

export interface FolderPage_me {
  __typename: "User";
  id: string;
}

export interface FolderPage {
  /**
   * Get a folder, identified by id or by slug,
   * optionally an authorization token can be used to enable access for current user.
   */
  folder: FolderPage_folder | null;
  /**
   * Currently authenticated user
   */
  me: FolderPage_me | null;
}

export interface FolderPageVariables {
  identifier: string;
  token?: string | null;
  userId?: string | null;
  page?: number | null;
  first?: number | null;
  tags?: string[] | null;
  search?: string | null;
  sort?: ElementSort | null;
  contentTypes?: ElementContentType[] | null;
  createdBy?: string[] | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: CurrentUserName
// ====================================================

export interface CurrentUserName_me_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface CurrentUserName_me {
  __typename: "User";
  /**
   * First name
   */
  firstname: string;
  id: string;
  /**
   * Main email address
   */
  email: any;
  subscriptionPlan: CurrentUserName_me_subscriptionPlan;
}

export interface CurrentUserName {
  /**
   * Currently authenticated user
   */
  me: CurrentUserName_me | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: HomeElements
// ====================================================

export interface HomeElements_elements_Folder {
  __typename: "Folder";
}

export interface HomeElements_elements_AudioContent_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface HomeElements_elements_AudioContent_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
}

export interface HomeElements_elements_AudioContent_creator {
  __typename: "User";
  id: string;
  /**
   * Main email address
   */
  email: any;
  /**
   * Self description of the user
   */
  bio: string | null;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: HomeElements_elements_AudioContent_creator_subscriptionPlan;
  workspace: HomeElements_elements_AudioContent_creator_workspace | null;
}

export interface HomeElements_elements_AudioContent_originalCreator {
  __typename: "User";
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
}

export interface HomeElements_elements_AudioContent {
  __typename: "AudioContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * When visibility is public and this flag is set to true require registration to view all content
   */
  need_registration: boolean | null;
  /**
   * Content creator
   */
  creator: HomeElements_elements_AudioContent_creator;
  /**
   * Where the element is contained
   */
  parent_folder_id: string | null;
  /**
   * Id of the saved collection copy (in the user's workspace) this content was copied as part of; null if the content is not a copy or was saved individually
   */
  parentSavedCollectionId: string | null;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Creator of the original content this is a copy of (null if this is not a copy)
   */
  originalCreator: HomeElements_elements_AudioContent_originalCreator | null;
  displayStatus: ContentDisplayStatus;
  /**
   * Total duration in seconds
   */
  duration: number | null;
  label: string | null;
  tags: string[];
  /**
   * Destination link
   */
  url: any | null;
}

export interface HomeElements_elements_EventContent_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface HomeElements_elements_EventContent_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
}

export interface HomeElements_elements_EventContent_creator {
  __typename: "User";
  id: string;
  /**
   * Main email address
   */
  email: any;
  /**
   * Self description of the user
   */
  bio: string | null;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: HomeElements_elements_EventContent_creator_subscriptionPlan;
  workspace: HomeElements_elements_EventContent_creator_workspace | null;
}

export interface HomeElements_elements_EventContent_registeredUsers {
  __typename: "User";
  id: string;
}

export interface HomeElements_elements_EventContent_coverDimensions {
  __typename: "CoverDimensions";
  height: number | null;
  width: number | null;
}

export interface HomeElements_elements_EventContent_originalCreator {
  __typename: "User";
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
}

export interface HomeElements_elements_EventContent {
  __typename: "EventContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * When visibility is public and this flag is set to true require registration to view all content
   */
  need_registration: boolean | null;
  /**
   * Content creator
   */
  creator: HomeElements_elements_EventContent_creator;
  /**
   * Where the element is contained
   */
  parent_folder_id: string | null;
  /**
   * Id of the saved collection copy (in the user's workspace) this content was copied as part of; null if the content is not a copy or was saved individually
   */
  parentSavedCollectionId: string | null;
  eventStatusForMenu: EventContentStatus;
  expired: any | null;
  isCurrentUserRegistered: boolean;
  participants: number | null;
  registeredUsers: HomeElements_elements_EventContent_registeredUsers[];
  registration: boolean;
  status: EventContentStatus;
  /**
   * Content subtype
   */
  subtype: EventContentSubtype;
  /**
   * Destination link
   */
  url: any | null;
  end: any | null;
  start: any | null;
  location: string | null;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: HomeElements_elements_EventContent_coverDimensions | null;
  /**
   * Creator of the original content this is a copy of (null if this is not a copy)
   */
  originalCreator: HomeElements_elements_EventContent_originalCreator | null;
  hasUserCompleted: boolean | null;
  displayStatus: ContentDisplayStatus;
  label: string | null;
  tags: string[];
  certificate_id: string | null;
}

export interface HomeElements_elements_ImageContent_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface HomeElements_elements_ImageContent_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
}

export interface HomeElements_elements_ImageContent_creator {
  __typename: "User";
  id: string;
  /**
   * Main email address
   */
  email: any;
  /**
   * Self description of the user
   */
  bio: string | null;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: HomeElements_elements_ImageContent_creator_subscriptionPlan;
  workspace: HomeElements_elements_ImageContent_creator_workspace | null;
}

export interface HomeElements_elements_ImageContent_coverDimensions {
  __typename: "CoverDimensions";
  height: number | null;
  width: number | null;
}

export interface HomeElements_elements_ImageContent_originalCreator {
  __typename: "User";
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
}

export interface HomeElements_elements_ImageContent {
  __typename: "ImageContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * When visibility is public and this flag is set to true require registration to view all content
   */
  need_registration: boolean | null;
  /**
   * Content creator
   */
  creator: HomeElements_elements_ImageContent_creator;
  /**
   * Where the element is contained
   */
  parent_folder_id: string | null;
  /**
   * Id of the saved collection copy (in the user's workspace) this content was copied as part of; null if the content is not a copy or was saved individually
   */
  parentSavedCollectionId: string | null;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: HomeElements_elements_ImageContent_coverDimensions | null;
  /**
   * Creator of the original content this is a copy of (null if this is not a copy)
   */
  originalCreator: HomeElements_elements_ImageContent_originalCreator | null;
  displayStatus: ContentDisplayStatus;
  /**
   * Content subtype
   */
  imageSubtype: string | null;
  label: string | null;
  tags: string[];
  /**
   * Destination link
   */
  url: any | null;
  /**
   * Effective images URL
   */
  urls: any[];
}

export interface HomeElements_elements_LinkContent_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface HomeElements_elements_LinkContent_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
}

export interface HomeElements_elements_LinkContent_creator {
  __typename: "User";
  id: string;
  /**
   * Main email address
   */
  email: any;
  /**
   * Self description of the user
   */
  bio: string | null;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: HomeElements_elements_LinkContent_creator_subscriptionPlan;
  workspace: HomeElements_elements_LinkContent_creator_workspace | null;
}

export interface HomeElements_elements_LinkContent_coverDimensions {
  __typename: "CoverDimensions";
  height: number | null;
  width: number | null;
}

export interface HomeElements_elements_LinkContent_originalCreator {
  __typename: "User";
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
}

export interface HomeElements_elements_LinkContent {
  __typename: "LinkContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * When visibility is public and this flag is set to true require registration to view all content
   */
  need_registration: boolean | null;
  /**
   * Content creator
   */
  creator: HomeElements_elements_LinkContent_creator;
  /**
   * Where the element is contained
   */
  parent_folder_id: string | null;
  /**
   * Id of the saved collection copy (in the user's workspace) this content was copied as part of; null if the content is not a copy or was saved individually
   */
  parentSavedCollectionId: string | null;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: HomeElements_elements_LinkContent_coverDimensions | null;
  /**
   * Creator of the original content this is a copy of (null if this is not a copy)
   */
  originalCreator: HomeElements_elements_LinkContent_originalCreator | null;
  displayStatus: ContentDisplayStatus;
  /**
   * Destination domain
   */
  domain: string | null;
  /**
   * Total duration in seconds, alias of embed.estimatedReadingTime
   */
  duration: number | null;
  label: string | null;
  tags: string[];
  /**
   * Destination link
   */
  url: any | null;
}

export interface HomeElements_elements_PdfContent_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface HomeElements_elements_PdfContent_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
}

export interface HomeElements_elements_PdfContent_creator {
  __typename: "User";
  id: string;
  /**
   * Main email address
   */
  email: any;
  /**
   * Self description of the user
   */
  bio: string | null;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: HomeElements_elements_PdfContent_creator_subscriptionPlan;
  workspace: HomeElements_elements_PdfContent_creator_workspace | null;
}

export interface HomeElements_elements_PdfContent_coverDimensions {
  __typename: "CoverDimensions";
  height: number | null;
  width: number | null;
}

export interface HomeElements_elements_PdfContent_originalCreator {
  __typename: "User";
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
}

export interface HomeElements_elements_PdfContent_pdfDetails {
  __typename: "PdfDetails";
  pages: number;
}

export interface HomeElements_elements_PdfContent {
  __typename: "PdfContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * When visibility is public and this flag is set to true require registration to view all content
   */
  need_registration: boolean | null;
  /**
   * Content creator
   */
  creator: HomeElements_elements_PdfContent_creator;
  /**
   * Where the element is contained
   */
  parent_folder_id: string | null;
  /**
   * Id of the saved collection copy (in the user's workspace) this content was copied as part of; null if the content is not a copy or was saved individually
   */
  parentSavedCollectionId: string | null;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: HomeElements_elements_PdfContent_coverDimensions | null;
  /**
   * Creator of the original content this is a copy of (null if this is not a copy)
   */
  originalCreator: HomeElements_elements_PdfContent_originalCreator | null;
  displayStatus: ContentDisplayStatus;
  /**
   * Total duration in seconds, alias of pdfDetails.estimatedReadingTime
   */
  duration: number | null;
  label: string | null;
  /**
   * PDF document additional details
   */
  pdfDetails: HomeElements_elements_PdfContent_pdfDetails | null;
  tags: string[];
  /**
   * Destination link
   */
  url: any | null;
  /**
   * Activate PDF download
   */
  canDownload: boolean | null;
}

export interface HomeElements_elements_QuizContent_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface HomeElements_elements_QuizContent_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
}

export interface HomeElements_elements_QuizContent_creator {
  __typename: "User";
  id: string;
  /**
   * Main email address
   */
  email: any;
  /**
   * Self description of the user
   */
  bio: string | null;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: HomeElements_elements_QuizContent_creator_subscriptionPlan;
  workspace: HomeElements_elements_QuizContent_creator_workspace | null;
}

export interface HomeElements_elements_QuizContent_coverDimensions {
  __typename: "CoverDimensions";
  height: number | null;
  width: number | null;
}

export interface HomeElements_elements_QuizContent_originalCreator {
  __typename: "User";
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
}

export interface HomeElements_elements_QuizContent_questions_QuizContentQuestionEssay {
  __typename: "QuizContentQuestionEssay" | "QuizContentQuestionMatching" | "QuizContentQuestionMissingWord" | "QuizContentQuestionNumerical";
}

export interface HomeElements_elements_QuizContent_questions_QuizContentQuestionSingleChoice_choices {
  __typename: "QuizContentQuestionTextChoice";
  isCorrect: boolean;
  text: string;
}

export interface HomeElements_elements_QuizContent_questions_QuizContentQuestionSingleChoice {
  __typename: "QuizContentQuestionSingleChoice";
  choices: HomeElements_elements_QuizContent_questions_QuizContentQuestionSingleChoice_choices[];
  title: string | null;
}

export interface HomeElements_elements_QuizContent_questions_QuizContentQuestionMultipleChoice_choices {
  __typename: "QuizContentQuestionTextChoice";
  isCorrect: boolean;
  text: string;
}

export interface HomeElements_elements_QuizContent_questions_QuizContentQuestionMultipleChoice {
  __typename: "QuizContentQuestionMultipleChoice";
  choices: HomeElements_elements_QuizContent_questions_QuizContentQuestionMultipleChoice_choices[];
  title: string | null;
}

export interface HomeElements_elements_QuizContent_questions_QuizContentQuestionTrueFalse {
  __typename: "QuizContentQuestionTrueFalse";
  isTrue: boolean;
  title: string | null;
}

export type HomeElements_elements_QuizContent_questions = HomeElements_elements_QuizContent_questions_QuizContentQuestionEssay | HomeElements_elements_QuizContent_questions_QuizContentQuestionSingleChoice | HomeElements_elements_QuizContent_questions_QuizContentQuestionMultipleChoice | HomeElements_elements_QuizContent_questions_QuizContentQuestionTrueFalse;

export interface HomeElements_elements_QuizContent {
  __typename: "QuizContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * When visibility is public and this flag is set to true require registration to view all content
   */
  need_registration: boolean | null;
  /**
   * Content creator
   */
  creator: HomeElements_elements_QuizContent_creator;
  /**
   * Where the element is contained
   */
  parent_folder_id: string | null;
  /**
   * Id of the saved collection copy (in the user's workspace) this content was copied as part of; null if the content is not a copy or was saved individually
   */
  parentSavedCollectionId: string | null;
  /**
   * Content subtype
   */
  quizSubtypeForMenu: QuizContentSubtype | null;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: HomeElements_elements_QuizContent_coverDimensions | null;
  /**
   * Creator of the original content this is a copy of (null if this is not a copy)
   */
  originalCreator: HomeElements_elements_QuizContent_originalCreator | null;
  displayStatus: ContentDisplayStatus;
  label: string | null;
  basket: number | null;
  questions: HomeElements_elements_QuizContent_questions[];
  /**
   * Content subtype
   */
  quizSubtype: QuizContentSubtype | null;
  tags: string[];
}

export interface HomeElements_elements_ScormContent_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface HomeElements_elements_ScormContent_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
}

export interface HomeElements_elements_ScormContent_creator {
  __typename: "User";
  id: string;
  /**
   * Main email address
   */
  email: any;
  /**
   * Self description of the user
   */
  bio: string | null;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: HomeElements_elements_ScormContent_creator_subscriptionPlan;
  workspace: HomeElements_elements_ScormContent_creator_workspace | null;
}

export interface HomeElements_elements_ScormContent_coverDimensions {
  __typename: "CoverDimensions";
  height: number | null;
  width: number | null;
}

export interface HomeElements_elements_ScormContent_originalCreator {
  __typename: "User";
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
}

export interface HomeElements_elements_ScormContent {
  __typename: "ScormContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * When visibility is public and this flag is set to true require registration to view all content
   */
  need_registration: boolean | null;
  /**
   * Content creator
   */
  creator: HomeElements_elements_ScormContent_creator;
  /**
   * Where the element is contained
   */
  parent_folder_id: string | null;
  /**
   * Id of the saved collection copy (in the user's workspace) this content was copied as part of; null if the content is not a copy or was saved individually
   */
  parentSavedCollectionId: string | null;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: HomeElements_elements_ScormContent_coverDimensions | null;
  /**
   * Creator of the original content this is a copy of (null if this is not a copy)
   */
  originalCreator: HomeElements_elements_ScormContent_originalCreator | null;
  displayStatus: ContentDisplayStatus;
  /**
   * Expected time to complete the package, in seconds: the LOM typicalLearningTime the package declares, read on import, or what the author set by hand; null when unknown. Unrelated to timeLimit
   */
  duration: number | null;
  label: string | null;
  tags: string[];
}

export interface HomeElements_elements_TextContent_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface HomeElements_elements_TextContent_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
}

export interface HomeElements_elements_TextContent_creator {
  __typename: "User";
  id: string;
  /**
   * Main email address
   */
  email: any;
  /**
   * Self description of the user
   */
  bio: string | null;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: HomeElements_elements_TextContent_creator_subscriptionPlan;
  workspace: HomeElements_elements_TextContent_creator_workspace | null;
}

export interface HomeElements_elements_TextContent_coverDimensions {
  __typename: "CoverDimensions";
  height: number | null;
  width: number | null;
}

export interface HomeElements_elements_TextContent_originalCreator {
  __typename: "User";
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
}

export interface HomeElements_elements_TextContent {
  __typename: "TextContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * When visibility is public and this flag is set to true require registration to view all content
   */
  need_registration: boolean | null;
  /**
   * Content creator
   */
  creator: HomeElements_elements_TextContent_creator;
  /**
   * Where the element is contained
   */
  parent_folder_id: string | null;
  /**
   * Id of the saved collection copy (in the user's workspace) this content was copied as part of; null if the content is not a copy or was saved individually
   */
  parentSavedCollectionId: string | null;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: HomeElements_elements_TextContent_coverDimensions | null;
  /**
   * Creator of the original content this is a copy of (null if this is not a copy)
   */
  originalCreator: HomeElements_elements_TextContent_originalCreator | null;
  displayStatus: ContentDisplayStatus;
  /**
   * Total duration in seconds, alias of pdfDetails.estimatedReadingTime
   */
  duration: number | null;
  label: string | null;
  tags: string[];
  /**
   * Destination link
   */
  url: any | null;
}

export interface HomeElements_elements_VideoContent_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface HomeElements_elements_VideoContent_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
}

export interface HomeElements_elements_VideoContent_creator {
  __typename: "User";
  id: string;
  /**
   * Main email address
   */
  email: any;
  /**
   * Self description of the user
   */
  bio: string | null;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: HomeElements_elements_VideoContent_creator_subscriptionPlan;
  workspace: HomeElements_elements_VideoContent_creator_workspace | null;
}

export interface HomeElements_elements_VideoContent_coverDimensions {
  __typename: "CoverDimensions";
  height: number | null;
  width: number | null;
}

export interface HomeElements_elements_VideoContent_originalCreator {
  __typename: "User";
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
}

export interface HomeElements_elements_VideoContent {
  __typename: "VideoContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * When visibility is public and this flag is set to true require registration to view all content
   */
  need_registration: boolean | null;
  /**
   * Content creator
   */
  creator: HomeElements_elements_VideoContent_creator;
  /**
   * Where the element is contained
   */
  parent_folder_id: string | null;
  /**
   * Id of the saved collection copy (in the user's workspace) this content was copied as part of; null if the content is not a copy or was saved individually
   */
  parentSavedCollectionId: string | null;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: HomeElements_elements_VideoContent_coverDimensions | null;
  /**
   * Creator of the original content this is a copy of (null if this is not a copy)
   */
  originalCreator: HomeElements_elements_VideoContent_originalCreator | null;
  displayStatus: ContentDisplayStatus;
  /**
   * Total duration in seconds
   */
  duration: number | null;
  label: string | null;
  tags: string[];
  /**
   * Destination link
   */
  url: any | null;
  aspectRatio: string | null;
}

export interface HomeElements_elements_MixedCollection_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface HomeElements_elements_MixedCollection_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
}

export interface HomeElements_elements_MixedCollection_creator {
  __typename: "User";
  id: string;
  /**
   * Main email address
   */
  email: any;
  /**
   * Self description of the user
   */
  bio: string | null;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: HomeElements_elements_MixedCollection_creator_subscriptionPlan;
  workspace: HomeElements_elements_MixedCollection_creator_workspace | null;
}

export interface HomeElements_elements_MixedCollection_coverDimensions {
  __typename: "CoverDimensions";
  height: number | null;
  width: number | null;
}

export interface HomeElements_elements_MixedCollection_originalCreator {
  __typename: "User";
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
}

export interface HomeElements_elements_MixedCollection {
  __typename: "MixedCollection" | "BlendedCollection" | "VideoCollection";
  /**
   * Defines if current user has a specific permission on the collection
   */
  canManage: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  selling: boolean;
  sellingPricing: number | null;
  sellingMethod: string | null;
  /**
   * When visibility is public and this flag is set to true require registration to view all content
   */
  need_registration: boolean | null;
  /**
   * Total duration of all the audio and video contents included
   */
  duration: number | null;
  /**
   * Get total contents for required type
   */
  totalAudio: number;
  /**
   * Get total contents for required type
   */
  totalImage: number;
  /**
   * Get total contents for required type
   */
  totalLink: number;
  /**
   * Get total contents for required type
   */
  totalPdf: number;
  /**
   * Get total contents for required type
   */
  totalQuiz: number;
  /**
   * Get total contents for required type
   */
  totalScorm: number;
  /**
   * Get total contents for required type
   */
  totalText: number;
  /**
   * Get total contents for required type
   */
  totalVideo: number;
  /**
   * Collection creator
   */
  creator: HomeElements_elements_MixedCollection_creator;
  sellingCurrency: string | null;
  /**
   * Defines if current user has a specific permission on the collection
   */
  canRead: boolean;
  collectionDisplayStatus: CollectionDisplayStatus;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: HomeElements_elements_MixedCollection_coverDimensions | null;
  /**
   * Creator of the original collection this is a copy of (null if this is not a copy)
   */
  originalCreator: HomeElements_elements_MixedCollection_originalCreator | null;
  label: string | null;
  tags: string[];
  parent_folder_id: string | null;
  certificate_id: string | null;
}

export type HomeElements_elements = HomeElements_elements_Folder | HomeElements_elements_AudioContent | HomeElements_elements_EventContent | HomeElements_elements_ImageContent | HomeElements_elements_LinkContent | HomeElements_elements_PdfContent | HomeElements_elements_QuizContent | HomeElements_elements_ScormContent | HomeElements_elements_TextContent | HomeElements_elements_VideoContent | HomeElements_elements_MixedCollection;

export interface HomeElements {
  /**
   * All homepage elements, including:
   * * created contents
   * * visited contents
   * * created collections
   * * visited collections
   * 
   * If createdByMe or community are defined, elements will be filtered.
   */
  elements: HomeElements_elements[];
  /**
   * Total homepage elements, including:
   * * created contents
   * * visited contents
   * * created collections
   * * visited collections
   * 
   * If createdByMe is defined, elements will be filtered.
   */
  totalElements: number;
}

export interface HomeElementsVariables {
  createdByMe?: boolean | null;
  limit?: number | null;
  offset?: number | null;
  userId?: string | null;
  filterByElementType?: (ElementTypeFilter | null)[] | null;
  search?: string | null;
  sort?: ElementSort | null;
  tags?: string[] | null;
  contentTypes?: ElementContentType[] | null;
  createdBy?: string[] | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: HomeFilters
// ====================================================

export interface HomeFilters_homeAvailableTags {
  __typename: "ElementTagFacet";
  tag: string;
  count: number;
}

export interface HomeFilters_homeAvailableContentTypes {
  __typename: "ElementContentTypeFacet";
  type: ElementContentType;
  count: number;
}

export interface HomeFilters_homeAvailableCreators {
  __typename: "User";
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
}

export interface HomeFilters {
  /**
   * Tags used by the current user's home elements, with usage counts, ordered by descending count.
   */
  homeAvailableTags: HomeFilters_homeAvailableTags[];
  /**
   * Content types present among the current user's home elements, with counts.
   */
  homeAvailableContentTypes: HomeFilters_homeAvailableContentTypes[];
  /**
   * Distinct creators of the current user's home elements.
   */
  homeAvailableCreators: HomeFilters_homeAvailableCreators[];
}

export interface HomeFiltersVariables {
  createdByMe?: boolean | null;
  workspaceUserId?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: TagsPageElements
// ====================================================

export interface TagsPageElements_elements_AudioContent_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface TagsPageElements_elements_AudioContent_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
}

export interface TagsPageElements_elements_AudioContent_creator {
  __typename: "User";
  id: string;
  /**
   * Main email address
   */
  email: any;
  /**
   * Self description of the user
   */
  bio: string | null;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: TagsPageElements_elements_AudioContent_creator_subscriptionPlan;
  workspace: TagsPageElements_elements_AudioContent_creator_workspace | null;
}

export interface TagsPageElements_elements_AudioContent_originalCreator {
  __typename: "User";
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
}

export interface TagsPageElements_elements_AudioContent {
  __typename: "AudioContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * When visibility is public and this flag is set to true require registration to view all content
   */
  need_registration: boolean | null;
  /**
   * Content creator
   */
  creator: TagsPageElements_elements_AudioContent_creator;
  /**
   * Where the element is contained
   */
  parent_folder_id: string | null;
  /**
   * Id of the saved collection copy (in the user's workspace) this content was copied as part of; null if the content is not a copy or was saved individually
   */
  parentSavedCollectionId: string | null;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Creator of the original content this is a copy of (null if this is not a copy)
   */
  originalCreator: TagsPageElements_elements_AudioContent_originalCreator | null;
  displayStatus: ContentDisplayStatus;
  /**
   * Total duration in seconds
   */
  duration: number | null;
  label: string | null;
  tags: string[];
  /**
   * Destination link
   */
  url: any | null;
}

export interface TagsPageElements_elements_EventContent_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface TagsPageElements_elements_EventContent_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
}

export interface TagsPageElements_elements_EventContent_creator {
  __typename: "User";
  id: string;
  /**
   * Main email address
   */
  email: any;
  /**
   * Self description of the user
   */
  bio: string | null;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: TagsPageElements_elements_EventContent_creator_subscriptionPlan;
  workspace: TagsPageElements_elements_EventContent_creator_workspace | null;
}

export interface TagsPageElements_elements_EventContent_registeredUsers {
  __typename: "User";
  id: string;
}

export interface TagsPageElements_elements_EventContent_coverDimensions {
  __typename: "CoverDimensions";
  height: number | null;
  width: number | null;
}

export interface TagsPageElements_elements_EventContent_originalCreator {
  __typename: "User";
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
}

export interface TagsPageElements_elements_EventContent {
  __typename: "EventContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * When visibility is public and this flag is set to true require registration to view all content
   */
  need_registration: boolean | null;
  /**
   * Content creator
   */
  creator: TagsPageElements_elements_EventContent_creator;
  /**
   * Where the element is contained
   */
  parent_folder_id: string | null;
  /**
   * Id of the saved collection copy (in the user's workspace) this content was copied as part of; null if the content is not a copy or was saved individually
   */
  parentSavedCollectionId: string | null;
  eventStatusForMenu: EventContentStatus;
  expired: any | null;
  isCurrentUserRegistered: boolean;
  participants: number | null;
  registeredUsers: TagsPageElements_elements_EventContent_registeredUsers[];
  registration: boolean;
  status: EventContentStatus;
  /**
   * Content subtype
   */
  subtype: EventContentSubtype;
  /**
   * Destination link
   */
  url: any | null;
  end: any | null;
  start: any | null;
  location: string | null;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: TagsPageElements_elements_EventContent_coverDimensions | null;
  /**
   * Creator of the original content this is a copy of (null if this is not a copy)
   */
  originalCreator: TagsPageElements_elements_EventContent_originalCreator | null;
  hasUserCompleted: boolean | null;
  displayStatus: ContentDisplayStatus;
  label: string | null;
  tags: string[];
  certificate_id: string | null;
}

export interface TagsPageElements_elements_ImageContent_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface TagsPageElements_elements_ImageContent_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
}

export interface TagsPageElements_elements_ImageContent_creator {
  __typename: "User";
  id: string;
  /**
   * Main email address
   */
  email: any;
  /**
   * Self description of the user
   */
  bio: string | null;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: TagsPageElements_elements_ImageContent_creator_subscriptionPlan;
  workspace: TagsPageElements_elements_ImageContent_creator_workspace | null;
}

export interface TagsPageElements_elements_ImageContent_coverDimensions {
  __typename: "CoverDimensions";
  height: number | null;
  width: number | null;
}

export interface TagsPageElements_elements_ImageContent_originalCreator {
  __typename: "User";
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
}

export interface TagsPageElements_elements_ImageContent {
  __typename: "ImageContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * When visibility is public and this flag is set to true require registration to view all content
   */
  need_registration: boolean | null;
  /**
   * Content creator
   */
  creator: TagsPageElements_elements_ImageContent_creator;
  /**
   * Where the element is contained
   */
  parent_folder_id: string | null;
  /**
   * Id of the saved collection copy (in the user's workspace) this content was copied as part of; null if the content is not a copy or was saved individually
   */
  parentSavedCollectionId: string | null;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: TagsPageElements_elements_ImageContent_coverDimensions | null;
  /**
   * Creator of the original content this is a copy of (null if this is not a copy)
   */
  originalCreator: TagsPageElements_elements_ImageContent_originalCreator | null;
  displayStatus: ContentDisplayStatus;
  /**
   * Content subtype
   */
  imageSubtype: string | null;
  label: string | null;
  tags: string[];
  /**
   * Destination link
   */
  url: any | null;
  /**
   * Effective images URL
   */
  urls: any[];
}

export interface TagsPageElements_elements_LinkContent_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface TagsPageElements_elements_LinkContent_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
}

export interface TagsPageElements_elements_LinkContent_creator {
  __typename: "User";
  id: string;
  /**
   * Main email address
   */
  email: any;
  /**
   * Self description of the user
   */
  bio: string | null;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: TagsPageElements_elements_LinkContent_creator_subscriptionPlan;
  workspace: TagsPageElements_elements_LinkContent_creator_workspace | null;
}

export interface TagsPageElements_elements_LinkContent_coverDimensions {
  __typename: "CoverDimensions";
  height: number | null;
  width: number | null;
}

export interface TagsPageElements_elements_LinkContent_originalCreator {
  __typename: "User";
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
}

export interface TagsPageElements_elements_LinkContent {
  __typename: "LinkContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * When visibility is public and this flag is set to true require registration to view all content
   */
  need_registration: boolean | null;
  /**
   * Content creator
   */
  creator: TagsPageElements_elements_LinkContent_creator;
  /**
   * Where the element is contained
   */
  parent_folder_id: string | null;
  /**
   * Id of the saved collection copy (in the user's workspace) this content was copied as part of; null if the content is not a copy or was saved individually
   */
  parentSavedCollectionId: string | null;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: TagsPageElements_elements_LinkContent_coverDimensions | null;
  /**
   * Creator of the original content this is a copy of (null if this is not a copy)
   */
  originalCreator: TagsPageElements_elements_LinkContent_originalCreator | null;
  displayStatus: ContentDisplayStatus;
  /**
   * Destination domain
   */
  domain: string | null;
  /**
   * Total duration in seconds, alias of embed.estimatedReadingTime
   */
  duration: number | null;
  label: string | null;
  tags: string[];
  /**
   * Destination link
   */
  url: any | null;
}

export interface TagsPageElements_elements_PdfContent_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface TagsPageElements_elements_PdfContent_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
}

export interface TagsPageElements_elements_PdfContent_creator {
  __typename: "User";
  id: string;
  /**
   * Main email address
   */
  email: any;
  /**
   * Self description of the user
   */
  bio: string | null;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: TagsPageElements_elements_PdfContent_creator_subscriptionPlan;
  workspace: TagsPageElements_elements_PdfContent_creator_workspace | null;
}

export interface TagsPageElements_elements_PdfContent_coverDimensions {
  __typename: "CoverDimensions";
  height: number | null;
  width: number | null;
}

export interface TagsPageElements_elements_PdfContent_originalCreator {
  __typename: "User";
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
}

export interface TagsPageElements_elements_PdfContent_pdfDetails {
  __typename: "PdfDetails";
  pages: number;
}

export interface TagsPageElements_elements_PdfContent {
  __typename: "PdfContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * When visibility is public and this flag is set to true require registration to view all content
   */
  need_registration: boolean | null;
  /**
   * Content creator
   */
  creator: TagsPageElements_elements_PdfContent_creator;
  /**
   * Where the element is contained
   */
  parent_folder_id: string | null;
  /**
   * Id of the saved collection copy (in the user's workspace) this content was copied as part of; null if the content is not a copy or was saved individually
   */
  parentSavedCollectionId: string | null;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: TagsPageElements_elements_PdfContent_coverDimensions | null;
  /**
   * Creator of the original content this is a copy of (null if this is not a copy)
   */
  originalCreator: TagsPageElements_elements_PdfContent_originalCreator | null;
  displayStatus: ContentDisplayStatus;
  /**
   * Total duration in seconds, alias of pdfDetails.estimatedReadingTime
   */
  duration: number | null;
  label: string | null;
  /**
   * PDF document additional details
   */
  pdfDetails: TagsPageElements_elements_PdfContent_pdfDetails | null;
  tags: string[];
  /**
   * Destination link
   */
  url: any | null;
  /**
   * Activate PDF download
   */
  canDownload: boolean | null;
}

export interface TagsPageElements_elements_QuizContent_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface TagsPageElements_elements_QuizContent_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
}

export interface TagsPageElements_elements_QuizContent_creator {
  __typename: "User";
  id: string;
  /**
   * Main email address
   */
  email: any;
  /**
   * Self description of the user
   */
  bio: string | null;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: TagsPageElements_elements_QuizContent_creator_subscriptionPlan;
  workspace: TagsPageElements_elements_QuizContent_creator_workspace | null;
}

export interface TagsPageElements_elements_QuizContent_coverDimensions {
  __typename: "CoverDimensions";
  height: number | null;
  width: number | null;
}

export interface TagsPageElements_elements_QuizContent_originalCreator {
  __typename: "User";
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
}

export interface TagsPageElements_elements_QuizContent_questions_QuizContentQuestionEssay {
  __typename: "QuizContentQuestionEssay" | "QuizContentQuestionMatching" | "QuizContentQuestionMissingWord" | "QuizContentQuestionNumerical";
}

export interface TagsPageElements_elements_QuizContent_questions_QuizContentQuestionSingleChoice_choices {
  __typename: "QuizContentQuestionTextChoice";
  isCorrect: boolean;
  text: string;
}

export interface TagsPageElements_elements_QuizContent_questions_QuizContentQuestionSingleChoice {
  __typename: "QuizContentQuestionSingleChoice";
  choices: TagsPageElements_elements_QuizContent_questions_QuizContentQuestionSingleChoice_choices[];
  title: string | null;
}

export interface TagsPageElements_elements_QuizContent_questions_QuizContentQuestionMultipleChoice_choices {
  __typename: "QuizContentQuestionTextChoice";
  isCorrect: boolean;
  text: string;
}

export interface TagsPageElements_elements_QuizContent_questions_QuizContentQuestionMultipleChoice {
  __typename: "QuizContentQuestionMultipleChoice";
  choices: TagsPageElements_elements_QuizContent_questions_QuizContentQuestionMultipleChoice_choices[];
  title: string | null;
}

export interface TagsPageElements_elements_QuizContent_questions_QuizContentQuestionTrueFalse {
  __typename: "QuizContentQuestionTrueFalse";
  isTrue: boolean;
  title: string | null;
}

export type TagsPageElements_elements_QuizContent_questions = TagsPageElements_elements_QuizContent_questions_QuizContentQuestionEssay | TagsPageElements_elements_QuizContent_questions_QuizContentQuestionSingleChoice | TagsPageElements_elements_QuizContent_questions_QuizContentQuestionMultipleChoice | TagsPageElements_elements_QuizContent_questions_QuizContentQuestionTrueFalse;

export interface TagsPageElements_elements_QuizContent {
  __typename: "QuizContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * When visibility is public and this flag is set to true require registration to view all content
   */
  need_registration: boolean | null;
  /**
   * Content creator
   */
  creator: TagsPageElements_elements_QuizContent_creator;
  /**
   * Where the element is contained
   */
  parent_folder_id: string | null;
  /**
   * Id of the saved collection copy (in the user's workspace) this content was copied as part of; null if the content is not a copy or was saved individually
   */
  parentSavedCollectionId: string | null;
  /**
   * Content subtype
   */
  quizSubtypeForMenu: QuizContentSubtype | null;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: TagsPageElements_elements_QuizContent_coverDimensions | null;
  /**
   * Creator of the original content this is a copy of (null if this is not a copy)
   */
  originalCreator: TagsPageElements_elements_QuizContent_originalCreator | null;
  displayStatus: ContentDisplayStatus;
  label: string | null;
  basket: number | null;
  questions: TagsPageElements_elements_QuizContent_questions[];
  /**
   * Content subtype
   */
  quizSubtype: QuizContentSubtype | null;
  tags: string[];
}

export interface TagsPageElements_elements_ScormContent_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface TagsPageElements_elements_ScormContent_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
}

export interface TagsPageElements_elements_ScormContent_creator {
  __typename: "User";
  id: string;
  /**
   * Main email address
   */
  email: any;
  /**
   * Self description of the user
   */
  bio: string | null;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: TagsPageElements_elements_ScormContent_creator_subscriptionPlan;
  workspace: TagsPageElements_elements_ScormContent_creator_workspace | null;
}

export interface TagsPageElements_elements_ScormContent_coverDimensions {
  __typename: "CoverDimensions";
  height: number | null;
  width: number | null;
}

export interface TagsPageElements_elements_ScormContent_originalCreator {
  __typename: "User";
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
}

export interface TagsPageElements_elements_ScormContent {
  __typename: "ScormContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * When visibility is public and this flag is set to true require registration to view all content
   */
  need_registration: boolean | null;
  /**
   * Content creator
   */
  creator: TagsPageElements_elements_ScormContent_creator;
  /**
   * Where the element is contained
   */
  parent_folder_id: string | null;
  /**
   * Id of the saved collection copy (in the user's workspace) this content was copied as part of; null if the content is not a copy or was saved individually
   */
  parentSavedCollectionId: string | null;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: TagsPageElements_elements_ScormContent_coverDimensions | null;
  /**
   * Creator of the original content this is a copy of (null if this is not a copy)
   */
  originalCreator: TagsPageElements_elements_ScormContent_originalCreator | null;
  displayStatus: ContentDisplayStatus;
  /**
   * Expected time to complete the package, in seconds: the LOM typicalLearningTime the package declares, read on import, or what the author set by hand; null when unknown. Unrelated to timeLimit
   */
  duration: number | null;
  label: string | null;
  tags: string[];
}

export interface TagsPageElements_elements_TextContent_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface TagsPageElements_elements_TextContent_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
}

export interface TagsPageElements_elements_TextContent_creator {
  __typename: "User";
  id: string;
  /**
   * Main email address
   */
  email: any;
  /**
   * Self description of the user
   */
  bio: string | null;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: TagsPageElements_elements_TextContent_creator_subscriptionPlan;
  workspace: TagsPageElements_elements_TextContent_creator_workspace | null;
}

export interface TagsPageElements_elements_TextContent_coverDimensions {
  __typename: "CoverDimensions";
  height: number | null;
  width: number | null;
}

export interface TagsPageElements_elements_TextContent_originalCreator {
  __typename: "User";
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
}

export interface TagsPageElements_elements_TextContent {
  __typename: "TextContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * When visibility is public and this flag is set to true require registration to view all content
   */
  need_registration: boolean | null;
  /**
   * Content creator
   */
  creator: TagsPageElements_elements_TextContent_creator;
  /**
   * Where the element is contained
   */
  parent_folder_id: string | null;
  /**
   * Id of the saved collection copy (in the user's workspace) this content was copied as part of; null if the content is not a copy or was saved individually
   */
  parentSavedCollectionId: string | null;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: TagsPageElements_elements_TextContent_coverDimensions | null;
  /**
   * Creator of the original content this is a copy of (null if this is not a copy)
   */
  originalCreator: TagsPageElements_elements_TextContent_originalCreator | null;
  displayStatus: ContentDisplayStatus;
  /**
   * Total duration in seconds, alias of pdfDetails.estimatedReadingTime
   */
  duration: number | null;
  label: string | null;
  tags: string[];
  /**
   * Destination link
   */
  url: any | null;
}

export interface TagsPageElements_elements_VideoContent_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface TagsPageElements_elements_VideoContent_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
}

export interface TagsPageElements_elements_VideoContent_creator {
  __typename: "User";
  id: string;
  /**
   * Main email address
   */
  email: any;
  /**
   * Self description of the user
   */
  bio: string | null;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: TagsPageElements_elements_VideoContent_creator_subscriptionPlan;
  workspace: TagsPageElements_elements_VideoContent_creator_workspace | null;
}

export interface TagsPageElements_elements_VideoContent_coverDimensions {
  __typename: "CoverDimensions";
  height: number | null;
  width: number | null;
}

export interface TagsPageElements_elements_VideoContent_originalCreator {
  __typename: "User";
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
}

export interface TagsPageElements_elements_VideoContent {
  __typename: "VideoContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * When visibility is public and this flag is set to true require registration to view all content
   */
  need_registration: boolean | null;
  /**
   * Content creator
   */
  creator: TagsPageElements_elements_VideoContent_creator;
  /**
   * Where the element is contained
   */
  parent_folder_id: string | null;
  /**
   * Id of the saved collection copy (in the user's workspace) this content was copied as part of; null if the content is not a copy or was saved individually
   */
  parentSavedCollectionId: string | null;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: TagsPageElements_elements_VideoContent_coverDimensions | null;
  /**
   * Creator of the original content this is a copy of (null if this is not a copy)
   */
  originalCreator: TagsPageElements_elements_VideoContent_originalCreator | null;
  displayStatus: ContentDisplayStatus;
  /**
   * Total duration in seconds
   */
  duration: number | null;
  label: string | null;
  tags: string[];
  /**
   * Destination link
   */
  url: any | null;
  aspectRatio: string | null;
}

export interface TagsPageElements_elements_MixedCollection_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface TagsPageElements_elements_MixedCollection_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
}

export interface TagsPageElements_elements_MixedCollection_creator {
  __typename: "User";
  id: string;
  /**
   * Main email address
   */
  email: any;
  /**
   * Self description of the user
   */
  bio: string | null;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: TagsPageElements_elements_MixedCollection_creator_subscriptionPlan;
  workspace: TagsPageElements_elements_MixedCollection_creator_workspace | null;
}

export interface TagsPageElements_elements_MixedCollection_coverDimensions {
  __typename: "CoverDimensions";
  height: number | null;
  width: number | null;
}

export interface TagsPageElements_elements_MixedCollection_originalCreator {
  __typename: "User";
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
}

export interface TagsPageElements_elements_MixedCollection {
  __typename: "MixedCollection" | "BlendedCollection" | "VideoCollection";
  /**
   * Defines if current user has a specific permission on the collection
   */
  canManage: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  selling: boolean;
  sellingPricing: number | null;
  sellingMethod: string | null;
  /**
   * When visibility is public and this flag is set to true require registration to view all content
   */
  need_registration: boolean | null;
  /**
   * Total duration of all the audio and video contents included
   */
  duration: number | null;
  /**
   * Get total contents for required type
   */
  totalAudio: number;
  /**
   * Get total contents for required type
   */
  totalImage: number;
  /**
   * Get total contents for required type
   */
  totalLink: number;
  /**
   * Get total contents for required type
   */
  totalPdf: number;
  /**
   * Get total contents for required type
   */
  totalQuiz: number;
  /**
   * Get total contents for required type
   */
  totalScorm: number;
  /**
   * Get total contents for required type
   */
  totalText: number;
  /**
   * Get total contents for required type
   */
  totalVideo: number;
  /**
   * Collection creator
   */
  creator: TagsPageElements_elements_MixedCollection_creator;
  sellingCurrency: string | null;
  /**
   * Defines if current user has a specific permission on the collection
   */
  canRead: boolean;
  collectionDisplayStatus: CollectionDisplayStatus;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: TagsPageElements_elements_MixedCollection_coverDimensions | null;
  /**
   * Creator of the original collection this is a copy of (null if this is not a copy)
   */
  originalCreator: TagsPageElements_elements_MixedCollection_originalCreator | null;
  label: string | null;
  tags: string[];
  parent_folder_id: string | null;
  certificate_id: string | null;
}

export interface TagsPageElements_elements_Folder_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface TagsPageElements_elements_Folder_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
}

export interface TagsPageElements_elements_Folder_creator {
  __typename: "User";
  /**
   * Self description of the user
   */
  bio: string | null;
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: TagsPageElements_elements_Folder_creator_subscriptionPlan;
  /**
   * Main email address
   */
  email: any;
  workspace: TagsPageElements_elements_Folder_creator_workspace | null;
}

export interface TagsPageElements_elements_Folder {
  __typename: "Folder";
  /**
   * Get total contents for required type
   */
  totalContents: number;
  /**
   * Get total contents for required type
   */
  totalCollections: number;
  /**
   * Get total contents for required type
   */
  totalFolders: number;
  canManage: boolean;
  canRead: boolean;
  /**
   * Folder creator
   */
  creator: TagsPageElements_elements_Folder_creator;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  tags: string[];
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * Where the element is contained
   */
  parent_folder_id: string | null;
}

export type TagsPageElements_elements = TagsPageElements_elements_AudioContent | TagsPageElements_elements_EventContent | TagsPageElements_elements_ImageContent | TagsPageElements_elements_LinkContent | TagsPageElements_elements_PdfContent | TagsPageElements_elements_QuizContent | TagsPageElements_elements_ScormContent | TagsPageElements_elements_TextContent | TagsPageElements_elements_VideoContent | TagsPageElements_elements_MixedCollection | TagsPageElements_elements_Folder;

export interface TagsPageElements {
  elements: TagsPageElements_elements[];
}

export interface TagsPageElementsVariables {
  tag: string;
  userId?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetUserPlanData
// ====================================================

export interface GetUserPlanData_user_subscriptionPlan_pivot {
  __typename: "Pivot";
  period_end: any | null;
}

export interface GetUserPlanData_user_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Product ID on Stripe
   */
  stripe_product_id: string | null;
  /**
   * Title
   */
  title: string | null;
  /**
   * Internal code
   */
  code: string;
  /**
   * Period_end of the plan
   */
  pivot: GetUserPlanData_user_subscriptionPlan_pivot | null;
}

export interface GetUserPlanData_user {
  __typename: "User";
  /**
   * First name
   */
  firstname: string;
  id: string;
  /**
   * Last name
   */
  lastname: string;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Main email address
   */
  email: any;
  subscriptionPlan: GetUserPlanData_user_subscriptionPlan;
}

export interface GetUserPlanData {
  /**
   * Currently authenticated user
   */
  user: GetUserPlanData_user | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetPartners
// ====================================================

export interface GetPartners_partners_edges_node {
  __typename: "PartnerPublic";
  /**
   * First name
   */
  firstname: string;
  /**
   * Last name
   */
  lastname: string;
  /**
   * Self description of the user
   */
  payoff: string | null;
  /**
   * User picture
   */
  picture: any;
  /**
   * User location (e.g., City, Country)
   */
  location: string | null;
  /**
   * User professional category
   */
  category: UserCategory | null;
  /**
   * Custom route
   */
  vanity_name: string | null;
}

export interface GetPartners_partners_edges {
  __typename: "PartnerPublicEdge";
  /**
   * The PartnerPublic node.
   */
  node: GetPartners_partners_edges_node;
}

export interface GetPartners_partners_pageInfo {
  __typename: "PageInfo";
  /**
   * When paginating forwards, are there more items?
   */
  hasNextPage: boolean;
  /**
   * The cursor to continue paginating forwards.
   */
  endCursor: string | null;
}

export interface GetPartners_partners {
  __typename: "PartnerPublicConnection";
  /**
   * A list of PartnerPublic edges.
   */
  edges: GetPartners_partners_edges[];
  /**
   * Pagination information about the list of edges.
   */
  pageInfo: GetPartners_partners_pageInfo;
}

export interface GetPartners {
  /**
   * List of partner users (active partner subscription plan)
   */
  partners: GetPartners_partners;
}

export interface GetPartnersVariables {
  first: number;
  after?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: CurrentUserContentsForProfile
// ====================================================

export interface CurrentUserContentsForProfile_me_contents_edges_node {
  __typename: "AudioContent" | "EventContent" | "ImageContent" | "LinkContent" | "PdfContent" | "QuizContent" | "ScormContent" | "TextContent" | "VideoContent";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Main title
   */
  title: string;
}

export interface CurrentUserContentsForProfile_me_contents_edges {
  __typename: "ContentEdge";
  /**
   * The Content node.
   */
  node: CurrentUserContentsForProfile_me_contents_edges_node;
}

export interface CurrentUserContentsForProfile_me_contents {
  __typename: "ContentConnection";
  /**
   * A list of Content edges.
   */
  edges: CurrentUserContentsForProfile_me_contents_edges[];
}

export interface CurrentUserContentsForProfile_me_collections_edges_node {
  __typename: "BlendedCollection" | "MixedCollection" | "VideoCollection";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Main title
   */
  title: string;
}

export interface CurrentUserContentsForProfile_me_collections_edges {
  __typename: "CollectionEdge";
  /**
   * The Collection node.
   */
  node: CurrentUserContentsForProfile_me_collections_edges_node;
}

export interface CurrentUserContentsForProfile_me_collections {
  __typename: "CollectionConnection";
  /**
   * A list of Collection edges.
   */
  edges: CurrentUserContentsForProfile_me_collections_edges[];
}

export interface CurrentUserContentsForProfile_me {
  __typename: "User";
  /**
   * Contents managed by the user
   */
  contents: CurrentUserContentsForProfile_me_contents;
  /**
   * Collections managed by the user
   */
  collections: CurrentUserContentsForProfile_me_collections;
  id: string;
}

export interface CurrentUserContentsForProfile {
  /**
   * Currently authenticated user
   */
  me: CurrentUserContentsForProfile_me | null;
}

export interface CurrentUserContentsForProfileVariables {
  visibility?: Visibility[] | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateUserProfilePageElements
// ====================================================

export interface UpdateUserProfilePageElements {
  updateUserProfilePageElements: boolean;
}

export interface UpdateUserProfilePageElementsVariables {
  elements: (UpdateUserProfilePageElement | null)[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: UserProfilePageElementsByType
// ====================================================

export interface UserProfilePageElementsByType_elements_Folder {
  __typename: "Folder";
}

export interface UserProfilePageElementsByType_elements_MixedCollection_coverDimensions {
  __typename: "CoverDimensions";
  height: number | null;
  width: number | null;
}

export interface UserProfilePageElementsByType_elements_MixedCollection_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface UserProfilePageElementsByType_elements_MixedCollection_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
}

export interface UserProfilePageElementsByType_elements_MixedCollection_creator {
  __typename: "User";
  /**
   * Self description of the user
   */
  bio: string | null;
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: UserProfilePageElementsByType_elements_MixedCollection_creator_subscriptionPlan;
  /**
   * Main email address
   */
  email: any;
  workspace: UserProfilePageElementsByType_elements_MixedCollection_creator_workspace | null;
}

export interface UserProfilePageElementsByType_elements_MixedCollection {
  __typename: "MixedCollection" | "BlendedCollection" | "VideoCollection";
  /**
   * Total duration of all the audio and video contents included
   */
  duration: number | null;
  /**
   * Get total contents for required type
   */
  totalAudio: number;
  /**
   * Get total contents for required type
   */
  totalImage: number;
  /**
   * Get total contents for required type
   */
  totalLink: number;
  /**
   * Get total contents for required type
   */
  totalPdf: number;
  /**
   * Get total contents for required type
   */
  totalQuiz: number;
  /**
   * Get total contents for required type
   */
  totalScorm: number;
  /**
   * Get total contents for required type
   */
  totalText: number;
  /**
   * Get total contents for required type
   */
  totalVideo: number;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Main title
   */
  title: string;
  /**
   * Cover picture
   */
  cover: any | null;
  presentation: string | null;
  certificate_id: string | null;
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: UserProfilePageElementsByType_elements_MixedCollection_coverDimensions | null;
  /**
   * Collection creator
   */
  creator: UserProfilePageElementsByType_elements_MixedCollection_creator;
  /**
   * Defines if current user has a specific permission on the collection
   */
  canRead: boolean;
  selling: boolean;
  sellingPricing: number | null;
  sellingCurrency: string | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  collectionDisplayStatus: CollectionDisplayStatus;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * Defines if current user has a specific permission on the collection
   */
  canManage: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * When visibility is public and this flag is set to true require registration to view all content
   */
  need_registration: boolean | null;
}

export interface UserProfilePageElementsByType_elements_AudioContent_coverDimensions {
  __typename: "CoverDimensions";
  height: number | null;
  width: number | null;
}

export interface UserProfilePageElementsByType_elements_AudioContent_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface UserProfilePageElementsByType_elements_AudioContent_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
}

export interface UserProfilePageElementsByType_elements_AudioContent_creator {
  __typename: "User";
  /**
   * Self description of the user
   */
  bio: string | null;
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: UserProfilePageElementsByType_elements_AudioContent_creator_subscriptionPlan;
  /**
   * Main email address
   */
  email: any;
  workspace: UserProfilePageElementsByType_elements_AudioContent_creator_workspace | null;
}

export interface UserProfilePageElementsByType_elements_AudioContent {
  __typename: "AudioContent" | "ImageContent" | "LinkContent" | "PdfContent" | "QuizContent" | "ScormContent" | "TextContent" | "VideoContent";
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  tags: string[];
  /**
   * Destination link
   */
  url: any | null;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: UserProfilePageElementsByType_elements_AudioContent_coverDimensions | null;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * Content creator
   */
  creator: UserProfilePageElementsByType_elements_AudioContent_creator;
  displayStatus: ContentDisplayStatus;
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
}

export interface UserProfilePageElementsByType_elements_EventContent_coverDimensions {
  __typename: "CoverDimensions";
  height: number | null;
  width: number | null;
}

export interface UserProfilePageElementsByType_elements_EventContent_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface UserProfilePageElementsByType_elements_EventContent_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
}

export interface UserProfilePageElementsByType_elements_EventContent_creator {
  __typename: "User";
  /**
   * Self description of the user
   */
  bio: string | null;
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: UserProfilePageElementsByType_elements_EventContent_creator_subscriptionPlan;
  /**
   * Main email address
   */
  email: any;
  workspace: UserProfilePageElementsByType_elements_EventContent_creator_workspace | null;
}

export interface UserProfilePageElementsByType_elements_EventContent_registeredUsers {
  __typename: "User";
  id: string;
}

export interface UserProfilePageElementsByType_elements_EventContent_originalCreator {
  __typename: "User";
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
}

export interface UserProfilePageElementsByType_elements_EventContent {
  __typename: "EventContent";
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  tags: string[];
  /**
   * Destination link
   */
  url: any | null;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: UserProfilePageElementsByType_elements_EventContent_coverDimensions | null;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * Content creator
   */
  creator: UserProfilePageElementsByType_elements_EventContent_creator;
  displayStatus: ContentDisplayStatus;
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  expired: any | null;
  isCurrentUserRegistered: boolean;
  participants: number | null;
  registeredUsers: UserProfilePageElementsByType_elements_EventContent_registeredUsers[];
  registration: boolean;
  status: EventContentStatus;
  /**
   * Content subtype
   */
  subtype: EventContentSubtype;
  end: any | null;
  start: any | null;
  location: string | null;
  /**
   * Creator of the original content this is a copy of (null if this is not a copy)
   */
  originalCreator: UserProfilePageElementsByType_elements_EventContent_originalCreator | null;
  hasUserCompleted: boolean | null;
  certificate_id: string | null;
}

export type UserProfilePageElementsByType_elements = UserProfilePageElementsByType_elements_Folder | UserProfilePageElementsByType_elements_MixedCollection | UserProfilePageElementsByType_elements_AudioContent | UserProfilePageElementsByType_elements_EventContent;

export interface UserProfilePageElementsByType {
  elements: UserProfilePageElementsByType_elements[];
}

export interface UserProfilePageElementsByTypeVariables {
  userId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: CurrentUserExternalAccounts
// ====================================================

export interface CurrentUserExternalAccounts_user_externalAccounts_edges_node {
  __typename: "UserExternalAccount";
  createdAt: any;
  expires: any | null;
  id: string;
  identifier: string;
  isExpired: boolean;
  provider: UserExternalAccountProvider;
}

export interface CurrentUserExternalAccounts_user_externalAccounts_edges {
  __typename: "UserExternalAccountEdge";
  /**
   * The UserExternalAccount node.
   */
  node: CurrentUserExternalAccounts_user_externalAccounts_edges_node;
}

export interface CurrentUserExternalAccounts_user_externalAccounts {
  __typename: "UserExternalAccountConnection";
  /**
   * A list of UserExternalAccount edges.
   */
  edges: CurrentUserExternalAccounts_user_externalAccounts_edges[];
}

export interface CurrentUserExternalAccounts_user {
  __typename: "User";
  externalAccounts: CurrentUserExternalAccounts_user_externalAccounts;
  id: string;
}

export interface CurrentUserExternalAccounts {
  /**
   * Currently authenticated user
   */
  user: CurrentUserExternalAccounts_user | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: DisconnectUserExternalAccount
// ====================================================

export interface DisconnectUserExternalAccount {
  disconnectUserExternalAccount: boolean;
}

export interface DisconnectUserExternalAccountVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetUserWorkspace
// ====================================================

export interface GetUserWorkspace_user_workspace_domain {
  __typename: "Domain";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Domain name
   */
  name: string;
  /**
   * Status of domain approval process
   */
  status: DomainStatus;
}

export interface GetUserWorkspace_user_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Name
   */
  name: string;
  /**
   * Domain for white label
   */
  domain: GetUserWorkspace_user_workspace_domain | null;
}

export interface GetUserWorkspace_user {
  __typename: "User";
  id: string;
  workspace: GetUserWorkspace_user_workspace | null;
}

export interface GetUserWorkspace {
  /**
   * Currently authenticated user
   */
  user: GetUserWorkspace_user | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CheckDomainStatus
// ====================================================

export interface CheckDomainStatus_checkStatus {
  __typename: "Domain";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Domain name
   */
  name: string;
  /**
   * Status of domain approval process
   */
  status: DomainStatus;
  /**
   * Last verification of DNS
   */
  lastCheckedAt: any | null;
}

export interface CheckDomainStatus {
  checkStatus: CheckDomainStatus_checkStatus;
}

export interface CheckDomainStatusVariables {
  domainId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetDomainInstructions
// ====================================================

export interface GetDomainInstructions_getInstructions_domain {
  __typename: "Domain";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Domain name
   */
  name: string;
  /**
   * Status of domain approval process
   */
  status: DomainStatus;
  /**
   * Last verification of DNS
   */
  lastCheckedAt: any | null;
}

export interface GetDomainInstructions_getInstructions_instructions {
  __typename: "DomainVerificationInstruction";
  type: string;
  name: string;
  value: string;
  reason: string | null;
}

export interface GetDomainInstructions_getInstructions {
  __typename: "DomainInstructions";
  domain: GetDomainInstructions_getInstructions_domain | null;
  resultCode: number;
  instructions: (GetDomainInstructions_getInstructions_instructions | null)[] | null;
}

export interface GetDomainInstructions {
  getInstructions: GetDomainInstructions_getInstructions;
}

export interface GetDomainInstructionsVariables {
  domainId: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: AddUserEmailAddress
// ====================================================

export interface AddUserEmailAddress_addUserEmail {
  __typename: "UserEmail";
  id: string;
}

export interface AddUserEmailAddress {
  addUserEmail: AddUserEmailAddress_addUserEmail | null;
}

export interface AddUserEmailAddressVariables {
  email: any;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: CurrentUserEmailAddresses
// ====================================================

export interface CurrentUserEmailAddresses_user_emails {
  __typename: "UserEmail";
  email: any;
  id: string;
  primary: boolean;
  verifiedAt: any | null;
}

export interface CurrentUserEmailAddresses_user {
  __typename: "User";
  emails: CurrentUserEmailAddresses_user_emails[];
  id: string;
}

export interface CurrentUserEmailAddresses {
  /**
   * Currently authenticated user
   */
  user: CurrentUserEmailAddresses_user | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: MakeUserEmailPrimary
// ====================================================

export interface MakeUserEmailPrimary_makeUserEmailPrimary {
  __typename: "UserEmail";
  id: string;
  primary: boolean;
}

export interface MakeUserEmailPrimary {
  makeUserEmailPrimary: MakeUserEmailPrimary_makeUserEmailPrimary;
}

export interface MakeUserEmailPrimaryVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: RemoveUserEmail
// ====================================================

export interface RemoveUserEmail {
  removeUserEmail: boolean;
}

export interface RemoveUserEmailVariables {
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: FetchOriginalPicture
// ====================================================

export interface FetchOriginalPicture_user {
  __typename: "User";
  id: string;
  picture: any | null;
}

export interface FetchOriginalPicture {
  /**
   * Currently authenticated user
   */
  user: FetchOriginalPicture_user | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UploadFileForPicture
// ====================================================

export interface UploadFileForPicture {
  /**
   * Upload a file that is publicly available
   */
  upload: any;
}

export interface UploadFileForPictureVariables {
  file: any;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateUserPersonalInfomation
// ====================================================

export interface UpdateUserPersonalInfomation_updateUser {
  __typename: "User";
  /**
   * First name
   */
  firstname: string;
  id: string;
  /**
   * Last name
   */
  lastname: string;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
}

export interface UpdateUserPersonalInfomation {
  /**
   * Update current user profile
   */
  updateUser: UpdateUserPersonalInfomation_updateUser;
}

export interface UpdateUserPersonalInfomationVariables {
  input: UpdateUserInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: UserPersonalInfomation
// ====================================================

export interface UserPersonalInfomation_user {
  __typename: "User";
  id: string;
  /**
   * First name
   */
  firstname: string;
  /**
   * Last name
   */
  lastname: string;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
}

export interface UserPersonalInfomation {
  /**
   * Currently authenticated user
   */
  user: UserPersonalInfomation_user | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: UserStripe
// ====================================================

export interface UserStripe_user_stripeAccount {
  __typename: "StripeAccount";
  detailsSubmitted: boolean;
  /**
   * Unique identifier for the object.
   */
  id: string;
}

export interface UserStripe_user {
  __typename: "User";
  id: string;
  stripeAccount: UserStripe_user_stripeAccount;
  stripeAccountLink: any;
}

export interface UserStripe {
  /**
   * Currently authenticated user
   */
  user: UserStripe_user | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateUserPreferences
// ====================================================

export interface UpdateUserPreferences_updateUser_preferences {
  __typename: "UserPreferences";
  hideMessageCreator: boolean;
}

export interface UpdateUserPreferences_updateUser {
  __typename: "User";
  id: string;
  preferences: UpdateUserPreferences_updateUser_preferences;
}

export interface UpdateUserPreferences {
  /**
   * Update current user profile
   */
  updateUser: UpdateUserPreferences_updateUser;
}

export interface UpdateUserPreferencesVariables {
  input: UpdateUserInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetUserPreferences
// ====================================================

export interface GetUserPreferences_user_preferences {
  __typename: "UserPreferences";
  hideMessageCreator: boolean;
}

export interface GetUserPreferences_user {
  __typename: "User";
  id: string;
  preferences: GetUserPreferences_user_preferences;
}

export interface GetUserPreferences {
  /**
   * Currently authenticated user
   */
  user: GetUserPreferences_user | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateWorkspacePreferences
// ====================================================

export interface UpdateWorkspacePreferences_updateWorkspace {
  __typename: "Workspace";
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
}

export interface UpdateWorkspacePreferences {
  /**
   * Update a workspace
   */
  updateWorkspace: UpdateWorkspacePreferences_updateWorkspace;
}

export interface UpdateWorkspacePreferencesVariables {
  input: UpdateWorkspaceInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetWorkspacePreferences
// ====================================================

export interface GetWorkspacePreferences_user_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
}

export interface GetWorkspacePreferences_user {
  __typename: "User";
  id: string;
  workspace: GetWorkspacePreferences_user_workspace | null;
}

export interface GetWorkspacePreferences {
  /**
   * Currently authenticated user
   */
  user: GetWorkspacePreferences_user | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: UpdateUserWorkspaceInfo
// ====================================================

export interface UpdateUserWorkspaceInfo_updateUser {
  __typename: "User";
  /**
   * Brand Name for white label
   */
  brandName: string | null;
  /**
   * Small squared logo for white label
   */
  brandLogoSmall: any | null;
  /**
   * Self description of the user
   */
  bio: string | null;
  /**
   * Personal website
   */
  website: any | null;
  /**
   * Profile page
   */
  linkedin: any | null;
  /**
   * Profile page
   */
  facebook: any | null;
  /**
   * Profile page
   */
  instagram: any | null;
  /**
   * Profile page
   */
  twitter: any | null;
  /**
   * User banner
   */
  banner: any | null;
  /**
   * Personal slogan
   */
  payoff: string | null;
  /**
   * User professional category
   */
  category: UserCategory | null;
  /**
   * User location (e.g., City, Country)
   */
  location: string | null;
}

export interface UpdateUserWorkspaceInfo {
  /**
   * Update current user profile
   */
  updateUser: UpdateUserWorkspaceInfo_updateUser;
}

export interface UpdateUserWorkspaceInfoVariables {
  input: UpdateUserInput;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetUserWorkspaceInfo
// ====================================================

export interface GetUserWorkspaceInfo_user_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Brand Name for white label
   */
  brandName: string | null;
  /**
   * Small squared logo for white label
   */
  brandLogoSmall: any | null;
}

export interface GetUserWorkspaceInfo_user {
  __typename: "User";
  id: string;
  /**
   * Self description of the user
   */
  bio: string | null;
  /**
   * Personal website
   */
  website: any | null;
  /**
   * Profile page
   */
  linkedin: any | null;
  /**
   * Profile page
   */
  facebook: any | null;
  /**
   * Profile page
   */
  instagram: any | null;
  /**
   * Profile page
   */
  twitter: any | null;
  /**
   * User banner
   */
  banner: any | null;
  /**
   * Personal slogan
   */
  payoff: string | null;
  /**
   * User professional category
   */
  category: UserCategory | null;
  /**
   * User location (e.g., City, Country)
   */
  location: string | null;
  workspace: GetUserWorkspaceInfo_user_workspace | null;
}

export interface GetUserWorkspaceInfo {
  /**
   * Currently authenticated user
   */
  user: GetUserWorkspaceInfo_user | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetPaginatedCollectionAuthAndInvites
// ====================================================

export interface GetPaginatedCollectionAuthAndInvites_element_paginatedAuthorizationsAndInvites_paginatorInfo {
  __typename: "PaginatorInfo";
  currentPage: number;
  lastPage: number;
  total: number;
  hasMorePages: boolean;
}

export interface GetPaginatedCollectionAuthAndInvites_element_paginatedAuthorizationsAndInvites_data_Authorization_user {
  __typename: "User";
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Main email address
   */
  email: any;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  getCompletedAt: any | null;
  hasUserVisited: boolean | null;
}

export interface GetPaginatedCollectionAuthAndInvites_element_paginatedAuthorizationsAndInvites_data_Authorization {
  __typename: "Authorization";
  id: string;
  user: GetPaginatedCollectionAuthAndInvites_element_paginatedAuthorizationsAndInvites_data_Authorization_user;
}

export interface GetPaginatedCollectionAuthAndInvites_element_paginatedAuthorizationsAndInvites_data_Invite {
  __typename: "Invite";
  id: string;
  createdAt: any;
}

export type GetPaginatedCollectionAuthAndInvites_element_paginatedAuthorizationsAndInvites_data = GetPaginatedCollectionAuthAndInvites_element_paginatedAuthorizationsAndInvites_data_Authorization | GetPaginatedCollectionAuthAndInvites_element_paginatedAuthorizationsAndInvites_data_Invite;

export interface GetPaginatedCollectionAuthAndInvites_element_paginatedAuthorizationsAndInvites {
  __typename: "PaginatedAuthorizationsAndInvites";
  paginatorInfo: GetPaginatedCollectionAuthAndInvites_element_paginatedAuthorizationsAndInvites_paginatorInfo;
  data: GetPaginatedCollectionAuthAndInvites_element_paginatedAuthorizationsAndInvites_data[];
}

export interface GetPaginatedCollectionAuthAndInvites_element {
  __typename: "BlendedCollection" | "MixedCollection" | "VideoCollection";
  /**
   * Unique identifier
   */
  id: string;
  paginatedAuthorizationsAndInvites: GetPaginatedCollectionAuthAndInvites_element_paginatedAuthorizationsAndInvites;
}

export interface GetPaginatedCollectionAuthAndInvites {
  /**
   * Get a collection, identified by id or by slug,
   * optionally an authorization token can be used to enable access for current user.
   */
  element: GetPaginatedCollectionAuthAndInvites_element | null;
}

export interface GetPaginatedCollectionAuthAndInvitesVariables {
  id: string;
  identifier: string;
  page: number;
  first: number;
  search?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetPaginatedContentAuthAndInvites
// ====================================================

export interface GetPaginatedContentAuthAndInvites_element_paginatedAuthorizationsAndInvites_paginatorInfo {
  __typename: "PaginatorInfo";
  currentPage: number;
  lastPage: number;
  total: number;
  hasMorePages: boolean;
}

export interface GetPaginatedContentAuthAndInvites_element_paginatedAuthorizationsAndInvites_data_Authorization_user {
  __typename: "User";
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Main email address
   */
  email: any;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  getCompletedAt: any | null;
  hasUserVisited: boolean | null;
}

export interface GetPaginatedContentAuthAndInvites_element_paginatedAuthorizationsAndInvites_data_Authorization {
  __typename: "Authorization";
  id: string;
  user: GetPaginatedContentAuthAndInvites_element_paginatedAuthorizationsAndInvites_data_Authorization_user;
}

export interface GetPaginatedContentAuthAndInvites_element_paginatedAuthorizationsAndInvites_data_Invite {
  __typename: "Invite";
  id: string;
  createdAt: any;
}

export type GetPaginatedContentAuthAndInvites_element_paginatedAuthorizationsAndInvites_data = GetPaginatedContentAuthAndInvites_element_paginatedAuthorizationsAndInvites_data_Authorization | GetPaginatedContentAuthAndInvites_element_paginatedAuthorizationsAndInvites_data_Invite;

export interface GetPaginatedContentAuthAndInvites_element_paginatedAuthorizationsAndInvites {
  __typename: "PaginatedAuthorizationsAndInvites";
  paginatorInfo: GetPaginatedContentAuthAndInvites_element_paginatedAuthorizationsAndInvites_paginatorInfo;
  data: GetPaginatedContentAuthAndInvites_element_paginatedAuthorizationsAndInvites_data[];
}

export interface GetPaginatedContentAuthAndInvites_element {
  __typename: "AudioContent" | "EventContent" | "ImageContent" | "LinkContent" | "PdfContent" | "QuizContent" | "ScormContent" | "TextContent" | "VideoContent";
  /**
   * Unique identifier
   */
  id: string;
  paginatedAuthorizationsAndInvites: GetPaginatedContentAuthAndInvites_element_paginatedAuthorizationsAndInvites;
}

export interface GetPaginatedContentAuthAndInvites {
  /**
   * Get a content, identified by id or by slug,
   * optionally an authorization token can be used to enable access for current user.
   */
  element: GetPaginatedContentAuthAndInvites_element | null;
}

export interface GetPaginatedContentAuthAndInvitesVariables {
  id: string;
  identifier: string;
  page: number;
  first: number;
  search?: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: WorkspaceBoardElements
// ====================================================

export interface WorkspaceBoardElements_elements_Folder {
  __typename: "Folder";
}

export interface WorkspaceBoardElements_elements_AudioContent_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface WorkspaceBoardElements_elements_AudioContent_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
}

export interface WorkspaceBoardElements_elements_AudioContent_creator {
  __typename: "User";
  id: string;
  /**
   * Main email address
   */
  email: any;
  /**
   * Self description of the user
   */
  bio: string | null;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: WorkspaceBoardElements_elements_AudioContent_creator_subscriptionPlan;
  workspace: WorkspaceBoardElements_elements_AudioContent_creator_workspace | null;
}

export interface WorkspaceBoardElements_elements_AudioContent_originalCreator {
  __typename: "User";
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
}

export interface WorkspaceBoardElements_elements_AudioContent {
  __typename: "AudioContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * When visibility is public and this flag is set to true require registration to view all content
   */
  need_registration: boolean | null;
  /**
   * Content creator
   */
  creator: WorkspaceBoardElements_elements_AudioContent_creator;
  /**
   * Where the element is contained
   */
  parent_folder_id: string | null;
  /**
   * Id of the saved collection copy (in the user's workspace) this content was copied as part of; null if the content is not a copy or was saved individually
   */
  parentSavedCollectionId: string | null;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Creator of the original content this is a copy of (null if this is not a copy)
   */
  originalCreator: WorkspaceBoardElements_elements_AudioContent_originalCreator | null;
  displayStatus: ContentDisplayStatus;
  /**
   * Total duration in seconds
   */
  duration: number | null;
  label: string | null;
  tags: string[];
  /**
   * Destination link
   */
  url: any | null;
}

export interface WorkspaceBoardElements_elements_EventContent_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface WorkspaceBoardElements_elements_EventContent_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
}

export interface WorkspaceBoardElements_elements_EventContent_creator {
  __typename: "User";
  id: string;
  /**
   * Main email address
   */
  email: any;
  /**
   * Self description of the user
   */
  bio: string | null;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: WorkspaceBoardElements_elements_EventContent_creator_subscriptionPlan;
  workspace: WorkspaceBoardElements_elements_EventContent_creator_workspace | null;
}

export interface WorkspaceBoardElements_elements_EventContent_registeredUsers {
  __typename: "User";
  id: string;
}

export interface WorkspaceBoardElements_elements_EventContent_coverDimensions {
  __typename: "CoverDimensions";
  height: number | null;
  width: number | null;
}

export interface WorkspaceBoardElements_elements_EventContent_originalCreator {
  __typename: "User";
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
}

export interface WorkspaceBoardElements_elements_EventContent {
  __typename: "EventContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * When visibility is public and this flag is set to true require registration to view all content
   */
  need_registration: boolean | null;
  /**
   * Content creator
   */
  creator: WorkspaceBoardElements_elements_EventContent_creator;
  /**
   * Where the element is contained
   */
  parent_folder_id: string | null;
  /**
   * Id of the saved collection copy (in the user's workspace) this content was copied as part of; null if the content is not a copy or was saved individually
   */
  parentSavedCollectionId: string | null;
  eventStatusForMenu: EventContentStatus;
  expired: any | null;
  isCurrentUserRegistered: boolean;
  participants: number | null;
  registeredUsers: WorkspaceBoardElements_elements_EventContent_registeredUsers[];
  registration: boolean;
  status: EventContentStatus;
  /**
   * Content subtype
   */
  subtype: EventContentSubtype;
  /**
   * Destination link
   */
  url: any | null;
  end: any | null;
  start: any | null;
  location: string | null;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: WorkspaceBoardElements_elements_EventContent_coverDimensions | null;
  /**
   * Creator of the original content this is a copy of (null if this is not a copy)
   */
  originalCreator: WorkspaceBoardElements_elements_EventContent_originalCreator | null;
  hasUserCompleted: boolean | null;
  displayStatus: ContentDisplayStatus;
  label: string | null;
  tags: string[];
  certificate_id: string | null;
}

export interface WorkspaceBoardElements_elements_ImageContent_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface WorkspaceBoardElements_elements_ImageContent_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
}

export interface WorkspaceBoardElements_elements_ImageContent_creator {
  __typename: "User";
  id: string;
  /**
   * Main email address
   */
  email: any;
  /**
   * Self description of the user
   */
  bio: string | null;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: WorkspaceBoardElements_elements_ImageContent_creator_subscriptionPlan;
  workspace: WorkspaceBoardElements_elements_ImageContent_creator_workspace | null;
}

export interface WorkspaceBoardElements_elements_ImageContent_coverDimensions {
  __typename: "CoverDimensions";
  height: number | null;
  width: number | null;
}

export interface WorkspaceBoardElements_elements_ImageContent_originalCreator {
  __typename: "User";
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
}

export interface WorkspaceBoardElements_elements_ImageContent {
  __typename: "ImageContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * When visibility is public and this flag is set to true require registration to view all content
   */
  need_registration: boolean | null;
  /**
   * Content creator
   */
  creator: WorkspaceBoardElements_elements_ImageContent_creator;
  /**
   * Where the element is contained
   */
  parent_folder_id: string | null;
  /**
   * Id of the saved collection copy (in the user's workspace) this content was copied as part of; null if the content is not a copy or was saved individually
   */
  parentSavedCollectionId: string | null;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: WorkspaceBoardElements_elements_ImageContent_coverDimensions | null;
  /**
   * Creator of the original content this is a copy of (null if this is not a copy)
   */
  originalCreator: WorkspaceBoardElements_elements_ImageContent_originalCreator | null;
  displayStatus: ContentDisplayStatus;
  /**
   * Content subtype
   */
  imageSubtype: string | null;
  label: string | null;
  tags: string[];
  /**
   * Destination link
   */
  url: any | null;
  /**
   * Effective images URL
   */
  urls: any[];
}

export interface WorkspaceBoardElements_elements_LinkContent_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface WorkspaceBoardElements_elements_LinkContent_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
}

export interface WorkspaceBoardElements_elements_LinkContent_creator {
  __typename: "User";
  id: string;
  /**
   * Main email address
   */
  email: any;
  /**
   * Self description of the user
   */
  bio: string | null;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: WorkspaceBoardElements_elements_LinkContent_creator_subscriptionPlan;
  workspace: WorkspaceBoardElements_elements_LinkContent_creator_workspace | null;
}

export interface WorkspaceBoardElements_elements_LinkContent_coverDimensions {
  __typename: "CoverDimensions";
  height: number | null;
  width: number | null;
}

export interface WorkspaceBoardElements_elements_LinkContent_originalCreator {
  __typename: "User";
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
}

export interface WorkspaceBoardElements_elements_LinkContent {
  __typename: "LinkContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * When visibility is public and this flag is set to true require registration to view all content
   */
  need_registration: boolean | null;
  /**
   * Content creator
   */
  creator: WorkspaceBoardElements_elements_LinkContent_creator;
  /**
   * Where the element is contained
   */
  parent_folder_id: string | null;
  /**
   * Id of the saved collection copy (in the user's workspace) this content was copied as part of; null if the content is not a copy or was saved individually
   */
  parentSavedCollectionId: string | null;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: WorkspaceBoardElements_elements_LinkContent_coverDimensions | null;
  /**
   * Creator of the original content this is a copy of (null if this is not a copy)
   */
  originalCreator: WorkspaceBoardElements_elements_LinkContent_originalCreator | null;
  displayStatus: ContentDisplayStatus;
  /**
   * Destination domain
   */
  domain: string | null;
  /**
   * Total duration in seconds, alias of embed.estimatedReadingTime
   */
  duration: number | null;
  label: string | null;
  tags: string[];
  /**
   * Destination link
   */
  url: any | null;
}

export interface WorkspaceBoardElements_elements_PdfContent_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface WorkspaceBoardElements_elements_PdfContent_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
}

export interface WorkspaceBoardElements_elements_PdfContent_creator {
  __typename: "User";
  id: string;
  /**
   * Main email address
   */
  email: any;
  /**
   * Self description of the user
   */
  bio: string | null;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: WorkspaceBoardElements_elements_PdfContent_creator_subscriptionPlan;
  workspace: WorkspaceBoardElements_elements_PdfContent_creator_workspace | null;
}

export interface WorkspaceBoardElements_elements_PdfContent_coverDimensions {
  __typename: "CoverDimensions";
  height: number | null;
  width: number | null;
}

export interface WorkspaceBoardElements_elements_PdfContent_originalCreator {
  __typename: "User";
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
}

export interface WorkspaceBoardElements_elements_PdfContent_pdfDetails {
  __typename: "PdfDetails";
  pages: number;
}

export interface WorkspaceBoardElements_elements_PdfContent {
  __typename: "PdfContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * When visibility is public and this flag is set to true require registration to view all content
   */
  need_registration: boolean | null;
  /**
   * Content creator
   */
  creator: WorkspaceBoardElements_elements_PdfContent_creator;
  /**
   * Where the element is contained
   */
  parent_folder_id: string | null;
  /**
   * Id of the saved collection copy (in the user's workspace) this content was copied as part of; null if the content is not a copy or was saved individually
   */
  parentSavedCollectionId: string | null;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: WorkspaceBoardElements_elements_PdfContent_coverDimensions | null;
  /**
   * Creator of the original content this is a copy of (null if this is not a copy)
   */
  originalCreator: WorkspaceBoardElements_elements_PdfContent_originalCreator | null;
  displayStatus: ContentDisplayStatus;
  /**
   * Total duration in seconds, alias of pdfDetails.estimatedReadingTime
   */
  duration: number | null;
  label: string | null;
  /**
   * PDF document additional details
   */
  pdfDetails: WorkspaceBoardElements_elements_PdfContent_pdfDetails | null;
  tags: string[];
  /**
   * Destination link
   */
  url: any | null;
  /**
   * Activate PDF download
   */
  canDownload: boolean | null;
}

export interface WorkspaceBoardElements_elements_QuizContent_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface WorkspaceBoardElements_elements_QuizContent_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
}

export interface WorkspaceBoardElements_elements_QuizContent_creator {
  __typename: "User";
  id: string;
  /**
   * Main email address
   */
  email: any;
  /**
   * Self description of the user
   */
  bio: string | null;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: WorkspaceBoardElements_elements_QuizContent_creator_subscriptionPlan;
  workspace: WorkspaceBoardElements_elements_QuizContent_creator_workspace | null;
}

export interface WorkspaceBoardElements_elements_QuizContent_coverDimensions {
  __typename: "CoverDimensions";
  height: number | null;
  width: number | null;
}

export interface WorkspaceBoardElements_elements_QuizContent_originalCreator {
  __typename: "User";
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
}

export interface WorkspaceBoardElements_elements_QuizContent_questions_QuizContentQuestionEssay {
  __typename: "QuizContentQuestionEssay" | "QuizContentQuestionMatching" | "QuizContentQuestionMissingWord" | "QuizContentQuestionNumerical";
}

export interface WorkspaceBoardElements_elements_QuizContent_questions_QuizContentQuestionSingleChoice_choices {
  __typename: "QuizContentQuestionTextChoice";
  isCorrect: boolean;
  text: string;
}

export interface WorkspaceBoardElements_elements_QuizContent_questions_QuizContentQuestionSingleChoice {
  __typename: "QuizContentQuestionSingleChoice";
  choices: WorkspaceBoardElements_elements_QuizContent_questions_QuizContentQuestionSingleChoice_choices[];
  title: string | null;
}

export interface WorkspaceBoardElements_elements_QuizContent_questions_QuizContentQuestionMultipleChoice_choices {
  __typename: "QuizContentQuestionTextChoice";
  isCorrect: boolean;
  text: string;
}

export interface WorkspaceBoardElements_elements_QuizContent_questions_QuizContentQuestionMultipleChoice {
  __typename: "QuizContentQuestionMultipleChoice";
  choices: WorkspaceBoardElements_elements_QuizContent_questions_QuizContentQuestionMultipleChoice_choices[];
  title: string | null;
}

export interface WorkspaceBoardElements_elements_QuizContent_questions_QuizContentQuestionTrueFalse {
  __typename: "QuizContentQuestionTrueFalse";
  isTrue: boolean;
  title: string | null;
}

export type WorkspaceBoardElements_elements_QuizContent_questions = WorkspaceBoardElements_elements_QuizContent_questions_QuizContentQuestionEssay | WorkspaceBoardElements_elements_QuizContent_questions_QuizContentQuestionSingleChoice | WorkspaceBoardElements_elements_QuizContent_questions_QuizContentQuestionMultipleChoice | WorkspaceBoardElements_elements_QuizContent_questions_QuizContentQuestionTrueFalse;

export interface WorkspaceBoardElements_elements_QuizContent {
  __typename: "QuizContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * When visibility is public and this flag is set to true require registration to view all content
   */
  need_registration: boolean | null;
  /**
   * Content creator
   */
  creator: WorkspaceBoardElements_elements_QuizContent_creator;
  /**
   * Where the element is contained
   */
  parent_folder_id: string | null;
  /**
   * Id of the saved collection copy (in the user's workspace) this content was copied as part of; null if the content is not a copy or was saved individually
   */
  parentSavedCollectionId: string | null;
  /**
   * Content subtype
   */
  quizSubtypeForMenu: QuizContentSubtype | null;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: WorkspaceBoardElements_elements_QuizContent_coverDimensions | null;
  /**
   * Creator of the original content this is a copy of (null if this is not a copy)
   */
  originalCreator: WorkspaceBoardElements_elements_QuizContent_originalCreator | null;
  displayStatus: ContentDisplayStatus;
  label: string | null;
  basket: number | null;
  questions: WorkspaceBoardElements_elements_QuizContent_questions[];
  /**
   * Content subtype
   */
  quizSubtype: QuizContentSubtype | null;
  tags: string[];
}

export interface WorkspaceBoardElements_elements_ScormContent_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface WorkspaceBoardElements_elements_ScormContent_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
}

export interface WorkspaceBoardElements_elements_ScormContent_creator {
  __typename: "User";
  id: string;
  /**
   * Main email address
   */
  email: any;
  /**
   * Self description of the user
   */
  bio: string | null;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: WorkspaceBoardElements_elements_ScormContent_creator_subscriptionPlan;
  workspace: WorkspaceBoardElements_elements_ScormContent_creator_workspace | null;
}

export interface WorkspaceBoardElements_elements_ScormContent_coverDimensions {
  __typename: "CoverDimensions";
  height: number | null;
  width: number | null;
}

export interface WorkspaceBoardElements_elements_ScormContent_originalCreator {
  __typename: "User";
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
}

export interface WorkspaceBoardElements_elements_ScormContent {
  __typename: "ScormContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * When visibility is public and this flag is set to true require registration to view all content
   */
  need_registration: boolean | null;
  /**
   * Content creator
   */
  creator: WorkspaceBoardElements_elements_ScormContent_creator;
  /**
   * Where the element is contained
   */
  parent_folder_id: string | null;
  /**
   * Id of the saved collection copy (in the user's workspace) this content was copied as part of; null if the content is not a copy or was saved individually
   */
  parentSavedCollectionId: string | null;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: WorkspaceBoardElements_elements_ScormContent_coverDimensions | null;
  /**
   * Creator of the original content this is a copy of (null if this is not a copy)
   */
  originalCreator: WorkspaceBoardElements_elements_ScormContent_originalCreator | null;
  displayStatus: ContentDisplayStatus;
  /**
   * Expected time to complete the package, in seconds: the LOM typicalLearningTime the package declares, read on import, or what the author set by hand; null when unknown. Unrelated to timeLimit
   */
  duration: number | null;
  label: string | null;
  tags: string[];
}

export interface WorkspaceBoardElements_elements_TextContent_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface WorkspaceBoardElements_elements_TextContent_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
}

export interface WorkspaceBoardElements_elements_TextContent_creator {
  __typename: "User";
  id: string;
  /**
   * Main email address
   */
  email: any;
  /**
   * Self description of the user
   */
  bio: string | null;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: WorkspaceBoardElements_elements_TextContent_creator_subscriptionPlan;
  workspace: WorkspaceBoardElements_elements_TextContent_creator_workspace | null;
}

export interface WorkspaceBoardElements_elements_TextContent_coverDimensions {
  __typename: "CoverDimensions";
  height: number | null;
  width: number | null;
}

export interface WorkspaceBoardElements_elements_TextContent_originalCreator {
  __typename: "User";
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
}

export interface WorkspaceBoardElements_elements_TextContent {
  __typename: "TextContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * When visibility is public and this flag is set to true require registration to view all content
   */
  need_registration: boolean | null;
  /**
   * Content creator
   */
  creator: WorkspaceBoardElements_elements_TextContent_creator;
  /**
   * Where the element is contained
   */
  parent_folder_id: string | null;
  /**
   * Id of the saved collection copy (in the user's workspace) this content was copied as part of; null if the content is not a copy or was saved individually
   */
  parentSavedCollectionId: string | null;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: WorkspaceBoardElements_elements_TextContent_coverDimensions | null;
  /**
   * Creator of the original content this is a copy of (null if this is not a copy)
   */
  originalCreator: WorkspaceBoardElements_elements_TextContent_originalCreator | null;
  displayStatus: ContentDisplayStatus;
  /**
   * Total duration in seconds, alias of pdfDetails.estimatedReadingTime
   */
  duration: number | null;
  label: string | null;
  tags: string[];
  /**
   * Destination link
   */
  url: any | null;
}

export interface WorkspaceBoardElements_elements_VideoContent_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface WorkspaceBoardElements_elements_VideoContent_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
}

export interface WorkspaceBoardElements_elements_VideoContent_creator {
  __typename: "User";
  id: string;
  /**
   * Main email address
   */
  email: any;
  /**
   * Self description of the user
   */
  bio: string | null;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: WorkspaceBoardElements_elements_VideoContent_creator_subscriptionPlan;
  workspace: WorkspaceBoardElements_elements_VideoContent_creator_workspace | null;
}

export interface WorkspaceBoardElements_elements_VideoContent_coverDimensions {
  __typename: "CoverDimensions";
  height: number | null;
  width: number | null;
}

export interface WorkspaceBoardElements_elements_VideoContent_originalCreator {
  __typename: "User";
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
}

export interface WorkspaceBoardElements_elements_VideoContent {
  __typename: "VideoContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * When visibility is public and this flag is set to true require registration to view all content
   */
  need_registration: boolean | null;
  /**
   * Content creator
   */
  creator: WorkspaceBoardElements_elements_VideoContent_creator;
  /**
   * Where the element is contained
   */
  parent_folder_id: string | null;
  /**
   * Id of the saved collection copy (in the user's workspace) this content was copied as part of; null if the content is not a copy or was saved individually
   */
  parentSavedCollectionId: string | null;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: WorkspaceBoardElements_elements_VideoContent_coverDimensions | null;
  /**
   * Creator of the original content this is a copy of (null if this is not a copy)
   */
  originalCreator: WorkspaceBoardElements_elements_VideoContent_originalCreator | null;
  displayStatus: ContentDisplayStatus;
  /**
   * Total duration in seconds
   */
  duration: number | null;
  label: string | null;
  tags: string[];
  /**
   * Destination link
   */
  url: any | null;
  aspectRatio: string | null;
}

export interface WorkspaceBoardElements_elements_MixedCollection_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface WorkspaceBoardElements_elements_MixedCollection_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
}

export interface WorkspaceBoardElements_elements_MixedCollection_creator {
  __typename: "User";
  id: string;
  /**
   * Main email address
   */
  email: any;
  /**
   * Self description of the user
   */
  bio: string | null;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: WorkspaceBoardElements_elements_MixedCollection_creator_subscriptionPlan;
  workspace: WorkspaceBoardElements_elements_MixedCollection_creator_workspace | null;
}

export interface WorkspaceBoardElements_elements_MixedCollection_coverDimensions {
  __typename: "CoverDimensions";
  height: number | null;
  width: number | null;
}

export interface WorkspaceBoardElements_elements_MixedCollection_originalCreator {
  __typename: "User";
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
}

export interface WorkspaceBoardElements_elements_MixedCollection {
  __typename: "MixedCollection" | "BlendedCollection" | "VideoCollection";
  /**
   * Defines if current user has a specific permission on the collection
   */
  canManage: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  selling: boolean;
  sellingPricing: number | null;
  sellingMethod: string | null;
  /**
   * When visibility is public and this flag is set to true require registration to view all content
   */
  need_registration: boolean | null;
  /**
   * Total duration of all the audio and video contents included
   */
  duration: number | null;
  /**
   * Get total contents for required type
   */
  totalAudio: number;
  /**
   * Get total contents for required type
   */
  totalImage: number;
  /**
   * Get total contents for required type
   */
  totalLink: number;
  /**
   * Get total contents for required type
   */
  totalPdf: number;
  /**
   * Get total contents for required type
   */
  totalQuiz: number;
  /**
   * Get total contents for required type
   */
  totalScorm: number;
  /**
   * Get total contents for required type
   */
  totalText: number;
  /**
   * Get total contents for required type
   */
  totalVideo: number;
  /**
   * Collection creator
   */
  creator: WorkspaceBoardElements_elements_MixedCollection_creator;
  sellingCurrency: string | null;
  /**
   * Defines if current user has a specific permission on the collection
   */
  canRead: boolean;
  collectionDisplayStatus: CollectionDisplayStatus;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: WorkspaceBoardElements_elements_MixedCollection_coverDimensions | null;
  /**
   * Creator of the original collection this is a copy of (null if this is not a copy)
   */
  originalCreator: WorkspaceBoardElements_elements_MixedCollection_originalCreator | null;
  label: string | null;
  tags: string[];
  parent_folder_id: string | null;
  certificate_id: string | null;
}

export type WorkspaceBoardElements_elements = WorkspaceBoardElements_elements_Folder | WorkspaceBoardElements_elements_AudioContent | WorkspaceBoardElements_elements_EventContent | WorkspaceBoardElements_elements_ImageContent | WorkspaceBoardElements_elements_LinkContent | WorkspaceBoardElements_elements_PdfContent | WorkspaceBoardElements_elements_QuizContent | WorkspaceBoardElements_elements_ScormContent | WorkspaceBoardElements_elements_TextContent | WorkspaceBoardElements_elements_VideoContent | WorkspaceBoardElements_elements_MixedCollection;

export interface WorkspaceBoardElements {
  /**
   * All homepage elements, including:
   * * created contents
   * * visited contents
   * * created collections
   * * visited collections
   * 
   * If createdByMe or community are defined, elements will be filtered.
   */
  elements: WorkspaceBoardElements_elements[];
  /**
   * Total homepage elements, including:
   * * created contents
   * * visited contents
   * * created collections
   * * visited collections
   * 
   * If createdByMe is defined, elements will be filtered.
   */
  totalElements: number;
}

export interface WorkspaceBoardElementsVariables {
  createdByMe?: boolean | null;
  limit?: number | null;
  offset?: number | null;
  workspaceUserId?: string | null;
  filterByElementType?: (ElementTypeFilter | null)[] | null;
  userId?: string | null;
  search?: string | null;
  sort?: ElementSort | null;
  tags?: string[] | null;
  contentTypes?: ElementContentType[] | null;
  createdBy?: string[] | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: CardCollection
// ====================================================

export interface CardCollection_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface CardCollection_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
}

export interface CardCollection_creator {
  __typename: "User";
  id: string;
  /**
   * Main email address
   */
  email: any;
  /**
   * Self description of the user
   */
  bio: string | null;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: CardCollection_creator_subscriptionPlan;
  workspace: CardCollection_creator_workspace | null;
}

export interface CardCollection_coverDimensions {
  __typename: "CoverDimensions";
  height: number | null;
  width: number | null;
}

export interface CardCollection_originalCreator {
  __typename: "User";
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
}

export interface CardCollection {
  __typename: "BlendedCollection" | "MixedCollection" | "VideoCollection";
  /**
   * Defines if current user has a specific permission on the collection
   */
  canManage: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  selling: boolean;
  sellingPricing: number | null;
  sellingMethod: string | null;
  /**
   * When visibility is public and this flag is set to true require registration to view all content
   */
  need_registration: boolean | null;
  /**
   * Total duration of all the audio and video contents included
   */
  duration: number | null;
  /**
   * Get total contents for required type
   */
  totalAudio: number;
  /**
   * Get total contents for required type
   */
  totalImage: number;
  /**
   * Get total contents for required type
   */
  totalLink: number;
  /**
   * Get total contents for required type
   */
  totalPdf: number;
  /**
   * Get total contents for required type
   */
  totalQuiz: number;
  /**
   * Get total contents for required type
   */
  totalScorm: number;
  /**
   * Get total contents for required type
   */
  totalText: number;
  /**
   * Get total contents for required type
   */
  totalVideo: number;
  /**
   * Collection creator
   */
  creator: CardCollection_creator;
  sellingCurrency: string | null;
  /**
   * Defines if current user has a specific permission on the collection
   */
  canRead: boolean;
  collectionDisplayStatus: CollectionDisplayStatus;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: CardCollection_coverDimensions | null;
  /**
   * Creator of the original collection this is a copy of (null if this is not a copy)
   */
  originalCreator: CardCollection_originalCreator | null;
  label: string | null;
  tags: string[];
  parent_folder_id: string | null;
  certificate_id: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: CardCollectionShareWrapperData
// ====================================================

export interface CardCollectionShareWrapperData {
  __typename: "BlendedCollection" | "MixedCollection" | "VideoCollection";
  /**
   * Defines if current user has a specific permission on the collection
   */
  canManage: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  selling: boolean;
  sellingPricing: number | null;
  sellingMethod: string | null;
  /**
   * When visibility is public and this flag is set to true require registration to view all content
   */
  need_registration: boolean | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: CardContent
// ====================================================

export interface CardContent_EventContent_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface CardContent_EventContent_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
}

export interface CardContent_EventContent_creator {
  __typename: "User";
  id: string;
  /**
   * Main email address
   */
  email: any;
  /**
   * Self description of the user
   */
  bio: string | null;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: CardContent_EventContent_creator_subscriptionPlan;
  workspace: CardContent_EventContent_creator_workspace | null;
}

export interface CardContent_EventContent_registeredUsers {
  __typename: "User";
  id: string;
}

export interface CardContent_EventContent_coverDimensions {
  __typename: "CoverDimensions";
  height: number | null;
  width: number | null;
}

export interface CardContent_EventContent_originalCreator {
  __typename: "User";
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
}

export interface CardContent_EventContent {
  __typename: "EventContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * When visibility is public and this flag is set to true require registration to view all content
   */
  need_registration: boolean | null;
  /**
   * Content creator
   */
  creator: CardContent_EventContent_creator;
  eventStatusForMenu: EventContentStatus;
  /**
   * Where the element is contained
   */
  parent_folder_id: string | null;
  /**
   * Id of the saved collection copy (in the user's workspace) this content was copied as part of; null if the content is not a copy or was saved individually
   */
  parentSavedCollectionId: string | null;
  expired: any | null;
  isCurrentUserRegistered: boolean;
  participants: number | null;
  registeredUsers: CardContent_EventContent_registeredUsers[];
  registration: boolean;
  status: EventContentStatus;
  /**
   * Content subtype
   */
  subtype: EventContentSubtype;
  /**
   * Destination link
   */
  url: any | null;
  end: any | null;
  start: any | null;
  location: string | null;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: CardContent_EventContent_coverDimensions | null;
  /**
   * Creator of the original content this is a copy of (null if this is not a copy)
   */
  originalCreator: CardContent_EventContent_originalCreator | null;
  hasUserCompleted: boolean | null;
  displayStatus: ContentDisplayStatus;
  label: string | null;
  tags: string[];
  certificate_id: string | null;
}

export interface CardContent_QuizContent_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface CardContent_QuizContent_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
}

export interface CardContent_QuizContent_creator {
  __typename: "User";
  id: string;
  /**
   * Main email address
   */
  email: any;
  /**
   * Self description of the user
   */
  bio: string | null;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: CardContent_QuizContent_creator_subscriptionPlan;
  workspace: CardContent_QuizContent_creator_workspace | null;
}

export interface CardContent_QuizContent_coverDimensions {
  __typename: "CoverDimensions";
  height: number | null;
  width: number | null;
}

export interface CardContent_QuizContent_originalCreator {
  __typename: "User";
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
}

export interface CardContent_QuizContent_questions_QuizContentQuestionEssay {
  __typename: "QuizContentQuestionEssay" | "QuizContentQuestionMatching" | "QuizContentQuestionMissingWord" | "QuizContentQuestionNumerical";
}

export interface CardContent_QuizContent_questions_QuizContentQuestionSingleChoice_choices {
  __typename: "QuizContentQuestionTextChoice";
  isCorrect: boolean;
  text: string;
}

export interface CardContent_QuizContent_questions_QuizContentQuestionSingleChoice {
  __typename: "QuizContentQuestionSingleChoice";
  choices: CardContent_QuizContent_questions_QuizContentQuestionSingleChoice_choices[];
  title: string | null;
}

export interface CardContent_QuizContent_questions_QuizContentQuestionMultipleChoice_choices {
  __typename: "QuizContentQuestionTextChoice";
  isCorrect: boolean;
  text: string;
}

export interface CardContent_QuizContent_questions_QuizContentQuestionMultipleChoice {
  __typename: "QuizContentQuestionMultipleChoice";
  choices: CardContent_QuizContent_questions_QuizContentQuestionMultipleChoice_choices[];
  title: string | null;
}

export interface CardContent_QuizContent_questions_QuizContentQuestionTrueFalse {
  __typename: "QuizContentQuestionTrueFalse";
  isTrue: boolean;
  title: string | null;
}

export type CardContent_QuizContent_questions = CardContent_QuizContent_questions_QuizContentQuestionEssay | CardContent_QuizContent_questions_QuizContentQuestionSingleChoice | CardContent_QuizContent_questions_QuizContentQuestionMultipleChoice | CardContent_QuizContent_questions_QuizContentQuestionTrueFalse;

export interface CardContent_QuizContent {
  __typename: "QuizContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * When visibility is public and this flag is set to true require registration to view all content
   */
  need_registration: boolean | null;
  /**
   * Content creator
   */
  creator: CardContent_QuizContent_creator;
  /**
   * Content subtype
   */
  quizSubtypeForMenu: QuizContentSubtype | null;
  /**
   * Where the element is contained
   */
  parent_folder_id: string | null;
  /**
   * Id of the saved collection copy (in the user's workspace) this content was copied as part of; null if the content is not a copy or was saved individually
   */
  parentSavedCollectionId: string | null;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: CardContent_QuizContent_coverDimensions | null;
  /**
   * Creator of the original content this is a copy of (null if this is not a copy)
   */
  originalCreator: CardContent_QuizContent_originalCreator | null;
  displayStatus: ContentDisplayStatus;
  label: string | null;
  basket: number | null;
  questions: CardContent_QuizContent_questions[];
  /**
   * Content subtype
   */
  quizSubtype: QuizContentSubtype | null;
  tags: string[];
}

export interface CardContent_AudioContent_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface CardContent_AudioContent_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
}

export interface CardContent_AudioContent_creator {
  __typename: "User";
  id: string;
  /**
   * Main email address
   */
  email: any;
  /**
   * Self description of the user
   */
  bio: string | null;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: CardContent_AudioContent_creator_subscriptionPlan;
  workspace: CardContent_AudioContent_creator_workspace | null;
}

export interface CardContent_AudioContent_originalCreator {
  __typename: "User";
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
}

export interface CardContent_AudioContent {
  __typename: "AudioContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * When visibility is public and this flag is set to true require registration to view all content
   */
  need_registration: boolean | null;
  /**
   * Content creator
   */
  creator: CardContent_AudioContent_creator;
  /**
   * Where the element is contained
   */
  parent_folder_id: string | null;
  /**
   * Id of the saved collection copy (in the user's workspace) this content was copied as part of; null if the content is not a copy or was saved individually
   */
  parentSavedCollectionId: string | null;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Creator of the original content this is a copy of (null if this is not a copy)
   */
  originalCreator: CardContent_AudioContent_originalCreator | null;
  displayStatus: ContentDisplayStatus;
  /**
   * Total duration in seconds
   */
  duration: number | null;
  label: string | null;
  tags: string[];
  /**
   * Destination link
   */
  url: any | null;
}

export interface CardContent_ImageContent_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface CardContent_ImageContent_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
}

export interface CardContent_ImageContent_creator {
  __typename: "User";
  id: string;
  /**
   * Main email address
   */
  email: any;
  /**
   * Self description of the user
   */
  bio: string | null;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: CardContent_ImageContent_creator_subscriptionPlan;
  workspace: CardContent_ImageContent_creator_workspace | null;
}

export interface CardContent_ImageContent_coverDimensions {
  __typename: "CoverDimensions";
  height: number | null;
  width: number | null;
}

export interface CardContent_ImageContent_originalCreator {
  __typename: "User";
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
}

export interface CardContent_ImageContent {
  __typename: "ImageContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * When visibility is public and this flag is set to true require registration to view all content
   */
  need_registration: boolean | null;
  /**
   * Content creator
   */
  creator: CardContent_ImageContent_creator;
  /**
   * Where the element is contained
   */
  parent_folder_id: string | null;
  /**
   * Id of the saved collection copy (in the user's workspace) this content was copied as part of; null if the content is not a copy or was saved individually
   */
  parentSavedCollectionId: string | null;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: CardContent_ImageContent_coverDimensions | null;
  /**
   * Creator of the original content this is a copy of (null if this is not a copy)
   */
  originalCreator: CardContent_ImageContent_originalCreator | null;
  displayStatus: ContentDisplayStatus;
  /**
   * Content subtype
   */
  imageSubtype: string | null;
  label: string | null;
  tags: string[];
  /**
   * Destination link
   */
  url: any | null;
  /**
   * Effective images URL
   */
  urls: any[];
}

export interface CardContent_LinkContent_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface CardContent_LinkContent_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
}

export interface CardContent_LinkContent_creator {
  __typename: "User";
  id: string;
  /**
   * Main email address
   */
  email: any;
  /**
   * Self description of the user
   */
  bio: string | null;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: CardContent_LinkContent_creator_subscriptionPlan;
  workspace: CardContent_LinkContent_creator_workspace | null;
}

export interface CardContent_LinkContent_coverDimensions {
  __typename: "CoverDimensions";
  height: number | null;
  width: number | null;
}

export interface CardContent_LinkContent_originalCreator {
  __typename: "User";
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
}

export interface CardContent_LinkContent {
  __typename: "LinkContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * When visibility is public and this flag is set to true require registration to view all content
   */
  need_registration: boolean | null;
  /**
   * Content creator
   */
  creator: CardContent_LinkContent_creator;
  /**
   * Where the element is contained
   */
  parent_folder_id: string | null;
  /**
   * Id of the saved collection copy (in the user's workspace) this content was copied as part of; null if the content is not a copy or was saved individually
   */
  parentSavedCollectionId: string | null;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: CardContent_LinkContent_coverDimensions | null;
  /**
   * Creator of the original content this is a copy of (null if this is not a copy)
   */
  originalCreator: CardContent_LinkContent_originalCreator | null;
  displayStatus: ContentDisplayStatus;
  /**
   * Destination domain
   */
  domain: string | null;
  /**
   * Total duration in seconds, alias of embed.estimatedReadingTime
   */
  duration: number | null;
  label: string | null;
  tags: string[];
  /**
   * Destination link
   */
  url: any | null;
}

export interface CardContent_PdfContent_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface CardContent_PdfContent_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
}

export interface CardContent_PdfContent_creator {
  __typename: "User";
  id: string;
  /**
   * Main email address
   */
  email: any;
  /**
   * Self description of the user
   */
  bio: string | null;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: CardContent_PdfContent_creator_subscriptionPlan;
  workspace: CardContent_PdfContent_creator_workspace | null;
}

export interface CardContent_PdfContent_coverDimensions {
  __typename: "CoverDimensions";
  height: number | null;
  width: number | null;
}

export interface CardContent_PdfContent_originalCreator {
  __typename: "User";
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
}

export interface CardContent_PdfContent_pdfDetails {
  __typename: "PdfDetails";
  pages: number;
}

export interface CardContent_PdfContent {
  __typename: "PdfContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * When visibility is public and this flag is set to true require registration to view all content
   */
  need_registration: boolean | null;
  /**
   * Content creator
   */
  creator: CardContent_PdfContent_creator;
  /**
   * Where the element is contained
   */
  parent_folder_id: string | null;
  /**
   * Id of the saved collection copy (in the user's workspace) this content was copied as part of; null if the content is not a copy or was saved individually
   */
  parentSavedCollectionId: string | null;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: CardContent_PdfContent_coverDimensions | null;
  /**
   * Creator of the original content this is a copy of (null if this is not a copy)
   */
  originalCreator: CardContent_PdfContent_originalCreator | null;
  displayStatus: ContentDisplayStatus;
  /**
   * Total duration in seconds, alias of pdfDetails.estimatedReadingTime
   */
  duration: number | null;
  label: string | null;
  /**
   * PDF document additional details
   */
  pdfDetails: CardContent_PdfContent_pdfDetails | null;
  tags: string[];
  /**
   * Destination link
   */
  url: any | null;
  /**
   * Activate PDF download
   */
  canDownload: boolean | null;
}

export interface CardContent_ScormContent_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface CardContent_ScormContent_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
}

export interface CardContent_ScormContent_creator {
  __typename: "User";
  id: string;
  /**
   * Main email address
   */
  email: any;
  /**
   * Self description of the user
   */
  bio: string | null;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: CardContent_ScormContent_creator_subscriptionPlan;
  workspace: CardContent_ScormContent_creator_workspace | null;
}

export interface CardContent_ScormContent_coverDimensions {
  __typename: "CoverDimensions";
  height: number | null;
  width: number | null;
}

export interface CardContent_ScormContent_originalCreator {
  __typename: "User";
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
}

export interface CardContent_ScormContent {
  __typename: "ScormContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * When visibility is public and this flag is set to true require registration to view all content
   */
  need_registration: boolean | null;
  /**
   * Content creator
   */
  creator: CardContent_ScormContent_creator;
  /**
   * Where the element is contained
   */
  parent_folder_id: string | null;
  /**
   * Id of the saved collection copy (in the user's workspace) this content was copied as part of; null if the content is not a copy or was saved individually
   */
  parentSavedCollectionId: string | null;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: CardContent_ScormContent_coverDimensions | null;
  /**
   * Creator of the original content this is a copy of (null if this is not a copy)
   */
  originalCreator: CardContent_ScormContent_originalCreator | null;
  displayStatus: ContentDisplayStatus;
  /**
   * Expected time to complete the package, in seconds: the LOM typicalLearningTime the package declares, read on import, or what the author set by hand; null when unknown. Unrelated to timeLimit
   */
  duration: number | null;
  label: string | null;
  tags: string[];
}

export interface CardContent_TextContent_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface CardContent_TextContent_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
}

export interface CardContent_TextContent_creator {
  __typename: "User";
  id: string;
  /**
   * Main email address
   */
  email: any;
  /**
   * Self description of the user
   */
  bio: string | null;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: CardContent_TextContent_creator_subscriptionPlan;
  workspace: CardContent_TextContent_creator_workspace | null;
}

export interface CardContent_TextContent_coverDimensions {
  __typename: "CoverDimensions";
  height: number | null;
  width: number | null;
}

export interface CardContent_TextContent_originalCreator {
  __typename: "User";
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
}

export interface CardContent_TextContent {
  __typename: "TextContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * When visibility is public and this flag is set to true require registration to view all content
   */
  need_registration: boolean | null;
  /**
   * Content creator
   */
  creator: CardContent_TextContent_creator;
  /**
   * Where the element is contained
   */
  parent_folder_id: string | null;
  /**
   * Id of the saved collection copy (in the user's workspace) this content was copied as part of; null if the content is not a copy or was saved individually
   */
  parentSavedCollectionId: string | null;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: CardContent_TextContent_coverDimensions | null;
  /**
   * Creator of the original content this is a copy of (null if this is not a copy)
   */
  originalCreator: CardContent_TextContent_originalCreator | null;
  displayStatus: ContentDisplayStatus;
  /**
   * Total duration in seconds, alias of pdfDetails.estimatedReadingTime
   */
  duration: number | null;
  label: string | null;
  tags: string[];
  /**
   * Destination link
   */
  url: any | null;
}

export interface CardContent_VideoContent_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface CardContent_VideoContent_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
}

export interface CardContent_VideoContent_creator {
  __typename: "User";
  id: string;
  /**
   * Main email address
   */
  email: any;
  /**
   * Self description of the user
   */
  bio: string | null;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: CardContent_VideoContent_creator_subscriptionPlan;
  workspace: CardContent_VideoContent_creator_workspace | null;
}

export interface CardContent_VideoContent_coverDimensions {
  __typename: "CoverDimensions";
  height: number | null;
  width: number | null;
}

export interface CardContent_VideoContent_originalCreator {
  __typename: "User";
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
}

export interface CardContent_VideoContent {
  __typename: "VideoContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * When visibility is public and this flag is set to true require registration to view all content
   */
  need_registration: boolean | null;
  /**
   * Content creator
   */
  creator: CardContent_VideoContent_creator;
  /**
   * Where the element is contained
   */
  parent_folder_id: string | null;
  /**
   * Id of the saved collection copy (in the user's workspace) this content was copied as part of; null if the content is not a copy or was saved individually
   */
  parentSavedCollectionId: string | null;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: CardContent_VideoContent_coverDimensions | null;
  /**
   * Creator of the original content this is a copy of (null if this is not a copy)
   */
  originalCreator: CardContent_VideoContent_originalCreator | null;
  displayStatus: ContentDisplayStatus;
  /**
   * Total duration in seconds
   */
  duration: number | null;
  label: string | null;
  tags: string[];
  /**
   * Destination link
   */
  url: any | null;
  aspectRatio: string | null;
}

export type CardContent = CardContent_EventContent | CardContent_QuizContent | CardContent_AudioContent | CardContent_ImageContent | CardContent_LinkContent | CardContent_PdfContent | CardContent_ScormContent | CardContent_TextContent | CardContent_VideoContent;

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: CardContentShareWrapperData
// ====================================================

export interface CardContentShareWrapperData {
  __typename: "AudioContent" | "EventContent" | "ImageContent" | "LinkContent" | "PdfContent" | "QuizContent" | "ScormContent" | "TextContent" | "VideoContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * When visibility is public and this flag is set to true require registration to view all content
   */
  need_registration: boolean | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: CardContentAudio
// ====================================================

export interface CardContentAudio_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface CardContentAudio_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
}

export interface CardContentAudio_creator {
  __typename: "User";
  /**
   * Self description of the user
   */
  bio: string | null;
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: CardContentAudio_creator_subscriptionPlan;
  /**
   * Main email address
   */
  email: any;
  workspace: CardContentAudio_creator_workspace | null;
}

export interface CardContentAudio_originalCreator {
  __typename: "User";
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
}

export interface CardContentAudio {
  __typename: "AudioContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Content creator
   */
  creator: CardContentAudio_creator;
  /**
   * Creator of the original content this is a copy of (null if this is not a copy)
   */
  originalCreator: CardContentAudio_originalCreator | null;
  /**
   * Main description, if given
   */
  description: string | null;
  displayStatus: ContentDisplayStatus;
  /**
   * Total duration in seconds
   */
  duration: number | null;
  label: string | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  tags: string[];
  /**
   * Main title
   */
  title: string;
  /**
   * Destination link
   */
  url: any | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: CardContentEvent
// ====================================================

export interface CardContentEvent_registeredUsers {
  __typename: "User";
  id: string;
}

export interface CardContentEvent_coverDimensions {
  __typename: "CoverDimensions";
  height: number | null;
  width: number | null;
}

export interface CardContentEvent_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface CardContentEvent_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
}

export interface CardContentEvent_creator {
  __typename: "User";
  /**
   * Self description of the user
   */
  bio: string | null;
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: CardContentEvent_creator_subscriptionPlan;
  /**
   * Main email address
   */
  email: any;
  workspace: CardContentEvent_creator_workspace | null;
}

export interface CardContentEvent_originalCreator {
  __typename: "User";
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
}

export interface CardContentEvent {
  __typename: "EventContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  expired: any | null;
  isCurrentUserRegistered: boolean;
  participants: number | null;
  registeredUsers: CardContentEvent_registeredUsers[];
  registration: boolean;
  status: EventContentStatus;
  /**
   * Content subtype
   */
  subtype: EventContentSubtype;
  /**
   * Destination link
   */
  url: any | null;
  end: any | null;
  start: any | null;
  location: string | null;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: CardContentEvent_coverDimensions | null;
  /**
   * Content creator
   */
  creator: CardContentEvent_creator;
  /**
   * Creator of the original content this is a copy of (null if this is not a copy)
   */
  originalCreator: CardContentEvent_originalCreator | null;
  hasUserCompleted: boolean | null;
  /**
   * Main description, if given
   */
  description: string | null;
  displayStatus: ContentDisplayStatus;
  label: string | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  tags: string[];
  /**
   * Main title
   */
  title: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: CardContentImage
// ====================================================

export interface CardContentImage_coverDimensions {
  __typename: "CoverDimensions";
  height: number | null;
  width: number | null;
}

export interface CardContentImage_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface CardContentImage_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
}

export interface CardContentImage_creator {
  __typename: "User";
  /**
   * Self description of the user
   */
  bio: string | null;
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: CardContentImage_creator_subscriptionPlan;
  /**
   * Main email address
   */
  email: any;
  workspace: CardContentImage_creator_workspace | null;
}

export interface CardContentImage_originalCreator {
  __typename: "User";
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
}

export interface CardContentImage {
  __typename: "ImageContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: CardContentImage_coverDimensions | null;
  /**
   * Content creator
   */
  creator: CardContentImage_creator;
  /**
   * Creator of the original content this is a copy of (null if this is not a copy)
   */
  originalCreator: CardContentImage_originalCreator | null;
  displayStatus: ContentDisplayStatus;
  /**
   * Content subtype
   */
  imageSubtype: string | null;
  label: string | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  tags: string[];
  /**
   * Main title
   */
  title: string;
  /**
   * Destination link
   */
  url: any | null;
  /**
   * Effective images URL
   */
  urls: any[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: CardContentLink
// ====================================================

export interface CardContentLink_coverDimensions {
  __typename: "CoverDimensions";
  height: number | null;
  width: number | null;
}

export interface CardContentLink_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface CardContentLink_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
}

export interface CardContentLink_creator {
  __typename: "User";
  /**
   * Self description of the user
   */
  bio: string | null;
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: CardContentLink_creator_subscriptionPlan;
  /**
   * Main email address
   */
  email: any;
  workspace: CardContentLink_creator_workspace | null;
}

export interface CardContentLink_originalCreator {
  __typename: "User";
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
}

export interface CardContentLink {
  __typename: "LinkContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: CardContentLink_coverDimensions | null;
  /**
   * Content creator
   */
  creator: CardContentLink_creator;
  /**
   * Creator of the original content this is a copy of (null if this is not a copy)
   */
  originalCreator: CardContentLink_originalCreator | null;
  /**
   * Main description, if given
   */
  description: string | null;
  displayStatus: ContentDisplayStatus;
  /**
   * Destination domain
   */
  domain: string | null;
  /**
   * Total duration in seconds, alias of embed.estimatedReadingTime
   */
  duration: number | null;
  label: string | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  tags: string[];
  /**
   * Main title
   */
  title: string;
  /**
   * Destination link
   */
  url: any | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: CardContentPdf
// ====================================================

export interface CardContentPdf_coverDimensions {
  __typename: "CoverDimensions";
  height: number | null;
  width: number | null;
}

export interface CardContentPdf_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface CardContentPdf_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
}

export interface CardContentPdf_creator {
  __typename: "User";
  /**
   * Self description of the user
   */
  bio: string | null;
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: CardContentPdf_creator_subscriptionPlan;
  /**
   * Main email address
   */
  email: any;
  workspace: CardContentPdf_creator_workspace | null;
}

export interface CardContentPdf_originalCreator {
  __typename: "User";
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
}

export interface CardContentPdf_pdfDetails {
  __typename: "PdfDetails";
  pages: number;
}

export interface CardContentPdf {
  __typename: "PdfContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: CardContentPdf_coverDimensions | null;
  /**
   * Content creator
   */
  creator: CardContentPdf_creator;
  /**
   * Creator of the original content this is a copy of (null if this is not a copy)
   */
  originalCreator: CardContentPdf_originalCreator | null;
  displayStatus: ContentDisplayStatus;
  /**
   * Total duration in seconds, alias of pdfDetails.estimatedReadingTime
   */
  duration: number | null;
  label: string | null;
  /**
   * PDF document additional details
   */
  pdfDetails: CardContentPdf_pdfDetails | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  tags: string[];
  /**
   * Main title
   */
  title: string;
  /**
   * Destination link
   */
  url: any | null;
  /**
   * Activate PDF download
   */
  canDownload: boolean | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: CardContentQuiz
// ====================================================

export interface CardContentQuiz_coverDimensions {
  __typename: "CoverDimensions";
  height: number | null;
  width: number | null;
}

export interface CardContentQuiz_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface CardContentQuiz_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
}

export interface CardContentQuiz_creator {
  __typename: "User";
  /**
   * Self description of the user
   */
  bio: string | null;
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: CardContentQuiz_creator_subscriptionPlan;
  /**
   * Main email address
   */
  email: any;
  workspace: CardContentQuiz_creator_workspace | null;
}

export interface CardContentQuiz_originalCreator {
  __typename: "User";
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
}

export interface CardContentQuiz_questions_QuizContentQuestionEssay {
  __typename: "QuizContentQuestionEssay" | "QuizContentQuestionMatching" | "QuizContentQuestionMissingWord" | "QuizContentQuestionNumerical";
}

export interface CardContentQuiz_questions_QuizContentQuestionSingleChoice_choices {
  __typename: "QuizContentQuestionTextChoice";
  isCorrect: boolean;
  text: string;
}

export interface CardContentQuiz_questions_QuizContentQuestionSingleChoice {
  __typename: "QuizContentQuestionSingleChoice";
  choices: CardContentQuiz_questions_QuizContentQuestionSingleChoice_choices[];
  title: string | null;
}

export interface CardContentQuiz_questions_QuizContentQuestionMultipleChoice_choices {
  __typename: "QuizContentQuestionTextChoice";
  isCorrect: boolean;
  text: string;
}

export interface CardContentQuiz_questions_QuizContentQuestionMultipleChoice {
  __typename: "QuizContentQuestionMultipleChoice";
  choices: CardContentQuiz_questions_QuizContentQuestionMultipleChoice_choices[];
  title: string | null;
}

export interface CardContentQuiz_questions_QuizContentQuestionTrueFalse {
  __typename: "QuizContentQuestionTrueFalse";
  isTrue: boolean;
  title: string | null;
}

export type CardContentQuiz_questions = CardContentQuiz_questions_QuizContentQuestionEssay | CardContentQuiz_questions_QuizContentQuestionSingleChoice | CardContentQuiz_questions_QuizContentQuestionMultipleChoice | CardContentQuiz_questions_QuizContentQuestionTrueFalse;

export interface CardContentQuiz {
  __typename: "QuizContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: CardContentQuiz_coverDimensions | null;
  /**
   * Content creator
   */
  creator: CardContentQuiz_creator;
  /**
   * Creator of the original content this is a copy of (null if this is not a copy)
   */
  originalCreator: CardContentQuiz_originalCreator | null;
  /**
   * Main description, if given
   */
  description: string | null;
  displayStatus: ContentDisplayStatus;
  label: string | null;
  basket: number | null;
  questions: CardContentQuiz_questions[];
  /**
   * Content subtype
   */
  quizSubtype: QuizContentSubtype | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  tags: string[];
  /**
   * Main title
   */
  title: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: CardContentScorm
// ====================================================

export interface CardContentScorm_coverDimensions {
  __typename: "CoverDimensions";
  height: number | null;
  width: number | null;
}

export interface CardContentScorm_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface CardContentScorm_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
}

export interface CardContentScorm_creator {
  __typename: "User";
  /**
   * Self description of the user
   */
  bio: string | null;
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: CardContentScorm_creator_subscriptionPlan;
  /**
   * Main email address
   */
  email: any;
  workspace: CardContentScorm_creator_workspace | null;
}

export interface CardContentScorm_originalCreator {
  __typename: "User";
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
}

export interface CardContentScorm {
  __typename: "ScormContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: CardContentScorm_coverDimensions | null;
  /**
   * Content creator
   */
  creator: CardContentScorm_creator;
  /**
   * Creator of the original content this is a copy of (null if this is not a copy)
   */
  originalCreator: CardContentScorm_originalCreator | null;
  displayStatus: ContentDisplayStatus;
  /**
   * Expected time to complete the package, in seconds: the LOM typicalLearningTime the package declares, read on import, or what the author set by hand; null when unknown. Unrelated to timeLimit
   */
  duration: number | null;
  label: string | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  tags: string[];
  /**
   * Main title
   */
  title: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: CardContentText
// ====================================================

export interface CardContentText_coverDimensions {
  __typename: "CoverDimensions";
  height: number | null;
  width: number | null;
}

export interface CardContentText_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface CardContentText_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
}

export interface CardContentText_creator {
  __typename: "User";
  /**
   * Self description of the user
   */
  bio: string | null;
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: CardContentText_creator_subscriptionPlan;
  /**
   * Main email address
   */
  email: any;
  workspace: CardContentText_creator_workspace | null;
}

export interface CardContentText_originalCreator {
  __typename: "User";
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
}

export interface CardContentText {
  __typename: "TextContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: CardContentText_coverDimensions | null;
  /**
   * Content creator
   */
  creator: CardContentText_creator;
  /**
   * Creator of the original content this is a copy of (null if this is not a copy)
   */
  originalCreator: CardContentText_originalCreator | null;
  displayStatus: ContentDisplayStatus;
  /**
   * Total duration in seconds, alias of pdfDetails.estimatedReadingTime
   */
  duration: number | null;
  label: string | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  tags: string[];
  /**
   * Main title
   */
  title: string;
  /**
   * Destination link
   */
  url: any | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: CardContentVideo
// ====================================================

export interface CardContentVideo_coverDimensions {
  __typename: "CoverDimensions";
  height: number | null;
  width: number | null;
}

export interface CardContentVideo_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface CardContentVideo_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
}

export interface CardContentVideo_creator {
  __typename: "User";
  /**
   * Self description of the user
   */
  bio: string | null;
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: CardContentVideo_creator_subscriptionPlan;
  /**
   * Main email address
   */
  email: any;
  workspace: CardContentVideo_creator_workspace | null;
}

export interface CardContentVideo_originalCreator {
  __typename: "User";
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
}

export interface CardContentVideo {
  __typename: "VideoContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: CardContentVideo_coverDimensions | null;
  /**
   * Content creator
   */
  creator: CardContentVideo_creator;
  /**
   * Creator of the original content this is a copy of (null if this is not a copy)
   */
  originalCreator: CardContentVideo_originalCreator | null;
  /**
   * Main description, if given
   */
  description: string | null;
  displayStatus: ContentDisplayStatus;
  /**
   * Total duration in seconds
   */
  duration: number | null;
  label: string | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  tags: string[];
  /**
   * Main title
   */
  title: string;
  /**
   * Destination link
   */
  url: any | null;
  aspectRatio: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: CardFolder
// ====================================================

export interface CardFolder_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface CardFolder_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
}

export interface CardFolder_creator {
  __typename: "User";
  /**
   * Self description of the user
   */
  bio: string | null;
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: CardFolder_creator_subscriptionPlan;
  /**
   * Main email address
   */
  email: any;
  workspace: CardFolder_creator_workspace | null;
}

export interface CardFolder {
  __typename: "Folder";
  /**
   * Get total contents for required type
   */
  totalContents: number;
  /**
   * Get total contents for required type
   */
  totalCollections: number;
  /**
   * Get total contents for required type
   */
  totalFolders: number;
  canManage: boolean;
  canRead: boolean;
  /**
   * Folder creator
   */
  creator: CardFolder_creator;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  tags: string[];
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * Where the element is contained
   */
  parent_folder_id: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: CardFolderShareWrapperData
// ====================================================

export interface CardFolderShareWrapperData {
  __typename: "Folder";
  canManage: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: MenuItems
// ====================================================

export interface MenuItems_Folder {
  __typename: "Folder";
}

export interface MenuItems_MixedCollection_creator {
  __typename: "User";
  id: string;
  /**
   * Main email address
   */
  email: any;
}

export interface MenuItems_MixedCollection {
  __typename: "MixedCollection" | "BlendedCollection" | "VideoCollection";
  /**
   * Defines if current user has a specific permission on the collection
   */
  canManage: boolean;
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * Collection creator
   */
  creator: MenuItems_MixedCollection_creator;
  selling: boolean;
  sellingCurrency: string | null;
  sellingMethod: string | null;
  sellingPricing: number | null;
}

export interface MenuItems_AudioContent_creator {
  __typename: "User";
  id: string;
  /**
   * Main email address
   */
  email: any;
}

export interface MenuItems_AudioContent {
  __typename: "AudioContent" | "ImageContent" | "LinkContent" | "PdfContent" | "ScormContent" | "TextContent" | "VideoContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * Content creator
   */
  creator: MenuItems_AudioContent_creator;
}

export interface MenuItems_EventContent_creator {
  __typename: "User";
  id: string;
  /**
   * Main email address
   */
  email: any;
}

export interface MenuItems_EventContent {
  __typename: "EventContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * Content creator
   */
  creator: MenuItems_EventContent_creator;
  eventStatusForMenu: EventContentStatus;
}

export interface MenuItems_QuizContent_creator {
  __typename: "User";
  id: string;
  /**
   * Main email address
   */
  email: any;
}

export interface MenuItems_QuizContent {
  __typename: "QuizContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * Content creator
   */
  creator: MenuItems_QuizContent_creator;
  /**
   * Content subtype
   */
  quizSubtypeForMenu: QuizContentSubtype | null;
}

export type MenuItems = MenuItems_Folder | MenuItems_MixedCollection | MenuItems_AudioContent | MenuItems_EventContent | MenuItems_QuizContent;

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: CardNavBarActionBar
// ====================================================

export interface CardNavBarActionBar_Folder {
  __typename: "Folder";
}

export interface CardNavBarActionBar_MixedCollection {
  __typename: "MixedCollection" | "BlendedCollection" | "VideoCollection";
  /**
   * Defines if current user has a specific permission on the collection
   */
  canManage: boolean;
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
}

export interface CardNavBarActionBar_AudioContent {
  __typename: "AudioContent" | "EventContent" | "ImageContent" | "LinkContent" | "PdfContent" | "QuizContent" | "ScormContent" | "TextContent" | "VideoContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
}

export type CardNavBarActionBar = CardNavBarActionBar_Folder | CardNavBarActionBar_MixedCollection | CardNavBarActionBar_AudioContent;

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: CardNavBar
// ====================================================

export interface CardNavBar_MixedCollection {
  __typename: "MixedCollection" | "BlendedCollection" | "VideoCollection";
  /**
   * Defines if current user has a specific permission on the collection
   */
  canManage: boolean;
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
}

export interface CardNavBar_AudioContent {
  __typename: "AudioContent" | "EventContent" | "ImageContent" | "LinkContent" | "PdfContent" | "QuizContent" | "ScormContent" | "TextContent" | "VideoContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
}

export interface CardNavBar_Folder {
  __typename: "Folder";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
}

export type CardNavBar = CardNavBar_MixedCollection | CardNavBar_AudioContent | CardNavBar_Folder;

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: CardNavBarStatusBar
// ====================================================

export interface CardNavBarStatusBar_MixedCollection {
  __typename: "MixedCollection" | "BlendedCollection" | "VideoCollection";
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
}

export interface CardNavBarStatusBar_AudioContent {
  __typename: "AudioContent" | "EventContent" | "ImageContent" | "LinkContent" | "PdfContent" | "QuizContent" | "ScormContent" | "TextContent" | "VideoContent";
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
}

export interface CardNavBarStatusBar_Folder {
  __typename: "Folder";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
}

export type CardNavBarStatusBar = CardNavBarStatusBar_MixedCollection | CardNavBarStatusBar_AudioContent | CardNavBarStatusBar_Folder;

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AddUserSuggestion
// ====================================================

export interface AddUserSuggestion {
  __typename: "User";
  /**
   * Main email address
   */
  email: any;
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: FetchElementAuthorizationsAuthorization
// ====================================================

export interface FetchElementAuthorizationsAuthorization_user {
  __typename: "User";
  /**
   * Main email address
   */
  email: any;
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
}

export interface FetchElementAuthorizationsAuthorization_authorizationGroup_group {
  __typename: "Group";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Name
   */
  name: string;
  /**
   * Total users in the group
   */
  usersCount: number;
}

export interface FetchElementAuthorizationsAuthorization_authorizationGroup {
  __typename: "AuthorizationGroup";
  id: string;
  group: FetchElementAuthorizationsAuthorization_authorizationGroup_group;
}

export interface FetchElementAuthorizationsAuthorization {
  __typename: "Authorization";
  id: string;
  user: FetchElementAuthorizationsAuthorization_user;
  authorizationGroup: FetchElementAuthorizationsAuthorization_authorizationGroup | null;
  value: number;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: FetchElementAuthorizationsInvite
// ====================================================

export interface FetchElementAuthorizationsInvite {
  __typename: "Invite";
  authorization: number | null;
  id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: PaginatedAuthorizationsFields
// ====================================================

export interface PaginatedAuthorizationsFields_data_Authorization_user {
  __typename: "User";
  /**
   * Main email address
   */
  email: any;
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
}

export interface PaginatedAuthorizationsFields_data_Authorization_authorizationGroup_group {
  __typename: "Group";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Name
   */
  name: string;
  /**
   * Total users in the group
   */
  usersCount: number;
}

export interface PaginatedAuthorizationsFields_data_Authorization_authorizationGroup {
  __typename: "AuthorizationGroup";
  id: string;
  group: PaginatedAuthorizationsFields_data_Authorization_authorizationGroup_group;
}

export interface PaginatedAuthorizationsFields_data_Authorization {
  __typename: "Authorization";
  id: string;
  user: PaginatedAuthorizationsFields_data_Authorization_user;
  authorizationGroup: PaginatedAuthorizationsFields_data_Authorization_authorizationGroup | null;
  value: number;
}

export interface PaginatedAuthorizationsFields_data_Invite {
  __typename: "Invite";
  authorization: number | null;
  id: string;
}

export type PaginatedAuthorizationsFields_data = PaginatedAuthorizationsFields_data_Authorization | PaginatedAuthorizationsFields_data_Invite;

export interface PaginatedAuthorizationsFields_paginatorInfo {
  __typename: "PaginatorInfo";
  currentPage: number;
  lastPage: number;
  perPage: number;
  total: number;
  count: number;
  hasMorePages: boolean;
}

export interface PaginatedAuthorizationsFields {
  __typename: "PaginatedAuthorizationsAndInvites";
  data: PaginatedAuthorizationsFields_data[];
  paginatorInfo: PaginatedAuthorizationsFields_paginatorInfo;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: CoverDimensions
// ====================================================

export interface CoverDimensions {
  __typename: "CoverDimensions";
  height: number | null;
  width: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: EventCallToAction
// ====================================================

export interface EventCallToAction_registeredUsers {
  __typename: "User";
  id: string;
}

export interface EventCallToAction {
  __typename: "EventContent";
  expired: any | null;
  /**
   * Unique identifier
   */
  id: string;
  isCurrentUserRegistered: boolean;
  participants: number | null;
  registeredUsers: EventCallToAction_registeredUsers[];
  registration: boolean;
  status: EventContentStatus;
  /**
   * Content subtype
   */
  subtype: EventContentSubtype;
  /**
   * Destination link
   */
  url: any | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ItemAudio
// ====================================================

export interface ItemAudio {
  __typename: "AudioContent";
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Total duration in seconds
   */
  duration: number | null;
  label: string | null;
  /**
   * Main title
   */
  title: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: CollectionInfo
// ====================================================

export interface CollectionInfo {
  __typename: "BlendedCollection" | "MixedCollection" | "VideoCollection";
  /**
   * Total duration of all the audio and video contents included
   */
  duration: number | null;
  /**
   * Get total contents for required type
   */
  totalAudio: number;
  /**
   * Get total contents for required type
   */
  totalImage: number;
  /**
   * Get total contents for required type
   */
  totalLink: number;
  /**
   * Get total contents for required type
   */
  totalPdf: number;
  /**
   * Get total contents for required type
   */
  totalQuiz: number;
  /**
   * Get total contents for required type
   */
  totalScorm: number;
  /**
   * Get total contents for required type
   */
  totalText: number;
  /**
   * Get total contents for required type
   */
  totalVideo: number;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ItemDateRange
// ====================================================

export interface ItemDateRange {
  __typename: "EventContent";
  end: any | null;
  start: any | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ItemEvent
// ====================================================

export interface ItemEvent {
  __typename: "EventContent";
  /**
   * Main description, if given
   */
  description: string | null;
  label: string | null;
  /**
   * Main title
   */
  title: string;
  isCurrentUserRegistered: boolean;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ItemImage
// ====================================================

export interface ItemImage {
  __typename: "ImageContent";
  /**
   * Main description, if given
   */
  description: string | null;
  label: string | null;
  /**
   * Main title
   */
  title: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ItemLink
// ====================================================

export interface ItemLink {
  __typename: "LinkContent";
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Destination domain
   */
  domain: string | null;
  /**
   * Total duration in seconds, alias of embed.estimatedReadingTime
   */
  duration: number | null;
  label: string | null;
  /**
   * Main title
   */
  title: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ItemLocationOrUrl
// ====================================================

export interface ItemLocationOrUrl {
  __typename: "EventContent";
  location: string | null;
  /**
   * Destination link
   */
  url: any | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ItemPdf
// ====================================================

export interface ItemPdf_pdfDetails {
  __typename: "PdfDetails";
  pages: number;
}

export interface ItemPdf {
  __typename: "PdfContent";
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Total duration in seconds, alias of pdfDetails.estimatedReadingTime
   */
  duration: number | null;
  label: string | null;
  /**
   * PDF document additional details
   */
  pdfDetails: ItemPdf_pdfDetails | null;
  /**
   * Main title
   */
  title: string;
  /**
   * Activate PDF download
   */
  canDownload: boolean | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ItemQuiz
// ====================================================

export interface ItemQuiz_questions {
  __typename: "QuizContentQuestionEssay" | "QuizContentQuestionMatching" | "QuizContentQuestionMissingWord" | "QuizContentQuestionMultipleChoice" | "QuizContentQuestionNumerical" | "QuizContentQuestionSingleChoice" | "QuizContentQuestionTrueFalse";
}

export interface ItemQuiz {
  __typename: "QuizContent";
  /**
   * Main description, if given
   */
  description: string | null;
  label: string | null;
  questions: ItemQuiz_questions[];
  /**
   * Main title
   */
  title: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ItemScorm
// ====================================================

export interface ItemScorm {
  __typename: "ScormContent";
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Expected time to complete the package, in seconds: the LOM typicalLearningTime the package declares, read on import, or what the author set by hand; null when unknown. Unrelated to timeLimit
   */
  duration: number | null;
  label: string | null;
  /**
   * Main title
   */
  title: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ItemText
// ====================================================

export interface ItemText {
  __typename: "TextContent";
  /**
   * Total duration in seconds, alias of pdfDetails.estimatedReadingTime
   */
  duration: number | null;
  label: string | null;
  /**
   * Main title
   */
  title: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: UserProfile
// ====================================================

export interface UserProfile_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface UserProfile_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
}

export interface UserProfile {
  __typename: "User";
  /**
   * Self description of the user
   */
  bio: string | null;
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: UserProfile_subscriptionPlan;
  /**
   * Main email address
   */
  email: any;
  workspace: UserProfile_workspace | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ItemVideo
// ====================================================

export interface ItemVideo {
  __typename: "VideoContent";
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Total duration in seconds
   */
  duration: number | null;
  label: string | null;
  /**
   * Main title
   */
  title: string;
  /**
   * Destination link
   */
  url: any | null;
  /**
   * Cover picture
   */
  cover: any | null;
  aspectRatio: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AppQuizUsage
// ====================================================

export interface AppQuizUsage_mySessions {
  __typename: "QuizContentSession";
  id: string;
}

export interface AppQuizUsage_questions_QuizContentQuestionEssay {
  __typename: "QuizContentQuestionEssay";
  canBeSkipped: boolean | null;
  id: string;
  image: any | null;
  missingPoints: number | null;
  title: string | null;
  successFeedback: string | null;
  successPoints: number | null;
  timeLimit: number | null;
}

export interface AppQuizUsage_questions_QuizContentQuestionMatching_matchPairs {
  __typename: "QuizContentQuestionMatchingRow";
  subanswer: string;
  subquestion: string;
}

export interface AppQuizUsage_questions_QuizContentQuestionMatching {
  __typename: "QuizContentQuestionMatching";
  canBeSkipped: boolean | null;
  failureFeedback: string | null;
  failurePoints: number | null;
  id: string;
  image: any | null;
  matchPairs: AppQuizUsage_questions_QuizContentQuestionMatching_matchPairs[];
  missingPoints: number | null;
  successFeedback: string | null;
  successPoints: number | null;
  title: string | null;
  timeLimit: number | null;
}

export interface AppQuizUsage_questions_QuizContentQuestionMissingWord {
  __typename: "QuizContentQuestionMissingWord";
  canBeSkipped: boolean | null;
  failureFeedback: string | null;
  failurePoints: number | null;
  id: string;
  image: any | null;
  missingPoints: number | null;
  successFeedback: string | null;
  successPoints: number | null;
  title: string | null;
  timeLimit: number | null;
}

export interface AppQuizUsage_questions_QuizContentQuestionMultipleChoice_choices {
  __typename: "QuizContentQuestionTextChoice";
  isCorrect: boolean;
  text: string;
}

export interface AppQuizUsage_questions_QuizContentQuestionMultipleChoice {
  __typename: "QuizContentQuestionMultipleChoice";
  canBeSkipped: boolean | null;
  choices: AppQuizUsage_questions_QuizContentQuestionMultipleChoice_choices[];
  failureFeedback: string | null;
  failurePoints: number | null;
  id: string;
  image: any | null;
  missingPoints: number | null;
  successFeedback: string | null;
  successPoints: number | null;
  title: string | null;
  timeLimit: number | null;
}

export interface AppQuizUsage_questions_QuizContentQuestionNumerical {
  __typename: "QuizContentQuestionNumerical";
  canBeSkipped: boolean | null;
  failureFeedback: string | null;
  failurePoints: number | null;
  id: string;
  image: any | null;
  missingPoints: number | null;
  number: number;
  range: number | null;
  successFeedback: string | null;
  successPoints: number | null;
  title: string | null;
  timeLimit: number | null;
}

export interface AppQuizUsage_questions_QuizContentQuestionSingleChoice_choices {
  __typename: "QuizContentQuestionTextChoice";
  isCorrect: boolean;
  text: string;
}

export interface AppQuizUsage_questions_QuizContentQuestionSingleChoice {
  __typename: "QuizContentQuestionSingleChoice";
  canBeSkipped: boolean | null;
  choices: AppQuizUsage_questions_QuizContentQuestionSingleChoice_choices[];
  failureFeedback: string | null;
  failurePoints: number | null;
  id: string;
  image: any | null;
  missingPoints: number | null;
  successFeedback: string | null;
  successPoints: number | null;
  title: string | null;
  timeLimit: number | null;
}

export interface AppQuizUsage_questions_QuizContentQuestionTrueFalse {
  __typename: "QuizContentQuestionTrueFalse";
  canBeSkipped: boolean | null;
  failureFeedback: string | null;
  failurePoints: number | null;
  id: string;
  image: any | null;
  isTrue: boolean;
  missingPoints: number | null;
  successFeedback: string | null;
  successPoints: number | null;
  title: string | null;
  timeLimit: number | null;
}

export type AppQuizUsage_questions = AppQuizUsage_questions_QuizContentQuestionEssay | AppQuizUsage_questions_QuizContentQuestionMatching | AppQuizUsage_questions_QuizContentQuestionMissingWord | AppQuizUsage_questions_QuizContentQuestionMultipleChoice | AppQuizUsage_questions_QuizContentQuestionNumerical | AppQuizUsage_questions_QuizContentQuestionSingleChoice | AppQuizUsage_questions_QuizContentQuestionTrueFalse;

export interface AppQuizUsage_session_questions_QuizContentQuestionEssay {
  __typename: "QuizContentQuestionEssay";
  canBeSkipped: boolean | null;
  id: string;
  image: any | null;
  missingPoints: number | null;
  title: string | null;
  successFeedback: string | null;
  successPoints: number | null;
  timeLimit: number | null;
}

export interface AppQuizUsage_session_questions_QuizContentQuestionMatching_matchPairs {
  __typename: "QuizContentQuestionMatchingRow";
  subanswer: string;
  subquestion: string;
}

export interface AppQuizUsage_session_questions_QuizContentQuestionMatching {
  __typename: "QuizContentQuestionMatching";
  canBeSkipped: boolean | null;
  failureFeedback: string | null;
  failurePoints: number | null;
  id: string;
  image: any | null;
  matchPairs: AppQuizUsage_session_questions_QuizContentQuestionMatching_matchPairs[];
  missingPoints: number | null;
  successFeedback: string | null;
  successPoints: number | null;
  title: string | null;
  timeLimit: number | null;
}

export interface AppQuizUsage_session_questions_QuizContentQuestionMissingWord {
  __typename: "QuizContentQuestionMissingWord";
  canBeSkipped: boolean | null;
  failureFeedback: string | null;
  failurePoints: number | null;
  id: string;
  image: any | null;
  missingPoints: number | null;
  successFeedback: string | null;
  successPoints: number | null;
  title: string | null;
  timeLimit: number | null;
}

export interface AppQuizUsage_session_questions_QuizContentQuestionMultipleChoice_choices {
  __typename: "QuizContentQuestionTextChoice";
  isCorrect: boolean;
  text: string;
}

export interface AppQuizUsage_session_questions_QuizContentQuestionMultipleChoice {
  __typename: "QuizContentQuestionMultipleChoice";
  canBeSkipped: boolean | null;
  choices: AppQuizUsage_session_questions_QuizContentQuestionMultipleChoice_choices[];
  failureFeedback: string | null;
  failurePoints: number | null;
  id: string;
  image: any | null;
  missingPoints: number | null;
  successFeedback: string | null;
  successPoints: number | null;
  title: string | null;
  timeLimit: number | null;
}

export interface AppQuizUsage_session_questions_QuizContentQuestionNumerical {
  __typename: "QuizContentQuestionNumerical";
  canBeSkipped: boolean | null;
  failureFeedback: string | null;
  failurePoints: number | null;
  id: string;
  image: any | null;
  missingPoints: number | null;
  number: number;
  range: number | null;
  successFeedback: string | null;
  successPoints: number | null;
  title: string | null;
  timeLimit: number | null;
}

export interface AppQuizUsage_session_questions_QuizContentQuestionSingleChoice_choices {
  __typename: "QuizContentQuestionTextChoice";
  isCorrect: boolean;
  text: string;
}

export interface AppQuizUsage_session_questions_QuizContentQuestionSingleChoice {
  __typename: "QuizContentQuestionSingleChoice";
  canBeSkipped: boolean | null;
  choices: AppQuizUsage_session_questions_QuizContentQuestionSingleChoice_choices[];
  failureFeedback: string | null;
  failurePoints: number | null;
  id: string;
  image: any | null;
  missingPoints: number | null;
  successFeedback: string | null;
  successPoints: number | null;
  title: string | null;
  timeLimit: number | null;
}

export interface AppQuizUsage_session_questions_QuizContentQuestionTrueFalse {
  __typename: "QuizContentQuestionTrueFalse";
  canBeSkipped: boolean | null;
  failureFeedback: string | null;
  failurePoints: number | null;
  id: string;
  image: any | null;
  isTrue: boolean;
  missingPoints: number | null;
  successFeedback: string | null;
  successPoints: number | null;
  title: string | null;
  timeLimit: number | null;
}

export type AppQuizUsage_session_questions = AppQuizUsage_session_questions_QuizContentQuestionEssay | AppQuizUsage_session_questions_QuizContentQuestionMatching | AppQuizUsage_session_questions_QuizContentQuestionMissingWord | AppQuizUsage_session_questions_QuizContentQuestionMultipleChoice | AppQuizUsage_session_questions_QuizContentQuestionNumerical | AppQuizUsage_session_questions_QuizContentQuestionSingleChoice | AppQuizUsage_session_questions_QuizContentQuestionTrueFalse;

export interface AppQuizUsage_session {
  __typename: "QuizContentSession";
  answers: any;
  completed: boolean;
  id: string;
  points: any;
  questions: AppQuizUsage_session_questions[];
  success: boolean;
}

export interface AppQuizUsage_coverDimensions {
  __typename: "CoverDimensions";
  height: number | null;
  width: number | null;
}

export interface AppQuizUsage {
  __typename: "QuizContent";
  canRepeat: boolean;
  canRepeatMaximum: number | null;
  canRepeatOnlyFailure: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  label: string | null;
  mySessions: AppQuizUsage_mySessions[];
  questions: AppQuizUsage_questions[];
  quizFeedbackFailureImage: any | null;
  quizFeedbackFailureMessage: string | null;
  quizFeedbackSuccessImage: any | null;
  quizFeedbackSuccessMessage: string | null;
  separateEvaluation: boolean;
  session: AppQuizUsage_session | null;
  showSummary: boolean;
  successPoints: number | null;
  /**
   * Main title
   */
  title: string;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: AppQuizUsage_coverDimensions | null;
  instructions: string | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  tags: string[];
  timeLimit: number | null;
  questionsNavigation: boolean;
  showAnswer: boolean;
  showProgress: boolean;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AppQuizUsageCompletion
// ====================================================

export interface AppQuizUsageCompletion_mySessions {
  __typename: "QuizContentSession";
  id: string;
}

export interface AppQuizUsageCompletion_questions {
  __typename: "QuizContentQuestionEssay" | "QuizContentQuestionMatching" | "QuizContentQuestionMissingWord" | "QuizContentQuestionMultipleChoice" | "QuizContentQuestionNumerical" | "QuizContentQuestionSingleChoice" | "QuizContentQuestionTrueFalse";
}

export interface AppQuizUsageCompletion_session_questions_QuizContentQuestionEssay {
  __typename: "QuizContentQuestionEssay";
  canBeSkipped: boolean | null;
  id: string;
  image: any | null;
  missingPoints: number | null;
  title: string | null;
  successFeedback: string | null;
  successPoints: number | null;
  timeLimit: number | null;
}

export interface AppQuizUsageCompletion_session_questions_QuizContentQuestionMatching_matchPairs {
  __typename: "QuizContentQuestionMatchingRow";
  subanswer: string;
  subquestion: string;
}

export interface AppQuizUsageCompletion_session_questions_QuizContentQuestionMatching {
  __typename: "QuizContentQuestionMatching";
  canBeSkipped: boolean | null;
  failureFeedback: string | null;
  failurePoints: number | null;
  id: string;
  image: any | null;
  matchPairs: AppQuizUsageCompletion_session_questions_QuizContentQuestionMatching_matchPairs[];
  missingPoints: number | null;
  successFeedback: string | null;
  successPoints: number | null;
  title: string | null;
  timeLimit: number | null;
}

export interface AppQuizUsageCompletion_session_questions_QuizContentQuestionMissingWord {
  __typename: "QuizContentQuestionMissingWord";
  canBeSkipped: boolean | null;
  failureFeedback: string | null;
  failurePoints: number | null;
  id: string;
  image: any | null;
  missingPoints: number | null;
  successFeedback: string | null;
  successPoints: number | null;
  title: string | null;
  timeLimit: number | null;
}

export interface AppQuizUsageCompletion_session_questions_QuizContentQuestionMultipleChoice_choices {
  __typename: "QuizContentQuestionTextChoice";
  isCorrect: boolean;
  text: string;
}

export interface AppQuizUsageCompletion_session_questions_QuizContentQuestionMultipleChoice {
  __typename: "QuizContentQuestionMultipleChoice";
  canBeSkipped: boolean | null;
  choices: AppQuizUsageCompletion_session_questions_QuizContentQuestionMultipleChoice_choices[];
  failureFeedback: string | null;
  failurePoints: number | null;
  id: string;
  image: any | null;
  missingPoints: number | null;
  successFeedback: string | null;
  successPoints: number | null;
  title: string | null;
  timeLimit: number | null;
}

export interface AppQuizUsageCompletion_session_questions_QuizContentQuestionNumerical {
  __typename: "QuizContentQuestionNumerical";
  canBeSkipped: boolean | null;
  failureFeedback: string | null;
  failurePoints: number | null;
  id: string;
  image: any | null;
  missingPoints: number | null;
  number: number;
  range: number | null;
  successFeedback: string | null;
  successPoints: number | null;
  title: string | null;
  timeLimit: number | null;
}

export interface AppQuizUsageCompletion_session_questions_QuizContentQuestionSingleChoice_choices {
  __typename: "QuizContentQuestionTextChoice";
  isCorrect: boolean;
  text: string;
}

export interface AppQuizUsageCompletion_session_questions_QuizContentQuestionSingleChoice {
  __typename: "QuizContentQuestionSingleChoice";
  canBeSkipped: boolean | null;
  choices: AppQuizUsageCompletion_session_questions_QuizContentQuestionSingleChoice_choices[];
  failureFeedback: string | null;
  failurePoints: number | null;
  id: string;
  image: any | null;
  missingPoints: number | null;
  successFeedback: string | null;
  successPoints: number | null;
  title: string | null;
  timeLimit: number | null;
}

export interface AppQuizUsageCompletion_session_questions_QuizContentQuestionTrueFalse {
  __typename: "QuizContentQuestionTrueFalse";
  canBeSkipped: boolean | null;
  failureFeedback: string | null;
  failurePoints: number | null;
  id: string;
  image: any | null;
  isTrue: boolean;
  missingPoints: number | null;
  successFeedback: string | null;
  successPoints: number | null;
  title: string | null;
  timeLimit: number | null;
}

export type AppQuizUsageCompletion_session_questions = AppQuizUsageCompletion_session_questions_QuizContentQuestionEssay | AppQuizUsageCompletion_session_questions_QuizContentQuestionMatching | AppQuizUsageCompletion_session_questions_QuizContentQuestionMissingWord | AppQuizUsageCompletion_session_questions_QuizContentQuestionMultipleChoice | AppQuizUsageCompletion_session_questions_QuizContentQuestionNumerical | AppQuizUsageCompletion_session_questions_QuizContentQuestionSingleChoice | AppQuizUsageCompletion_session_questions_QuizContentQuestionTrueFalse;

export interface AppQuizUsageCompletion_session {
  __typename: "QuizContentSession";
  answers: any;
  completed: boolean;
  id: string;
  points: any;
  questions: AppQuizUsageCompletion_session_questions[];
  success: boolean;
}

export interface AppQuizUsageCompletion {
  __typename: "QuizContent";
  canRepeat: boolean;
  canRepeatMaximum: number | null;
  canRepeatOnlyFailure: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  label: string | null;
  mySessions: AppQuizUsageCompletion_mySessions[];
  questions: AppQuizUsageCompletion_questions[];
  quizFeedbackFailureImage: any | null;
  quizFeedbackFailureMessage: string | null;
  quizFeedbackSuccessImage: any | null;
  quizFeedbackSuccessMessage: string | null;
  separateEvaluation: boolean;
  session: AppQuizUsageCompletion_session | null;
  showSummary: boolean;
  successPoints: number | null;
  /**
   * Main title
   */
  title: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AppQuizUsageCover
// ====================================================

export interface AppQuizUsageCover_coverDimensions {
  __typename: "CoverDimensions";
  height: number | null;
  width: number | null;
}

export interface AppQuizUsageCover_questions {
  __typename: "QuizContentQuestionEssay" | "QuizContentQuestionMatching" | "QuizContentQuestionMissingWord" | "QuizContentQuestionMultipleChoice" | "QuizContentQuestionNumerical" | "QuizContentQuestionSingleChoice" | "QuizContentQuestionTrueFalse";
}

export interface AppQuizUsageCover {
  __typename: "QuizContent";
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: AppQuizUsageCover_coverDimensions | null;
  /**
   * Main description, if given
   */
  description: string | null;
  instructions: string | null;
  label: string | null;
  questions: AppQuizUsageCover_questions[];
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  tags: string[];
  timeLimit: number | null;
  /**
   * Main title
   */
  title: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AppQuizUsageQuestions
// ====================================================

export interface AppQuizUsageQuestions_questions_QuizContentQuestionEssay {
  __typename: "QuizContentQuestionEssay";
  canBeSkipped: boolean | null;
  id: string;
  image: any | null;
  missingPoints: number | null;
  title: string | null;
  successFeedback: string | null;
  successPoints: number | null;
  timeLimit: number | null;
}

export interface AppQuizUsageQuestions_questions_QuizContentQuestionMatching_matchPairs {
  __typename: "QuizContentQuestionMatchingRow";
  subanswer: string;
  subquestion: string;
}

export interface AppQuizUsageQuestions_questions_QuizContentQuestionMatching {
  __typename: "QuizContentQuestionMatching";
  canBeSkipped: boolean | null;
  failureFeedback: string | null;
  failurePoints: number | null;
  id: string;
  image: any | null;
  matchPairs: AppQuizUsageQuestions_questions_QuizContentQuestionMatching_matchPairs[];
  missingPoints: number | null;
  successFeedback: string | null;
  successPoints: number | null;
  title: string | null;
  timeLimit: number | null;
}

export interface AppQuizUsageQuestions_questions_QuizContentQuestionMissingWord {
  __typename: "QuizContentQuestionMissingWord";
  canBeSkipped: boolean | null;
  failureFeedback: string | null;
  failurePoints: number | null;
  id: string;
  image: any | null;
  missingPoints: number | null;
  successFeedback: string | null;
  successPoints: number | null;
  title: string | null;
  timeLimit: number | null;
}

export interface AppQuizUsageQuestions_questions_QuizContentQuestionMultipleChoice_choices {
  __typename: "QuizContentQuestionTextChoice";
  isCorrect: boolean;
  text: string;
}

export interface AppQuizUsageQuestions_questions_QuizContentQuestionMultipleChoice {
  __typename: "QuizContentQuestionMultipleChoice";
  canBeSkipped: boolean | null;
  choices: AppQuizUsageQuestions_questions_QuizContentQuestionMultipleChoice_choices[];
  failureFeedback: string | null;
  failurePoints: number | null;
  id: string;
  image: any | null;
  missingPoints: number | null;
  successFeedback: string | null;
  successPoints: number | null;
  title: string | null;
  timeLimit: number | null;
}

export interface AppQuizUsageQuestions_questions_QuizContentQuestionNumerical {
  __typename: "QuizContentQuestionNumerical";
  canBeSkipped: boolean | null;
  failureFeedback: string | null;
  failurePoints: number | null;
  id: string;
  image: any | null;
  missingPoints: number | null;
  number: number;
  range: number | null;
  successFeedback: string | null;
  successPoints: number | null;
  title: string | null;
  timeLimit: number | null;
}

export interface AppQuizUsageQuestions_questions_QuizContentQuestionSingleChoice_choices {
  __typename: "QuizContentQuestionTextChoice";
  isCorrect: boolean;
  text: string;
}

export interface AppQuizUsageQuestions_questions_QuizContentQuestionSingleChoice {
  __typename: "QuizContentQuestionSingleChoice";
  canBeSkipped: boolean | null;
  choices: AppQuizUsageQuestions_questions_QuizContentQuestionSingleChoice_choices[];
  failureFeedback: string | null;
  failurePoints: number | null;
  id: string;
  image: any | null;
  missingPoints: number | null;
  successFeedback: string | null;
  successPoints: number | null;
  title: string | null;
  timeLimit: number | null;
}

export interface AppQuizUsageQuestions_questions_QuizContentQuestionTrueFalse {
  __typename: "QuizContentQuestionTrueFalse";
  canBeSkipped: boolean | null;
  failureFeedback: string | null;
  failurePoints: number | null;
  id: string;
  image: any | null;
  isTrue: boolean;
  missingPoints: number | null;
  successFeedback: string | null;
  successPoints: number | null;
  title: string | null;
  timeLimit: number | null;
}

export type AppQuizUsageQuestions_questions = AppQuizUsageQuestions_questions_QuizContentQuestionEssay | AppQuizUsageQuestions_questions_QuizContentQuestionMatching | AppQuizUsageQuestions_questions_QuizContentQuestionMissingWord | AppQuizUsageQuestions_questions_QuizContentQuestionMultipleChoice | AppQuizUsageQuestions_questions_QuizContentQuestionNumerical | AppQuizUsageQuestions_questions_QuizContentQuestionSingleChoice | AppQuizUsageQuestions_questions_QuizContentQuestionTrueFalse;

export interface AppQuizUsageQuestions {
  __typename: "QuizContent";
  label: string | null;
  questions: AppQuizUsageQuestions_questions[];
  questionsNavigation: boolean;
  showAnswer: boolean;
  showProgress: boolean;
  timeLimit: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AppQuizUsageQuestion
// ====================================================

export interface AppQuizUsageQuestion_QuizContentQuestionEssay {
  __typename: "QuizContentQuestionEssay";
  canBeSkipped: boolean | null;
  id: string;
  image: any | null;
  missingPoints: number | null;
  title: string | null;
  successFeedback: string | null;
  successPoints: number | null;
  timeLimit: number | null;
}

export interface AppQuizUsageQuestion_QuizContentQuestionMatching_matchPairs {
  __typename: "QuizContentQuestionMatchingRow";
  subanswer: string;
  subquestion: string;
}

export interface AppQuizUsageQuestion_QuizContentQuestionMatching {
  __typename: "QuizContentQuestionMatching";
  canBeSkipped: boolean | null;
  failureFeedback: string | null;
  failurePoints: number | null;
  id: string;
  image: any | null;
  matchPairs: AppQuizUsageQuestion_QuizContentQuestionMatching_matchPairs[];
  missingPoints: number | null;
  successFeedback: string | null;
  successPoints: number | null;
  title: string | null;
  timeLimit: number | null;
}

export interface AppQuizUsageQuestion_QuizContentQuestionMissingWord {
  __typename: "QuizContentQuestionMissingWord";
  canBeSkipped: boolean | null;
  failureFeedback: string | null;
  failurePoints: number | null;
  id: string;
  image: any | null;
  missingPoints: number | null;
  successFeedback: string | null;
  successPoints: number | null;
  title: string | null;
  timeLimit: number | null;
}

export interface AppQuizUsageQuestion_QuizContentQuestionMultipleChoice_choices {
  __typename: "QuizContentQuestionTextChoice";
  isCorrect: boolean;
  text: string;
}

export interface AppQuizUsageQuestion_QuizContentQuestionMultipleChoice {
  __typename: "QuizContentQuestionMultipleChoice";
  canBeSkipped: boolean | null;
  choices: AppQuizUsageQuestion_QuizContentQuestionMultipleChoice_choices[];
  failureFeedback: string | null;
  failurePoints: number | null;
  id: string;
  image: any | null;
  missingPoints: number | null;
  successFeedback: string | null;
  successPoints: number | null;
  title: string | null;
  timeLimit: number | null;
}

export interface AppQuizUsageQuestion_QuizContentQuestionNumerical {
  __typename: "QuizContentQuestionNumerical";
  canBeSkipped: boolean | null;
  failureFeedback: string | null;
  failurePoints: number | null;
  id: string;
  image: any | null;
  missingPoints: number | null;
  number: number;
  range: number | null;
  successFeedback: string | null;
  successPoints: number | null;
  title: string | null;
  timeLimit: number | null;
}

export interface AppQuizUsageQuestion_QuizContentQuestionSingleChoice_choices {
  __typename: "QuizContentQuestionTextChoice";
  isCorrect: boolean;
  text: string;
}

export interface AppQuizUsageQuestion_QuizContentQuestionSingleChoice {
  __typename: "QuizContentQuestionSingleChoice";
  canBeSkipped: boolean | null;
  choices: AppQuizUsageQuestion_QuizContentQuestionSingleChoice_choices[];
  failureFeedback: string | null;
  failurePoints: number | null;
  id: string;
  image: any | null;
  missingPoints: number | null;
  successFeedback: string | null;
  successPoints: number | null;
  title: string | null;
  timeLimit: number | null;
}

export interface AppQuizUsageQuestion_QuizContentQuestionTrueFalse {
  __typename: "QuizContentQuestionTrueFalse";
  canBeSkipped: boolean | null;
  failureFeedback: string | null;
  failurePoints: number | null;
  id: string;
  image: any | null;
  isTrue: boolean;
  missingPoints: number | null;
  successFeedback: string | null;
  successPoints: number | null;
  title: string | null;
  timeLimit: number | null;
}

export type AppQuizUsageQuestion = AppQuizUsageQuestion_QuizContentQuestionEssay | AppQuizUsageQuestion_QuizContentQuestionMatching | AppQuizUsageQuestion_QuizContentQuestionMissingWord | AppQuizUsageQuestion_QuizContentQuestionMultipleChoice | AppQuizUsageQuestion_QuizContentQuestionNumerical | AppQuizUsageQuestion_QuizContentQuestionSingleChoice | AppQuizUsageQuestion_QuizContentQuestionTrueFalse;

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AppQuizUsageQuestionEssay
// ====================================================

export interface AppQuizUsageQuestionEssay {
  __typename: "QuizContentQuestionEssay";
  canBeSkipped: boolean | null;
  id: string;
  image: any | null;
  missingPoints: number | null;
  title: string | null;
  successFeedback: string | null;
  successPoints: number | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AppQuizUsageQuestionMatching
// ====================================================

export interface AppQuizUsageQuestionMatching_matchPairs {
  __typename: "QuizContentQuestionMatchingRow";
  subanswer: string;
  subquestion: string;
}

export interface AppQuizUsageQuestionMatching {
  __typename: "QuizContentQuestionMatching";
  canBeSkipped: boolean | null;
  failureFeedback: string | null;
  failurePoints: number | null;
  id: string;
  image: any | null;
  matchPairs: AppQuizUsageQuestionMatching_matchPairs[];
  missingPoints: number | null;
  successFeedback: string | null;
  successPoints: number | null;
  title: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AppQuizUsageQuestionMissingWord
// ====================================================

export interface AppQuizUsageQuestionMissingWord {
  __typename: "QuizContentQuestionMissingWord";
  canBeSkipped: boolean | null;
  failureFeedback: string | null;
  failurePoints: number | null;
  id: string;
  image: any | null;
  missingPoints: number | null;
  successFeedback: string | null;
  successPoints: number | null;
  title: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AppQuizUsageQuestionMultipleChoice
// ====================================================

export interface AppQuizUsageQuestionMultipleChoice_choices {
  __typename: "QuizContentQuestionTextChoice";
  isCorrect: boolean;
  text: string;
}

export interface AppQuizUsageQuestionMultipleChoice {
  __typename: "QuizContentQuestionMultipleChoice";
  canBeSkipped: boolean | null;
  choices: AppQuizUsageQuestionMultipleChoice_choices[];
  failureFeedback: string | null;
  failurePoints: number | null;
  id: string;
  image: any | null;
  missingPoints: number | null;
  successFeedback: string | null;
  successPoints: number | null;
  title: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AppQuizUsageQuestionNumerical
// ====================================================

export interface AppQuizUsageQuestionNumerical {
  __typename: "QuizContentQuestionNumerical";
  canBeSkipped: boolean | null;
  failureFeedback: string | null;
  failurePoints: number | null;
  id: string;
  image: any | null;
  missingPoints: number | null;
  number: number;
  range: number | null;
  successFeedback: string | null;
  successPoints: number | null;
  title: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AppQuizUsageQuestionSingleChoice
// ====================================================

export interface AppQuizUsageQuestionSingleChoice_choices {
  __typename: "QuizContentQuestionTextChoice";
  isCorrect: boolean;
  text: string;
}

export interface AppQuizUsageQuestionSingleChoice {
  __typename: "QuizContentQuestionSingleChoice";
  canBeSkipped: boolean | null;
  choices: AppQuizUsageQuestionSingleChoice_choices[];
  failureFeedback: string | null;
  failurePoints: number | null;
  id: string;
  image: any | null;
  missingPoints: number | null;
  successFeedback: string | null;
  successPoints: number | null;
  title: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: AppQuizUsageQuestionTrueFalse
// ====================================================

export interface AppQuizUsageQuestionTrueFalse {
  __typename: "QuizContentQuestionTrueFalse";
  canBeSkipped: boolean | null;
  failureFeedback: string | null;
  failurePoints: number | null;
  id: string;
  image: any | null;
  isTrue: boolean;
  missingPoints: number | null;
  successFeedback: string | null;
  successPoints: number | null;
  title: string | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: CardDetails
// ====================================================

export interface CardDetails_coverDimensions {
  __typename: "CoverDimensions";
  height: number | null;
  width: number | null;
}

export interface CardDetails_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface CardDetails_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
}

export interface CardDetails_creator {
  __typename: "User";
  /**
   * Self description of the user
   */
  bio: string | null;
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: CardDetails_creator_subscriptionPlan;
  /**
   * Main email address
   */
  email: any;
  workspace: CardDetails_creator_workspace | null;
}

export interface CardDetails {
  __typename: "BlendedCollection" | "MixedCollection" | "VideoCollection";
  /**
   * Total duration of all the audio and video contents included
   */
  duration: number | null;
  /**
   * Get total contents for required type
   */
  totalAudio: number;
  /**
   * Get total contents for required type
   */
  totalImage: number;
  /**
   * Get total contents for required type
   */
  totalLink: number;
  /**
   * Get total contents for required type
   */
  totalPdf: number;
  /**
   * Get total contents for required type
   */
  totalQuiz: number;
  /**
   * Get total contents for required type
   */
  totalScorm: number;
  /**
   * Get total contents for required type
   */
  totalText: number;
  /**
   * Get total contents for required type
   */
  totalVideo: number;
  /**
   * Defines if current user has a specific permission on the collection
   */
  canManage: boolean;
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: CardDetails_coverDimensions | null;
  /**
   * Collection creator
   */
  creator: CardDetails_creator;
  /**
   * Main description, if given
   */
  description: string | null;
  label: string | null;
  tags: string[];
  /**
   * Main title
   */
  title: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: CollectionContents
// ====================================================

export interface CollectionContents_contents_edges_node_AudioContent {
  __typename: "AudioContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * Determines if subject content is visible in a collection
   */
  visibilityForCollection: Visibility | null;
  /**
   * Total duration in seconds
   */
  duration: number | null;
  hasUserCompleted: boolean | null;
}

export interface CollectionContents_contents_edges_node_EventContent_presences_event {
  __typename: "EventContent";
  /**
   * Unique identifier
   */
  id: string;
}

export interface CollectionContents_contents_edges_node_EventContent_presences_user {
  __typename: "User";
  id: string;
}

export interface CollectionContents_contents_edges_node_EventContent_presences {
  __typename: "EventContentPresence";
  event: CollectionContents_contents_edges_node_EventContent_presences_event;
  user: CollectionContents_contents_edges_node_EventContent_presences_user;
  presence: boolean | null;
}

export interface CollectionContents_contents_edges_node_EventContent {
  __typename: "EventContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * Determines if subject content is visible in a collection
   */
  visibilityForCollection: Visibility | null;
  isCurrentUserRegistered: boolean;
  hasUserCompleted: boolean | null;
  presences: CollectionContents_contents_edges_node_EventContent_presences[];
}

export interface CollectionContents_contents_edges_node_ImageContent {
  __typename: "ImageContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * Determines if subject content is visible in a collection
   */
  visibilityForCollection: Visibility | null;
  hasUserVisited: boolean;
}

export interface CollectionContents_contents_edges_node_LinkContent {
  __typename: "LinkContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * Determines if subject content is visible in a collection
   */
  visibilityForCollection: Visibility | null;
  /**
   * Destination domain
   */
  domain: string | null;
  /**
   * Total duration in seconds, alias of embed.estimatedReadingTime
   */
  duration: number | null;
  hasUserVisited: boolean;
}

export interface CollectionContents_contents_edges_node_PdfContent_pdfDetails {
  __typename: "PdfDetails";
  pages: number;
}

export interface CollectionContents_contents_edges_node_PdfContent {
  __typename: "PdfContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * Determines if subject content is visible in a collection
   */
  visibilityForCollection: Visibility | null;
  /**
   * Total duration in seconds, alias of pdfDetails.estimatedReadingTime
   */
  duration: number | null;
  /**
   * PDF document additional details
   */
  pdfDetails: CollectionContents_contents_edges_node_PdfContent_pdfDetails | null;
  /**
   * Activate PDF download
   */
  canDownload: boolean | null;
  hasUserVisited: boolean;
}

export interface CollectionContents_contents_edges_node_QuizContent_questions {
  __typename: "QuizContentQuestionEssay" | "QuizContentQuestionMatching" | "QuizContentQuestionMissingWord" | "QuizContentQuestionMultipleChoice" | "QuizContentQuestionNumerical" | "QuizContentQuestionSingleChoice" | "QuizContentQuestionTrueFalse";
}

export interface CollectionContents_contents_edges_node_QuizContent {
  __typename: "QuizContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * Determines if subject content is visible in a collection
   */
  visibilityForCollection: Visibility | null;
  questions: CollectionContents_contents_edges_node_QuizContent_questions[];
  hasUserCompleted: boolean | null;
}

export interface CollectionContents_contents_edges_node_ScormContent {
  __typename: "ScormContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * Determines if subject content is visible in a collection
   */
  visibilityForCollection: Visibility | null;
  /**
   * Expected time to complete the package, in seconds: the LOM typicalLearningTime the package declares, read on import, or what the author set by hand; null when unknown. Unrelated to timeLimit
   */
  duration: number | null;
  /**
   * Whether the user completed the package. Only the runtime can report it: a visit never counts,
   * so a preparatory course keeps the next element locked until the package is completed.
   */
  hasUserCompleted: boolean | null;
}

export interface CollectionContents_contents_edges_node_TextContent {
  __typename: "TextContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * Determines if subject content is visible in a collection
   */
  visibilityForCollection: Visibility | null;
  /**
   * Total duration in seconds, alias of pdfDetails.estimatedReadingTime
   */
  duration: number | null;
  hasUserVisited: boolean;
}

export interface CollectionContents_contents_edges_node_VideoContent {
  __typename: "VideoContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * Determines if subject content is visible in a collection
   */
  visibilityForCollection: Visibility | null;
  /**
   * Total duration in seconds
   */
  duration: number | null;
  /**
   * Destination link
   */
  url: any | null;
  /**
   * Cover picture
   */
  cover: any | null;
  aspectRatio: string | null;
  hasUserCompleted: boolean | null;
}

export type CollectionContents_contents_edges_node = CollectionContents_contents_edges_node_AudioContent | CollectionContents_contents_edges_node_EventContent | CollectionContents_contents_edges_node_ImageContent | CollectionContents_contents_edges_node_LinkContent | CollectionContents_contents_edges_node_PdfContent | CollectionContents_contents_edges_node_QuizContent | CollectionContents_contents_edges_node_ScormContent | CollectionContents_contents_edges_node_TextContent | CollectionContents_contents_edges_node_VideoContent;

export interface CollectionContents_contents_edges {
  __typename: "ContentEdge";
  /**
   * The Content node.
   */
  node: CollectionContents_contents_edges_node;
}

export interface CollectionContents_contents {
  __typename: "ContentConnection";
  /**
   * A list of Content edges.
   */
  edges: CollectionContents_contents_edges[];
}

export interface CollectionContents {
  __typename: "BlendedCollection" | "MixedCollection" | "VideoCollection";
  /**
   * Defines if current user has a specific permission on the collection
   */
  canManage: boolean;
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * List of all the contents included in subject collection
   */
  contents: CollectionContents_contents | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: CollectionModules
// ====================================================

export interface CollectionModules_modules_edges_node_contents_edges_node_AudioContent {
  __typename: "AudioContent";
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * Determines if subject content is visible in a collection
   */
  visibilityForCollection: Visibility | null;
  /**
   * Total duration in seconds
   */
  duration: number | null;
  hasUserCompleted: boolean | null;
}

export interface CollectionModules_modules_edges_node_contents_edges_node_EventContent {
  __typename: "EventContent";
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * Determines if subject content is visible in a collection
   */
  visibilityForCollection: Visibility | null;
  isCurrentUserRegistered: boolean;
  hasUserCompleted: boolean | null;
}

export interface CollectionModules_modules_edges_node_contents_edges_node_ImageContent {
  __typename: "ImageContent";
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * Determines if subject content is visible in a collection
   */
  visibilityForCollection: Visibility | null;
  hasUserVisited: boolean;
}

export interface CollectionModules_modules_edges_node_contents_edges_node_LinkContent {
  __typename: "LinkContent";
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * Determines if subject content is visible in a collection
   */
  visibilityForCollection: Visibility | null;
  /**
   * Destination domain
   */
  domain: string | null;
  /**
   * Total duration in seconds, alias of embed.estimatedReadingTime
   */
  duration: number | null;
  hasUserVisited: boolean;
}

export interface CollectionModules_modules_edges_node_contents_edges_node_PdfContent_pdfDetails {
  __typename: "PdfDetails";
  pages: number;
}

export interface CollectionModules_modules_edges_node_contents_edges_node_PdfContent {
  __typename: "PdfContent";
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * Determines if subject content is visible in a collection
   */
  visibilityForCollection: Visibility | null;
  /**
   * Total duration in seconds, alias of pdfDetails.estimatedReadingTime
   */
  duration: number | null;
  /**
   * PDF document additional details
   */
  pdfDetails: CollectionModules_modules_edges_node_contents_edges_node_PdfContent_pdfDetails | null;
  /**
   * Activate PDF download
   */
  canDownload: boolean | null;
  hasUserVisited: boolean;
}

export interface CollectionModules_modules_edges_node_contents_edges_node_QuizContent_questions {
  __typename: "QuizContentQuestionEssay" | "QuizContentQuestionMatching" | "QuizContentQuestionMissingWord" | "QuizContentQuestionMultipleChoice" | "QuizContentQuestionNumerical" | "QuizContentQuestionSingleChoice" | "QuizContentQuestionTrueFalse";
}

export interface CollectionModules_modules_edges_node_contents_edges_node_QuizContent {
  __typename: "QuizContent";
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * Determines if subject content is visible in a collection
   */
  visibilityForCollection: Visibility | null;
  questions: CollectionModules_modules_edges_node_contents_edges_node_QuizContent_questions[];
  hasUserCompleted: boolean | null;
}

export interface CollectionModules_modules_edges_node_contents_edges_node_ScormContent {
  __typename: "ScormContent";
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * Determines if subject content is visible in a collection
   */
  visibilityForCollection: Visibility | null;
  /**
   * Expected time to complete the package, in seconds: the LOM typicalLearningTime the package declares, read on import, or what the author set by hand; null when unknown. Unrelated to timeLimit
   */
  duration: number | null;
  /**
   * Whether the user completed the package. Only the runtime can report it: a visit never counts,
   * so a preparatory course keeps the next element locked until the package is completed.
   */
  hasUserCompleted: boolean | null;
}

export interface CollectionModules_modules_edges_node_contents_edges_node_TextContent {
  __typename: "TextContent";
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * Determines if subject content is visible in a collection
   */
  visibilityForCollection: Visibility | null;
  /**
   * Total duration in seconds, alias of pdfDetails.estimatedReadingTime
   */
  duration: number | null;
  hasUserVisited: boolean;
}

export interface CollectionModules_modules_edges_node_contents_edges_node_VideoContent {
  __typename: "VideoContent";
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * Determines if subject content is visible in a collection
   */
  visibilityForCollection: Visibility | null;
  /**
   * Total duration in seconds
   */
  duration: number | null;
  /**
   * Destination link
   */
  url: any | null;
  /**
   * Cover picture
   */
  cover: any | null;
  aspectRatio: string | null;
  hasUserCompleted: boolean | null;
}

export type CollectionModules_modules_edges_node_contents_edges_node = CollectionModules_modules_edges_node_contents_edges_node_AudioContent | CollectionModules_modules_edges_node_contents_edges_node_EventContent | CollectionModules_modules_edges_node_contents_edges_node_ImageContent | CollectionModules_modules_edges_node_contents_edges_node_LinkContent | CollectionModules_modules_edges_node_contents_edges_node_PdfContent | CollectionModules_modules_edges_node_contents_edges_node_QuizContent | CollectionModules_modules_edges_node_contents_edges_node_ScormContent | CollectionModules_modules_edges_node_contents_edges_node_TextContent | CollectionModules_modules_edges_node_contents_edges_node_VideoContent;

export interface CollectionModules_modules_edges_node_contents_edges {
  __typename: "ContentEdge";
  /**
   * The Content node.
   */
  node: CollectionModules_modules_edges_node_contents_edges_node;
}

export interface CollectionModules_modules_edges_node_contents {
  __typename: "ContentConnection";
  /**
   * A list of Content edges.
   */
  edges: CollectionModules_modules_edges_node_contents_edges[];
}

export interface CollectionModules_modules_edges_node {
  __typename: "Module";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Module position order inside collection
   */
  position: number;
  /**
   * Total duration of all the audio and video contents included
   */
  duration: number | null;
  /**
   * List of all the contents included in subject Module
   */
  contents: CollectionModules_modules_edges_node_contents;
}

export interface CollectionModules_modules_edges {
  __typename: "ModuleEdge";
  /**
   * The Module node.
   */
  node: CollectionModules_modules_edges_node;
}

export interface CollectionModules_modules {
  __typename: "ModuleConnection";
  /**
   * A list of Module edges.
   */
  edges: CollectionModules_modules_edges[];
}

export interface CollectionModules {
  __typename: "BlendedCollection" | "MixedCollection" | "VideoCollection";
  /**
   * List of all the modules included in subject collection
   */
  modules: CollectionModules_modules | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ContentPageEvent
// ====================================================

export interface ContentPageEvent_registeredUsers {
  __typename: "User";
  id: string;
}

export interface ContentPageEvent_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface ContentPageEvent_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
}

export interface ContentPageEvent_creator {
  __typename: "User";
  /**
   * Self description of the user
   */
  bio: string | null;
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: ContentPageEvent_creator_subscriptionPlan;
  /**
   * Main email address
   */
  email: any;
  workspace: ContentPageEvent_creator_workspace | null;
}

export interface ContentPageEvent_presences_event {
  __typename: "EventContent";
  /**
   * Unique identifier
   */
  id: string;
}

export interface ContentPageEvent_presences_user {
  __typename: "User";
  id: string;
}

export interface ContentPageEvent_presences {
  __typename: "EventContentPresence";
  event: ContentPageEvent_presences_event;
  user: ContentPageEvent_presences_user;
  presence: boolean | null;
}

export interface ContentPageEvent_relatedContents_EventContent {
  __typename: "EventContent" | "ScormContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
}

export interface ContentPageEvent_relatedContents_AudioContent {
  __typename: "AudioContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Total duration in seconds
   */
  duration: number | null;
}

export interface ContentPageEvent_relatedContents_ImageContent {
  __typename: "ImageContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
}

export interface ContentPageEvent_relatedContents_LinkContent {
  __typename: "LinkContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Destination domain
   */
  domain: string | null;
  /**
   * Total duration in seconds, alias of embed.estimatedReadingTime
   */
  duration: number | null;
}

export interface ContentPageEvent_relatedContents_PdfContent_pdfDetails {
  __typename: "PdfDetails";
  pages: number;
}

export interface ContentPageEvent_relatedContents_PdfContent {
  __typename: "PdfContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Total duration in seconds, alias of pdfDetails.estimatedReadingTime
   */
  duration: number | null;
  /**
   * PDF document additional details
   */
  pdfDetails: ContentPageEvent_relatedContents_PdfContent_pdfDetails | null;
  /**
   * Activate PDF download
   */
  canDownload: boolean | null;
}

export interface ContentPageEvent_relatedContents_QuizContent_questions {
  __typename: "QuizContentQuestionEssay" | "QuizContentQuestionMatching" | "QuizContentQuestionMissingWord" | "QuizContentQuestionMultipleChoice" | "QuizContentQuestionNumerical" | "QuizContentQuestionSingleChoice" | "QuizContentQuestionTrueFalse";
}

export interface ContentPageEvent_relatedContents_QuizContent {
  __typename: "QuizContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  questions: ContentPageEvent_relatedContents_QuizContent_questions[];
}

export interface ContentPageEvent_relatedContents_TextContent {
  __typename: "TextContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Total duration in seconds, alias of pdfDetails.estimatedReadingTime
   */
  duration: number | null;
}

export interface ContentPageEvent_relatedContents_VideoContent {
  __typename: "VideoContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  /**
   * Total duration in seconds
   */
  duration: number | null;
  /**
   * Destination link
   */
  url: any | null;
  /**
   * Cover picture
   */
  cover: any | null;
  aspectRatio: string | null;
}

export type ContentPageEvent_relatedContents = ContentPageEvent_relatedContents_EventContent | ContentPageEvent_relatedContents_AudioContent | ContentPageEvent_relatedContents_ImageContent | ContentPageEvent_relatedContents_LinkContent | ContentPageEvent_relatedContents_PdfContent | ContentPageEvent_relatedContents_QuizContent | ContentPageEvent_relatedContents_TextContent | ContentPageEvent_relatedContents_VideoContent;

export interface ContentPageEvent {
  __typename: "EventContent";
  expired: any | null;
  /**
   * Unique identifier
   */
  id: string;
  isCurrentUserRegistered: boolean;
  participants: number | null;
  registeredUsers: ContentPageEvent_registeredUsers[];
  registration: boolean;
  status: EventContentStatus;
  /**
   * Content subtype
   */
  subtype: EventContentSubtype;
  /**
   * Destination link
   */
  url: any | null;
  end: any | null;
  start: any | null;
  location: string | null;
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Content creator
   */
  creator: ContentPageEvent_creator;
  /**
   * Main description, if given
   */
  description: string | null;
  presentation: string | null;
  presences: ContentPageEvent_presences[];
  relatedContents: ContentPageEvent_relatedContents[];
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  tags: string[];
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * When visibility is public and this flag is set to true require registration to view all content
   */
  need_registration: boolean | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ContentPageImage
// ====================================================

export interface ContentPageImage_coverDimensions {
  __typename: "CoverDimensions";
  height: number | null;
  width: number | null;
}

export interface ContentPageImage_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface ContentPageImage_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
}

export interface ContentPageImage_creator {
  __typename: "User";
  /**
   * Self description of the user
   */
  bio: string | null;
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: ContentPageImage_creator_subscriptionPlan;
  /**
   * Main email address
   */
  email: any;
  workspace: ContentPageImage_creator_workspace | null;
}

export interface ContentPageImage {
  __typename: "ImageContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: ContentPageImage_coverDimensions | null;
  /**
   * Content creator
   */
  creator: ContentPageImage_creator;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Content subtype
   */
  imageSubtype: string | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  tags: string[];
  /**
   * Main title
   */
  title: string;
  /**
   * Destination link
   */
  url: any | null;
  /**
   * Effective images URL
   */
  urls: any[];
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * When visibility is public and this flag is set to true require registration to view all content
   */
  need_registration: boolean | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: ContentPageText
// ====================================================

export interface ContentPageText_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface ContentPageText_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
}

export interface ContentPageText_creator {
  __typename: "User";
  /**
   * Self description of the user
   */
  bio: string | null;
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: ContentPageText_creator_subscriptionPlan;
  /**
   * Main email address
   */
  email: any;
  workspace: ContentPageText_creator_workspace | null;
}

export interface ContentPageText {
  __typename: "TextContent";
  body: string;
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Content creator
   */
  creator: ContentPageText_creator;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Total duration in seconds, alias of pdfDetails.estimatedReadingTime
   */
  duration: number | null;
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  tags: string[];
  /**
   * Main title
   */
  title: string;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  /**
   * When visibility is public and this flag is set to true require registration to view all content
   */
  need_registration: boolean | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: FolderContents
// ====================================================

export interface FolderContents_contents_ScormContent_coverDimensions {
  __typename: "CoverDimensions";
  height: number | null;
  width: number | null;
}

export interface FolderContents_contents_ScormContent_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface FolderContents_contents_ScormContent_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
}

export interface FolderContents_contents_ScormContent_creator {
  __typename: "User";
  /**
   * Self description of the user
   */
  bio: string | null;
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: FolderContents_contents_ScormContent_creator_subscriptionPlan;
  /**
   * Main email address
   */
  email: any;
  workspace: FolderContents_contents_ScormContent_creator_workspace | null;
}

export interface FolderContents_contents_ScormContent {
  __typename: "ScormContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  tags: string[];
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  displayStatus: ContentDisplayStatus;
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: FolderContents_contents_ScormContent_coverDimensions | null;
  /**
   * Where the element is contained
   */
  parent_folder_id: string | null;
  /**
   * Content creator
   */
  creator: FolderContents_contents_ScormContent_creator;
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
}

export interface FolderContents_contents_EventContent_coverDimensions {
  __typename: "CoverDimensions";
  height: number | null;
  width: number | null;
}

export interface FolderContents_contents_EventContent_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface FolderContents_contents_EventContent_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
}

export interface FolderContents_contents_EventContent_creator {
  __typename: "User";
  /**
   * Self description of the user
   */
  bio: string | null;
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: FolderContents_contents_EventContent_creator_subscriptionPlan;
  /**
   * Main email address
   */
  email: any;
  workspace: FolderContents_contents_EventContent_creator_workspace | null;
}

export interface FolderContents_contents_EventContent {
  __typename: "EventContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  tags: string[];
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  displayStatus: ContentDisplayStatus;
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: FolderContents_contents_EventContent_coverDimensions | null;
  /**
   * Where the element is contained
   */
  parent_folder_id: string | null;
  /**
   * Content creator
   */
  creator: FolderContents_contents_EventContent_creator;
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  eventStatusForMenu: EventContentStatus;
  isCurrentUserRegistered: boolean;
  status: EventContentStatus;
  start: any | null;
  end: any | null;
}

export interface FolderContents_contents_QuizContent_coverDimensions {
  __typename: "CoverDimensions";
  height: number | null;
  width: number | null;
}

export interface FolderContents_contents_QuizContent_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface FolderContents_contents_QuizContent_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
}

export interface FolderContents_contents_QuizContent_creator {
  __typename: "User";
  /**
   * Self description of the user
   */
  bio: string | null;
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: FolderContents_contents_QuizContent_creator_subscriptionPlan;
  /**
   * Main email address
   */
  email: any;
  workspace: FolderContents_contents_QuizContent_creator_workspace | null;
}

export interface FolderContents_contents_QuizContent_questions {
  __typename: "QuizContentQuestionEssay" | "QuizContentQuestionMatching" | "QuizContentQuestionMissingWord" | "QuizContentQuestionMultipleChoice" | "QuizContentQuestionNumerical" | "QuizContentQuestionSingleChoice" | "QuizContentQuestionTrueFalse";
}

export interface FolderContents_contents_QuizContent {
  __typename: "QuizContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  tags: string[];
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  displayStatus: ContentDisplayStatus;
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: FolderContents_contents_QuizContent_coverDimensions | null;
  /**
   * Where the element is contained
   */
  parent_folder_id: string | null;
  /**
   * Content creator
   */
  creator: FolderContents_contents_QuizContent_creator;
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Content subtype
   */
  quizSubtypeForMenu: QuizContentSubtype | null;
  questions: FolderContents_contents_QuizContent_questions[];
}

export interface FolderContents_contents_AudioContent_coverDimensions {
  __typename: "CoverDimensions";
  height: number | null;
  width: number | null;
}

export interface FolderContents_contents_AudioContent_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface FolderContents_contents_AudioContent_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
}

export interface FolderContents_contents_AudioContent_creator {
  __typename: "User";
  /**
   * Self description of the user
   */
  bio: string | null;
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: FolderContents_contents_AudioContent_creator_subscriptionPlan;
  /**
   * Main email address
   */
  email: any;
  workspace: FolderContents_contents_AudioContent_creator_workspace | null;
}

export interface FolderContents_contents_AudioContent {
  __typename: "AudioContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  tags: string[];
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  displayStatus: ContentDisplayStatus;
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: FolderContents_contents_AudioContent_coverDimensions | null;
  /**
   * Where the element is contained
   */
  parent_folder_id: string | null;
  /**
   * Content creator
   */
  creator: FolderContents_contents_AudioContent_creator;
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Total duration in seconds
   */
  duration: number | null;
}

export interface FolderContents_contents_ImageContent_coverDimensions {
  __typename: "CoverDimensions";
  height: number | null;
  width: number | null;
}

export interface FolderContents_contents_ImageContent_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface FolderContents_contents_ImageContent_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
}

export interface FolderContents_contents_ImageContent_creator {
  __typename: "User";
  /**
   * Self description of the user
   */
  bio: string | null;
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: FolderContents_contents_ImageContent_creator_subscriptionPlan;
  /**
   * Main email address
   */
  email: any;
  workspace: FolderContents_contents_ImageContent_creator_workspace | null;
}

export interface FolderContents_contents_ImageContent {
  __typename: "ImageContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  tags: string[];
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  displayStatus: ContentDisplayStatus;
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: FolderContents_contents_ImageContent_coverDimensions | null;
  /**
   * Where the element is contained
   */
  parent_folder_id: string | null;
  /**
   * Content creator
   */
  creator: FolderContents_contents_ImageContent_creator;
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
}

export interface FolderContents_contents_LinkContent_coverDimensions {
  __typename: "CoverDimensions";
  height: number | null;
  width: number | null;
}

export interface FolderContents_contents_LinkContent_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface FolderContents_contents_LinkContent_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
}

export interface FolderContents_contents_LinkContent_creator {
  __typename: "User";
  /**
   * Self description of the user
   */
  bio: string | null;
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: FolderContents_contents_LinkContent_creator_subscriptionPlan;
  /**
   * Main email address
   */
  email: any;
  workspace: FolderContents_contents_LinkContent_creator_workspace | null;
}

export interface FolderContents_contents_LinkContent {
  __typename: "LinkContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  tags: string[];
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  displayStatus: ContentDisplayStatus;
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: FolderContents_contents_LinkContent_coverDimensions | null;
  /**
   * Where the element is contained
   */
  parent_folder_id: string | null;
  /**
   * Content creator
   */
  creator: FolderContents_contents_LinkContent_creator;
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Destination domain
   */
  domain: string | null;
  /**
   * Total duration in seconds, alias of embed.estimatedReadingTime
   */
  duration: number | null;
}

export interface FolderContents_contents_PdfContent_coverDimensions {
  __typename: "CoverDimensions";
  height: number | null;
  width: number | null;
}

export interface FolderContents_contents_PdfContent_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface FolderContents_contents_PdfContent_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
}

export interface FolderContents_contents_PdfContent_creator {
  __typename: "User";
  /**
   * Self description of the user
   */
  bio: string | null;
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: FolderContents_contents_PdfContent_creator_subscriptionPlan;
  /**
   * Main email address
   */
  email: any;
  workspace: FolderContents_contents_PdfContent_creator_workspace | null;
}

export interface FolderContents_contents_PdfContent_pdfDetails {
  __typename: "PdfDetails";
  pages: number;
}

export interface FolderContents_contents_PdfContent {
  __typename: "PdfContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  tags: string[];
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  displayStatus: ContentDisplayStatus;
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: FolderContents_contents_PdfContent_coverDimensions | null;
  /**
   * Where the element is contained
   */
  parent_folder_id: string | null;
  /**
   * Content creator
   */
  creator: FolderContents_contents_PdfContent_creator;
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Total duration in seconds, alias of pdfDetails.estimatedReadingTime
   */
  duration: number | null;
  /**
   * PDF document additional details
   */
  pdfDetails: FolderContents_contents_PdfContent_pdfDetails | null;
  /**
   * Activate PDF download
   */
  canDownload: boolean | null;
}

export interface FolderContents_contents_TextContent_coverDimensions {
  __typename: "CoverDimensions";
  height: number | null;
  width: number | null;
}

export interface FolderContents_contents_TextContent_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface FolderContents_contents_TextContent_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
}

export interface FolderContents_contents_TextContent_creator {
  __typename: "User";
  /**
   * Self description of the user
   */
  bio: string | null;
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: FolderContents_contents_TextContent_creator_subscriptionPlan;
  /**
   * Main email address
   */
  email: any;
  workspace: FolderContents_contents_TextContent_creator_workspace | null;
}

export interface FolderContents_contents_TextContent {
  __typename: "TextContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  tags: string[];
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  displayStatus: ContentDisplayStatus;
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: FolderContents_contents_TextContent_coverDimensions | null;
  /**
   * Where the element is contained
   */
  parent_folder_id: string | null;
  /**
   * Content creator
   */
  creator: FolderContents_contents_TextContent_creator;
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Total duration in seconds, alias of pdfDetails.estimatedReadingTime
   */
  duration: number | null;
}

export interface FolderContents_contents_VideoContent_coverDimensions {
  __typename: "CoverDimensions";
  height: number | null;
  width: number | null;
}

export interface FolderContents_contents_VideoContent_creator_subscriptionPlan {
  __typename: "SubscriptionPlan";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Internal code
   */
  code: string;
}

export interface FolderContents_contents_VideoContent_creator_workspace {
  __typename: "Workspace";
  /**
   * Unique identifier
   */
  id: string;
  /**
   * Flag to hide support UI for consumer users
   */
  hideSupportUIForConsumer: boolean;
}

export interface FolderContents_contents_VideoContent_creator {
  __typename: "User";
  /**
   * Self description of the user
   */
  bio: string | null;
  id: string;
  /**
   * Full name
   */
  name: string;
  /**
   * Custom route
   */
  vanity_name: string | null;
  /**
   * User picture, if not set defaults to:
   * * [Gravatar](https: // en.gravatar.com/site/implement/images/) if available
   * * an avatar with name initials
   */
  picture: any;
  /**
   * Personal website
   */
  website: any | null;
  subscriptionPlan: FolderContents_contents_VideoContent_creator_subscriptionPlan;
  /**
   * Main email address
   */
  email: any;
  workspace: FolderContents_contents_VideoContent_creator_workspace | null;
}

export interface FolderContents_contents_VideoContent {
  __typename: "VideoContent";
  /**
   * Defines if current user has a specific permission on the content
   */
  canRead: boolean;
  /**
   * Main description, if given
   */
  description: string | null;
  /**
   * Unique identifier
   */
  id: string;
  label: string | null;
  /**
   * Slug, could be generated randomly or set by the creator
   */
  slug: string;
  /**
   * Main title
   */
  title: string;
  tags: string[];
  /**
   * Cover picture
   */
  cover: any | null;
  /**
   * Visibility, defines if publicly accessible or not
   */
  visibility: Visibility;
  displayStatus: ContentDisplayStatus;
  /**
   * Dimensions of the cover, when available
   */
  coverDimensions: FolderContents_contents_VideoContent_coverDimensions | null;
  /**
   * Where the element is contained
   */
  parent_folder_id: string | null;
  /**
   * Content creator
   */
  creator: FolderContents_contents_VideoContent_creator;
  /**
   * Defines if current user has a specific permission on the content
   */
  canManage: boolean;
  /**
   * Total duration in seconds
   */
  duration: number | null;
  /**
   * Destination link
   */
  url: any | null;
  aspectRatio: string | null;
}

export type FolderContents_contents = FolderContents_contents_ScormContent | FolderContents_contents_EventContent | FolderContents_contents_QuizContent | FolderContents_contents_AudioContent | FolderContents_contents_ImageContent | FolderContents_contents_LinkContent | FolderContents_contents_PdfContent | FolderContents_contents_TextContent | FolderContents_contents_VideoContent;

export interface FolderContents {
  __typename: "Folder";
  /**
   * List of all the contents included in subject
   */
  contents: FolderContents_contents[];
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum AssociateCertificateToElementType {
  course = "course",
  event = "event",
}

export enum CertificateTemplate {
  default = "default",
  whitelabel = "whitelabel",
}

export enum CollectionDisplayStatus {
  analytics = "analytics",
  default = "default",
}

export enum CollectionSellingMethodType {
  contact = "contact",
  online = "online",
}

export enum CollectionType {
  blended = "blended",
  mixed = "mixed",
  video = "video",
}

export enum ContentDisplayStatus {
  analytics = "analytics",
  default = "default",
}

export enum ContentType {
  audio = "audio",
  event = "event",
  image = "image",
  link = "link",
  pdf = "pdf",
  quiz = "quiz",
  scorm = "scorm",
  text = "text",
  video = "video",
}

export enum DomainStatus {
  active = "active",
  failed = "failed",
  pending = "pending",
}

/**
 * Granular content-type filter for element listings.
 * `course` maps to any collection; the remaining values map to the matching
 * content type.
 */
export enum ElementContentType {
  audio = "audio",
  course = "course",
  link = "link",
  pdf = "pdf",
  quiz = "quiz",
  text = "text",
  video = "video",
}

/**
 * Ordering options for element listings (home and folder).
 */
export enum ElementSort {
  NEWEST = "NEWEST",
  OLDEST = "OLDEST",
  TITLE_ASC = "TITLE_ASC",
  TITLE_DESC = "TITLE_DESC",
}

export enum ElementToFolderType {
  collection = "collection",
  content = "content",
  folder = "folder",
}

export enum ElementToHomeType {
  collection = "collection",
  content = "content",
  folder = "folder",
}

export enum ElementTypeEnum {
  collection = "collection",
  content = "content",
  folder = "folder",
}

export enum EventContentStatus {
  expired = "expired",
  in_progress = "in_progress",
  past = "past",
  scheduled = "scheduled",
}

export enum EventContentSubtype {
  online_event = "online_event",
  presence_event = "presence_event",
  zoom_event = "zoom_event",
}

export enum ImportJobStatus {
  COMPLETED = "COMPLETED",
  FAILED = "FAILED",
  PENDING = "PENDING",
  PROCESSING = "PROCESSING",
}

export enum QuizContentQuestionType {
  essay = "essay",
  matching = "matching",
  missing_word = "missing_word",
  multiple_choice = "multiple_choice",
  numerical = "numerical",
  single_choice = "single_choice",
  true_false = "true_false",
}

export enum QuizContentSubtype {
  quick_quiz = "quick_quiz",
  self_assessment_test = "self_assessment_test",
  verification_test = "verification_test",
}

export enum RemoveCertificateToElementType {
  course = "course",
  event = "event",
}

export enum RemoveUserElementType {
  collection = "collection",
  content = "content",
  folder = "folder",
}

export enum UpdateUserProfilePageElementType {
  collection = "collection",
  content = "content",
  folder = "folder",
}

export enum UserCategory {
  consulting_strategy = "consulting_strategy",
  marketing_communication = "marketing_communication",
  tech_data = "tech_data",
  training_academy = "training_academy",
}

export enum UserExternalAccountProvider {
  apple = "apple",
  doorway = "doorway",
  facebook = "facebook",
  google = "google",
  instagram = "instagram",
  linkedin = "linkedin",
  microsoft = "microsoft",
  twitter = "twitter",
  vodafone = "vodafone",
  zoom = "zoom",
}

export enum Visibility {
  mine = "mine",
  preview = "preview",
  private = "private",
  protected = "protected",
  public = "public",
}

export interface CreateCertificateInput {
  background_image?: any | null;
  title: string;
  type?: string | null;
  first_phrase?: string | null;
  second_phrase?: string | null;
  third_phrase?: string | null;
  note?: string | null;
  template?: CertificateTemplate | null;
}

export interface CreateCollectionInput {
  cover?: any | null;
  description?: string | null;
  label?: string | null;
  presentation?: string | null;
  tags?: string[] | null;
  title: string;
  type?: CollectionType | null;
  visibility?: Visibility | null;
  selling?: boolean | null;
  sellingPricing?: number | null;
  sellingCurrency?: string | null;
  sellingMethod?: CollectionSellingMethodType | null;
  privacyPolicy?: string | null;
  preparatory?: string | null;
  workspaceId?: string | null;
  parent_folder_id?: string | null;
}

export interface CreateContentInput {
  cover?: any | null;
  description?: string | null;
  label?: string | null;
  tags?: string[] | null;
  title?: string | null;
  type?: ContentType | null;
  url: any;
  visibility?: Visibility | null;
  canDownload?: boolean | null;
  workspaceId?: string | null;
  parent_folder_id?: string | null;
}

export interface CreateDomainInput {
  name: string;
}

export interface CreateEventContentInput {
  cover?: any | null;
  description?: string | null;
  end?: any | null;
  label?: string | null;
  location?: string | null;
  participants?: number | null;
  presentation?: string | null;
  registration?: boolean | null;
  start?: any | null;
  subtype: EventContentSubtype;
  tags?: string[] | null;
  title: string;
  url?: any | null;
  visibility?: Visibility | null;
  workspaceId?: string | null;
  parent_folder_id?: string | null;
}

export interface CreateFolderInput {
  description?: string | null;
  label?: string | null;
  tags?: string[] | null;
  title: string;
  visibility?: Visibility | null;
  workspaceId?: string | null;
}

export interface CreateImageContentInput {
  description?: string | null;
  label?: string | null;
  subtype?: string | null;
  tags?: string[] | null;
  title?: string | null;
  type?: ContentType | null;
  urls: any[];
  visibility?: Visibility | null;
  workspaceId?: string | null;
}

export interface CreateModuleInput {
  title: string;
}

export interface CreateQuizContentInput {
  appendRequiredQuestions?: boolean | null;
  basket?: number | null;
  canRepeat?: boolean | null;
  canRepeatOnlyFailure?: boolean | null;
  canRepeatMaximum?: number | null;
  cover?: any | null;
  description?: string | null;
  instructions?: string | null;
  label?: string | null;
  questions: any;
  questionsNavigation?: boolean | null;
  quizFeedbackSuccessMessage?: string | null;
  quizFeedbackSuccessImage?: any | null;
  quizFeedbackFailureMessage?: string | null;
  quizFeedbackFailureImage?: any | null;
  timeLimit?: number | null;
  randomOrder?: boolean | null;
  restartFromBegin?: boolean | null;
  separateEvaluation?: boolean | null;
  showAnswer?: boolean | null;
  showProgress?: boolean | null;
  showSummary?: boolean | null;
  subtype?: QuizContentSubtype | null;
  successPoints?: number | null;
  tags?: string[] | null;
  title: string;
  visibility?: Visibility | null;
  workspaceId?: string | null;
  parent_folder_id?: string | null;
}

export interface CreateTextContentInput {
  body: string;
  cover?: any | null;
  description?: string | null;
  label?: string | null;
  tags?: string[] | null;
  title: string;
  visibility?: Visibility | null;
  workspaceId?: string | null;
  parent_folder_id?: string | null;
}

export interface ElementToFolder {
  elementId: string;
  elementType: ElementToFolderType;
}

export interface ElementTypeFilter {
  value?: ElementTypeEnum | null;
}

export interface SellingContactRequestInput {
  collectionId: string;
  email: string;
  message: string;
  name: string;
}

export interface UpdateCertificateInput {
  background_image?: any | null;
  title?: string | null;
  type?: string | null;
  first_phrase?: string | null;
  second_phrase?: string | null;
  third_phrase?: string | null;
  note?: string | null;
  template?: CertificateTemplate | null;
}

export interface UpdateCollectionInput {
  cover?: any | null;
  description?: string | null;
  label?: string | null;
  presentation?: string | null;
  tags?: string[] | null;
  title?: string | null;
  visibility?: Visibility | null;
  selling?: boolean | null;
  sellingPricing?: number | null;
  sellingCurrency?: string | null;
  sellingMethod?: CollectionSellingMethodType | null;
  privacyPolicy?: string | null;
  preparatory?: string | null;
  need_registration?: boolean | null;
}

export interface UpdateContentInput {
  cover?: any | null;
  description?: string | null;
  label?: string | null;
  tags?: string[] | null;
  title?: string | null;
  url?: any | null;
  visibility?: Visibility | null;
  canDownload?: boolean | null;
  need_registration?: boolean | null;
  duration?: number | null;
}

export interface UpdateEventContentInput {
  cover?: any | null;
  description?: string | null;
  end?: any | null;
  label?: string | null;
  location?: string | null;
  participants?: number | null;
  presentation?: string | null;
  registration?: boolean | null;
  start?: any | null;
  tags?: string[] | null;
  title?: string | null;
  url?: any | null;
  visibility?: Visibility | null;
}

export interface UpdateFolderInput {
  description?: string | null;
  label?: string | null;
  tags?: string[] | null;
  title?: string | null;
  visibility?: Visibility | null;
}

export interface UpdateImageContentInput {
  description?: string | null;
  label?: string | null;
  tags?: string[] | null;
  title?: string | null;
  urls: any[];
  visibility?: Visibility | null;
}

export interface UpdateModuleInput {
  title: string;
}

export interface UpdateQuizContentInput {
  appendRequiredQuestions?: boolean | null;
  basket?: number | null;
  canRepeat?: boolean | null;
  canRepeatOnlyFailure?: boolean | null;
  canRepeatMaximum?: number | null;
  cover?: any | null;
  description?: string | null;
  instructions?: string | null;
  label?: string | null;
  questions?: any | null;
  questionsNavigation?: boolean | null;
  quizFeedbackSuccessMessage?: string | null;
  quizFeedbackSuccessImage?: any | null;
  quizFeedbackFailureMessage?: string | null;
  quizFeedbackFailureImage?: any | null;
  timeLimit?: number | null;
  randomOrder?: boolean | null;
  restartFromBegin?: boolean | null;
  separateEvaluation?: boolean | null;
  showAnswer?: boolean | null;
  showProgress?: boolean | null;
  showSummary?: boolean | null;
  subtype?: QuizContentSubtype | null;
  successPoints?: number | null;
  tags?: string[] | null;
  title?: string | null;
  visibility?: Visibility | null;
}

export interface UpdateTextContentInput {
  body: string;
  cover?: any | null;
  description?: string | null;
  label?: string | null;
  tags?: string[] | null;
  title?: string | null;
  visibility?: Visibility | null;
}

export interface UpdateUserInput {
  bio?: string | null;
  firstname?: string | null;
  lastname?: string | null;
  language?: string | null;
  payoff?: string | null;
  stripe_account_id?: string | null;
  brandName?: string | null;
  brandLogoSmall?: any | null;
  website?: any | null;
  linkedin?: any | null;
  twitter?: any | null;
  facebook?: any | null;
  instagram?: any | null;
  picture?: any | null;
  banner?: any | null;
  preferences?: UpdateUserPreferencesInput | null;
  location?: string | null;
  category?: UserCategory | null;
}

export interface UpdateUserPreferencesInput {
  hidePromoFooter?: boolean | null;
  hideMessageCreator?: boolean | null;
}

export interface UpdateUserProfilePageElement {
  id: string;
  type: UpdateUserProfilePageElementType;
  value: boolean;
}

export interface UpdateWorkspaceInput {
  name?: string | null;
  brandName?: string | null;
  brandLogoSmall?: any | null;
  description?: string | null;
  hideSupportUIForConsumer?: boolean | null;
}

export interface UserField {
  name: string;
  value: string;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
